var _a, _b, _c, _d, _e, _f, _g;
import { BlockTypes, BlockAttrsParams, NodeViewTypes, SeshatNodes, MarkTypes, RECALCULATE_PLACEHOLDER, SeshatInlineNodes, DEFAULT_REFERENCE, HASH_REFERENCE, capitalizeFirstLetter, SeshatNodeGroups, SeshatWrappingBlocks, pipe, CARD_NOTE_TYPE, LAUNCHER_EDITOR_ID, EDITOR_RELATED_ELEMENT_IDS, ClipBookmarksTypes, isYoutubeUrl, getYoutubeVideoId, getNameAndExtFromFileName, sanitizeForFileName, MarkAttrsParams, generateRandomId, CAPTURE_TO_ANCHOR, REFERENCE_BRACKET_PLACEHOLDER, uuidV5, generateText, urlMediaParser, debug as debug$2, findSubstringOffset, SeshatCssClass, SESHAT_JSON_MIME, isUrl, CARD_TASK_TYPE, REFERENCE_HASH_PLACEHOLDER, MENTION_PLACEHOLDER, uuidForBlockMigration, convertContentToTitle, includesCardType, CARD_WITHOUT_TITLE_IN_TEXT_EDITOR_CONTENT, REFERENCE_TE_ITEM, CARD_UNTITLED, CARD_WITH_TITLE_IN_TEXT_EDITOR_CONTENT, STATUS_TRASH, STATUS_DONE, generateMarkText, CARD_DAY_TYPE, DEFAULT_CARD_TYPE, uuidV1, sanitizeSlackEmoji, sanitizeFacebookEmoji, traverseProsemirrorDoc } from "@lazy-app/common";
export { BlockAttrsParams as BlockAttrs, BlockTypes, CardClipStatus, NodeViewTypes, SeshatCssClass, SeshatNodes, SeshatWrappingBlocks } from "@lazy-app/common";
import { findChildrenInRange, findChildren, Extension, getSchema, getText as getText$1, getTextSerializersFromSchema, Node, InputRule, Mark, mergeAttributes, markPasteRule, markInputRule, getMarksBetween, getExtensionField, Editor } from "@tiptap/core";
import { PluginKey, Plugin, Selection, TextSelection, NodeSelection } from "@tiptap/pm/state";
import { ReplaceStep, AddMarkStep, RemoveMarkStep, ReplaceAroundStep } from "@tiptap/pm/transform";
import { Plugin as Plugin$1, PluginKey as PluginKey$1, TextSelection as TextSelection$1 } from "prosemirror-state";
import { defaultMarkdownSerializer, MarkdownSerializer } from "@tiptap/pm/markdown";
import { Fragment, Slice, DOMParser as DOMParser$1, Node as Node$1, DOMSerializer, NodeRange } from "@tiptap/pm/model";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { sanitizeHtmlInterface } from "@lazy-app/interface";
import MarkdownIt from "markdown-it";
import { Bold } from "@tiptap/extension-bold";
import { Code } from "@tiptap/extension-code";
import { Extension as Extension$1 } from "@tiptap/react";
import Fuse from "fuse.js";
import arduino from "highlight.js/lib/languages/arduino";
import bash from "highlight.js/lib/languages/bash";
import c from "highlight.js/lib/languages/c";
import cpp from "highlight.js/lib/languages/cpp";
import csharp from "highlight.js/lib/languages/csharp";
import css from "highlight.js/lib/languages/css";
import diff from "highlight.js/lib/languages/diff";
import go from "highlight.js/lib/languages/go";
import ini from "highlight.js/lib/languages/ini";
import java from "highlight.js/lib/languages/java";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import kotlin from "highlight.js/lib/languages/kotlin";
import less from "highlight.js/lib/languages/less";
import lua from "highlight.js/lib/languages/lua";
import makefile from "highlight.js/lib/languages/makefile";
import markdown from "highlight.js/lib/languages/markdown";
import objectivec from "highlight.js/lib/languages/objectivec";
import perl from "highlight.js/lib/languages/perl";
import php from "highlight.js/lib/languages/php";
import phpTemplate from "highlight.js/lib/languages/php-template";
import plaintext from "highlight.js/lib/languages/plaintext";
import python from "highlight.js/lib/languages/python";
import pythonRepl from "highlight.js/lib/languages/python-repl";
import r from "highlight.js/lib/languages/r";
import ruby from "highlight.js/lib/languages/ruby";
import rust from "highlight.js/lib/languages/rust";
import scss from "highlight.js/lib/languages/scss";
import shell from "highlight.js/lib/languages/shell";
import sql from "highlight.js/lib/languages/sql";
import swift from "highlight.js/lib/languages/swift";
import typescript from "highlight.js/lib/languages/typescript";
import vbnet from "highlight.js/lib/languages/vbnet";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";
import high from "highlight.js/lib/core";
import formatter from "format";
import { History } from "@tiptap/extension-history";
import { history } from "@tiptap/pm/history";
import { Document } from "@tiptap/extension-document";
import { Typography } from "@tiptap/extension-typography";
export { Typography as TypographyExtension } from "@tiptap/extension-typography";
import _ from "lodash";
import { Italic } from "@tiptap/extension-italic";
import { Link } from "@tiptap/extension-link";
import { Strike } from "@tiptap/extension-strike";
import { TextStyle } from "@tiptap/extension-text-style";
import { Underline } from "@tiptap/extension-underline";
import { Text } from "@tiptap/extension-text";
const seshatBlockAttributes = {
  type: {
    default: BlockTypes.PARAGRAPH,
    keepOnSplit: true
  },
  nodeViewType: {
    default: void 0,
    keepOnSplit: true
  },
  dir: {
    default: "auto",
    keepOnSplit: true
  },
  textAlign: {
    default: "auto",
    keepOnSplit: true
  },
  [BlockAttrsParams.CONTEXT_UUID]: {
    default: void 0,
    keepOnSplit: true
  },
  [BlockAttrsParams.BLOCK_UUID]: {
    default: void 0,
    keepOnSplit: false
  },
  ai: {
    default: void 0,
    keepOnSplit: true
  },
  allowFullScreen: {
    default: void 0,
    keepOnSplit: true
  },
  asin: {
    default: void 0,
    keepOnSplit: true
  },
  attachmentUuid: {
    default: void 0,
    keepOnSplit: true
  },
  author: {
    default: void 0,
    keepOnSplit: true
  },
  authors: {
    default: void 0,
    keepOnSplit: true
  },
  cardType: {
    default: void 0,
    keepOnSplit: true
  },
  clipBookmarkType: {
    default: void 0,
    keepOnSplit: true
  },
  clipContentJSON: {
    default: void 0,
    keepOnSplit: false,
    rendered: false
  },
  collapsed: {
    default: void 0,
    keepOnSplit: true
  },
  color: {
    default: void 0,
    keepOnSplit: true
  },
  connectedClip: {
    default: void 0,
    keepOnSplit: true
  },
  contentEditable: {
    default: void 0,
    keepOnSplit: true
  },
  coverUrl: {
    default: void 0,
    keepOnSplit: true
  },
  email: {
    default: void 0,
    keepOnSplit: true
  },
  emoji: {
    default: void 0,
    keepOnSplit: true
  },
  favicon: {
    default: void 0,
    keepOnSplit: true,
    rendered: false
  },
  fetched: {
    default: void 0,
    keepOnSplit: true
  },
  fileUuid: {
    default: void 0,
    keepOnSplit: true
  },
  fileName: {
    default: void 0,
    keepOnSplit: true
  },
  fileSize: {
    default: void 0,
    keepOnSplit: true
  },
  fileType: {
    default: void 0,
    keepOnSplit: true
  },
  highlightId: {
    default: void 0,
    keepOnSplit: true
  },
  highlightNote: {
    default: void 0,
    keepOnSplit: true
  },
  highlights: {
    default: void 0,
    keepOnSplit: false,
    rendered: false
  },
  href: {
    default: void 0,
    keepOnSplit: true
  },
  hrefBackup: {
    default: void 0,
    keepOnSplit: true
  },
  isDone: {
    default: void 0,
    keepOnSplit: true
  },
  isPaywallContent: {
    default: void 0,
    keepOnSplit: true,
    rendered: false
  },
  kindleHighlights: {
    default: void 0,
    keepOnSplit: true
  },
  language: {
    default: void 0,
    keepOnSplit: true
  },
  parentCardUuid: {
    default: void 0,
    keepOnSplit: true
  },
  pending: {
    default: void 0,
    keepOnSplit: true
  },
  position: {
    default: void 0,
    keepOnSplit: true,
    rendered: false
  },
  previewType: {
    default: void 0,
    keepOnSplit: true
  },
  src: {
    default: void 0,
    keepOnSplit: true
  },
  srcDoc: {
    default: void 0,
    keepOnSplit: true
  },
  status: {
    default: void 0,
    keepOnSplit: true
  },
  target: {
    default: void 0,
    keepOnSplit: true
  },
  timestamp: {
    default: void 0,
    keepOnSplit: true
  },
  title: {
    default: void 0,
    keepOnSplit: true,
    rendered: false
  },
  twitter: {
    default: void 0,
    keepOnSplit: true
  },
  url: {
    default: void 0,
    keepOnSplit: true
  },
  value: {
    default: void 0,
    keepOnSplit: true
  },
  video: {
    default: void 0,
    keepOnSplit: true
  },
  width: {
    default: void 0,
    keepOnSplit: true
  }
};
const PreviewFile = {
  IMAGE: "image",
  EXTERNAL_IMAGE: "externalImage",
  FILE: "file",
  PDF: "pdf",
  VIDEO: "video",
  AUDIO: "audio",
  EXTERNAL_VIDEO: "externalVideo"
};
const noPlaceholderPreviewFile = [
  PreviewFile.IMAGE,
  PreviewFile.PDF,
  PreviewFile.FILE,
  PreviewFile.VIDEO,
  PreviewFile.AUDIO
];
const findAncestor = ($from, predicate) => {
  let depth = $from.depth;
  while (depth >= 0) {
    let node = $from.node(depth);
    if (predicate(node)) {
      return { node, depth };
    } else {
      depth--;
    }
  }
  return void 0;
};
const SESHAT_ROOT_DEPTH = 1;
const SESHAT_CONTENT_DEPTH = 2;
const seshatBlockOnEnter = {
  [BlockTypes.HEADING_1]: BlockTypes.PARAGRAPH,
  [BlockTypes.HEADING_2]: BlockTypes.PARAGRAPH,
  [BlockTypes.HEADING_3]: BlockTypes.PARAGRAPH,
  [BlockTypes.HEADING_4]: BlockTypes.PARAGRAPH,
  [BlockTypes.CODE]: BlockTypes.PARAGRAPH,
  [BlockTypes.NODE_VIEW]: BlockTypes.PARAGRAPH
};
const seshatBlockResetOnStartBackspace = [
  BlockTypes.HEADING_1,
  BlockTypes.HEADING_2,
  BlockTypes.HEADING_3,
  BlockTypes.HEADING_4,
  BlockTypes.BULLETED_LIST,
  BlockTypes.NUMBERED_LIST,
  BlockTypes.HIGHLIGHT,
  BlockTypes.CODE,
  BlockTypes.CARD_CONTENT,
  BlockTypes.TASK_EDITABLE,
  BlockTypes.NOTE_EDITABLE
];
const seshatBlockResetOnEmptyEnter = [
  BlockTypes.HEADING_1,
  BlockTypes.HEADING_2,
  BlockTypes.HEADING_3,
  BlockTypes.HEADING_4,
  BlockTypes.BULLETED_LIST,
  BlockTypes.NUMBERED_LIST,
  BlockTypes.BLOCKQUOTE,
  BlockTypes.CARD_CONTENT
];
const seshatBlockSoftBreakOnEnter = [BlockTypes.CODE];
const HARD_BREAK_DUE_TO_PARENT_TYPE = [
  BlockTypes.HIGHLIGHT_NOTE,
  BlockTypes.BLOCKQUOTE,
  BlockTypes.CLIP_CONTENT
];
const HARD_BREAK_DUE_TO_BLOCK_TYPE = [BlockTypes.CODE];
const disabledIndent = [BlockTypes.CARD_LINK];
const isContentEditableFalseBlockType = [
  BlockTypes.CARD_LINK,
  BlockTypes.NODE_VIEW
];
const clipBlocks = [
  BlockTypes.CLIP_CONTENT,
  NodeViewTypes.CLIP_BOOK,
  NodeViewTypes.CLIP_BOOKMARK
];
const excludedFromBlockSelection = [
  BlockTypes.HIGHLIGHT,
  BlockTypes.HIGHLIGHT_NOTE,
  BlockTypes.TWEET,
  BlockTypes.BLOCK_COLUMN
];
const ParagraphBlockConfig = {
  type: BlockTypes.PARAGRAPH,
  title: "Text",
  search: ["paragraph", "text"],
  schemaType: SeshatNodes.BLOCK,
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.PARAGRAPH }).run()
};
const HeadingBlockConfig = (level) => ({
  type: `heading${level}`,
  title: `Heading ${level}`,
  schemaType: SeshatNodes.BLOCK,
  search: ["title", "headings", "header", `header ${level}`, `h${level}`],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({
    type: `heading${level}`
  }).run()
});
const BulletBlockConfig = {
  type: BlockTypes.BULLETED_LIST,
  title: "Bullet List",
  schemaType: SeshatNodes.BLOCK,
  search: ["list", "bullet"],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.BULLETED_LIST }).run()
};
const NumberedBlockConfig = {
  type: BlockTypes.NUMBERED_LIST,
  title: "Numbered List",
  schemaType: SeshatNodes.BLOCK,
  search: ["number", "list", "ordered list"],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.NUMBERED_LIST }).run()
};
const AddTaskBlockConfig = {
  type: BlockTypes.TASK_EDITABLE,
  title: "Task",
  schemaType: SeshatNodes.BLOCK,
  search: ["tasks", "todo"],
  commandsType: ["basic-node-view-content"],
  shouldBeHidden: (editorApi) => {
    const contentDepthOfRoot = SESHAT_ROOT_DEPTH + SESHAT_CONTENT_DEPTH + 1;
    const selectionDepth = editorApi == null ? void 0 : editorApi.state.selection.$from.depth;
    return !selectionDepth || selectionDepth > contentDepthOfRoot;
  },
  runCommand: (editorApi) => editorApi.chain().focus().insertBlock({
    type: BlockTypes.TASK_EDITABLE,
    isDone: false
  }).run()
};
const TaskBlockConfig = {
  type: BlockTypes.TASK_EDITABLE,
  title: "Task",
  schemaType: SeshatNodes.BLOCK,
  search: ["tasks", "todo"],
  commandsType: ["turn-into"],
  shouldBeHidden: (editorApi) => {
    const contentDepthOfRoot = SESHAT_ROOT_DEPTH + SESHAT_CONTENT_DEPTH + 1;
    const selectionDepth = editorApi == null ? void 0 : editorApi.state.selection.$from.depth;
    return !selectionDepth || selectionDepth > contentDepthOfRoot;
  },
  runCommand: (editorApi, initiator) => editorApi.chain().focus().unsetMark(MarkTypes.LINK).updateBlockAttributes(
    {
      type: BlockTypes.TASK_EDITABLE
    },
    initiator === "drag-handle-menu" || initiator === "shortcut" ? { turnIntoCardLink: true } : {}
  ).run()
};
const QuoteBlockConfig = {
  type: BlockTypes.BLOCKQUOTE,
  title: "Quote",
  schemaType: SeshatNodes.WRAPPING_BLOCK,
  search: ["quote"],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().wrapIntoBlock({ type: BlockTypes.BLOCKQUOTE }).run()
};
const CodeBlockConfig = {
  type: BlockTypes.CODE,
  title: "Code",
  schemaType: SeshatNodes.BLOCK,
  search: ["codeblock", "code-block", "code block"],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.CODE }).run()
};
const DividerBlockConfig = {
  type: NodeViewTypes.HORIZONTAL_RULE,
  title: "Divider",
  schemaType: SeshatNodes.BLOCK,
  search: ["divider", "horizontal"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().setHorizontalRule().run()
};
const EmbedBlockConfig = {
  type: NodeViewTypes.IFRAME,
  title: "Embed",
  schemaType: NodeViewTypes.IFRAME,
  search: [
    "iframe",
    "media",
    "embed",
    "youtube",
    "twitter",
    "spotify",
    "linkedin"
  ],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().setIframe({}).run()
};
const TableOfContentBlockConfig = {
  type: NodeViewTypes.TABLE_OF_CONTENTS,
  title: "Table of contents",
  schemaType: SeshatNodes.BLOCK,
  search: ["table", "content"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().setTableOfContents().run()
};
const AddNoteBlockConfig = {
  type: BlockTypes.NOTE_EDITABLE,
  title: "Note",
  schemaType: SeshatNodes.BLOCK,
  search: ["note", "card"],
  commandsType: ["basic-node-view-content"],
  shouldBeHidden: (editorApi) => {
    const contentDepthOfRoot = SESHAT_ROOT_DEPTH + SESHAT_CONTENT_DEPTH + 1;
    const selectionDepth = editorApi == null ? void 0 : editorApi.state.selection.$from.depth;
    return !selectionDepth || selectionDepth > contentDepthOfRoot;
  },
  runCommand: (editorApi) => editorApi.chain().focus().insertBlock({
    type: BlockTypes.NOTE_EDITABLE
  }).run()
};
const NoteBlockConfig = {
  type: BlockTypes.NOTE_EDITABLE,
  title: "Note",
  schemaType: SeshatNodes.BLOCK,
  search: ["note", "card", "page"],
  commandsType: ["turn-into"],
  shouldBeHidden: (editorApi) => {
    const contentDepthOfRoot = SESHAT_ROOT_DEPTH + SESHAT_CONTENT_DEPTH + 1;
    const selectionDepth = editorApi == null ? void 0 : editorApi.state.selection.$from.depth;
    return !selectionDepth || selectionDepth > contentDepthOfRoot;
  },
  runCommand: (editorApi, initiator) => editorApi.chain().focus().unsetMark(MarkTypes.LINK).updateBlockAttributes(
    {
      type: BlockTypes.NOTE_EDITABLE
    },
    initiator === "drag-handle-menu" || initiator === "shortcut" ? { turnIntoCardLink: true } : {}
  ).run()
};
const HighlightsConfig = {
  type: BlockTypes.HIGHLIGHTS,
  title: "Highlights block",
  schemaType: SeshatNodes.WRAPPING_BLOCK,
  search: ["highlights", "block"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().insertHighlightsBlock().setMeta(RECALCULATE_PLACEHOLDER, true).run()
};
const FileBlockConfig = (previewType) => ({
  type: NodeViewTypes.FILE,
  title: capitalizeFirstLetter(previewType),
  schemaType: NodeViewTypes.FILE,
  search: ["file", previewType],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().setFile({
    previewType
  }).run()
});
const ClipBlockConfig = {
  type: BlockTypes.CLIP_CONTENT,
  title: "Clip",
  schemaType: SeshatNodes.WRAPPING_BLOCK,
  search: ["Clip"],
  commandsType: ["basic-node-view-content"],
  shouldBeHidden: (editor) => !!editor && !!findAncestor(
    editor.state.selection.$from,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.CLIP_CONTENT
  ),
  runCommand: (editorApi) => {
    return editorApi.chain().focus().wrapIntoBlock({ type: BlockTypes.CLIP_CONTENT }).setMeta(RECALCULATE_PLACEHOLDER, true).run();
  }
};
const ConnectionConfig = {
  type: SeshatInlineNodes.REFERENCE,
  title: "Make connection",
  schemaType: SeshatInlineNodes.REFERENCE,
  search: ["make connection connections"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => {
    return editorApi.chain().focus().insertMentionPlaceholder({
      type: editorApi.schema.node(DEFAULT_REFERENCE.name + "placeholder").type,
      attrs: { char: DEFAULT_REFERENCE.char }
    }).run();
  }
};
const ReferenceConfig = {
  type: SeshatInlineNodes.REFERENCE,
  title: "Tag",
  schemaType: SeshatInlineNodes.REFERENCE,
  search: ["make hashtags references tag"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => {
    return editorApi.chain().focus().insertMentionPlaceholder({
      type: editorApi.schema.node(HASH_REFERENCE.name + "placeholder").type,
      attrs: { char: HASH_REFERENCE.char }
    }).run();
  }
};
const ALL_BLOCK_COMMANDS = [
  ParagraphBlockConfig,
  HeadingBlockConfig(1),
  HeadingBlockConfig(2),
  HeadingBlockConfig(3),
  TaskBlockConfig,
  AddTaskBlockConfig,
  BulletBlockConfig,
  NumberedBlockConfig,
  CodeBlockConfig,
  NoteBlockConfig,
  QuoteBlockConfig,
  DividerBlockConfig,
  EmbedBlockConfig,
  ClipBlockConfig,
  FileBlockConfig(PreviewFile.VIDEO),
  FileBlockConfig(PreviewFile.IMAGE),
  FileBlockConfig(PreviewFile.PDF),
  FileBlockConfig(PreviewFile.FILE),
  TableOfContentBlockConfig,
  HighlightsConfig,
  ConnectionConfig,
  ReferenceConfig
];
const isBlock = (node, predicate) => {
  var _a2;
  if (!node || node.type.spec.group !== SeshatNodeGroups.BLOCK)
    return false;
  return (_a2 = predicate == null ? void 0 : predicate(node)) != null ? _a2 : true;
};
const getCurrentBlock = (doc, pos, predicate) => {
  try {
    for (let i = pos; i >= 0; i--) {
      const node = doc.nodeAt(i);
      const $i = doc.resolve(i);
      if (!isBlock(node, predicate))
        continue;
      return {
        node,
        depth: $i.depth + 1,
        from: i,
        $from: $i,
        to: i + node.nodeSize,
        $to: doc.resolve(i + node.nodeSize)
      };
    }
    return void 0;
  } catch {
    return void 0;
  }
};
const seshatBlockMarkdown = [
  {
    regexExps: [RegExp(`^(#{1,${1}})\\s$`)],
    attrs: { type: BlockTypes.HEADING_1 }
  },
  {
    regexExps: [RegExp(`^(#{1,${2}})\\s$`)],
    attrs: { type: BlockTypes.HEADING_2 }
  },
  {
    regexExps: [RegExp(`^(#{1,${3}})\\s$`)],
    attrs: { type: BlockTypes.HEADING_3 }
  },
  {
    regexExps: [/^\s*([-+*])\s$/],
    attrs: { type: BlockTypes.BULLETED_LIST },
    matchCondition: (state) => {
      var _a2;
      return ((_a2 = getCurrentBlock(state.doc, state.selection.from)) == null ? void 0 : _a2.node.attrs.type) !== BlockTypes.BULLETED_LIST;
    }
  },
  { regexExps: [/^(\d+)\.\s$/], attrs: { type: BlockTypes.NUMBERED_LIST } },
  {
    regexExps: [/^(\[\]|\[ \])/],
    attrs: { type: BlockTypes.TASK_EDITABLE, isDone: false },
    matchCondition: (state) => {
      var _a2;
      return ((_a2 = getCurrentBlock(state.doc, state.selection.from)) == null ? void 0 : _a2.$from.depth) === 1;
    }
  },
  {
    regexExps: [/^\[\S\]/],
    attrs: { type: BlockTypes.TASK_EDITABLE, isDone: true },
    matchCondition: (state) => {
      var _a2;
      return ((_a2 = getCurrentBlock(state.doc, state.selection.from)) == null ? void 0 : _a2.$from.depth) === 1;
    }
  },
  {
    regexExps: [
      /^``` $/,
      /^~~~ $/,
      /^```(?<language>[a-z]*)? $/,
      /^~~~(?<language>[a-z]*)? $/
    ],
    attrs: { type: BlockTypes.CODE }
  },
  { regexExps: [/^\s*\|\s$/gm], attrs: { type: BlockTypes.BLOCKQUOTE } },
  {
    regexExps: [/^\s*“\s$/gm, /^\s*"\s$/gm],
    attrs: { type: BlockTypes.BLOCKQUOTE }
  }
];
const YELLOW = "rgba(244, 169, 82, 0.24)";
const GroupHighlightColors = [
  {
    title: "Default",
    color: "inherit",
    order: 1
  },
  {
    title: "Gray",
    color: "rgba(122, 122, 122, 0.24)",
    colorForIcon: "rgba(122, 122, 122, 0.64)",
    order: 2
  },
  {
    title: "Yellow",
    color: YELLOW,
    colorForIcon: "rgba(244, 169, 82, 0.64)",
    order: 5
  },
  {
    title: "Blue",
    color: "rgba(24, 149, 220, 0.24)",
    colorForIcon: "rgba(24, 149, 220, 0.64)",
    order: 6
  },
  {
    title: "Purple",
    color: "rgba(86, 44, 201, 0.24)",
    colorForIcon: "rgba(86, 44, 201, 0.64)",
    order: 8
  },
  {
    title: "Pink",
    color: "rgba(201, 44, 107, 0.24)",
    colorForIcon: "rgba(201, 44, 107, 0.64)",
    order: 9
  }
];
const GroupColors = [
  {
    title: "Default",
    color: "inherit",
    order: 1
  },
  {
    title: "Brown",
    color: "rgb(147, 114, 100)",
    order: 3
  },
  {
    title: "Orange",
    color: "rgb(255, 163, 68)",
    order: 4
  },
  {
    title: "Green",
    color: "rgb(77, 171, 154)",
    order: 7
  },
  {
    title: "Red",
    color: "rgb(255, 115, 105)",
    order: 10
  },
  {
    title: "Gray",
    color: "rgba(122, 122, 122)",
    order: 2
  },
  {
    title: "Yellow",
    color: "rgba(244, 169, 82)",
    order: 5
  },
  {
    title: "Blue",
    color: "rgba(24, 149, 220)",
    order: 6
  },
  {
    title: "Purple",
    color: "rgba(86, 44, 201)",
    order: 8
  },
  {
    title: "Pink",
    color: "rgba(201, 44, 107)",
    order: 9
  }
];
function minMax(value = 0, min = 0, max = 0) {
  return Math.min(Math.max(value, min), max);
}
const getModifiedRangeFromTransaction = (tr) => {
  let start = tr.doc.nodeSize;
  let end = 0;
  tr.mapping.maps.forEach((stepMap, index) => {
    stepMap.forEach((from, to) => {
      const newStart = tr.mapping.slice(index).map(from, -1);
      const newEnd = tr.mapping.slice(index).map(to);
      if (newStart < start)
        start = newStart;
      if (newEnd > end)
        end = newEnd;
    });
  });
  return { start, end };
};
const getModifiedStartAndEnd = (trs) => {
  if (!trs.some((tr) => tr.docChanged))
    return { start: void 0, end: void 0 };
  const currentDoc = trs[trs.length - 1].doc;
  let finalStart = currentDoc.content.size;
  let finalEnd = 0;
  trs.forEach((tr) => {
    const { start, end } = getModifiedRangeFromTransaction(tr);
    if (start < finalStart)
      finalStart = start;
    if (end > finalEnd)
      finalEnd = end;
  });
  return {
    start: minMax(finalStart, 0, currentDoc.content.size),
    end: minMax(finalEnd, 0, currentDoc.content.size)
  };
};
const unwrapBlockColumns = (tr, columns) => {
  columns.reverse().forEach(({ node, pos }) => {
    const $columnContentStart = tr.doc.resolve(pos + 1);
    const $columnContentEnd = tr.doc.resolve(pos + node.nodeSize - 1);
    const range = $columnContentStart.blockRange($columnContentEnd);
    if (range)
      tr.lift(range, tr.doc.resolve(pos).depth);
  });
  return tr;
};
const isBlockLine = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_LINE;
const findBlockLines = (doc, range) => {
  return range ? findChildrenInRange(doc, range, isBlockLine) : findChildren(doc, isBlockLine);
};
const BlockColumnObserverPluginKey = new PluginKey("blockColumnObserverPlugin");
const blockColumnObserverPlugin = new Plugin({
  key: BlockColumnObserverPluginKey,
  appendTransaction(trs, oldState, newState) {
    if (oldState.doc.eq(newState.doc))
      return;
    const { start, end } = getModifiedStartAndEnd(trs);
    if (start === void 0 || end === void 0)
      return;
    const blockColumns = findOrphanedBlockColumns(newState.doc, {
      from: start,
      to: end
    });
    if (!blockColumns.length)
      return;
    return unwrapBlockColumns(newState.tr, blockColumns);
  }
});
const findOrphanedBlockColumns = (doc, range) => {
  return findChildrenInRange(
    doc,
    range,
    (node) => node.attrs.type === BlockTypes.BLOCK_COLUMN
  ).filter(({ pos }) => !findAncestor(doc.resolve(pos), isBlockLine));
};
const MAX_COLUMNS = 12;
const expandNarrowestColumn = ({
  tr,
  blockLinePos
}) => {
  const blockLine = tr.doc.nodeAt(blockLinePos);
  if (!blockLine)
    return;
  const narrowestColumn = getNarrowestColumn(blockLine);
  const leftoverWidth = getLeftoverWidth(blockLine);
  if (!narrowestColumn)
    return;
  return tr.setNodeMarkup(
    blockLinePos + narrowestColumn.offset + 1,
    void 0,
    {
      ...narrowestColumn.node.attrs,
      width: narrowestColumn.node.attrs.width + leftoverWidth
    }
  );
};
const getLeftoverWidth = (blockLine) => {
  let leftoverWidth = MAX_COLUMNS;
  blockLine.content.forEach((columnNode) => {
    const columnWidth = columnNode.attrs.width;
    leftoverWidth -= columnWidth;
  });
  return leftoverWidth;
};
const getNarrowestColumn = (blockLine) => {
  let narrowestColumn;
  blockLine.content.forEach((node, offset) => {
    if (!narrowestColumn || narrowestColumn.node.attrs.width > node.attrs.width) {
      narrowestColumn = { node, offset };
    }
  });
  return narrowestColumn;
};
const maybeDeleteEmptyColumns = (tr) => {
  const blockLines = findBlockLines(tr.doc);
  const emptyColumns = getAllEmptyBlockColumns(blockLines);
  if (!emptyColumns.length)
    return;
  emptyColumns.forEach(({ node, pos }) => {
    var _a2, _b2;
    const width = node.attrs.width;
    tr.delete(pos, pos + node.nodeSize);
    if (width) {
      const blockLinePos = (_a2 = getParentBlockLine(tr.doc, pos)) == null ? void 0 : _a2.pos;
      if (!blockLinePos)
        return;
      tr = (_b2 = expandNarrowestColumn({ tr, blockLinePos })) != null ? _b2 : tr;
    }
  });
  return tr;
};
const getAllEmptyBlockColumns = (blockLines) => {
  const emptyColumns = [];
  blockLines.forEach(({ node, pos }) => {
    node.content.forEach((columnNode, columnOffset) => {
      if (columnNode.childCount === 0)
        emptyColumns.unshift({ node: columnNode, pos: pos + columnOffset + 1 });
    });
  });
  return emptyColumns;
};
const getParentBlockLine = (doc, pos) => {
  const $pos = doc.resolve(pos);
  const blockLine = findAncestor(
    $pos,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_LINE
  );
  return blockLine ? { node: blockLine.node, pos: $pos.before(blockLine.depth) } : void 0;
};
const maybeUnwrapBlockLinesWithOneColumn = (tr) => {
  const blockLines = findBlockLines(tr.doc);
  const singleColumnBlockLines = getBlockLinesWithOneColumn(blockLines);
  if (!singleColumnBlockLines.length)
    return;
  singleColumnBlockLines.reverse().forEach(({ node, pos }) => {
    const $columnContentStart = tr.doc.resolve(pos + 2);
    const $columnContentEnd = tr.doc.resolve(pos + node.nodeSize - 2);
    const range = $columnContentStart.blockRange($columnContentEnd);
    if (range)
      tr.lift(range, tr.doc.resolve(pos).depth);
  });
  return tr;
};
const getBlockLinesWithOneColumn = (blockLines) => {
  return blockLines.filter(({ node }) => node.childCount === 1);
};
const getNearestSeshatBlockOfType = ({
  doc,
  pos,
  type
}) => {
  var _a2;
  for (let i = pos; i >= 0; i--) {
    let node = doc.nodeAt(i);
    if (((_a2 = node == null ? void 0 : node.attrs) == null ? void 0 : _a2.type) === type)
      return { node, pos: i };
  }
  return;
};
const containsChildCountChange = ({
  trs,
  oldState,
  newState
}) => {
  let changedBlockLine;
  const containsChange = trs.some(
    (tr) => tr.steps.some((step) => {
      if (!isReplaceStepWithinDoc(oldState, step))
        return false;
      const { from } = step;
      const oldBlockLine = getNearestSeshatBlockOfType({
        doc: oldState.doc,
        pos: getPosLimitedToDocSize({ state: oldState, from }),
        type: BlockTypes.BLOCK_LINE
      });
      const newBlockLine = getNearestSeshatBlockOfType({
        doc: newState.doc,
        pos: getPosLimitedToDocSize({ state: newState, from }),
        type: BlockTypes.BLOCK_LINE
      });
      const childCountChanged = (oldBlockLine == null ? void 0 : oldBlockLine.node.childCount) !== (newBlockLine == null ? void 0 : newBlockLine.node.childCount);
      if (!oldBlockLine || !newBlockLine || !childCountChanged)
        return false;
      const wasColumnInserted = oldBlockLine.node.childCount < newBlockLine.node.childCount;
      changedBlockLine = {
        ...newBlockLine,
        columnInsertedAtPos: wasColumnInserted ? from : void 0
      };
      return true;
    })
  );
  return { containsChange, changedBlockLine };
};
const isReplaceStepWithinDoc = (oldState, step) => {
  return step instanceof ReplaceStep && step.from < oldState.doc.nodeSize - SESHAT_CONTENT_DEPTH;
};
const DOC_MARGE_SIZE = 2;
const getPosLimitedToDocSize = ({
  state,
  from
}) => state.doc.nodeSize - 2 < from ? state.doc.nodeSize - DOC_MARGE_SIZE : from;
const shrinkWidestColumn = ({
  tr,
  blockLinePos
}) => {
  const blockLine = tr.doc.nodeAt(blockLinePos);
  if (!blockLine)
    return;
  const widestColumn = getWidestColumn(blockLine);
  const insertedColumn = getInsertedColumn(blockLine);
  if (!widestColumn || !insertedColumn)
    return;
  const insertedColumnWidth = Math.round(widestColumn.node.attrs.width / 2);
  return tr.setNodeMarkup(blockLinePos + insertedColumn.offset + 1, void 0, {
    ...insertedColumn.node.attrs,
    width: insertedColumnWidth
  }).setNodeMarkup(blockLinePos + widestColumn.offset + 1, void 0, {
    ...widestColumn.node.attrs,
    width: widestColumn.node.attrs.width - insertedColumnWidth
  });
};
const getWidestColumn = (blockLine) => {
  let widestColumn;
  blockLine.content.forEach((node, offset) => {
    if (!node.attrs.width)
      return;
    if (!widestColumn || widestColumn.node.attrs.width < node.attrs.width) {
      widestColumn = { node, offset };
    }
  });
  return widestColumn;
};
const getInsertedColumn = (blockLine) => {
  let insertedColumn;
  blockLine.content.forEach((node, offset) => {
    if (!node.attrs.width) {
      insertedColumn = { node, offset };
    }
  });
  return insertedColumn;
};
const maybeUpdateColumnWidths = (trs, oldState, state) => {
  const { containsChange, changedBlockLine } = containsChildCountChange({
    trs,
    oldState,
    newState: state
  });
  if (!containsChange || !changedBlockLine || !hasFixedWidthColumns(changedBlockLine.node))
    return;
  const { pos: blockLinePos, columnInsertedAtPos } = changedBlockLine;
  if (columnInsertedAtPos) {
    return shrinkWidestColumn({ tr: state.tr, blockLinePos });
  } else {
    return expandNarrowestColumn({ tr: state.tr, blockLinePos });
  }
};
const hasFixedWidthColumns = (blockLineNode) => {
  var _a2, _b2;
  return ((_a2 = blockLineNode == null ? void 0 : blockLineNode.firstChild) == null ? void 0 : _a2.attrs.width) || ((_b2 = blockLineNode.lastChild) == null ? void 0 : _b2.attrs.width);
};
const BlockLineObserverPluginKey = new PluginKey("blockLineObserverPlugin");
const blockLineObserverPlugin = new Plugin({
  key: BlockLineObserverPluginKey,
  appendTransaction(trs, oldState, newState) {
    if (oldState.doc.eq(newState.doc))
      return;
    const { start, end } = getModifiedStartAndEnd(trs);
    if (start === void 0 || end === void 0)
      return;
    const blockLines = findBlockLines(newState.doc, { from: start, to: end });
    if (!blockLines.length)
      return;
    let tr = maybeUpdateColumnWidths(trs, oldState, newState);
    const deleteColumnTr = maybeDeleteEmptyColumns(tr != null ? tr : newState.tr);
    if (deleteColumnTr)
      tr = deleteColumnTr;
    const unwrapTr = maybeUnwrapBlockLinesWithOneColumn(tr != null ? tr : newState.tr);
    if (unwrapTr)
      tr = unwrapTr;
    return tr;
  }
});
const BlockLineBlock = Extension.create({
  name: BlockTypes.BLOCK_LINE,
  onCreate() {
    const { state } = this.editor;
    const blockLines = findBlockLines(state.doc);
    if (!blockLines.length)
      return;
    let tr = maybeDeleteEmptyColumns(state.tr);
    const unwrapTr = maybeUnwrapBlockLinesWithOneColumn(tr != null ? tr : state.tr);
    if (unwrapTr)
      tr = unwrapTr;
    if (tr)
      this.editor.view.dispatch(tr);
  },
  addProseMirrorPlugins() {
    return [blockLineObserverPlugin, blockColumnObserverPlugin];
  }
});
const isBlockCollapsible = (node) => {
  return [
    BlockTypes.CARD_CONTENT,
    BlockTypes.BULLETED_LIST,
    BlockTypes.HIGHLIGHTS
  ].includes(node.attrs.type);
};
const isBlockCollapsed = (node) => {
  return !!node && isBlockCollapsible(node) && !!node.attrs.collapsed;
};
const shortcutConfig = {
  strikethrough: "Mod-Shift-s",
  lastUsedColor: "Mod-Alt-c",
  highlight: "Mod-Shift-h",
  moveUp: "Mod-Shift-ArrowUp",
  moveDown: "Mod-Shift-ArrowDown",
  selectAll: "Mod-a",
  selectPrevBlock: "ArrowUp",
  selectNextBlock: "ArrowDown",
  expandPrevBlock: "Shift-ArrowUp",
  expandNextBlock: "Shift-ArrowDown",
  link: "Mod-k",
  undo: "Mod-y",
  redo: "Mod-Shift-y",
  markAsDone: "e",
  markAsUndone: "Shift-e"
};
const seshatBlockShortcut = [
  { keys: "Mod-Alt-0", type: BlockTypes.PARAGRAPH },
  { keys: "Mod-Alt-1", type: BlockTypes.HEADING_1 },
  { keys: "Mod-Alt-2", type: BlockTypes.HEADING_2 },
  { keys: "Mod-Alt-3", type: BlockTypes.HEADING_3 },
  { keys: "Mod-Alt-4", type: BlockTypes.TASK_EDITABLE },
  { keys: "Mod-Alt-5", type: BlockTypes.BULLETED_LIST },
  { keys: "Mod-Alt-6", type: BlockTypes.NUMBERED_LIST },
  { keys: "Mod-Alt-7", type: BlockTypes.CODE },
  { keys: "Mod-Alt-8", type: BlockTypes.BLOCKQUOTE },
  { keys: "Mod-Alt-9", type: BlockTypes.NOTE_EDITABLE }
];
class BlockSelectionBookmark {
  constructor(from, to) {
    this.from = from;
    this.to = to;
  }
  map(mapping) {
    return new BlockSelectionBookmark(
      mapping.map(this.from),
      mapping.map(this.to)
    );
  }
  resolve(doc) {
    return BlockSelection.createFromRange(doc, this.from, this.to);
  }
}
class BlockSelection extends Selection {
  constructor($anchor, $head) {
    super($anchor, $head);
    this.$anchor = $anchor;
    this.$head = $head;
  }
  eq(other) {
    if (!(other instanceof BlockSelection))
      return false;
    return other.$head.pos === this.$head.pos && other.$anchor.pos === this.$anchor.pos;
  }
  toJSON() {
    return {
      type: "block",
      anchor: this.anchor,
      head: this.head
    };
  }
  static fromJSON(doc, json2) {
    if (typeof json2.anchor != "number" || typeof json2.head != "number")
      throw new RangeError("Invalid input for BlockSelection.fromJSON");
    return new BlockSelection(doc.resolve(json2.anchor), doc.resolve(json2.head));
  }
  getBookmark() {
    return new BlockSelectionBookmark(this.from, this.to);
  }
  map(doc, mapping) {
    const $anchor = doc.resolve(mapping.map(this.anchor));
    const $head = doc.resolve(mapping.map(this.head));
    return new BlockSelection($anchor, $head);
  }
  listPositions() {
    const doc = this.$head.doc;
    const positions = [];
    for (let pos = this.from; pos < this.to; pos++) {
      const node = doc.nodeAt(pos);
      if ((node == null ? void 0 : node.type.spec.group) === SeshatNodeGroups.BLOCK) {
        positions.push(pos);
      }
    }
    return positions;
  }
  firstBlock() {
    return this.list()[0];
  }
  lastBlock() {
    const list = this.list();
    return list[list.length - 1];
  }
  list() {
    const doc = this.$head.doc;
    const blockList = this.listPositions().map((pos) => {
      const node = doc.nodeAt(pos);
      const $pos = doc.resolve(pos);
      if (!node)
        return void 0;
      return {
        node,
        from: pos,
        $from: doc.resolve(pos),
        to: pos + node.nodeSize,
        $to: doc.resolve(pos + node.nodeSize),
        depth: $pos.depth + 1
      };
    }).filter((item) => item !== void 0);
    const minDepth = blockList.reduce(
      (cur, next) => next.depth < cur ? next.depth : cur,
      Number.MAX_SAFE_INTEGER
    );
    return blockList.filter((block) => block.depth === minDepth);
  }
  getFragment() {
    return this.list().reduce((fragment, block) => {
      return fragment.append(Fragment.from(block.node));
    }, Fragment.from());
  }
  static createFromPositions(doc, blocksPositions) {
    const sortedBlocksPositions = blocksPositions.slice().filter((pos) => pos !== 0).sort((a, b) => a > b ? 1 : -1);
    if (!blocksPositions.length)
      return new this(doc.resolve(0), doc.resolve(0));
    const anchor = sortedBlocksPositions[0];
    if (!anchor)
      return new this(doc.resolve(0), doc.resolve(0));
    const head = Math.max(
      ...sortedBlocksPositions.map(
        (pos) => {
          var _a2, _b2;
          return pos + ((_b2 = (_a2 = doc.nodeAt(pos)) == null ? void 0 : _a2.nodeSize) != null ? _b2 : 0);
        }
      )
    );
    const $anchor = doc.resolve(anchor);
    const $head = doc.resolve(head);
    return new this($anchor, $head);
  }
  static createFromRange(doc, from, to) {
    return new BlockSelection(doc.resolve(from), doc.resolve(to));
  }
  static createFromPosition(doc, pos) {
    const block = getCurrentBlock(doc, pos);
    if (!block)
      throw new Error("position is not valid");
    return new BlockSelection(block.$from, block.$to);
  }
  static createFromTextSelection(doc, textSelection) {
    var _a2, _b2;
    const firstBlockDepth = (_a2 = getCurrentBlock(doc, textSelection.from)) == null ? void 0 : _a2.depth;
    const lastBlockDepth = (_b2 = getCurrentBlock(doc, textSelection.to)) == null ? void 0 : _b2.depth;
    return BlockSelection.createFromRange(
      doc,
      textSelection.$from.before(firstBlockDepth),
      textSelection.$to.after(lastBlockDepth)
    );
  }
}
function isBlockSelection(value) {
  return !!value && value instanceof BlockSelection;
}
const isSelectableBlock = (node) => {
  if (excludedFromBlockSelection.includes(node.attrs.type))
    return false;
  return true;
};
const isSelectableBlockInReadView = (node) => {
  const extendedBlacklist = [
    ...excludedFromBlockSelection,
    BlockTypes.BLOCK_LINE,
    BlockTypes.BLOCKQUOTE,
    BlockTypes.CLIP_CONTENT_TITLE,
    BlockTypes.NODE_VIEW
  ];
  if (extendedBlacklist.includes(node.attrs.type))
    return false;
  return true;
};
const countLeaves = (content) => {
  return content.reduce((acc, node) => {
    if (node.content) {
      return acc + countLeaves(node.content);
    }
    return acc + 1;
  }, 0);
};
const findChildByBlockId = ({
  parentNode,
  blockId
}) => {
  let childIndex = -1;
  if (!blockId)
    return { index: childIndex, node: null };
  parentNode.content.content.some((node, index) => {
    if (node.attrs[BlockAttrsParams.BLOCK_UUID] === blockId) {
      childIndex = index;
      return true;
    }
    return false;
  });
  return {
    index: childIndex,
    node: childIndex !== -1 ? parentNode.content.child(childIndex) : null
  };
};
const generateEmptyBlock = (attrs) => {
  var _a2;
  return {
    type: SeshatNodes.BLOCK,
    content: [
      {
        type: SeshatNodes.BLOCK_CONTENT,
        content: [
          {
            type: SeshatNodes.CONTENT
          }
        ]
      }
    ],
    attrs: {
      type: (_a2 = attrs == null ? void 0 : attrs.type) != null ? _a2 : BlockTypes.PARAGRAPH,
      ...attrs
    }
  };
};
const generateParagraph = ({
  content,
  children,
  attrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    ...attrs,
    type: "paragraph"
  },
  content: children != null ? children : [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT,
          content: content != null ? content : [
            {
              type: "text",
              text: "Hello, I am a default Seshat Block"
            }
          ]
        }
      ]
    }
  ]
});
const generateBulletedList = ({
  content,
  children,
  attrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    ...attrs,
    type: "bulletedList"
  },
  content: children != null ? children : [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT,
          content: content != null ? content : [
            {
              type: "text",
              text: "Hello, I am a bulletedList Seshat Block"
            }
          ]
        }
      ]
    }
  ]
});
const generateCapture = ({
  children,
  attrs
} = {}) => ({
  attrs: {
    ...attrs,
    type: BlockTypes.CAPTURE
  },
  content: children != null ? children : [],
  type: SeshatNodes.WRAPPING_BLOCK
});
const generateNote = ({
  content,
  children,
  attrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    isDone: 0,
    ...attrs,
    type: BlockTypes.CARD_CONTENT,
    cardType: "note"
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT,
          content: content != null ? content : [
            {
              type: "text",
              text: "Card Title"
            }
          ]
        }
      ]
    },
    ...children != null ? children : []
  ]
});
const generateTask = ({
  content,
  children,
  attrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    isDone: 0,
    ...attrs,
    type: BlockTypes.CARD_CONTENT,
    cardType: "task"
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT,
          content: content != null ? content : [
            {
              type: "text",
              text: "Card Title"
            }
          ]
        }
      ]
    },
    ...children != null ? children : []
  ]
});
const generateEditable = ({
  attrs,
  content
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    ...attrs
  },
  content: [
    {
      type: "seshatBlockContent",
      content: [
        {
          type: "seshatContent",
          content: content != null ? content : [
            {
              type: "text",
              text: "Editable Name"
            }
          ]
        }
      ]
    }
  ]
});
const generateHighlights = ({
  attrs,
  children
} = {}) => ({
  type: SeshatNodes.WRAPPING_BLOCK,
  attrs: {
    connectedClip: "clipId1",
    ...attrs,
    type: BlockTypes.HIGHLIGHTS
  },
  content: children != null ? children : []
});
const generateHighlightWithNote = ({
  attrs,
  children,
  highlightChildren,
  highlightNoteChildren
} = {}) => ({
  type: SeshatNodes.WRAPPING_BLOCK,
  attrs: {
    ...attrs,
    type: BlockTypes.HIGHLIGHT
  },
  content: children != null ? children : [
    {
      type: SeshatNodes.WRAPPING_BLOCK,
      attrs: { type: BlockTypes.BLOCKQUOTE },
      content: highlightChildren != null ? highlightChildren : [generateParagraph()]
    },
    {
      type: SeshatNodes.WRAPPING_BLOCK,
      attrs: { type: BlockTypes.HIGHLIGHT_NOTE },
      content: highlightNoteChildren != null ? highlightNoteChildren : [generateParagraph()]
    }
  ]
});
const generateClipBookmark = ({
  attrs,
  content,
  children,
  bookmarkAttrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    ...attrs,
    nodeViewType: NodeViewTypes.CLIP_BOOKMARK,
    type: BlockTypes.NODE_VIEW
  },
  content: children != null ? children : [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT_NODE_VIEW,
          content: content != null ? content : [
            {
              type: NodeViewTypes.CLIP_BOOKMARK,
              attrs: {
                title: "Bookmark Title",
                href: "https://www.google.com",
                highlights: void 0,
                ...bookmarkAttrs
              }
            }
          ]
        }
      ]
    }
  ]
});
const generateClipContent = ({
  attrs,
  children
}) => ({
  type: SeshatNodes.WRAPPING_BLOCK,
  attrs: {
    ...attrs,
    type: BlockTypes.CLIP_CONTENT
  },
  content: children != null ? children : [
    {
      type: SeshatNodes.BLOCK,
      attrs: {
        type: BlockTypes.PARAGRAPH
      },
      content: [
        {
          type: SeshatNodes.BLOCK_CONTENT,
          content: [
            {
              type: SeshatNodes.CONTENT,
              content: []
            }
          ]
        }
      ]
    }
  ]
});
const generateHorizontalRule = ({
  attrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    ...attrs,
    type: BlockTypes.NODE_VIEW
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT_NODE_VIEW,
          content: [
            {
              type: NodeViewTypes.HORIZONTAL_RULE
            }
          ]
        }
      ]
    }
  ]
});
const getBlocksOfType = ({
  content,
  includeInType
}) => {
  return (content == null ? void 0 : content.reduce((result, node) => {
    var _a2;
    if (node.attrs && node.attrs["type"] && ((_a2 = node.attrs) == null ? void 0 : _a2.type.includes(includeInType))) {
      return [...result, node];
    }
    if (!node.content)
      return result;
    return [
      ...result,
      ...getBlocksOfType({
        content: node.content.content,
        includeInType
      })
    ];
  }, [])) || [];
};
const getCardUuid = (editor, isReadLater = false) => {
  const capture = editor.state.doc.firstChild;
  return isReadLater ? capture == null ? void 0 : capture.attrs.parentCardUuid : capture == null ? void 0 : capture.attrs[BlockAttrsParams.BLOCK_UUID];
};
const getNearestClip = ({ doc, from }) => {
  for (let i = from; i <= doc.nodeSize - SESHAT_CONTENT_DEPTH; i++) {
    const node = doc.nodeAt(i);
    if (isSeshatBlockClip$1(node)) {
      return { node, pos: i };
    }
  }
  for (let i = from; i >= 0; i--) {
    const node = doc.nodeAt(i);
    if (isSeshatBlockClip$1(node)) {
      return { node, pos: i };
    }
  }
  return void 0;
};
const isSeshatBlockClip$1 = (node) => {
  var _a2;
  if ((node == null ? void 0 : node.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  const nodeType = (_a2 = node == null ? void 0 : node.attrs.nodeViewType) != null ? _a2 : node == null ? void 0 : node.attrs.type;
  return nodeType && clipBlocks.includes(nodeType);
};
const hasChildren = (node) => {
  return node.content.content.some(
    (childNode) => (childNode == null ? void 0 : childNode.type.spec.group) === SeshatNodeGroups.BLOCK
  );
};
const isContentEditableFalse = (node) => isContentEditableFalseBlockType.includes(node == null ? void 0 : node.attrs.type) || (node == null ? void 0 : node.attrs.contentEditable) === false;
const getNextBlock = (doc, pos, predicate, options) => {
  try {
    const $posBefore = doc.resolve(pos - 1);
    const blockBefore = $posBefore.before($posBefore.depth);
    const hasChildren2 = hasBlockBeforeChildren(doc, blockBefore);
    const hasSelectableChildBlocks = !!hasChildren2 && hasSelectableChildren$1(doc, blockBefore);
    const start = !(options == null ? void 0 : options.ignoreChildren) && hasSelectableChildBlocks ? blockBefore + 1 : pos;
    for (let i = start; i < doc.nodeSize - 1; i++) {
      const node = doc.nodeAt(i);
      const $i = doc.resolve(i);
      if (!isBlock(node, predicate))
        continue;
      return {
        node,
        from: i,
        to: i + node.nodeSize,
        $from: $i,
        $to: doc.resolve(i + node.nodeSize),
        depth: $i.depth
      };
    }
    return void 0;
  } catch {
    return void 0;
  }
};
const hasBlockBeforeChildren = (doc, pos) => {
  const blockBefore = doc.nodeAt(pos);
  return blockBefore && hasChildren(blockBefore);
};
const hasSelectableChildren$1 = (doc, pos) => {
  const blockBefore = doc.nodeAt(pos);
  return blockBefore && blockBefore.attrs.collapsed !== true && !isContentEditableFalse(blockBefore);
};
const getNodeTypeByBlockType = (type) => {
  if (type && SeshatWrappingBlocks.includes(type))
    return SeshatNodes.WRAPPING_BLOCK;
  else
    return SeshatNodes.BLOCK;
};
const getPreviousBlock = (doc, pos, predicate, options) => {
  try {
    const currentBlock = getCurrentBlock(doc, pos);
    if (!currentBlock)
      return void 0;
    for (let i = currentBlock.from - 1; i >= 1; i--) {
      const node = doc.nodeAt(i);
      const $i = doc.resolve(i);
      if (!isBlock(node, predicate))
        continue;
      if (isNonSelectableChildOfParent(doc, i, currentBlock.depth - 1))
        continue;
      if ((options == null ? void 0 : options.ignoreChildren) && currentBlock.depth <= $i.depth)
        continue;
      return {
        node,
        depth: $i.depth,
        from: i,
        $from: $i,
        to: i + node.nodeSize,
        $to: doc.resolve(i + node.nodeSize)
      };
    }
    return void 0;
  } catch {
    return void 0;
  }
};
const isNonSelectableChildOfParent = (doc, pos, depth) => {
  const $pos = doc.resolve(pos);
  if ($pos.depth <= depth)
    return false;
  const parentPos = $pos.before(depth + 1);
  const parent = doc.nodeAt(parentPos);
  return parent && (isContentEditableFalse(parent) || parent.attrs.collapsed === true);
};
const getSeshatBlockByBlockId = (doc, id) => {
  if (!id)
    return void 0;
  const blocks = findChildren(doc, (node) => {
    return node.attrs[BlockAttrsParams.BLOCK_UUID] === id;
  });
  return blocks.length ? blocks[0] : void 0;
};
const getSeshatContent = (block) => {
  let node = block.firstChild;
  let depth = 1;
  while (node && ![
    SeshatNodes.CONTENT_NODE_VIEW,
    SeshatNodes.CONTENT
  ].includes(node == null ? void 0 : node.type.name)) {
    node = node.firstChild;
    depth++;
  }
  return { node, depth };
};
const isRootBlock = (node) => {
  var _a2, _b2;
  return (node == null ? void 0 : node.type.name) === SeshatNodes.BLOCK && ((_a2 = node == null ? void 0 : node.attrs) == null ? void 0 : _a2.type) === BlockTypes.CARD_CONTENT || (node == null ? void 0 : node.type.name) === SeshatNodes.WRAPPING_BLOCK && ((_b2 = node == null ? void 0 : node.attrs) == null ? void 0 : _b2.type) === BlockTypes.CAPTURE;
};
const isRootBlockJSON = (nodeJson) => {
  var _a2, _b2;
  return (nodeJson == null ? void 0 : nodeJson.type) === SeshatNodes.BLOCK && ((_a2 = nodeJson == null ? void 0 : nodeJson.attrs) == null ? void 0 : _a2.type) === BlockTypes.CARD_CONTENT || (nodeJson == null ? void 0 : nodeJson.type) === SeshatNodes.WRAPPING_BLOCK && ((_b2 = nodeJson == null ? void 0 : nodeJson.attrs) == null ? void 0 : _b2.type) === BlockTypes.CAPTURE;
};
const isParentRootBlock = ({
  $from,
  blockDepth
}) => {
  const parent = $from.node(blockDepth);
  const parentStart = $from.start(blockDepth);
  return isRootBlock(parent) && parentStart === 1;
};
const isSeshatBlockEmpty = (node) => {
  return (node == null ? void 0 : node.type.spec.group) === SeshatNodeGroups.BLOCK && node.nodeSize <= 6;
};
const formatContentNotACard = (content) => {
  if (isRootBlockJSON(content[0]))
    return content;
  return [
    {
      type: SeshatNodes.WRAPPING_BLOCK,
      attrs: {
        type: BlockTypes.CAPTURE
      },
      content
    }
  ];
};
const formatParallelSeshatBlock = (content) => {
  var _a2;
  if (content.length <= 1 || !isRootBlockJSON(content[0]))
    return content;
  const firstElement = content.shift();
  return [
    { ...firstElement, content: [...(_a2 = firstElement.content) != null ? _a2 : [], ...content] }
  ];
};
const verifyRootBlock = pipe(
  formatParallelSeshatBlock,
  formatContentNotACard
);
const turnBlockIntoNote = (block) => {
  var _a2, _b2, _c2, _d2;
  const isWrappingBlock2 = block.type === SeshatNodes.WRAPPING_BLOCK;
  if (isWrappingBlock2) {
    const firstBlockContent = (_b2 = (_a2 = block.content) == null ? void 0 : _a2[0].content) == null ? void 0 : _b2[0];
    const remainingChildren = (_d2 = (_c2 = block.content) == null ? void 0 : _c2.slice(1)) != null ? _d2 : [];
    return {
      type: SeshatNodes.BLOCK,
      attrs: {
        ...block.attrs,
        type: BlockTypes.CARD_CONTENT,
        cardType: CARD_NOTE_TYPE
      },
      content: firstBlockContent ? [firstBlockContent, ...remainingChildren] : remainingChildren
    };
  } else {
    return {
      type: SeshatNodes.BLOCK,
      attrs: {
        ...block.attrs,
        type: BlockTypes.CARD_CONTENT,
        cardType: CARD_NOTE_TYPE
      },
      content: block.content
    };
  }
};
const createSeshatBlock = ({
  attrs = { type: BlockTypes.PARAGRAPH },
  content,
  schema,
  children = []
}) => {
  var _a2, _b2, _c2, _d2;
  let _content = content;
  if (typeof _content === "string") {
    _content = _content !== "" ? schema.text(_content) : void 0;
  }
  const nodeType = getNodeTypeByBlockType(attrs.type);
  if (nodeType === SeshatNodes.WRAPPING_BLOCK) {
    return (_a2 = schema.nodes[SeshatNodes.WRAPPING_BLOCK]) == null ? void 0 : _a2.create({ ...attrs }, [
      ...children
    ]);
  }
  const seshatContent = (_b2 = schema.nodes[SeshatNodes.CONTENT]) == null ? void 0 : _b2.create(
    {},
    _content
  );
  const seshatBlockContent = (_c2 = schema.nodes[SeshatNodes.BLOCK_CONTENT]) == null ? void 0 : _c2.create(
    {},
    seshatContent
  );
  return (_d2 = schema.nodes[SeshatNodes.BLOCK]) == null ? void 0 : _d2.create({ ...attrs }, [
    seshatBlockContent,
    ...children
  ]);
};
const isEmptyNode = (node) => {
  var _a2;
  if (node.content) {
    return node.content.every((child) => isEmptyNode(child));
  }
  return !((_a2 = node.text) == null ? void 0 : _a2.length);
};
const LARGE_DOCUMENT_LEAVES_COUNT = 100;
const isLargeDocument = (content) => countLeaves(content) >= LARGE_DOCUMENT_LEAVES_COUNT;
const findFirst = (content, matches) => {
  var _a2;
  for (const node of content) {
    const match = matches(node) ? node : findFirst((_a2 = node.content) != null ? _a2 : [], matches);
    if (match)
      return match;
  }
  return void 0;
};
const insertTrailingLine = (props) => ({ state, dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(insertTrailingLineTransaction({ state, tr, ...props }));
  return true;
};
const insertTrailingLineTransaction = ({
  tr,
  state,
  withoutSetSelection
}) => {
  const newParagraphBlock = createSeshatBlock({ schema: state.schema });
  const insertPos = tr.doc.content.size - SESHAT_ROOT_DEPTH;
  tr.insert(insertPos, newParagraphBlock);
  if (!withoutSetSelection) {
    const caretPos = insertPos + SESHAT_CONTENT_DEPTH;
    tr.setSelection(TextSelection.create(tr.doc, caretPos)).scrollIntoView();
  }
  return tr;
};
const findBlockAtMousePosition = (view, event) => {
  const { doc } = view.state;
  const pos = view.posAtCoords({ left: event.clientX, top: event.clientY });
  const isPosInsideEditor = (pos == null ? void 0 : pos.pos) && (pos == null ? void 0 : pos.inside) !== -1;
  if (!isPosInsideEditor)
    return findNearestBlockInsideEditor(view, event);
  const $block = getCurrentBlock(doc, pos.pos);
  if (!$block)
    return void 0;
  return {
    $block,
    clientX: event.clientX,
    clientY: event.clientY,
    isOutsideEditor: false
  };
};
const findNearestBlockInsideEditor = (view, event) => {
  var _a2, _b2, _c2;
  const { doc } = view.state;
  const editorRect = view.dom.getBoundingClientRect();
  const { paddingLeft, paddingRight } = window.getComputedStyle(view.dom);
  const rightBoundary = editorRect.right - parseInt(paddingRight, 10);
  const leftBoundary = editorRect.left + parseInt(paddingLeft, 10) * 0.6;
  if (event.clientX > rightBoundary) {
    const left = event.clientX - 50;
    const pos = (_a2 = view.posAtCoords({ left, top: event.clientY })) == null ? void 0 : _a2.pos;
    const $block = pos && getCurrentBlock(doc, pos);
    if (!$block)
      return void 0;
    return {
      $block,
      clientX: event.clientX,
      clientY: event.clientY,
      isOutsideEditor: "right"
    };
  }
  if (event.clientX < leftBoundary) {
    const left = event.clientX + 50;
    const pos = (_b2 = view.posAtCoords({ left, top: event.clientY })) == null ? void 0 : _b2.pos;
    const $block = pos && getCurrentBlock(doc, pos);
    if (!$block)
      return void 0;
    return {
      $block,
      clientX: event.clientX,
      clientY: event.clientY,
      isOutsideEditor: "left"
    };
  }
  const editorContentLeft = editorRect.left + parseInt(paddingLeft, 10);
  if (leftBoundary < event.clientX && event.clientX < editorContentLeft) {
    const left = event.clientX + 50;
    const pos = (_c2 = view.posAtCoords({ left, top: event.clientY })) == null ? void 0 : _c2.pos;
    const $block = pos && getCurrentBlock(doc, pos);
    if (!$block)
      return void 0;
    return {
      $block,
      clientX: event.clientX,
      clientY: event.clientY
    };
  }
  return void 0;
};
const findNextCaretPosition = (doc, pos) => {
  if (pos > doc.content.size - SESHAT_ROOT_DEPTH)
    return void 0;
  if (pos < 0)
    return findNextCaretPosition(doc, SESHAT_ROOT_DEPTH);
  const next = Selection.findFrom(doc.resolve(pos), 1);
  if (next && doc.resolve(next.from).parent.type.name !== SeshatNodes.CONTENT)
    return findNextCaretPosition(doc, next.to + 1);
  return next ? next.from : void 0;
};
const getBlocksInRange = (state, range) => {
  return BlockSelection.createFromTextSelection(
    state.doc,
    TextSelection.create(state.doc, range.from, range.to)
  ).list().map((block) => ({
    node: block.node.toJSON(),
    from: block.from,
    to: block.to
  }));
};
const getFromNToFromRange = (ranges) => {
  const from = Math.min(...ranges.map((range) => range.$from.pos));
  const to = Math.max(...ranges.map((range) => range.$to.pos));
  return { from, to };
};
const isRangeTextSelected = (editorState) => {
  const { selection, doc } = editorState;
  const { ranges, empty } = selection;
  const from = Math.min(...ranges.map((range) => range.$from.pos));
  const to = Math.max(...ranges.map((range) => range.$to.pos));
  if (from === to)
    return false;
  const isTextSelected = doc.textBetween(from, to).length > 0 && selection instanceof TextSelection;
  if (empty || !isTextSelected)
    return false;
  return true;
};
const getSeshatEditorSchema = (extensionOptions) => {
  return getSchema(getEditorExtensions({ extensionOptions }));
};
class TextSerializer {
  constructor(schema) {
    this.schema = schema || getSeshatEditorSchema();
  }
  serializeContent(json2, options) {
    const fragment = Fragment.fromJSON(this.schema, json2);
    return this.serializeFragment(fragment, options);
  }
  serializeFragment(fragment, options) {
    try {
      const { blockSeparator = "\n\n" } = options || {};
      const capture = this.schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
        { type: BlockTypes.CAPTURE },
        fragment.content
      );
      return getText$1(capture, {
        blockSeparator,
        textSerializers: getTextSerializersFromSchema(this.schema)
      });
    } catch (e) {
      return "";
    }
  }
}
const getSelectionText = (state) => {
  const serializer = new TextSerializer(state.schema);
  const selectedContent = state.selection.content().content;
  return selectedContent ? serializer.serializeFragment(selectedContent) : "";
};
const setCaretNearby = (props) => ({
  state,
  dispatch,
  tr
}) => {
  dispatch == null ? void 0 : dispatch(setCaretNearbyTransaction({ state, tr, ...props }));
  return true;
};
const setCaretNearbyTransaction = ({
  tr,
  pos,
  state
}) => {
  const caretPos = findNextCaretPosition(tr.doc, pos);
  if (!caretPos)
    return insertTrailingLineTransaction({ state, tr });
  return tr.setSelection(TextSelection.create(tr.doc, caretPos)).scrollIntoView();
};
const deleteBlockSelection = () => ({
  state,
  tr,
  dispatch
}) => {
  const { selection, doc } = state;
  if (!isBlockSelection(selection))
    return false;
  const rangeToDelete = { from: selection.from, to: selection.to };
  while (containsAllContentOfWrappingBlock({ doc, range: rangeToDelete })) {
    rangeToDelete.from--;
    rangeToDelete.to++;
  }
  tr.delete(rangeToDelete.from, rangeToDelete.to);
  const caretPos = state.selection.from;
  tr = setCaretNearbyTransaction({ state, tr, pos: caretPos });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const containsAllContentOfWrappingBlock = ({
  doc,
  range
}) => {
  if (range.from <= 1)
    return false;
  const nodeBefore = doc.nodeAt(range.from - 1);
  if ((nodeBefore == null ? void 0 : nodeBefore.type.name) !== SeshatNodes.WRAPPING_BLOCK)
    return false;
  if ((nodeBefore == null ? void 0 : nodeBefore.attrs.type) === BlockTypes.HIGHLIGHTS)
    return false;
  return range.to === range.from + nodeBefore.content.size;
};
const getNodeFromPosition = (state, position) => {
  const $pos = state.doc.resolve(position);
  const { parent, parentOffset } = $pos;
  return { ...parent.childAfter(parentOffset), parentOffset };
};
const getAllEditors = () => {
  return [...document.querySelectorAll(".ProseMirror")];
};
const getEditorApi = (editorId) => {
  var _a2, _b2;
  let editorElement;
  if (editorId) {
    editorElement = document.getElementById(editorId);
  } else {
    const selection = (_b2 = (_a2 = window.getSelection()) == null ? void 0 : _a2.anchorNode) == null ? void 0 : _b2.parentElement;
    editorElement = selection == null ? void 0 : selection.closest(".ProseMirror");
  }
  return editorElement == null ? void 0 : editorElement.editor;
};
const getEditorId = (editor) => {
  var _a2;
  return (_a2 = editor.options.editorProps.attributes) == null ? void 0 : _a2.id;
};
const isLauncherEditor = (editor) => editor.options.editorProps.attributes.id === LAUNCHER_EDITOR_ID;
const isEditorRelatedElementFocused = (event) => {
  const editor = event.target;
  if (event.relatedTarget instanceof HTMLElement) {
    if (editor.contains(event.relatedTarget)) {
      return true;
    }
    const isRelatedElementFocused = EDITOR_RELATED_ELEMENT_IDS.some((id) => {
      return event.relatedTarget.closest(`#${id}`) !== null;
    });
    if (isRelatedElementFocused)
      return true;
  }
  return false;
};
const getExtensionName = (extension) => {
  var _a2;
  if (typeof extension !== "function")
    return extension.name;
  const _extension = extension();
  return Array.isArray(_extension) ? (_a2 = _extension[0]) == null ? void 0 : _a2.name : _extension.name;
};
const getExtensionOptions = (editor, extensionName) => {
  var _a2, _b2;
  const extension = (_b2 = (_a2 = editor == null ? void 0 : editor.options) == null ? void 0 : _a2.extensions) == null ? void 0 : _b2.find(
    (r2) => r2.name === extensionName
  );
  return extension == null ? void 0 : extension.options;
};
const getPluginStateValue = (state, key) => {
  return key.getState(state);
};
const hideSelectionDecoration = (doc) => {
  return Decoration.node(0, doc.content.size, {
    class: "ProseMirror-hideselection"
  });
};
const setPluginStateValue = (view, key, value) => {
  var _a2, _b2;
  return (_b2 = view.dispatch) == null ? void 0 : _b2.call(view, (_a2 = view.state) == null ? void 0 : _a2.tr.setMeta(key, value));
};
const getAsinUrl = (asin) => `https://read.amazon.com/?asin=${asin}&language=en-US`;
const BLOCKS_WITHOUT_CHILDREN = [
  BlockTypes.CODE,
  BlockTypes.NODE_VIEW,
  BlockTypes.CARD_LINK,
  BlockTypes.CLIP_CONTENT_TITLE
];
const LIST_BLOCKS = [BlockTypes.BULLETED_LIST, BlockTypes.NUMBERED_LIST];
const NODE_VIEW_NODES = Object.values(NodeViewTypes).reduce(
  (acc, type) => ({ ...acc, [type]: () => {
  } }),
  {}
);
const markdownSerializerConfig = {
  nodes: {
    ...NODE_VIEW_NODES,
    [SeshatNodes.BLOCK]: (state, node, parent, index) => {
      var _a2, _b2, _c2, _d2, _e2;
      const { type } = node.attrs;
      if (!type)
        return;
      if (type === BlockTypes.HEADING_1 && node.textContent) {
        state.write("# ");
      }
      if (type === BlockTypes.HEADING_2 && node.textContent) {
        state.write("## ");
      }
      if (type === BlockTypes.HEADING_3 && node.textContent) {
        state.write("### ");
      }
      if (type === BlockTypes.HEADING_4 && node.textContent) {
        state.write("#### ");
      }
      if (type === BlockTypes.BULLETED_LIST && node.textContent) {
        state.write("- ");
      }
      if (type === BlockTypes.NUMBERED_LIST && node.textContent) {
        const value = getOrderedListValue(parent, index);
        state.write(`${value}. `);
      }
      if (type === BlockTypes.CODE) {
        state.write("```" + (node.attrs.language || "") + "\n");
        state.text(node.textContent, false);
        state.ensureNewLine();
        state.write("```");
      }
      if (type === BlockTypes.CARD_LINK) {
        const cardLinkComponent = (_b2 = (_a2 = node.firstChild) == null ? void 0 : _a2.firstChild) == null ? void 0 : _b2.firstChild;
        const { cardType, cardLinkText } = (_c2 = cardLinkComponent == null ? void 0 : cardLinkComponent.attrs) != null ? _c2 : {};
        if (!cardLinkText)
          return;
        if (cardType === "task" && node.attrs.isDone)
          state.write("[X] ");
        if (cardType === "task" && !node.attrs.isDone)
          state.write("[ ] ");
        const text = new TextSerializer().serializeContent(cardLinkText);
        state.write(`[[${text}]]`);
        state.ensureNewLine();
      }
      if (type === BlockTypes.CLIP_CONTENT_TITLE && node.textContent) {
        const href = parent.attrs.href;
        if (href)
          state.write(`# [${node.textContent.trim()}](${href})`);
        else
          state.write(`# ${node.textContent.trim()}`);
        state.ensureNewLine();
      }
      if (type === BlockTypes.NODE_VIEW) {
        const component = (_e2 = (_d2 = node.firstChild) == null ? void 0 : _d2.firstChild) == null ? void 0 : _e2.firstChild;
        if ((component == null ? void 0 : component.type.name) === NodeViewTypes.CLIP_BOOK) {
          const { title, asin } = component.attrs;
          if (!title || !asin)
            return;
          state.write(`[${title}](${getAsinUrl(asin)})`);
          state.ensureNewLine();
        }
        if ((component == null ? void 0 : component.type.name) === NodeViewTypes.CLIP_BOOKMARK) {
          if (component.attrs.clipBookmarkType === ClipBookmarksTypes.PDF) {
            const { title } = component.attrs;
            if (!title)
              return;
            state.write(title);
            state.ensureNewLine();
          } else {
            const { href, title } = component.attrs;
            if (!title || !href)
              return;
            state.write(`[${title}](${href})`);
            state.ensureNewLine();
          }
        }
        if ((component == null ? void 0 : component.type.name) === NodeViewTypes.HORIZONTAL_RULE) {
          const parentType = parent.attrs.type;
          if (parentType === BlockTypes.CLIP_CONTENT)
            state.write("--");
          else if (parentType === BlockTypes.BLOCKQUOTE)
            state.write("--");
          else
            state.write("---");
          state.ensureNewLine();
        }
        if ((component == null ? void 0 : component.type.name) === NodeViewTypes.IFRAME) {
          const src = component.attrs.src;
          const youtubeId = isYoutubeUrl(src) ? getYoutubeVideoId(src) : null;
          const link = youtubeId ? `https://www.youtube.com/watch?v=${youtubeId}` : src;
          if (link)
            state.write(`[${link}](${link})`);
          if (link)
            state.ensureNewLine();
        }
        if ((component == null ? void 0 : component.type.name) === NodeViewTypes.EXTERNAL_VIDEO) {
          const src = component.attrs.src.replace(/[()]/g, "\\$&");
          if (src)
            state.write(`![${src}](${src})
`);
        }
        if ((component == null ? void 0 : component.type.name) === NodeViewTypes.FILE) {
          const { fileName } = component.attrs;
          if (!fileName)
            return;
          const { name, ext } = getNameAndExtFromFileName(fileName);
          const file = createFileNameForMarkdown(name);
          const path = createPathForMarkdown(file, ext);
          state.write(`![${file}](${path})`);
          state.ensureNewLine();
        }
      }
      if (LIST_BLOCKS.includes(node.attrs.type)) {
        state.renderList(node, "    ", (i) => i === 0 ? "" : "    ");
      } else if (!BLOCKS_WITHOUT_CHILDREN.includes(node.attrs.type)) {
        state.renderContent(node);
      }
      state.closeBlock(node);
    },
    [SeshatNodes.WRAPPING_BLOCK]: (state, node) => {
      var _a2;
      if (node.attrs.type === BlockTypes.CAPTURE) {
        state.wrapBlock("", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
      if (node.attrs.type === BlockTypes.BLOCK_LINE) {
        state.wrapBlock("", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
      if (node.attrs.type === BlockTypes.BLOCK_COLUMN) {
        state.wrapBlock("", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
      if (node.attrs.type === BlockTypes.HIGHLIGHTS) {
        state.wrapBlock("", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
      if (node.attrs.type === BlockTypes.HIGHLIGHT) {
        if (node.attrs.timestamp)
          state.write(`> ${node.attrs.timestamp}`);
        state.wrapBlock("", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
      if (node.attrs.type === BlockTypes.HIGHLIGHT_NOTE) {
        state.wrapBlock("", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
      if (node.attrs.type === BlockTypes.TWEET) {
        state.wrapBlock("", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
      if (node.attrs.type === BlockTypes.BLOCKQUOTE && node.textContent) {
        state.wrapBlock("> ", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
      if (node.attrs.type === BlockTypes.CLIP_CONTENT && node.textContent) {
        if (node.attrs.twitter && node.attrs.href) {
          try {
            const { name } = (_a2 = JSON.parse(node.attrs.twitter)) != null ? _a2 : {};
            if (!name || !node.attrs.href)
              return;
            state.write(`> # [${name}](${node.attrs.href})`);
            state.ensureNewLine();
          } catch {
          }
        }
        state.wrapBlock("> ", null, node, () => state.renderContent(node));
        state.closeBlock(node);
      }
    },
    [SeshatNodes.BLOCK_CONTENT]: (state, node, parent) => {
      if (parent.attrs.type === BlockTypes.CARD_CONTENT && node.textContent) {
        if (parent.attrs.cardType === "task" && parent.attrs.isDone) {
          state.write(`# [X] ${node.textContent.trim()}`);
        } else if (parent.attrs.cardType === "task" && !parent.attrs.isDone) {
          state.write(`# [ ] ${node.textContent.trim()}`);
        } else {
          state.write(`# ${node.textContent.trim()}`);
        }
      } else {
        state.renderContent(node);
      }
      state.closeBlock(node);
    },
    [SeshatNodes.CONTENT]: (state, node) => {
      state.renderInline(node);
      state.closeBlock(node);
    },
    [SeshatNodes.CONTENT_NODE_VIEW]: (state, node) => {
      state.renderInline(node);
      state.closeBlock(node);
    },
    [SeshatInlineNodes.REFERENCE]: (state, node) => {
      const { value } = node.attrs;
      if (!value)
        return;
      const name = createFileNameForMarkdown(value);
      state.write(`[[${name}]]`);
    },
    [SeshatInlineNodes.EXTERNAL_IMAGE]: (state, node) => {
      const alt = state.esc(node.attrs.alt || "");
      const src = node.attrs.src.replace(/[()]/g, "\\$&");
      if (src)
        state.write(`![${alt}](${src})
`);
    },
    [SeshatInlineNodes.TEXT]: (state, node) => {
      if (node.text)
        state.text(node.text, false);
    }
  },
  marks: {
    [MarkTypes.BOLD]: defaultMarkdownSerializer.marks.strong,
    [MarkTypes.ITALIC]: defaultMarkdownSerializer.marks.em,
    [MarkTypes.CODE]: defaultMarkdownSerializer.marks.code,
    [MarkTypes.LINK]: {
      open: (state, mark, parent, index) => {
        const node = parent.content.content.find((n) => mark.isInSet(n.marks));
        if (!node || node.type.name !== SeshatInlineNodes.TEXT)
          return "";
        const { open } = defaultMarkdownSerializer.marks.link;
        if (typeof open === "string")
          return open;
        else
          return open(state, mark, parent, index);
      },
      close: (state, mark, parent, index) => {
        const node = parent.content.content.find((n) => mark.isInSet(n.marks));
        if (!node || node.type.name !== SeshatInlineNodes.TEXT)
          return "";
        const { close } = defaultMarkdownSerializer.marks.link;
        if (typeof close === "string")
          return close;
        else
          return close(state, mark, parent, index);
      }
    },
    [MarkTypes.UNDERLINE]: { open: "", close: "", mixable: true },
    [MarkTypes.HIGHLIGHT]: { open: "", close: "", mixable: true },
    [MarkTypes.SHINE]: { open: "", close: "", mixable: true },
    [MarkTypes.STRIKE]: { open: "", close: "", mixable: true },
    [MarkTypes.FONT_COLOR]: { open: "", close: "", mixable: true },
    [MarkTypes.TEXT_ALIGN]: { open: "", close: "", mixable: true },
    [MarkTypes.TEXT_STYLE]: { open: "", close: "", mixable: true }
  }
};
const getOrderedListValue = (parent, index) => {
  let value = 1;
  let i = index;
  try {
    while (parent.child(i - 1).attrs.type === BlockTypes.NUMBERED_LIST) {
      value++;
      i--;
    }
  } catch {
  }
  return value;
};
const createMarkdownSerializer = (config) => {
  return {
    serializer: new MarkdownSerializer(
      { ...defaultMarkdownSerializer.nodes, ...config.nodes },
      { ...defaultMarkdownSerializer.marks, ...config.marks }
    ),
    serialize(content) {
      try {
        return this.serializer.serialize(content);
      } catch {
        return "";
      }
    }
  };
};
const createMarkdownFromJSON = (content, {
  extensionConfiguration
} = {}) => {
  const schema = getSeshatEditorSchema(extensionConfiguration);
  if (Array.isArray(content)) {
    const nodes = content.map((node2) => schema.nodeFromJSON(node2));
    const fragment = Fragment.fromArray(nodes).toJSON();
    return createMarkdownSerializer(markdownSerializerConfig).serialize(
      schema.nodeFromJSON({ type: "doc", content: fragment })
    );
  }
  const node = schema.nodeFromJSON(content);
  return createMarkdownSerializer(markdownSerializerConfig).serialize(node);
};
const FILES_DIRECTORY = "files";
const createPathForMarkdown = (fileName, ext) => {
  return `${FILES_DIRECTORY}/${fileName}.${ext}`;
};
const createFileNameForMarkdown = (fileName) => {
  return sanitizeForFileName(fileName);
};
const ATTRS_TO_UNSET = [
  BlockAttrsParams.BLOCK_UUID,
  BlockAttrsParams.HIGHLIGHT_UUID,
  MarkAttrsParams.HIGHLIGHT_NOTE
];
const resetAttrsInSlice = (schema, slice, attrsToUnset) => {
  var _a2;
  const newSlice = Slice.fromJSON(schema, (_a2 = slice.toJSON()) != null ? _a2 : {});
  newSlice.content.nodesBetween(0, newSlice.size, (node) => {
    node = resetAttrsInNode(node, attrsToUnset != null ? attrsToUnset : ATTRS_TO_UNSET);
  });
  return newSlice;
};
const resetAttrsInNode = (node, attrs) => {
  const updatedNode = Object.assign({}, node);
  attrs.forEach((attr) => {
    if (node.attrs[attr] !== void 0) {
      updatedNode.attrs[attr] = void 0;
    }
    node.marks.forEach((mark, i) => {
      if (mark.attrs[attr] !== void 0) {
        updatedNode.marks[i].attrs[attr] = attr === MarkAttrsParams.HIGHLIGHT_UUID ? generateRandomId() : void 0;
      }
    });
  });
  return updatedNode;
};
function findSuggestionMatch(config) {
  const { char, allowSpaces, prefixSpace, startOfLine, $position } = config;
  const escapedChar = char.split("").map((c2) => `\\${c2}`).join("");
  const suffix = new RegExp(`\\s${escapedChar}$`);
  const prefix = startOfLine ? "^" : "";
  const regexp = allowSpaces ? new RegExp(`${prefix}${escapedChar}.*?(?=\\s${escapedChar}|$)`, "gm") : new RegExp(`${prefix}(?:^)?${escapedChar}[^\\s${escapedChar}]*`, "gm");
  const isTopLevelNode = $position.depth <= 0;
  const textFrom = isTopLevelNode ? 0 : $position.before();
  const textTo = $position.pos;
  const text = $position.doc.textBetween(textFrom, textTo, "\0", "\0");
  const match = Array.from(text.matchAll(regexp)).pop();
  if (!match || match.input === void 0 || match.index === void 0) {
    return null;
  }
  const matchPrefix = match.input.slice(
    Math.max(0, match.index - 1),
    match.index
  );
  const matchPrefixIsSpace = /^[\s\0]?$/.test(matchPrefix);
  if (prefixSpace && !matchPrefixIsSpace || !matchPrefixIsSpace && char === CAPTURE_TO_ANCHOR) {
    return null;
  }
  const from = match.index + $position.start();
  let to = from + match[0].length;
  if (allowSpaces && suffix.test(text.slice(to - 1, to + 1))) {
    match[0] += " ";
    to += 1;
  }
  if (from < $position.pos && to >= $position.pos) {
    return {
      range: {
        from,
        to
      },
      query: match[0].slice(char.length),
      text: match[0]
    };
  }
  return null;
}
const SuggestionPluginKey = new PluginKey("seshatSuggestion");
const Suggestion = ({
  pluginKey = SuggestionPluginKey,
  editor,
  char = "@",
  allowSpaces = false,
  prefixSpace = true,
  startOfLine = false,
  decorationTag = "span",
  decorationClass = "suggestion",
  findSuggestionMatch: customFindSuggestionMatch,
  command = () => null,
  items = () => [],
  render = () => ({}),
  allow = () => true
}) => {
  let props;
  const renderer = render == null ? void 0 : render();
  return new Plugin({
    key: pluginKey,
    view() {
      return {
        update: async (view, prevState) => {
          var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h, _i, _j;
          const prev = (_a2 = this.key) == null ? void 0 : _a2.getState(prevState);
          const next = (_b2 = this.key) == null ? void 0 : _b2.getState(view.state);
          const moved = (prev == null ? void 0 : prev.active) && (next == null ? void 0 : next.active) && ((_c2 = prev.range) == null ? void 0 : _c2.from) !== ((_d2 = next.range) == null ? void 0 : _d2.from);
          const started = !(prev == null ? void 0 : prev.active) && (next == null ? void 0 : next.active);
          const stopped = (prev == null ? void 0 : prev.active) && !(next == null ? void 0 : next.active);
          const changed = !started && !stopped && (prev == null ? void 0 : prev.query) !== (next == null ? void 0 : next.query);
          const handleStart = started || moved;
          const handleChange = changed && !moved;
          const handleExit = stopped || moved;
          if (!handleStart && !handleChange && !handleExit || (next == null ? void 0 : next.escape)) {
            return;
          }
          const state = handleExit && !handleStart ? prev : next;
          if (!state)
            return;
          const decorationNode = document.querySelector(
            `[data-decoration-id="${state.decorationId}"]`
          );
          props = {
            editor,
            range: state.range,
            query: (_e2 = state.query) != null ? _e2 : "",
            text: (_f2 = state.text) != null ? _f2 : "",
            items: handleChange || handleStart ? await items({
              editor,
              query: (_g2 = state.query) != null ? _g2 : ""
            }) : [],
            command: (commandProps) => {
              command({
                editor,
                range: state.range,
                props: commandProps
              });
            },
            decorationNode,
            clientRect: decorationNode ? () => {
              var _a3, _b3;
              const { decorationId } = (_b3 = (_a3 = this.key) == null ? void 0 : _a3.getState(editor.state)) != null ? _b3 : {};
              if (!decorationId)
                return new DOMRect();
              const currentDecorationNode = document.querySelector(
                `[data-decoration-id="${decorationId}"]`
              );
              return (currentDecorationNode == null ? void 0 : currentDecorationNode.getBoundingClientRect()) || new DOMRect();
            } : null
          };
          if (handleExit) {
            (_h = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _h.call(renderer, { ...props, escape: true });
          }
          if (handleChange) {
            (_i = renderer == null ? void 0 : renderer.onUpdate) == null ? void 0 : _i.call(renderer, props);
          }
          if (handleStart) {
            (_j = renderer == null ? void 0 : renderer.onStart) == null ? void 0 : _j.call(renderer, props);
          }
        },
        destroy: () => {
          var _a2;
          if (!props) {
            return;
          }
          (_a2 = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _a2.call(renderer, props);
        }
      };
    },
    state: {
      init() {
        return {
          active: false,
          range: { from: 0, to: 0 },
          query: null,
          text: null,
          composing: false,
          escape: false
        };
      },
      apply(transaction, prev, state) {
        var _a2;
        const { composing } = editor.view;
        const { selection } = transaction;
        const { empty, from } = selection;
        const next = (_a2 = transaction.getMeta(pluginKey)) != null ? _a2 : { ...prev };
        next.composing = composing;
        if (empty || editor.view.composing) {
          if ((from < prev.range.from || from > prev.range.to) && !composing && !prev.composing) {
            next.active = false;
          }
          const config = {
            char,
            allowSpaces,
            prefixSpace,
            startOfLine,
            $position: selection.$from
          };
          const customMatch = customFindSuggestionMatch == null ? void 0 : customFindSuggestionMatch({
            config,
            state,
            transaction
          });
          const match = customMatch === false || customMatch === void 0 ? findSuggestionMatch(config) : customMatch;
          const decorationId = `id_${Math.floor(Math.random() * 4294967295)}`;
          if (match && allow({ editor, state, range: match.range })) {
            next.active = true;
            next.decorationId = prev.decorationId ? prev.decorationId : decorationId;
            next.range = match.range;
            next.query = match.query;
            next.text = match.text;
            next.escape = prev.decorationId ? next.escape : false;
          } else {
            next.active = false;
          }
        } else {
          next.active = false;
        }
        if (!(next == null ? void 0 : next.active)) {
          next.decorationId = null;
          next.range = {};
          next.query = null;
          next.text = null;
        }
        return next;
      }
    },
    props: {
      handleDOMEvents: {
        keydown(view, event) {
          var _a2, _b2, _c2;
          if (!(event instanceof KeyboardEvent))
            return false;
          const state = this.getState(view.state);
          if (!state)
            return false;
          const { active, range } = state;
          if (!active) {
            return false;
          }
          const handleEscape = () => {
            var _a3;
            const updatedState = { ...state, escape: true };
            view.dispatch(view.state.tr.setMeta(pluginKey, updatedState));
            (_a3 = renderer.onExit) == null ? void 0 : _a3.call(renderer);
          };
          if (event.key === "Escape") {
            handleEscape();
            if (!state.escape && state.text)
              return true;
          }
          if (state.escape)
            return false;
          const result = (_a2 = renderer == null ? void 0 : renderer.onKeyDown) == null ? void 0 : _a2.call(renderer, { view, event, range });
          if (event.key === "Enter" && state.active && ((_b2 = state.range) == null ? void 0 : _b2.from) === ((_c2 = state.range) == null ? void 0 : _c2.to)) {
            setTimeout(() => {
              handleEscape();
            }, 20);
          }
          return result || false;
        }
      },
      decorations(state) {
        var _a2;
        const { active, range, decorationId } = (_a2 = this.getState(state)) != null ? _a2 : {};
        if (!active || !range) {
          return null;
        }
        return DecorationSet.create(state.doc, [
          Decoration.inline(range.from, range.to, {
            nodeName: decorationTag,
            class: decorationClass,
            "data-decoration-id": decorationId
          })
        ]);
      }
    }
  });
};
class SeshatDOMParser extends DOMParser$1 {
  parse(dom, options = {}) {
    return super.parse(dom, { ...options, preserveWhitespace: "full" });
  }
  parseSlice(dom, options) {
    return super.parseSlice(dom, { ...options, preserveWhitespace: "full" });
  }
  static fromSchema(schema) {
    return schema.cached.domParser || (schema.cached.domParser = new SeshatDOMParser(
      schema,
      SeshatDOMParser.schemaRules(schema)
    ));
  }
}
const SeshatDOMParserPlugin = (schema) => {
  return new Plugin({
    key: new PluginKey("seshatDomParser"),
    props: {
      domParser: SeshatDOMParser.fromSchema(schema)
    }
  });
};
function elementFromString(value) {
  const wrappedValue = `<body>${value}</body>`;
  return new window.DOMParser().parseFromString(wrappedValue, "text/html").body;
}
const formatBidirectionalLink = (content, bidirectionalName) => {
  if (!bidirectionalName)
    return content;
  const div = document.createElement("div");
  div.innerHTML = content;
  const references = div.querySelectorAll("a[data-uuid]");
  Object.values(references).forEach((node) => {
    var _a2;
    const span = document.createElement("span");
    span.dataset.mention = bidirectionalName;
    const attrs = node.attributes;
    Object.values(attrs).forEach((attr) => {
      if (attr.nodeValue)
        span.setAttribute(attr.nodeName, attr.nodeValue);
    });
    (_a2 = node.parentNode) == null ? void 0 : _a2.replaceChild(span, node);
  });
  return div.innerHTML;
};
const isCaptureWithHeading = (block) => {
  var _a2, _b2, _c2;
  return ((_a2 = block.attrs) == null ? void 0 : _a2.type) === BlockTypes.CAPTURE && ((_c2 = (_b2 = block.content) == null ? void 0 : _b2[0].attrs) == null ? void 0 : _c2.type) === BlockTypes.HEADING_1;
};
const removeBlockNodes = (json2) => {
  const inlineNodes = Object.values(SeshatInlineNodes);
  return json2.filter((node) => node.type && inlineNodes.includes(node.type));
};
const removeWhitespaceBetweenHTMLTags = (element) => {
  if (typeof element === "string") {
    element = new DOMParser().parseFromString(element, "text/html").body;
  }
  Array.from(element.querySelectorAll("div, p")).forEach((el) => {
    if (el.closest("pre"))
      return;
    el.innerHTML = el.innerHTML.trim();
  });
  return element.innerHTML.replace(new RegExp("(?<=<(ol|ul)>)\\s+(?=<li>)", "g"), "").replace(/\s+<ol/g, "<ol").replace(/\s+<ul/g, "<ul").replace(new RegExp("(?<=<\\/li>)\\s+(?=<li>)", "g"), "").replace(new RegExp("(?<=<\\/li>)\\s+(?=<\\/(ol|ul)>)", "g"), "").replace(new RegExp("(?<=<tr>)\\s+(?=<(td|th)>)", "g"), "").replace(new RegExp("(?<=<(tbody|thead)>)\\s+(?=<tr>)", "g"), "").replace(new RegExp("(?<=<\\/td>)\\s+(?=<td>)", "g"), "").replace(new RegExp("(?<=<\\/th>)\\s+(?=<th>)", "g"), "").replace(new RegExp("(?<=<\\/tr>)\\s+(?=<tr>)", "g"), "").replace(/>\s+<div/g, "><div").replace(/<div><\/div>/gi, "").replace(/<p><\/p>/gi, "");
};
const toSchemaValidJson = ({
  node,
  schema
}) => {
  var _a2;
  const contentNodes = node.content.content;
  if (contentNodes.every(({ isInline }) => isInline)) {
    return [
      generateParagraph({
        attrs: { type: BlockTypes.PARAGRAPH, textAlign: "auto", dir: "auto" },
        content: (_a2 = node.content.toJSON()) != null ? _a2 : []
      })
    ];
  }
  return contentNodes.map((node2) => {
    if (node2.type.spec.group !== SeshatNodeGroups.BLOCK) {
      const seshatBlock = createSeshatBlock({
        attrs: { type: BlockTypes.PARAGRAPH },
        schema,
        content: [node2]
      });
      return seshatBlock.toJSON();
    }
    return node2.toJSON();
  });
};
const DefaultHTMLParserConfig = {
  referenceName: REFERENCE_BRACKET_PLACEHOLDER
};
class HTMLParser {
  constructor(schema) {
    this.schema = schema || getSeshatEditorSchema();
    this.parser = SeshatDOMParser.fromSchema(this.schema);
  }
  parseSlice(html, options) {
    var _a2, _b2;
    const config = { ...DefaultHTMLParserConfig, ...(_a2 = options == null ? void 0 : options.config) != null ? _a2 : {} };
    html = formatBidirectionalLink(html, config == null ? void 0 : config.referenceName);
    if (!(options == null ? void 0 : options.disableSanitizing) && !(options == null ? void 0 : options.legacyMode)) {
      html = sanitizeHtmlInterface(html);
    }
    const element = elementFromString(html);
    element.innerHTML = removeWhitespaceBetweenHTMLTags(element);
    return this.parser.parseSlice(element, {
      preserveWhitespace: (_b2 = options == null ? void 0 : options.preserveWhitespace) != null ? _b2 : "full"
    });
  }
  parseContent(html, options) {
    if (html === "")
      return [generateEmptyBlock()];
    const slice = this.parseSlice(html, options);
    return toSchemaValidJson({ node: slice, schema: this.schema });
  }
  parseDoc(html, options) {
    const json2 = this.parseContent(html, options);
    const [capture] = verifyRootBlock(json2);
    if (isCaptureWithHeading(capture)) {
      return [turnBlockIntoNote(capture)];
    } else {
      return [capture];
    }
  }
  parseInline(html, options) {
    var _a2;
    const element = elementFromString(html);
    const slice = this.parser.parseSlice(element, {
      preserveWhitespace: (_a2 = options == null ? void 0 : options.preserveWhitespace) != null ? _a2 : "full"
    });
    const inlineNodes = slice.toJSON().content;
    return removeBlockNodes(inlineNodes);
  }
}
const MarkdownParserDefaultPlugins = {
  Highlight: {
    name: "highlight",
    regex: /==([^=]+)==/,
    chain: "inline",
    replace: (match) => {
      return `<highlight>${match}</highlight>`;
    }
  }
};
const MarkdownParserPlugins = {
  Reference: {
    name: "reference",
    regex: new RegExp("(?<!#)\\[\\[([^[\\]]+)\\]\\]"),
    chain: "inline",
    replace: (match) => {
      const encodedUrl = encodeURIComponent(match);
      return `<a class="reference" href="${encodedUrl}.md">${match}</a>`;
    }
  },
  Tag: {
    name: "tag",
    regex: /#\[\[([^[\]]+)\]\]/,
    chain: "inline",
    replacePredecessor: (content) => {
      return content.substring(0, content.length);
    },
    replace: (match) => {
      const encodedUrl = encodeURIComponent(match);
      return `<a class="reference" href="${encodedUrl}.md">#${match}</a>`;
    }
  },
  RoamTodoUndone: {
    name: "roamTodoUndone",
    regex: /{{\[\[TODO\]\]}} (.+)/,
    chain: "inline",
    replace: (match) => {
      return `<ul><li>[ ] ${match}</li></ul>`;
    }
  },
  RoamTodoDone: {
    name: "roamTodoDone",
    regex: /{{\[\[DONE\]\]}} (.+)/,
    chain: "inline",
    replace: (match) => {
      return `<ul><li>[X] ${match}</li></ul>`;
    }
  }
};
const MarkdownParserToLazyRefPlugins = {
  Reference: {
    name: "reference",
    regex: /\[\[([^[\]]+)\]\]/,
    chain: "inline",
    replace: (match) => {
      return `<a class="reference" data-char='#'>${match}</a>`;
    }
  }
};
const createMarkdownParserPluginList = (plugins) => {
  const pluginList = Object.values(MarkdownParserDefaultPlugins);
  return plugins ? pluginList.concat(plugins) : pluginList;
};
const createRegexPlugin = (md, options) => {
  if (!options)
    return;
  md.renderer.rules[options.name] = (tokens, idx) => {
    return rendererRule(tokens, idx, options, void 0, md.renderer);
  };
  md.core.ruler.push(options.name, (state) => {
    coreRuler(state, options);
  });
};
const rendererRule = (tokens, idx, options) => {
  return options.replace(tokens[idx].content);
};
const coreRuler = (state, options) => {
  for (let i = 0; i < state.tokens.length; i++) {
    if (state.tokens[i].type !== options.chain)
      continue;
    const tokens = state.tokens[i].children;
    if (!tokens)
      continue;
    for (let j = tokens.length - 1; j >= 0; j--) {
      if (tokens[j].type === "text" && options.regex.test(tokens[j].content)) {
        const replacedChildren = tokens[j].content.split(options.regex).map((item, index) => ({
          type: index % 2 === 0 ? "text" : options.name,
          content: item
        })).filter((item) => item.content.length > 0).map((item, i2) => {
          const newToken = new state.Token(item.type, "", 0);
          if (i2 === 0 && options.replacePredecessor) {
            newToken.content = options.replacePredecessor(item.content);
            return newToken;
          }
          if (i2 === 2 && options.replaceSuccessor) {
            newToken.content = options.replaceSuccessor(item.content);
            return newToken;
          }
          newToken.content = item.content;
          return newToken;
        });
        state.tokens[i].children = [
          ...tokens.slice(0, j),
          ...replacedChildren,
          ...tokens.slice(j + 1)
        ];
      }
    }
  }
};
class MarkdownParser {
  constructor(schema, options) {
    this.schema = schema || getSeshatEditorSchema();
    this.options = options || {};
    this.markdownRenderer = MarkdownIt({ html: true, breaks: true });
    const { plugins } = this.options;
    for (const plugin of createMarkdownParserPluginList(plugins)) {
      this.markdownRenderer.use(createRegexPlugin, plugin);
    }
    this.htmlParser = new HTMLParser(this.schema);
  }
  parseSlice(markdown2) {
    const html = this.markdownRenderer.render(markdown2);
    const slice = this.htmlParser.parseSlice(html);
    return slice;
  }
  parseContent(markdown2) {
    const html = this.markdownRenderer.render(markdown2);
    const json2 = this.htmlParser.parseContent(html);
    return json2;
  }
  parseDoc(markdown2) {
    const json2 = this.parseContent(markdown2);
    const [capture] = verifyRootBlock(json2);
    if (isCaptureWithHeading(capture)) {
      return [turnBlockIntoNote(capture)];
    } else {
      return [capture];
    }
  }
  parseInline(markdown2) {
    const html = this.markdownRenderer.renderInline(markdown2);
    const json2 = this.htmlParser.parseInline(html);
    return json2;
  }
}
const blockIdPluginKey = new PluginKey(BlockAttrsParams.BLOCK_UUID);
const getNodeAttribute = (node, type) => {
  var _a2;
  return (_a2 = node == null ? void 0 : node.attrs) == null ? void 0 : _a2[type];
};
const generateBlockIds = (props) => ({
  state,
  dispatch,
  tr
}) => {
  dispatch == null ? void 0 : dispatch(generateBlockIdsTransaction({ state, tr, ...props }));
  return true;
};
const generateBlockIdsTransaction = ({
  tr,
  state,
  from,
  to,
  options
}) => {
  const start = minMax(from != null ? from : 0, 0, state.doc.content.size);
  const end = minMax(to != null ? to : state.doc.content.size, 0, state.doc.content.size);
  state.doc.nodesBetween(start, end, (node, pos) => {
    var _a2, _b2;
    const blockID = getNodeAttribute(node, BlockAttrsParams.BLOCK_UUID);
    if (node.type.spec.group === SeshatNodeGroups.BLOCK) {
      if (!hasNodeSchemaAttribute({
        schema: state.schema,
        node,
        attributeType: BlockAttrsParams.BLOCK_UUID
      }))
        return;
      const shouldAddBlockIdToNode = blockID === void 0 || blockID === null;
      if (shouldAddBlockIdToNode && node.type.validContent(node.content)) {
        const attrs = {
          ...node.attrs,
          [BlockAttrsParams.BLOCK_UUID]: (_b2 = (_a2 = options == null ? void 0 : options.generateId) == null ? void 0 : _a2.call(options)) != null ? _b2 : generateRandomId()
        };
        tr.setNodeMarkup(pos, void 0, attrs).setMeta(blockIdPluginKey, true).setMeta(IgnoreContentEditableFalse, true);
      }
    }
  });
  return tr.setMeta("skipUpdate", true);
};
const BlockIDExtension = (options) => Extension.create({
  name: "BlockIDExtension",
  addOptions() {
    var _a2;
    return {
      generateId: (_a2 = options == null ? void 0 : options.generateRandomId) != null ? _a2 : generateRandomId
    };
  },
  addCommands() {
    return {
      generateBlockIds
    };
  },
  onCreate() {
    this.editor.commands.generateBlockIds({ options: this.options });
  },
  addProseMirrorPlugins() {
    const { options: options2 } = this;
    return [
      new Plugin({
        key: blockIdPluginKey,
        appendTransaction: (trs, oldState, newState) => {
          if (oldState.doc.eq(newState.doc))
            return;
          const { start, end } = getModifiedStartAndEnd(trs);
          if (start === void 0 || end === void 0)
            return;
          const newTr = generateBlockIdsTransaction({
            tr: newState.tr,
            state: newState,
            from: start,
            to: end,
            options: options2
          });
          if (newTr.steps.length === 0)
            return;
          return newTr;
        }
      })
    ];
  }
});
const applyBlockIdToExtension = (options) => (extension) => {
  var _a2;
  const generateId = (_a2 = options == null ? void 0 : options.generateRandomId) != null ? _a2 : generateRandomId;
  return extension.extend({
    addAttributes() {
      var _a3;
      return {
        ...(_a3 = this.parent) == null ? void 0 : _a3.call(this),
        [BlockAttrsParams.BLOCK_UUID]: {
          default: void 0,
          keepOnSplit: false,
          parseHTML: (element) => {
            return element.getAttribute(BlockAttrsParams.BLOCK_UUID) || generateId();
          },
          renderHTML: (attributes) => {
            return {
              ...attributes,
              [BlockAttrsParams.BLOCK_UUID]: attributes == null ? void 0 : attributes[BlockAttrsParams.BLOCK_UUID]
            };
          }
        }
      };
    }
  });
};
const generateBlockId = (editor) => {
  var _a2, _b2, _c2;
  return (_c2 = (_b2 = (_a2 = getExtensionOptions(
    editor,
    BlockIDExtension.name
  )) == null ? void 0 : _a2.generateId) == null ? void 0 : _b2.call(_a2)) != null ? _c2 : generateRandomId();
};
const MentionPlaceholderExtensionKey = "mention-placeholder";
const PREVENT_EDITOR_INPUT_PLUGIN = "prevent-editor-input-plugin";
const PREVENT_EDITOR_INPUT_PLUGIN_KEY = new PluginKey(
  PREVENT_EDITOR_INPUT_PLUGIN
);
const preventEditorInputPlugin = new Plugin({
  key: PREVENT_EDITOR_INPUT_PLUGIN_KEY,
  state: {
    init() {
      return { preventTextInput: false };
    },
    apply(tr, pluginState) {
      const value = tr.getMeta(PREVENT_EDITOR_INPUT_PLUGIN);
      if (value === void 0)
        return pluginState;
      return { preventTextInput: value };
    }
  },
  props: {
    decorations: (state) => {
      return PREVENT_EDITOR_INPUT_PLUGIN_KEY.getState(state).preventTextInput ? DecorationSet.create(state.doc, [hideSelectionDecoration(state.doc)]) : void 0;
    },
    handleTextInput(view) {
      const state = PREVENT_EDITOR_INPUT_PLUGIN_KEY.getState(view.state);
      return state.preventTextInput;
    }
  }
});
const insertMentionPlaceholderTransaction = ({
  type,
  range,
  tr,
  attrs
}) => {
  const node = type.create(attrs);
  const isInputRuleInitiated = range.from !== range.to;
  if (isInputRuleInitiated)
    tr.delete(range.from, range.to);
  return tr.insert(range.from, node).setMeta(MentionPlaceholderExtensionKey, true).setMeta(PREVENT_EDITOR_INPUT_PLUGIN, true);
};
const getSelectedText = (selection) => {
  const nodeStartPosition = selection.$head.start();
  return selection.$head.parent.textBetween(
    selection.$from.pos - nodeStartPosition,
    selection.$to.pos - nodeStartPosition
  );
};
const getEndPosition = ({
  selection,
  lastCharElement,
  isBracketBefore
}) => {
  const nodeStartPosition = selection.$head.start();
  const isEndBracketAfter = selection.$head.parent.textBetween(
    selection.$from.pos - nodeStartPosition,
    selection.$to.pos - nodeStartPosition + (isBracketBefore ? lastCharElement.length : 0)
  ).endsWith("]");
  return isEndBracketAfter ? selection.to + 1 : selection.to;
};
const isBracketBeforeSelection = ({
  selection,
  firstCharElement
}) => {
  var _a2;
  const isSelectionAtStartOfLine = !selection.$from.nodeBefore;
  return !firstCharElement && isSelectionAtStartOfLine || ((_a2 = selection.$from.nodeBefore) == null ? void 0 : _a2.textContent.endsWith(firstCharElement));
};
const insertMentionPlaceholderOnTextSelectionTransaction = ({
  tr,
  type,
  attrs: { char },
  forceInsert
}) => {
  const chars = char.split("");
  const lastCharElement = chars.pop();
  const firstCharElement = chars.join();
  if (!lastCharElement)
    return false;
  const { selection } = tr;
  if (char === HASH_REFERENCE.char && !selection.empty)
    return insertMentionPlaceholderTransaction({
      tr,
      type,
      attrs: {
        originalValue: getSelectedText(selection) || "",
        onActiveRange: true,
        char
      },
      range: {
        from: selection.from,
        to: selection.to
      }
    });
  const isBracketBefore = isBracketBeforeSelection({
    selection,
    firstCharElement
  });
  if (!forceInsert && (selection.empty || !isBracketBefore))
    return false;
  return insertMentionPlaceholderTransaction({
    tr,
    type,
    attrs: {
      originalValue: getSelectedText(selection) || "",
      onActiveRange: true,
      char
    },
    range: {
      from: isBracketBefore ? selection.from - 1 : selection.from,
      to: getEndPosition({ selection, lastCharElement, isBracketBefore })
    }
  });
};
const handleMentionCharsOnSelectionPlugin = (mention) => new Plugin({
  key: new PluginKey("CHARS_FOR_MENTION_PLACEHOLDER" + mention.name),
  props: {
    handleKeyPress: handleKeyPress({
      type: mention.type,
      char: mention.char
    })
  }
});
const handleKeyPress = ({ type, char }) => (view, event) => {
  const { key } = event;
  const lastCharElement = char.split("").pop();
  if (key !== lastCharElement)
    return false;
  const tr = insertMentionPlaceholderOnTextSelectionTransaction({
    type,
    tr: view.state.tr,
    forceInsert: false,
    attrs: { char }
  });
  if (!tr)
    return false;
  view.dispatch(tr);
  return true;
};
const MentionPlaceholderNodes = (options) => {
  var _a2, _b2;
  return (_b2 = (_a2 = options == null ? void 0 : options.mentions) == null ? void 0 : _a2.items.map(
    (mention) => Node.create({
      name: mention.name + "placeholder",
      inline: true,
      selectable: true,
      atom: true,
      group: "inline",
      priority: 1e3,
      addOptions() {
        return mention;
      },
      addAttributes() {
        return {
          char: {
            default: void 0
          },
          placeholder: {
            default: void 0
          },
          originalValue: {
            default: void 0
          },
          onActiveRange: {
            default: void 0
          }
        };
      },
      renderHTML() {
        return ["span"];
      },
      addCommands() {
        if (!mention.isDefault)
          return {};
        return {
          insertMentionPlaceholderOnTextSelection: ({
            type,
            attrs: { char }
          }) => ({ dispatch, tr }) => {
            const transaction = insertMentionPlaceholderOnTextSelectionTransaction(
              {
                tr,
                type: type != null ? type : this.type,
                attrs: { char: char != null ? char : mention.char },
                forceInsert: true
              }
            );
            if (!transaction)
              return false;
            dispatch == null ? void 0 : dispatch(transaction);
            return true;
          },
          insertMentionPlaceholder: ({
            type,
            attrs: { char }
          }) => ({ tr, dispatch }) => {
            dispatch == null ? void 0 : dispatch(
              insertMentionPlaceholderTransaction({
                tr,
                type: type != null ? type : this.type,
                attrs: { char: char != null ? char : mention.char },
                range: {
                  from: tr.selection.anchor < tr.selection.head ? tr.selection.anchor : tr.selection.head,
                  to: tr.selection.anchor < tr.selection.head ? tr.selection.head : tr.selection.anchor
                }
              })
            );
            return true;
          }
        };
      },
      addProseMirrorPlugins() {
        return [
          ...mention.char === "#" ? [preventEditorInputPlugin] : [],
          ...mention.handleWrappingKeyDown || mention.char === "#" ? [
            handleMentionCharsOnSelectionPlugin({
              ...mention,
              type: this.type
            })
          ] : []
        ];
      },
      addInputRules() {
        const regexExp = mention.char === "[[" ? new RegExp(
          "((\\s|^)" + mention.char.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&") + ")$",
          "gm"
        ) : new RegExp(
          "((\\s|^)" + mention.char.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&") + ")(\\w+)$",
          "gm"
        );
        return [
          new InputRule({
            find: regexExp,
            handler: ({ match, range, commands }) => {
              commands.command(({ dispatch, tr }) => {
                var _a3;
                const isInvalidPos = range.from < SESHAT_ROOT_DEPTH || !tr.doc.nodeAt(range.from);
                if (isInvalidPos)
                  return false;
                dispatch == null ? void 0 : dispatch(
                  insertMentionPlaceholderTransaction({
                    tr,
                    type: this.type,
                    attrs: {
                      char: match[1],
                      originalValue: (_a3 = match[3]) != null ? _a3 : ""
                    },
                    range
                  })
                );
                return true;
              });
            }
          })
        ];
      }
    })
  )) != null ? _b2 : [];
};
const highlightsBlocksObserverPluginKey = new PluginKey(
  "highlightsBlocksObserverPlugin"
);
const clipObserverPluginKey = new PluginKey("clipObserverPlugin");
const MODIFICATION_STEPS = [
  AddMarkStep,
  RemoveMarkStep,
  ReplaceStep,
  ReplaceAroundStep
];
const isModificationStep = (step) => {
  return MODIFICATION_STEPS.some(
    (ModificationStep) => step instanceof ModificationStep
  );
};
const isModificationWithinNode = (node, step) => node.$from.pos < step.from && step.to < node.$to.pos;
const isReplacementAcrossNode = (node, step) => step instanceof ReplaceStep && step.slice.size === 0 && step.from <= node.$from.pos && node.$to.pos <= step.to;
const wasTransactionDispatchedBySyncPlugin = (tr) => tr.getMeta(clipObserverPluginKey) || tr.getMeta(highlightsBlocksObserverPluginKey);
const wasTransactionDispatchedByBlockIdPlugin = (tr) => tr.getMeta(blockIdPluginKey);
const wasTransactionDispatchedByMentionPlugin = (tr) => tr.getMeta(MentionPlaceholderExtensionKey);
const IgnoreContentEditableFalse = "ignoreContentEditableFalse";
const ContentEditableExtension = (options) => Extension.create({
  name: "contentEditable",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("contentEditable"),
        filterTransaction: (tr) => {
          if (!tr.docChanged)
            return true;
          if (tr.getMeta(IgnoreContentEditableFalse))
            return true;
          if (tr.getMeta("history$"))
            return true;
          return !tr.steps.some((step, i) => {
            const doc = tr.docs.length && tr.docs[i];
            if (!doc || !isModificationStep(step))
              return false;
            return !!findAncestor(
              doc.resolve(step.from),
              (node) => !isEditable(node, options)
            );
          });
        },
        appendTransaction: (_2, __, state) => {
          const $selectionEnd = state.selection.$to;
          const nonEditableParent = findAncestor(
            $selectionEnd,
            (node) => !isEditable(node, options)
          );
          if (!nonEditableParent)
            return;
          const parent = $selectionEnd.node(nonEditableParent.depth - 1);
          if (parent.attrs.type === BlockTypes.HIGHLIGHT)
            return;
          const tr = state.tr;
          const parentPos = $selectionEnd.before(nonEditableParent.depth);
          const selection = BlockSelection.createFromPosition(
            tr.doc,
            parentPos
          );
          return tr.setSelection(selection);
        }
      })
    ];
  }
});
const isEditable = (node, options) => {
  if ((options == null ? void 0 : options.extensionVersion) === "launcher" && isSeshatBlockClip$1(node))
    return false;
  return !isContentEditableFalse(node);
};
const createHighlightsFromKindleHighlights = ({
  schema,
  kindleHighlights
}) => {
  return kindleHighlights.map((kindleHighlight) => {
    return createHighlightNode$1({ schema, kindleHighlight });
  });
};
const createHighlightNode$1 = ({
  schema,
  kindleHighlight
}) => {
  var _a2;
  const quote = schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { type: BlockTypes.BLOCKQUOTE, contentEditable: false },
    [createSeshatBlock({ schema, content: kindleHighlight.highlight })]
  );
  const note = !!kindleHighlight.note && schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { type: BlockTypes.HIGHLIGHT_NOTE },
    [createSeshatBlock({ schema, content: kindleHighlight.note })]
  );
  return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    {
      type: BlockTypes.HIGHLIGHT,
      [BlockAttrsParams.HIGHLIGHT_UUID]: (_a2 = kindleHighlight.id) != null ? _a2 : generateRandomId()
    },
    note ? [quote, note] : [quote]
  );
};
const isNestedClipBookNodeView = (node) => node.type.name === NodeViewTypes.CLIP_BOOK;
const createNewHighlightsFromKindleHighlights = ({
  schema,
  clip,
  block
}) => {
  var _a2, _b2;
  const view = (_a2 = findChildren(clip.node, isNestedClipBookNodeView)) == null ? void 0 : _a2[0];
  const existingHighlightIds = block.node.content.content.map(
    (node) => node.attrs.highlightId
  );
  const newHighlights = (_b2 = view == null ? void 0 : view.node) == null ? void 0 : _b2.attrs.kindleHighlights.filter(
    (highlight2) => !existingHighlightIds.includes(highlight2.id)
  );
  return createHighlightsFromKindleHighlights({
    schema,
    kindleHighlights: newHighlights
  });
};
const getHighlightsFromClipBook = (node) => {
  var _a2;
  return node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOK ? (_a2 = findChildren(node, isNestedClipBookNodeView)) == null ? void 0 : _a2[0].node.attrs.kindleHighlights : void 0;
};
const getHighlightsFromClipBookmark = (node) => {
  var _a2;
  return node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOKMARK ? (_a2 = findChildren(node, isNestedClipBookmarkNodeView)) == null ? void 0 : _a2[0].node.attrs.highlights : void 0;
};
const isNestedClipBookmarkNodeView = (node) => node.type.name === NodeViewTypes.CLIP_BOOKMARK;
const createHighlightsBlockFromClipBookmark = ({
  schema,
  clip
}) => {
  const bookmarkHighlights = getHighlightsFromClipBookmark(clip);
  return Node$1.fromJSON(schema, bookmarkHighlights);
};
const syncClipBookmark = ({
  tr,
  highlightsBlock,
  clip
}) => {
  var _a2;
  const clipBookmarkNodePos = clip.pos + SESHAT_CONTENT_DEPTH + 1;
  const highlights = (_a2 = tr.doc.nodeAt(highlightsBlock.pos)) != null ? _a2 : highlightsBlock.node;
  const highlightsJSON = highlights.toJSON();
  return tr.setNodeAttribute(clipBookmarkNodePos, "highlights", highlightsJSON);
};
const formatPDFHighlightsToSeshatHighlights = ({
  pdfHighlights,
  seshatHighlights,
  workspaceUuid,
  connectedClip
}) => {
  var _a2;
  return {
    type: SeshatNodes.WRAPPING_BLOCK,
    attrs: {
      type: BlockTypes.HIGHLIGHTS,
      connectedClip,
      [BlockAttrsParams.BLOCK_UUID]: uuidV5(workspaceUuid != null ? workspaceUuid : "", "highlights"),
      ...(_a2 = seshatHighlights == null ? void 0 : seshatHighlights.attrs) != null ? _a2 : {}
    },
    content: pdfHighlights.filter((highlight2) => !!highlight2.content).map((highlight2) => {
      var _a3, _b2, _c2;
      const findHighlight2 = (_b2 = highlight2.prosemirrorHighlight) != null ? _b2 : (_a3 = seshatHighlights == null ? void 0 : seshatHighlights.content) == null ? void 0 : _a3.find(
        (content) => {
          var _a4;
          return ((_a4 = content.attrs) == null ? void 0 : _a4[BlockAttrsParams.BLOCK_UUID]) === highlight2.id;
        }
      );
      if (findHighlight2)
        return {
          ...findHighlight2,
          attrs: { ...findHighlight2.attrs, position: highlight2.position }
        };
      return {
        type: SeshatNodes.WRAPPING_BLOCK,
        attrs: {
          type: BlockTypes.HIGHLIGHT,
          textAlign: "auto",
          dir: "auto",
          [BlockAttrsParams.BLOCK_UUID]: (_c2 = highlight2.id) != null ? _c2 : uuidV5(workspaceUuid != null ? workspaceUuid : "", "highlight"),
          highlightId: void 0,
          position: highlight2.position
        },
        content: [
          {
            type: SeshatNodes.WRAPPING_BLOCK,
            attrs: {
              type: BlockTypes.BLOCKQUOTE,
              textAlign: "auto",
              dir: "auto",
              [BlockAttrsParams.BLOCK_UUID]: uuidV5(
                workspaceUuid != null ? workspaceUuid : "",
                "blockquote"
              )
            },
            content: [
              {
                type: SeshatNodes.BLOCK,
                attrs: {
                  type: BlockTypes.PARAGRAPH,
                  textAlign: "auto",
                  dir: "auto",
                  [BlockAttrsParams.BLOCK_UUID]: uuidV5(
                    workspaceUuid != null ? workspaceUuid : "",
                    "paragraph"
                  )
                },
                content: [
                  {
                    type: SeshatNodes.BLOCK_CONTENT,
                    content: [
                      {
                        type: SeshatNodes.CONTENT,
                        content: generateText(highlight2.content)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          ...highlight2.prosemirrorNote ? [highlight2.prosemirrorNote] : []
        ]
      };
    })
  };
};
const formatSeshatHighlightsToPDFHighlights = (seshatHighlights) => {
  var _a2, _b2;
  if (!seshatHighlights)
    return [];
  return (_b2 = (_a2 = seshatHighlights.content) == null ? void 0 : _a2.map((highlight2) => {
    var _a3, _b3, _c2, _d2, _e2;
    const position = (_a3 = highlight2.attrs) == null ? void 0 : _a3.position;
    const id = (_b3 = highlight2.attrs) == null ? void 0 : _b3[BlockAttrsParams.BLOCK_UUID];
    const blockquote = (_c2 = highlight2.content) == null ? void 0 : _c2.find(
      (b) => {
        var _a4;
        return ((_a4 = b.attrs) == null ? void 0 : _a4.type) === BlockTypes.BLOCKQUOTE;
      }
    );
    const prosemirrorNote = (_d2 = highlight2.content) == null ? void 0 : _d2.find(
      (b) => {
        var _a4;
        return ((_a4 = b.attrs) == null ? void 0 : _a4.type) === BlockTypes.HIGHLIGHT_NOTE;
      }
    );
    const text = new TextSerializer().serializeContent(
      (_e2 = blockquote == null ? void 0 : blockquote.content) != null ? _e2 : []
    );
    return {
      content: text,
      position,
      id,
      prosemirrorHighlight: highlight2,
      prosemirrorNote
    };
  })) != null ? _b2 : [];
};
const isClipWithAttributesSync = (node) => (node == null ? void 0 : node.attrs) && (node.attrs.isPaywallContent && !node.textContent || node.attrs.video);
const addHighlightsInHighlightsAttribute = () => ({
  tr,
  dispatch,
  state
}) => {
  dispatch == null ? void 0 : dispatch(addHighlightsInHighlightsAttributeTransaction({ tr, state }));
  return false;
};
const addHighlightsInHighlightsAttributeTransaction = ({
  tr,
  state: { schema }
}) => {
  var _a2, _b2;
  const clip = (_a2 = findChildren(
    tr.doc,
    (node) => node.attrs.type === BlockTypes.CLIP_CONTENT
  )) == null ? void 0 : _a2[0];
  const highlightsBlock = (_b2 = findChildren(
    tr.doc,
    (node) => node.attrs.type === BlockTypes.HIGHLIGHTS
  )) == null ? void 0 : _b2[0];
  if (!clip || !highlightsBlock)
    return tr;
  if (!isClipThatShouldSyncWithAttributes(
    clip,
    highlightsBlock.node.content.content
  ))
    return tr;
  if (shouldHaveEmptyContent(clip)) {
    tr.delete(clip.pos + 1, clip.pos + clip.node.content.size);
    tr.insert(clip.pos + 1, createSeshatBlock({ schema }));
  }
  tr.setNodeMarkup(clip.pos, void 0, {
    ...clip.node.attrs,
    isPaywallContent: !clip.node.attrs.video,
    highlights: highlightsBlock ? highlightsBlock.node.toJSON() : void 0
  });
  tr.setNodeMarkup(highlightsBlock.pos, void 0, {
    ...highlightsBlock.node.attrs,
    connectedClip: clip.node.attrs[BlockAttrsParams.BLOCK_UUID]
  });
  return tr;
};
const highlightContentExceedsClipContent = (clip, highlights) => {
  const clipLength = clip.node.textContent.length;
  const highlightLength = highlights.reduce(
    (prev, node) => {
      var _a2, _b2;
      return prev + ((_b2 = (_a2 = node.firstChild) == null ? void 0 : _a2.textContent.length) != null ? _b2 : 0);
    },
    0
  );
  return highlightLength > clipLength;
};
const shouldHaveEmptyContent = (clip) => clip.node.attrs.isPaywallContent && !clip.node.attrs.video;
const isClipThatShouldSyncWithAttributes = (clip, highlights) => isClipWithAttributesSync(clip.node) || highlightContentExceedsClipContent(clip, highlights);
const replaceHeadingWithClipTitle = (json2) => {
  var _a2;
  const firstBlock = json2[0];
  if ((_a2 = firstBlock.attrs) == null ? void 0 : _a2.type.startsWith("heading")) {
    firstBlock.attrs.type = BlockTypes.CLIP_CONTENT_TITLE;
    return json2;
  } else {
    return json2;
  }
};
const DEPTH_BETWEEN_PREVIOUS_SESHAT_BLOCK_AND_CLIP_CONTENT_FIRST_ELEMENT = (SESHAT_CONTENT_DEPTH + 1) * 2 + 1;
const insertClip$1 = ({
  contentEditable,
  content,
  href,
  hrefBackup,
  contextUuid,
  status,
  insertAtEnd = false,
  focus,
  attrs
}) => ({ editor, chain, state, tr }) => {
  let json2 = new HTMLParser(state.schema).parseContent(content);
  if (!json2.length)
    json2 = [generateEmptyBlock()];
  json2 = replaceHeadingWithClipTitle(json2);
  const {
    selection,
    doc: { nodeSize }
  } = tr;
  const { $from } = selection;
  const selectionEndBlock = $from.end();
  const pos = $from.pos;
  const docSize = nodeSize - SESHAT_CONTENT_DEPTH * 2;
  const insertPosition = insertAtEnd ? docSize + 1 : selectionEndBlock + SESHAT_CONTENT_DEPTH + 1;
  const focusPos = !href ? pos : selectionEndBlock + DEPTH_BETWEEN_PREVIOUS_SESHAT_BLOCK_AND_CLIP_CONTENT_FIRST_ELEMENT;
  const clipUuid = generateBlockId(editor);
  let _chain = chain().withPerformanceLogs("insertClip").replaceWith({
    content: {
      type: SeshatNodes.WRAPPING_BLOCK,
      content: json2,
      attrs: {
        ...attrs,
        type: BlockTypes.CLIP_CONTENT,
        pending: !!!content,
        contentEditable,
        href,
        hrefBackup,
        [BlockAttrsParams.CONTEXT_UUID]: contextUuid,
        [BlockAttrsParams.BLOCK_UUID]: clipUuid,
        status
      }
    },
    from: insertPosition,
    to: insertPosition
  });
  _chain = maybeConnectHighlights({ tr, chain: _chain, clipUuid });
  if (focus === false)
    return _chain.run();
  _chain.focus(focusPos);
  if (contentEditable !== false) {
    _chain.scrollIntoView();
  }
  return _chain.run();
};
const maybeConnectHighlights = ({
  tr,
  clipUuid,
  chain
}) => {
  const highlightWithNoConnection = findChildren(
    tr.doc,
    (node) => node.attrs.type === BlockTypes.HIGHLIGHTS
  ).find((nodePos) => !nodePos.node.attrs.connectedClip);
  if (highlightWithNoConnection) {
    chain.updateBlockAttributesAt({
      pos: highlightWithNoConnection.pos,
      attrs: { connectedClip: clipUuid }
    });
    chain.setMeta("clipObserverPlugin", true);
  }
  return chain;
};
const insertClipTitle = ({
  clipUuid,
  title
}) => ({ editor, tr }) => {
  var _a2;
  const { node, pos } = ((_a2 = findChildren(
    tr.doc,
    (node2) => node2.attrs.type === BlockTypes.CLIP_CONTENT && node2.attrs[BlockAttrsParams.BLOCK_UUID] === clipUuid
  )) == null ? void 0 : _a2[0]) || {};
  if (!node || !pos)
    return false;
  const block = createSeshatBlock({
    schema: editor.state.schema,
    attrs: { type: BlockTypes.CLIP_CONTENT_TITLE },
    content: title
  });
  tr.insert(pos + 1, block);
  tr.setMeta(IgnoreContentEditableFalse, true);
  return true;
};
const insertClipVideo$1 = ({
  content,
  href,
  ...props
}) => ({ chain }) => {
  const url = urlMediaParser(href);
  return chain().focus().insertClip({
    ...props,
    href,
    content: content + `<iframe src="${url}" alt="${props.hrefBackup}"/>`
  }).run();
};
const debug$1 = debug$2("seshat:core");
const ANALYTICS_META = "sendEventToAnalytics";
const ANALYTICS_EVENTS = {
  CLIP_CONTENT_FROM_BOOKMARK: "Clip content from bookmark",
  CREATE_NOTE_FROM_BIDIRECTIONAL_LINK: "Create note from bidirectional link",
  INSERT_HIGHLIGHT_NOTE: "Insert highlight note",
  INSERT_BIDIRECTIONAL_LINK: "Insert bidirectional link",
  MARKDOWN_TURN_INTO_NOTE: "Turn into note via Markdown",
  MARKDOWN_TURN_INTO_TASK: "Turn into task via Markdown",
  SET_HIGHLIGHT_VIA_CLICK: "Set highlight via click",
  SET_HIGHLIGHT_VIA_SHORTCUT: "Set highlight via shortcut",
  UNABLE_TO_CLIP_CONTENT: "Unable to clip content",
  UNMATCHED_HIGHLIGHT: "Unmatched highlight",
  UNSET_HIGHLIGHT_VIA_CLICK: "Unset highlight via click"
};
const TRANSACTION_MEASURE = "transaction-duration";
const CAPTURING_TRANSACTION = "capturing-transaction-mark";
const CAPTURED_TRANSACTION = "captured-transaction-mark";
const AnalyticsExtension = (options) => Extension$1.create({
  name: "AnalyticsExtension",
  addCommands() {
    return {
      withPerformanceLogs: (eventName) => () => {
        if (!performance.mark)
          return true;
        performance.mark(CAPTURING_TRANSACTION, { detail: eventName });
        return true;
      }
    };
  },
  onTransaction({ transaction }) {
    var _a2, _b2, _c2;
    measurePerformance();
    const editorVersion = (_a2 = options == null ? void 0 : options.extensionVersion) != null ? _a2 : "main";
    const event = transaction.getMeta(ANALYTICS_META);
    if (typeof event === "string") {
      debug$1(`event:${event.toLowerCase()}`);
      (_b2 = options == null ? void 0 : options.analytics) == null ? void 0 : _b2.onTransactionToSend({ name: event, editorVersion });
    }
    if (typeof event === "object") {
      debug$1(`event:${event.name.toLowerCase()}`, event.details);
      (_c2 = options == null ? void 0 : options.analytics) == null ? void 0 : _c2.onTransactionToSend({
        name: event.name,
        details: event.details,
        editorVersion
      });
    }
  }
});
const measurePerformance = () => {
  var _a2;
  if (!performance.mark)
    return;
  performance.mark(CAPTURED_TRANSACTION);
  const transactions = performance.getEntriesByName(CAPTURING_TRANSACTION);
  if (transactions.length !== 0) {
    const measured = performance.measure(
      TRANSACTION_MEASURE,
      CAPTURING_TRANSACTION,
      CAPTURED_TRANSACTION
    );
    const type = (_a2 = transactions[0]) == null ? void 0 : _a2.detail;
    const time = `${Math.floor(measured.duration)}ms`;
    debug$1(type ? `transaction:${type}` : "transaction", time);
  }
  [CAPTURED_TRANSACTION, CAPTURING_TRANSACTION].forEach((mark) => {
    performance.clearMarks(mark);
  });
  performance.clearMeasures();
};
const withPerformanceLogs = (tr, eventName) => {
  if (!performance.mark)
    return tr;
  performance.mark(CAPTURING_TRANSACTION, { detail: eventName });
  return tr;
};
const seshatBlockMarkRule = (rule) => {
  return new InputRule({
    find: rule.find,
    handler: (args) => {
      const $pos = args.state.doc.resolve(args.range.from);
      const block = $pos.node($pos.depth - SESHAT_CONTENT_DEPTH);
      if ((block == null ? void 0 : block.attrs.type) === BlockTypes.CODE)
        return;
      return rule.handler(args);
    }
  });
};
const getClipPositions = ({
  doc,
  clipId
}) => {
  if (!clipId) {
    return NodeSelection.create(doc, 0);
  }
  const clip = getSeshatBlockByBlockId(doc, clipId);
  if (!clip)
    return void 0;
  return NodeSelection.create(doc, clip.pos);
};
const getHighlightsFromClipContent = ({
  doc,
  clipId
}) => {
  const clipPos = getClipPositions({ doc, clipId });
  if (!clipPos)
    return void 0;
  const { $from, $to } = clipPos;
  let highlights = [];
  doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
    const highlightMark = getHighlightMarkFromNode(node);
    if (highlightMark)
      highlights = addHighlightToHighlightsArray({ highlights, node, pos });
  });
  return highlights;
};
const addHighlightToHighlightsArray = ({
  highlights,
  node,
  pos
}) => {
  const highlightMark = getHighlightMarkFromNode(node);
  const highlightId = highlightMark == null ? void 0 : highlightMark.attrs[MarkAttrsParams.HIGHLIGHT_UUID];
  const highlightNote = highlightMark == null ? void 0 : highlightMark.attrs[MarkAttrsParams.HIGHLIGHT_NOTE];
  if (!highlightId)
    return highlights;
  const index = getHighlightsArrayIndex(highlights, highlightId);
  if (index === -1) {
    highlights.push({
      [MarkAttrsParams.HIGHLIGHT_UUID]: highlightId,
      [MarkAttrsParams.HIGHLIGHT_NOTE]: highlightNote,
      from: pos,
      to: pos + node.nodeSize
    });
  } else {
    highlights[index].to = pos + node.nodeSize;
  }
  return highlights;
};
const getHighlightsArrayIndex = (highlights, id) => highlights.map((h) => h[MarkAttrsParams.HIGHLIGHT_UUID]).indexOf(id);
const getHighlightsFromAttrs = (highlights) => highlights ? {
  highlights: ((highlights == null ? void 0 : highlights.content) || []).length,
  notes: ((highlights == null ? void 0 : highlights.content) || []).filter(
    (highlight2) => {
      var _a2;
      return ((_a2 = highlight2 == null ? void 0 : highlight2.content) == null ? void 0 : _a2.length) === 2;
    }
  ).length
} : {
  highlights: 0,
  notes: 0
};
const findFirstHighlight = ({
  doc
}) => {
  let found;
  doc.descendants((node, pos) => {
    if (found)
      return false;
    if (node.attrs.type === BlockTypes.HIGHLIGHT) {
      found = { node, pos };
      return true;
    }
    return;
  });
  return found;
};
const findHighlightsBlockWithOutConnectedClipId = ({
  doc
}) => {
  let found;
  doc.descendants((node, pos) => {
    if (found)
      return false;
    if (node.attrs.type === BlockTypes.HIGHLIGHTS && !node.attrs.connectedClip) {
      found = { node, pos };
      return false;
    }
    return;
  });
  return found;
};
const findHighlights = ({
  doc,
  blockUuid
}) => {
  let found;
  doc.descendants((node) => {
    if (found)
      return false;
    if (node.attrs.type === BlockTypes.HIGHLIGHTS && node.attrs.connectedClip === blockUuid) {
      found = node;
      return true;
    }
    return;
  });
  return found;
};
const findHighlight = ({
  doc,
  highlightId
}) => {
  let found;
  doc.descendants((node) => {
    if (found)
      return false;
    if (node.attrs.type === BlockTypes.HIGHLIGHT && node.attrs.highlightId === highlightId) {
      found = node;
      return true;
    }
    return;
  });
  return found;
};
const findHighlightBlockQuote = (highlightNode) => {
  let found;
  highlightNode == null ? void 0 : highlightNode.descendants((node) => {
    if (found)
      return false;
    if (node.type.name === SeshatNodes.WRAPPING_BLOCK && node.attrs.type === BlockTypes.BLOCKQUOTE) {
      found = node;
      return true;
    }
    return;
  });
  return found;
};
const findHighlightBlockQuoteParagraph = (highlightNode) => {
  let found;
  highlightNode == null ? void 0 : highlightNode.descendants((node) => {
    if (found)
      return false;
    if (node.type.name === SeshatNodes.BLOCK && node.attrs.type === BlockTypes.PARAGRAPH) {
      found = node;
      return true;
    }
    return;
  });
  return found;
};
const createHighlightsFromClipContent = ({
  doc,
  schema,
  clipId
}) => {
  const highlights = getHighlightsFromClipContent({ doc, clipId });
  if (!highlights)
    return void 0;
  return highlights.map((highlight2) => {
    return createHighlightNode({ schema, doc, highlight: highlight2 });
  });
};
const createHighlightNode = ({
  schema,
  doc,
  highlight: highlight2
}) => {
  const matchingHighlightNodeInContent = findHighlight({
    doc,
    highlightId: highlight2.highlightId
  });
  const quote = createBlockquoteFromHighlight({
    schema,
    doc,
    highlight: highlight2,
    matchingHighlightNodeInContent
  });
  const content = highlight2.highlightNote ? [quote, Node$1.fromJSON(schema, highlight2.highlightNote)] : [quote];
  return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    {
      ...matchingHighlightNodeInContent == null ? void 0 : matchingHighlightNodeInContent.attrs,
      type: BlockTypes.HIGHLIGHT,
      [BlockAttrsParams.HIGHLIGHT_UUID]: highlight2.highlightId
    },
    content
  );
};
const maybeMatchTheHighlightBlockquoteBlocksWithCurrentContent = ({
  content,
  matchingBlockquoteNodeInContent
}) => content.content.map(
  (node, index) => {
    var _a2, _b2;
    return node.type.create(
      {
        ...node.attrs,
        [BlockAttrsParams.BLOCK_UUID]: (_b2 = (_a2 = matchingBlockquoteNodeInContent == null ? void 0 : matchingBlockquoteNodeInContent.content.content) == null ? void 0 : _a2[index]) == null ? void 0 : _b2.attrs[BlockAttrsParams.BLOCK_UUID]
      },
      node.content
    );
  }
);
const createBlockquoteFromHighlight = ({
  schema,
  doc,
  highlight: highlight2,
  matchingHighlightNodeInContent
}) => {
  var _a2;
  const { content } = doc.slice(highlight2.from, highlight2.to);
  let contentNodes = content.content;
  const matchingBlockquoteNodeInContent = findHighlightBlockQuote(
    matchingHighlightNodeInContent
  );
  if (((_a2 = content.firstChild) == null ? void 0 : _a2.type.spec.group) !== SeshatNodeGroups.BLOCK) {
    contentNodes = wrapFragmentInDefaultSeshatBlock({
      schema,
      content,
      matchingBlockquoteNodeInContent
    });
  } else {
    contentNodes = maybeMatchTheHighlightBlockquoteBlocksWithCurrentContent({
      content,
      matchingBlockquoteNodeInContent
    });
  }
  return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { ...matchingBlockquoteNodeInContent == null ? void 0 : matchingBlockquoteNodeInContent.attrs, type: BlockTypes.BLOCKQUOTE },
    contentNodes
  );
};
const wrapFragmentInDefaultSeshatBlock = ({
  schema,
  content,
  matchingBlockquoteNodeInContent
}) => {
  const matchingParagraphNodeInContent = findHighlightBlockQuoteParagraph(
    matchingBlockquoteNodeInContent
  );
  const contentWithBlockWrapper = createSeshatBlock({
    attrs: {
      ...matchingParagraphNodeInContent == null ? void 0 : matchingParagraphNodeInContent.attrs,
      type: BlockTypes.PARAGRAPH
    },
    content: [...content.content],
    schema
  });
  return Fragment.from(contentWithBlockWrapper).content;
};
const createHighlightsFromPaywallClipContent = ({
  schema,
  clip
}) => {
  const highlightsBlock = clip.attrs.highlights;
  if (!highlightsBlock)
    return void 0;
  return Node$1.fromJSON(schema, highlightsBlock).content.content;
};
const getHighlightsFromClipContentById = ({
  clip,
  highlightId
}) => {
  return findChildren(clip, (node) => {
    return hasMarksWithGivenHighlightId(node, highlightId);
  });
};
const hasMarksWithGivenHighlightId = (node, highlightId) => node.marks.some(
  (mark) => mark.attrs[MarkAttrsParams.HIGHLIGHT_UUID] === highlightId
);
const getNodeWithBlockId = ({
  clip,
  start,
  end
}) => {
  const clipHighlightedNode = [];
  clip.node.nodesBetween(start - clip.pos, end - clip.pos, (node) => {
    if (node.attrs[BlockAttrsParams.BLOCK_UUID]) {
      clipHighlightedNode.push(node);
    }
  });
  return clipHighlightedNode;
};
const getPositionOfTheNodeWithBlockIdAfterClipModification = ({
  start,
  end,
  highlightsBlock,
  tr
}) => {
  const connectedClipId = highlightsBlock == null ? void 0 : highlightsBlock.node.attrs.connectedClip;
  const clipAfterModification = getSeshatBlockByBlockId(
    tr.doc,
    connectedClipId
  );
  const blockPos = [];
  clipAfterModification == null ? void 0 : clipAfterModification.node.nodesBetween(
    start - clipAfterModification.pos,
    end - clipAfterModification.pos,
    (node, pos) => {
      if (node.attrs[BlockAttrsParams.BLOCK_UUID]) {
        blockPos.push(pos + clipAfterModification.pos);
      }
    }
  );
  return blockPos;
};
const syncClipContent = ({
  tr,
  schema,
  highlightsBlock,
  clip
}) => {
  let newTr = withPerformanceLogs(tr, "syncClipContent");
  let diff2 = 0;
  const highlightMarkType = schema.marks[MarkTypes.HIGHLIGHT];
  newTr.removeMark(clip.pos, clip.pos + clip.node.nodeSize, highlightMarkType);
  highlightsBlock.node.content.forEach((highlight2) => {
    const highlightId = highlight2.attrs[MarkAttrsParams.HIGHLIGHT_UUID];
    if (!highlightId)
      return;
    const associatedClipHighlights = getHighlightsFromClipContentById({
      clip: clip.node,
      highlightId
    });
    if (!associatedClipHighlights.length)
      return;
    const oldMark = getHighlightMarkFromNode(associatedClipHighlights[0].node);
    if (!oldMark)
      return;
    const updatedContent = getBlockquoteContentFromHighlight(highlight2);
    const updatedMark = highlightMarkType.create({
      ...oldMark.attrs,
      [MarkAttrsParams.HIGHLIGHT_NOTE]: getNoteFromHighlight(highlight2)
    });
    const { start, end } = getStartAndEndOfClipHighlight({
      clipPos: clip.pos,
      clipHighlights: associatedClipHighlights
    });
    if (updatedContent.size === 0) {
      newTr = newTr.removeMark(start + diff2, end + diff2, highlightMarkType);
      return;
    }
    const contentDiff = updatedContent.size - (end - start);
    const nodeWidthBlockIdInClipBeforeModification = getNodeWithBlockId({
      start: start + diff2,
      end: end + diff2,
      clip
    });
    newTr = newTr.replace(start + diff2, end + diff2, updatedContent).addMark(start + diff2, end + diff2 + contentDiff, updatedMark);
    const blockPos = getPositionOfTheNodeWithBlockIdAfterClipModification({
      start: start + diff2,
      end: end + diff2,
      tr: newTr,
      highlightsBlock
    });
    blockPos.forEach((pos, index) => {
      var _a2;
      if (!((_a2 = nodeWidthBlockIdInClipBeforeModification[index]) == null ? void 0 : _a2.attrs))
        return;
      newTr = newTr.setNodeMarkup(
        pos + 1,
        void 0,
        nodeWidthBlockIdInClipBeforeModification[index].attrs
      );
    });
    diff2 += contentDiff;
  });
  return newTr;
};
const getStartAndEndOfClipHighlight = ({
  clipPos,
  clipHighlights
}) => {
  const correctedClipPos = clipPos + 1;
  const firstClipHighlight = clipHighlights[0];
  const lastClipHighlight = clipHighlights[clipHighlights.length - 1];
  return {
    start: correctedClipPos + firstClipHighlight.pos,
    end: correctedClipPos + lastClipHighlight.pos + lastClipHighlight.node.nodeSize
  };
};
const syncPaywallClipContent = ({
  tr,
  highlightsBlock,
  clip
}) => {
  var _a2;
  const highlights = (_a2 = tr.doc.nodeAt(highlightsBlock.pos)) != null ? _a2 : highlightsBlock.node;
  return tr.setNodeMarkup(clip.pos, void 0, {
    ...clip.node.attrs,
    highlights: highlights.toJSON()
  });
};
const insertBlockquoteInHighlight = ({
  content
}) => ({ tr, commands }) => {
  var _a2;
  const highlight2 = findFirstHighlight({ doc: tr.doc });
  if (!highlight2)
    return false;
  const blockquoteInHighlight = highlight2.node.firstChild;
  const highlightSize = (_a2 = blockquoteInHighlight == null ? void 0 : blockquoteInHighlight.nodeSize) != null ? _a2 : 0;
  return commands.replaceWith({
    from: highlight2.pos + 2,
    to: highlight2.pos + 2 + highlightSize - 2,
    content
  });
};
const getExtendedMarkRange = (doc, markType, initialRange) => {
  const range = getMarkRange(doc, markType, initialRange);
  if (range.from < initialRange.from || range.to > initialRange.to) {
    return range;
  }
  return void 0;
};
const getMarkTypePredicate = (type) => (mark) => mark.type.name === type;
const getMarkRange = (doc, markType, range) => {
  var _a2, _b2;
  const predicate = getMarkTypePredicate(markType);
  let start = range.from;
  let end = range.to;
  while (start > 0 && ((_a2 = doc.nodeAt(start - 1)) == null ? void 0 : _a2.marks.some(predicate))) {
    start -= 1;
  }
  while (end < doc.content.size && ((_b2 = doc.nodeAt(end)) == null ? void 0 : _b2.marks.some(predicate))) {
    end += 1;
  }
  return {
    from: start,
    to: end
  };
};
const getDefaultHighlightColor = () => {
  var _a2;
  const defaultColor = (_a2 = GroupHighlightColors.find(
    (item) => item.title.toLowerCase() === "yellow"
  )) == null ? void 0 : _a2.color;
  return defaultColor != null ? defaultColor : "";
};
const isHighlightMark = (mark) => mark.type.name === MarkTypes.HIGHLIGHT;
const getHighlightMarkFromNode = (node) => {
  var _a2;
  return node ? (_a2 = node.marks.filter(isHighlightMark)) == null ? void 0 : _a2[0] : void 0;
};
const { HIGHLIGHT_NOTE: HIGHLIGHT_NOTE$1, HIGHLIGHT_UUID: HIGHLIGHT_UUID$2 } = MarkAttrsParams;
const { BLOCK_UUID } = BlockAttrsParams;
const reduceHighlightNoteContent = ({
  tr,
  schema,
  doc,
  from,
  to,
  appendContent
}) => {
  var _a2;
  const containedHighlights = containsHighlights(doc, from, to);
  if (!containedHighlights)
    return appendContent;
  const knownIds = [];
  const existingHighlightNoteContent = containedHighlights.reduce(
    (acc, mark) => {
      var _a3, _b2, _c2;
      const notes = (_c2 = (_b2 = (_a3 = mark.attrs) == null ? void 0 : _a3[HIGHLIGHT_NOTE$1]) == null ? void 0 : _b2.content) != null ? _c2 : [];
      notes.forEach((note) => {
        var _a4;
        const id = (_a4 = note.attrs) == null ? void 0 : _a4[BLOCK_UUID];
        const inAcc = acc.find(({ attrs }) => (attrs == null ? void 0 : attrs[BLOCK_UUID]) === id);
        if (!!id && !inAcc && !knownIds.includes(id)) {
          const newId = generateRandomId();
          acc.push({ ...note, attrs: { ...note.attrs, [BLOCK_UUID]: newId } });
          knownIds.push(id);
        }
      });
      return acc;
    },
    []
  );
  const content = [...existingHighlightNoteContent, ...appendContent != null ? appendContent : []];
  const previousAddMarkSteps = tr == null ? void 0 : tr.steps.filter(
    (s) => s instanceof AddMarkStep
  );
  if (tr && schema && (previousAddMarkSteps == null ? void 0 : previousAddMarkSteps.length)) {
    const lastAddedMark = previousAddMarkSteps[previousAddMarkSteps.length - 1];
    const lastAddedNote = (_a2 = lastAddedMark.mark.attrs) == null ? void 0 : _a2[HIGHLIGHT_NOTE$1];
    if (lastAddedNote == null ? void 0 : lastAddedNote.content) {
      lastAddedNote.content.forEach((block) => {
        var _a3;
        const id = (_a3 = block.attrs) == null ? void 0 : _a3[BLOCK_UUID];
        if (!content.some(({ attrs }) => id && (attrs == null ? void 0 : attrs[BLOCK_UUID]) === id)) {
          content.push(block);
        }
      });
      previousAddMarkSteps.forEach((step) => {
        tr.addMark(
          step.from,
          step.to,
          schema.marks[MarkTypes.HIGHLIGHT].create({
            ...step.mark.attrs,
            [HIGHLIGHT_NOTE$1]: {
              type: SeshatNodes.WRAPPING_BLOCK,
              attrs: lastAddedNote.attrs,
              content
            }
          })
        );
      });
    }
  }
  return content;
};
const containsHighlights = (doc, from, to) => {
  let contains = [];
  doc.nodesBetween(
    minMax(from, 0, doc.content.size),
    minMax(to, 0, doc.content.size),
    (node) => {
      const highlight2 = getHighlightMarkFromNode(node);
      const existingIds = contains.map((mark) => mark.attrs[HIGHLIGHT_UUID$2]);
      if (highlight2 && !existingIds.includes(highlight2.attrs[HIGHLIGHT_UUID$2]))
        contains.push(highlight2);
    }
  );
  return contains.length > 0 ? contains : void 0;
};
const { HIGHLIGHT_COLOR: HIGHLIGHT_COLOR$1, HIGHLIGHT_NOTE, HIGHLIGHT_UUID: HIGHLIGHT_UUID$1 } = MarkAttrsParams;
const setHighlight$1 = (attrs) => ({
  chain,
  state
}) => {
  var _a2, _b2, _c2, _d2, _e2;
  const newNote = attrs == null ? void 0 : attrs[HIGHLIGHT_NOTE];
  const extendedRange = getExtendedMarkRange(state.doc, MarkTypes.HIGHLIGHT, {
    from: state.selection.from,
    to: state.selection.to
  });
  const from = (_a2 = extendedRange == null ? void 0 : extendedRange.from) != null ? _a2 : state.selection.from;
  const to = (_b2 = extendedRange == null ? void 0 : extendedRange.to) != null ? _b2 : state.selection.to;
  const notes = reduceHighlightNoteContent({
    doc: state.doc,
    from,
    to,
    appendContent: newNote == null ? void 0 : newNote.content
  });
  const highlightNote = (notes == null ? void 0 : notes.length) ? {
    type: SeshatNodes.WRAPPING_BLOCK,
    attrs: {
      ...(_c2 = newNote == null ? void 0 : newNote.attrs) != null ? _c2 : {},
      type: BlockTypes.HIGHLIGHT_NOTE
    },
    content: notes
  } : void 0;
  const runningChain = chain().markAsAnnotation();
  if (extendedRange) {
    runningChain.setTextSelection({ from, to });
  }
  return runningChain.setMark(MarkTypes.HIGHLIGHT, {
    ...attrs,
    [HIGHLIGHT_UUID$1]: (_d2 = attrs == null ? void 0 : attrs.highlightId) != null ? _d2 : generateRandomId(),
    [HIGHLIGHT_COLOR$1]: (_e2 = attrs == null ? void 0 : attrs.color) != null ? _e2 : getDefaultHighlightColor(),
    [HIGHLIGHT_NOTE]: highlightNote
  }).run();
};
const isHighlightMarkAllowed = (node) => {
  var _a2;
  return node.type.spec.marks === "_" || !!((_a2 = node.type.spec.marks) == null ? void 0 : _a2.includes(MarkTypes.HIGHLIGHT));
};
const toggleHighlight = (attrs) => ({
  chain,
  tr
}) => {
  let hasHighlightMark = true;
  tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node) => {
    const highlights = node.marks.filter(isHighlightMark);
    if (isHighlightMarkAllowed(node) && !highlights.length) {
      hasHighlightMark = false;
    }
  });
  if (hasHighlightMark) {
    return chain().markAsAnnotation().unsetHighlight().run();
  } else {
    return chain().markAsAnnotation().setHighlight(attrs).run();
  }
};
const { HIGHLIGHT_UUID, HIGHLIGHT_COLOR } = MarkAttrsParams;
const unsetHighlight = () => ({ chain, tr }) => {
  var _a2, _b2;
  const currentHighlights = findChildrenInRange(
    tr.doc,
    { from: tr.selection.from, to: tr.selection.to },
    (node) => !!getHighlightMarkFromNode(node)
  );
  const currentHighlightMark = (_b2 = (_a2 = currentHighlights == null ? void 0 : currentHighlights[0]) == null ? void 0 : _a2.node) == null ? void 0 : _b2.marks.find(
    isHighlightMark
  );
  const currentHighlightId = currentHighlightMark == null ? void 0 : currentHighlightMark.attrs[HIGHLIGHT_UUID];
  if (!currentHighlightId)
    return false;
  return chain().markAsAnnotation().unsetMark("highlight").command(({ tr: tr2, state, dispatch }) => {
    const precedingHighlights = findChildrenInRange(
      tr2.doc,
      { from: 0, to: tr2.selection.from },
      (node) => {
        const mark = node.marks.find(isHighlightMark);
        return !!mark && mark.attrs.highlightId === currentHighlightId;
      }
    );
    const newMark = state.schema.marks.highlight.create({
      color: currentHighlightMark.attrs[HIGHLIGHT_COLOR],
      highlightId: generateRandomId(),
      highlightNote: void 0
    });
    precedingHighlights.forEach(({ node, pos }) => {
      tr2.addMark(pos, pos + node.nodeSize, newMark);
    });
    dispatch == null ? void 0 : dispatch(tr2);
    return true;
  }).run();
};
const getLazyColor = (hsl) => {
  let lightness = Math.floor(hsl.l), saturation = Math.floor(hsl.s), hue = Math.floor(hsl.h);
  if (saturation === 0 && hue === 0 && lightness >= 80)
    return;
  if (saturation <= 10 && lightness <= 70 || saturation === 0) {
    return "Gray";
  } else if (hue >= 0 && hue <= 15 || hue >= 346) {
    return "Red";
  } else if (hue >= 16 && hue <= 35) {
    if (saturation < 90) {
      return "Brown";
    } else {
      return "Orange";
    }
  } else if (hue >= 36 && hue <= 54) {
    if (saturation < 90) {
      return "Brown";
    } else {
      return "Yellow";
    }
  } else if (hue >= 55 && hue <= 165) {
    return "Green";
  } else if (hue >= 166 && hue <= 260) {
    return "Blue";
  } else if (hue >= 261 && hue <= 290) {
    return "Purple";
  } else if (hue >= 291 && hue <= 345) {
    return "Pink";
  }
  return;
};
const rgbToHsl = (rgbArr) => {
  let r1 = Number(rgbArr[0]) / 255, g1 = Number(rgbArr[1]) / 255, b1 = Number(rgbArr[2]) / 255;
  let maxColor = Math.max(r1, g1, b1), minColor = Math.min(r1, g1, b1);
  let L = (maxColor + minColor) / 2, S = 0, H = 0;
  if (maxColor !== minColor) {
    if (L < 0.5) {
      S = (maxColor - minColor) / (maxColor + minColor);
    } else {
      S = (maxColor - minColor) / (2 - maxColor - minColor);
    }
    if (r1 === maxColor) {
      H = (g1 - b1) / (maxColor - minColor);
    } else if (g1 === maxColor) {
      H = 2 + (b1 - r1) / (maxColor - minColor);
    } else {
      H = 4 + (r1 - g1) / (maxColor - minColor);
    }
  }
  L = L * 100;
  S = S * 100;
  H = H * 60;
  if (H < 0) {
    H += 360;
  }
  return { h: H, s: S, l: L };
};
const EVERNOTE_HIGHLIGHT = "span[data-highlight]";
const isSpanFromTwitter = (htmlNode) => htmlNode.style.fontFamily.includes("TwitterChirp");
const highlightParseRules = () => [
  {
    tag: "highlight"
  },
  {
    tag: "mark"
  },
  {
    tag: EVERNOTE_HIGHLIGHT,
    priority: 55,
    getAttrs: (node) => {
      const htmlNode = node;
      const color = htmlNode.getAttribute("data-highlight");
      const colorTranslation = GroupHighlightColors.find(
        (item) => item.title.toLowerCase() === color
      );
      if (!colorTranslation)
        return false;
      htmlNode.setAttribute(
        "style",
        `background-color: ${colorTranslation.color};`
      );
      return {
        type: MarkTypes.HIGHLIGHT,
        highlightId: generateRandomId(),
        color: colorTranslation.color
      };
    }
  },
  {
    tag: "span",
    style: "background-color",
    priority: 55,
    getAttrs: (node) => {
      let htmlNode = node;
      const color = htmlNode.style.backgroundColor;
      if (isSpanFromTwitter(htmlNode))
        return false;
      const rgb = color.replace(/[^0-9,]/g, "").split(",");
      const nameColor = getLazyColor(rgbToHsl(rgb));
      const colorTranslation = GroupHighlightColors.find(
        (item) => item.title === nameColor
      );
      if (!colorTranslation)
        return false;
      return {
        type: MarkTypes.HIGHLIGHT,
        highlightId: generateRandomId(),
        color: colorTranslation.color
      };
    }
  }
];
const inputRegex = /(?:^|\s)((?:==)((?:[^~]+))(?:==))$/gm;
const pasteRegex = /(?:^|\s)((?:==)((?:[^~]+))(?:==))/gm;
const pasteRegexForRoam = /(?:^|\s)((?:\^\^)((?:[^~]+))(?:\^\^))/gm;
const HighlightMark = Mark.create({
  priority: 1e5,
  name: MarkTypes.HIGHLIGHT,
  addAttributes() {
    return {
      [MarkAttrsParams.HIGHLIGHT_UUID]: {
        default: void 0,
        keepOnSplit: true,
        parseHTML: (element) => element.getAttribute("highlightId") || generateRandomId()
      },
      [MarkAttrsParams.HIGHLIGHT_NOTE]: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      [MarkAttrsParams.HIGHLIGHT_COLOR]: {
        default: void 0,
        parseHTML: (element) => element.getAttribute("data-color") || element.style.backgroundColor || getDefaultHighlightColor(),
        renderHTML: (attributes) => attributes.color && {
          "data-color": attributes.color,
          style: `background-color: ${attributes.color}`
        }
      }
    };
  },
  parseHTML() {
    return highlightParseRules();
  },
  renderHTML({ HTMLAttributes }) {
    return ["highlight", mergeAttributes(HTMLAttributes), 0];
  },
  addPasteRules() {
    return [
      markPasteRule({ find: pasteRegex, type: this.type }),
      markPasteRule({ find: pasteRegexForRoam, type: this.type })
    ];
  },
  addInputRules() {
    return [
      seshatBlockMarkRule(
        markInputRule({
          find: inputRegex,
          type: this.type,
          getAttributes: () => ({
            [MarkAttrsParams.HIGHLIGHT_UUID]: generateRandomId()
          })
        })
      )
    ];
  },
  addCommands() {
    return {
      setHighlight: setHighlight$1,
      toggleHighlight,
      unsetHighlight,
      insertBlockquoteInHighlight
    };
  }
});
const getHighlightIdFromNode = (node) => {
  var _a2;
  return isHighlightMarkAllowed(node) ? (_a2 = getHighlightMarkFromNode(node)) == null ? void 0 : _a2.attrs[MarkAttrsParams.HIGHLIGHT_UUID] : node == null ? void 0 : node.attrs[BlockAttrsParams.HIGHLIGHT_UUID];
};
const getNoteFromHighlight = (highlight2) => {
  var _a2;
  if (((_a2 = highlight2.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE && highlight2.lastChild.lastChild) {
    return highlight2.lastChild.toJSON();
  } else {
    return void 0;
  }
};
const generateSearchIndex = (clip) => {
  const clipContentTextNodes = extractTextNodes(clip);
  const clipContentImageNodes = extractImageNodes(clip);
  const searchableClipText = new Fuse(clipContentTextNodes, {
    includeScore: true,
    includeMatches: true,
    ignoreLocation: true,
    threshold: 0.1,
    keys: ["node.textContent"]
  });
  const searchableClipImages = new Fuse(clipContentImageNodes, {
    includeScore: true,
    includeMatches: true,
    ignoreLocation: true,
    threshold: 0,
    keys: ["node.attrs.src"]
  });
  return {
    searchableClipImages,
    searchableClipText
  };
};
const extractTextNodes = (clip) => {
  const textNodes = [];
  clip.node.content.nodesBetween(0, clip.node.content.size, (node, pos) => {
    if (node.type.name === SeshatNodes.CONTENT) {
      textNodes.push({ node, pos: clip.pos + pos });
    }
  });
  return textNodes;
};
const extractImageNodes = (clip) => {
  const imageNodes = [];
  clip.node.content.nodesBetween(0, clip.node.content.size, (node, pos) => {
    if (node.type.name === SeshatInlineNodes.EXTERNAL_IMAGE) {
      imageNodes.push({ node, pos: clip.pos + pos });
    }
  });
  return imageNodes;
};
const highlightMatchingClipContent = ({
  schema,
  tr,
  searchableClipText,
  searchableClipImages,
  blockquote,
  highlight: highlight2
}) => {
  let newTr = tr;
  let matched = false;
  blockquote.node.content.forEach((childNode) => {
    const imageNode = getNestedImageNode(childNode);
    if (imageNode) {
      const updated = highlighters.highlightImageNode({
        schema,
        tr: newTr,
        searchableClipImages,
        imageNode,
        highlight: highlight2
      });
      newTr = updated.tr;
      matched = updated.matched;
    } else {
      const updated = highlighters.replaceAndHighlightTextNode({
        schema,
        tr: newTr,
        blockNode: childNode,
        searchableClipText,
        highlight: highlight2
      });
      newTr = updated.tr;
      matched = updated.matched;
    }
  });
  return { newTr, matched };
};
const isImageNode = (node) => node.type.name === SeshatInlineNodes.EXTERNAL_IMAGE;
const getNestedImageNode = (node) => {
  let imageNode;
  node.nodesBetween(0, node.content.size, (node2, _2, parent) => {
    var _a2;
    if (!isImageNode(node2) || ((_a2 = parent == null ? void 0 : parent.childCount) != null ? _a2 : 0) > 1)
      return;
    imageNode = node2;
  });
  return imageNode;
};
const hasAmbiguousMatches = (results) => {
  const isFirstMatchVeryPrecise = results[0].score && results[0].score < 0.1;
  return results.length > 5 && !isFirstMatchVeryPrecise;
};
const replaceAndHighlightTextNode = ({
  schema,
  tr,
  searchableClipText,
  blockNode,
  highlight: highlight2
}) => {
  var _a2, _b2, _c2, _d2;
  const searchResult = searchableClipText.search(blockNode.textContent);
  if (!searchResult.length)
    return { tr, matched: false };
  let foundClipContentNode = searchResult[0].item.node;
  let foundClipContentPos = searchResult[0].item.pos;
  if (highlighters.hasAmbiguousMatches(searchResult)) {
    const bestResult = searchResult[0];
    if (bestResult.score && bestResult.score > 0.75)
      return { tr, matched: false };
    const isOtherResultLikely = searchResult.slice(1).some((r2) => r2.score && r2.score < 0.9);
    const doesTextMatchExactly = blockNode.textContent.length > 10 && bestResult.item.node.textContent.includes(blockNode.textContent);
    if (isOtherResultLikely || !doesTextMatchExactly)
      return { tr, matched: false };
    foundClipContentNode = bestResult.item.node;
    foundClipContentPos = bestResult.item.pos;
  }
  const parent = tr.doc.nodeAt(foundClipContentPos - SESHAT_CONTENT_DEPTH);
  if ((parent == null ? void 0 : parent.attrs.type) === BlockTypes.CLIP_CONTENT)
    return { tr, matched: false };
  const blockquoteContent = blockNode.slice(
    SESHAT_CONTENT_DEPTH,
    blockNode.content.size - SESHAT_CONTENT_DEPTH
  );
  const offset = findSubstringOffset(
    foundClipContentNode.textContent,
    blockNode.textContent
  );
  if (!offset)
    return { tr, matched: false };
  const diff2 = blockquoteContent.size - (offset.end - offset.start);
  const clipNodeContentStart = foundClipContentPos + SESHAT_CONTENT_DEPTH;
  const replacedContentStart = clipNodeContentStart + offset.start;
  const replacedContentEnd = clipNodeContentStart + offset.end;
  const extendedRange = getExtendedMarkRange(tr.doc, MarkTypes.HIGHLIGHT, {
    from: replacedContentStart,
    to: replacedContentEnd + diff2
  });
  const highlightStart = (_a2 = extendedRange == null ? void 0 : extendedRange.from) != null ? _a2 : replacedContentStart;
  const highlightEnd = (_b2 = extendedRange == null ? void 0 : extendedRange.to) != null ? _b2 : replacedContentEnd + diff2;
  const note = (_c2 = highlight2.attrs) == null ? void 0 : _c2[MarkAttrsParams.HIGHLIGHT_NOTE];
  const notes = reduceHighlightNoteContent({
    tr,
    schema,
    doc: tr.doc,
    from: highlightStart,
    to: highlightEnd,
    appendContent: note == null ? void 0 : note.content
  });
  const newHighlight = schema.marks[MarkTypes.HIGHLIGHT].create({
    ...highlight2.attrs,
    [MarkAttrsParams.HIGHLIGHT_NOTE]: notes ? {
      type: SeshatNodes.WRAPPING_BLOCK,
      attrs: {
        ...(_d2 = note == null ? void 0 : note.attrs) != null ? _d2 : {},
        type: BlockTypes.HIGHLIGHT_NOTE
      },
      content: notes
    } : void 0
  });
  tr.replace(replacedContentStart, replacedContentEnd, blockquoteContent);
  tr.addMark(highlightStart, highlightEnd, newHighlight);
  return { tr, matched: true };
};
const hasSrc = (node, src) => node.attrs.src === src;
const highlightImageNode = ({
  schema,
  tr,
  searchableClipImages,
  imageNode,
  highlight: highlight2
}) => {
  var _a2, _b2, _c2, _d2;
  const imgSrc = imageNode.attrs.src;
  const searchResult = searchableClipImages.search(imgSrc);
  if (!searchResult.length)
    return { tr, matched: false };
  const imagesWithSrc = findChildren(tr.doc, (node2) => hasSrc(node2, imgSrc));
  const updatedClipImageNode = imagesWithSrc.filter(
    (node2) => !getNearestHighlightBlock(tr.doc.resolve(node2.pos))
  );
  if (!updatedClipImageNode.length)
    return { tr, matched: false };
  const { node, pos } = updatedClipImageNode == null ? void 0 : updatedClipImageNode[0];
  const extendedRange = getExtendedMarkRange(tr.doc, MarkTypes.HIGHLIGHT, {
    from: pos,
    to: pos + node.nodeSize
  });
  const highlightStart = (_a2 = extendedRange == null ? void 0 : extendedRange.from) != null ? _a2 : pos;
  const highlightEnd = (_b2 = extendedRange && extendedRange.to + 1) != null ? _b2 : pos + node.nodeSize;
  const note = (_c2 = highlight2.attrs) == null ? void 0 : _c2[MarkAttrsParams.HIGHLIGHT_NOTE];
  const notes = reduceHighlightNoteContent({
    tr,
    schema,
    doc: tr.doc,
    from: highlightStart,
    to: highlightEnd,
    appendContent: note == null ? void 0 : note.content
  });
  const newHighlight = schema.marks[MarkTypes.HIGHLIGHT].create({
    ...highlight2.attrs,
    [MarkAttrsParams.HIGHLIGHT_NOTE]: notes ? {
      type: SeshatNodes.WRAPPING_BLOCK,
      attrs: {
        ...(_d2 = note == null ? void 0 : note.attrs) != null ? _d2 : {},
        type: BlockTypes.HIGHLIGHT_NOTE
      },
      content: notes
    } : void 0
  });
  tr.addMark(highlightStart, highlightEnd, newHighlight);
  return { tr, matched: true };
};
const highlighters = {
  hasAmbiguousMatches,
  highlightImageNode,
  replaceAndHighlightTextNode
};
const matchHighlightsWithClipContent = () => ({
  state,
  dispatch,
  tr
}) => {
  tr = withPerformanceLogs(tr, "matchHighlightsWithClipContent");
  dispatch == null ? void 0 : dispatch(matchHighlightsWithClipContentTransaction({ tr, state }));
  return false;
};
const matchHighlightsWithClipContentTransaction = ({
  tr,
  state
}) => {
  var _a2, _b2;
  const { schema } = state;
  const clip = (_a2 = findChildren(tr.doc, isClipContent$1)) == null ? void 0 : _a2[0];
  const highlightsBlock = (_b2 = findChildren(tr.doc, isHighlightsBlock$3)) == null ? void 0 : _b2[0];
  if (!clip || !highlightsBlock)
    return tr;
  if (clip.node.attrs.clipBookmarkType) {
    const highlightsJSON = highlightsBlock.node.toJSON();
    return tr.setNodeAttribute(clip.pos, "highlights", highlightsJSON);
  }
  if (clip && isClipWithAttributesSync(clip.node))
    return addHighlightsInHighlightsAttributeTransaction({ state, tr });
  const { searchableClipImages, searchableClipText } = generateSearchIndex(
    clip
  );
  const mappingBlockIdHighlightId = {};
  highlightsBlock.node.content.forEach((node) => {
    var _a3, _b3, _c2;
    const blockId = node.attrs[BlockAttrsParams.BLOCK_UUID];
    const highlightBlock = getSeshatBlockByBlockId(tr.doc, blockId);
    if (!highlightBlock)
      return;
    let highlightId = getHighlightIdFromClip(clip.node, highlightBlock.node);
    if (highlightId) {
      mappingBlockIdHighlightId[blockId] = highlightId;
      return;
    }
    const blockquote = (_a3 = findChildren(highlightBlock.node, isBlockquote)) == null ? void 0 : _a3[0];
    const note = (_b3 = findChildren(highlightBlock.node, isHighlightNote$2)) == null ? void 0 : _b3[0];
    highlightId = (_c2 = getHighlightIdFromNode(highlightBlock.node)) != null ? _c2 : generateRandomId();
    let { newTr, matched } = highlightMatchingClipContent({
      schema,
      tr,
      searchableClipText,
      searchableClipImages,
      blockquote,
      highlight: schema.marks[MarkTypes.HIGHLIGHT].create({
        [MarkAttrsParams.HIGHLIGHT_UUID]: highlightId,
        [MarkAttrsParams.HIGHLIGHT_COLOR]: getDefaultHighlightColor(),
        [MarkAttrsParams.HIGHLIGHT_NOTE]: note ? note.node.toJSON() : void 0
      })
    });
    tr = newTr;
    if (matched) {
      mappingBlockIdHighlightId[blockId] = highlightId;
      tr.setNodeMarkup(highlightBlock.pos, void 0, {
        ...highlightBlock.node.attrs,
        highlightId
      });
    } else {
      tr = turnHighlightIntoBlockquote({ tr, schema, block: highlightBlock });
      tr.setMeta(ANALYTICS_META, {
        name: ANALYTICS_EVENTS.UNMATCHED_HIGHLIGHT,
        details: {
          url: clip.node.attrs.href,
          highlight: highlightBlock.node.textContent,
          blockquote: blockquote.node.textContent
        }
      });
    }
  });
  const didHighlightsMatch = Object.values(mappingBlockIdHighlightId).some(
    (highlightId) => highlightId !== void 0
  );
  if (didHighlightsMatch && !hasConnectedClip(highlightsBlock.node)) {
    tr.setNodeMarkup(highlightsBlock.pos, void 0, {
      ...highlightsBlock.node.attrs,
      connectedClip: clip.node.attrs[BlockAttrsParams.BLOCK_UUID]
    });
  }
  if (didHighlightsMatch && !!clip.node.attrs.highlights) {
    const clipId = clip.node.attrs[BlockAttrsParams.BLOCK_UUID];
    const updatedClip = getSeshatBlockByBlockId(tr.doc, clipId);
    if (updatedClip) {
      tr.setNodeMarkup(updatedClip.pos, void 0, {
        ...updatedClip.node.attrs,
        highlights: void 0
      });
    }
  }
  return tr.setMeta(IgnoreContentEditableFalse, true);
};
const isHighlightsBlock$3 = (node) => node.attrs.type === BlockTypes.HIGHLIGHTS;
const isClipContent$1 = (node) => node.attrs.type === BlockTypes.CLIP_CONTENT || node.attrs.clipBookmarkType === ClipBookmarksTypes.PDF;
const isBlockquote = (node) => node.attrs.type === BlockTypes.BLOCKQUOTE;
const isHighlightNote$2 = (node) => node.attrs.type === BlockTypes.HIGHLIGHT_NOTE;
const hasConnectedClip = (highlightsBlock) => !!highlightsBlock.attrs.connectedClip;
const getHighlightIdFromClip = (clip, highlight2) => {
  const highlightId = highlight2.attrs[BlockAttrsParams.HIGHLIGHT_UUID];
  if (!highlightId)
    return void 0;
  const clipContentHighlights = findChildren(clip, (node) => {
    const highlightMark = getHighlightMarkFromNode(node);
    return (highlightMark == null ? void 0 : highlightMark.attrs[MarkAttrsParams.HIGHLIGHT_UUID]) === highlightId;
  });
  return !!clipContentHighlights.length ? highlightId : void 0;
};
const turnHighlightIntoBlockquote = ({
  tr,
  block,
  schema
}) => {
  const blockquote = tr.doc.slice(
    block.pos + 1,
    block.pos + block.node.firstChild.nodeSize
  ).content;
  const note = getNoteFromHighlight(block.node);
  const noteContent = note ? Node$1.fromJSON(schema, note).content.content : void 0;
  const $highlight = tr.doc.resolve(block.pos);
  tr.insert(
    $highlight.after(),
    Fragment.fromArray([...blockquote.content, ...noteContent != null ? noteContent : []])
  );
  tr.delete(block.pos, block.pos + block.node.nodeSize);
  return tr;
};
const setClipContentStatus = ({
  attrs,
  scrollIntoView = true
}) => ({ commands, tr, dispatch }) => {
  var _a2;
  const result = (_a2 = findChildren(
    tr.doc,
    (node) => node.attrs.type === BlockTypes.CLIP_CONTENT || Object.values(ClipBookmarksTypes).includes(node.attrs.clipBookmarkType)
  )) == null ? void 0 : _a2[0];
  if (!result)
    return false;
  const { node: seshatBlock, pos } = result;
  if (seshatBlock.attrs.clipBookmarkType) {
    for (const [key, value] of Object.entries(attrs)) {
      tr.setNodeAttribute(pos, key, value);
    }
    dispatch == null ? void 0 : dispatch(tr);
    return true;
  } else {
    commands.updateBlockAttributesAt({
      pos,
      attrs: {
        ...seshatBlock.attrs,
        ...attrs
      },
      scrollIntoView
    });
    return true;
  }
};
const CLIP_CONTENT_FIRST_POSITION_DEEP = SESHAT_CONTENT_DEPTH + 2;
const toggleClipContentEditable = () => ({ chain, tr }) => {
  const result = getCurrentBlock(
    tr.doc,
    tr.selection.from,
    (node) => node.attrs.type === BlockTypes.CLIP_CONTENT
  );
  if (!result)
    return false;
  const { node: seshatBlock, from: editAttrPos } = result;
  const currentContentEditableStatus = seshatBlock.attrs.contentEditable;
  chain().updateBlockAttributesAt({
    pos: editAttrPos,
    attrs: {
      ...seshatBlock.attrs,
      contentEditable: !currentContentEditableStatus
    },
    scrollIntoView: true
  });
  if (!currentContentEditableStatus)
    chain().unsetBlockSelection().focus(editAttrPos + CLIP_CONTENT_FIRST_POSITION_DEEP);
  else
    chain().focus(editAttrPos).selectBlock();
  chain().scrollIntoView().run();
  return true;
};
const ClipContentBlock = Extension.create({
  name: BlockTypes.CLIP_CONTENT,
  addCommands() {
    return {
      addHighlightsInHighlightsAttribute,
      matchHighlightsWithClipContent,
      insertClip: insertClip$1,
      toggleClipContentEditable,
      insertClipVideo: insertClipVideo$1,
      insertClipTitle,
      setClipContentStatus
    };
  }
});
const maybeAddMissingMarksInClipContent = ({
  tr,
  clipId
}) => {
  const highlights = getHighlightsFromClipContent({ doc: tr.doc, clipId });
  if (!highlights)
    return tr;
  highlights.forEach((highlight2) => {
    tr.doc.nodesBetween(highlight2.from, highlight2.to, (node, pos) => {
      if (!isHighlightMarkAllowed(node) || getHighlightMarkFromNode(node))
        return;
      const previousNode = tr.doc.nodeAt(highlight2.from);
      const mark = getHighlightMarkFromNode(previousNode);
      if (mark)
        tr.addMark(pos, pos + node.nodeSize, mark);
    });
  });
  return tr;
};
const getClipContent = (doc) => {
  const clip = findChildren(
    doc,
    (node) => node.attrs.type === BlockTypes.CLIP_CONTENT
  );
  return clip.length ? clip[0] : void 0;
};
const isEmptyClip = (node) => node.attrs.type === BlockTypes.CLIP_CONTENT && !!!node.textContent && node.nodeSize === 8;
const isCaretInEmptyClip = (state) => {
  const { $anchor } = state.selection;
  return $anchor.depth >= 5 && isEmptyClip($anchor.node($anchor.depth - 3));
};
function getClipContentBlock({
  pos,
  doc
}) {
  const block = getCurrentBlock(doc, pos);
  if (!block)
    return void 0;
  if (block.node.attrs.type === BlockTypes.CLIP_CONTENT) {
    return block.node;
  }
  const ancestor = doc.resolve(pos).node(block.depth - 1);
  if ((ancestor == null ? void 0 : ancestor.attrs.type) === BlockTypes.CLIP_CONTENT) {
    return ancestor;
  }
  return void 0;
}
const getClipsFromDoc = (doc) => {
  return findChildren(doc, isSeshatBlockClip$1).map(
    (node) => NodeSelection.create(doc, node.pos)
  );
};
const getConnectedHighlightsBlockByClipId = (doc, clipId) => {
  if (!clipId)
    return void 0;
  const blocks = findChildren(doc, (node) => {
    return !!clipId && node.attrs.connectedClip === clipId;
  });
  return blocks.length ? blocks[0] : void 0;
};
const deleteBlock = () => ({ tr, dispatch }) => {
  dispatch == null ? void 0 : dispatch(deleteBlockTransaction({ tr }));
  return true;
};
const deleteBlockTransaction = ({ tr }) => {
  const { selection, doc } = tr;
  const { from } = selection;
  const seshatBlock = getCurrentBlock(doc, from);
  if (!(seshatBlock == null ? void 0 : seshatBlock.node))
    return tr;
  tr.delete(seshatBlock.from, seshatBlock.to);
  const caretPos = minMax(
    seshatBlock.from - SESHAT_CONTENT_DEPTH - 1,
    SESHAT_ROOT_DEPTH,
    tr.doc.nodeSize - SESHAT_ROOT_DEPTH
  );
  tr.setSelection(TextSelection.near(tr.doc.resolve(caretPos)));
  return tr;
};
const getHighlightsBlocksFromDoc = (doc) => {
  return findChildren(doc, isHighlightsBlockNode).map(
    (node) => NodeSelection.create(doc, node.pos)
  );
};
const isHighlightsBlockNode = (node) => node.attrs.type === BlockTypes.HIGHLIGHTS;
const createHighlightsBlock = ({
  doc,
  schema,
  clip
}) => {
  if (!clip || isClipAlreadyConnected({ doc, clip: clip.node }))
    return createHighlightsBlockNode({ schema, content: void 0 });
  const clipId = clip.node.attrs[BlockAttrsParams.BLOCK_UUID];
  if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOK) {
    const kindleHighlights = getHighlightsFromClipBook(clip.node);
    return createHighlightsBlockNode({
      schema,
      connectedClipId: clipId,
      content: kindleHighlights ? createHighlightsFromKindleHighlights({
        schema,
        kindleHighlights
      }) : void 0
    });
  }
  if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOKMARK) {
    return createHighlightsBlockFromClipBookmark({
      schema,
      clip: clip.node
    });
  }
  if (clip.node.attrs.type === BlockTypes.CLIP_CONTENT) {
    return createHighlightsBlockNode({
      schema,
      connectedClipId: clipId,
      content: isClipWithAttributesSync(clip.node) ? createHighlightsFromPaywallClipContent({ schema, clip: clip.node }) : createHighlightsFromClipContent({ doc, schema, clipId })
    });
  }
  return createHighlightsBlockNode({ schema, content: void 0 });
};
const createHighlightsBlockNode = ({
  schema,
  connectedClipId,
  content
}) => {
  return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    {
      type: BlockTypes.HIGHLIGHTS,
      connectedClip: connectedClipId,
      collapsed: false
    },
    content
  );
};
const isClipAlreadyConnected = ({
  doc,
  clip
}) => {
  if (!clip)
    return false;
  const highlightsBlocks = getHighlightsBlocksFromDoc(doc);
  return highlightsBlocks.some(
    (highlightsBlock) => highlightsBlock.node.attrs.connectedClip === clip.attrs[BlockAttrsParams.BLOCK_UUID]
  );
};
const insertHighlightsBlock = ({
  pos,
  collapsed
} = {}) => ({ dispatch, state }) => dispatch == null ? void 0 : dispatch(insertHighlightsBlockHelper({ state, pos, collapsed }));
const insertHighlightsBlockHelper = ({
  state,
  existingTr,
  pos,
  collapsed
}) => {
  var _a2;
  let newTr = existingTr != null ? existingTr : state.tr;
  const { $from } = newTr.selection;
  let insertPos = pos;
  if (!insertPos) {
    const block = getCurrentBlock(newTr.doc, $from.pos);
    if (block && isSeshatBlockEmpty(block.node)) {
      newTr = deleteBlockTransaction({ tr: newTr });
      insertPos = $from.start(block.depth) - 1;
    } else {
      insertPos = ($from == null ? void 0 : $from.end((_a2 = block == null ? void 0 : block.depth) != null ? _a2 : 0)) + 1;
    }
  }
  return insertHighlightsBlockTransaction({
    state,
    tr: newTr,
    pos: insertPos,
    selection: state.selection,
    collapsed
  });
};
const getInsertPos = ({
  clip,
  $from
}) => {
  if (clip)
    return clip.pos;
  return $from.pos;
};
const mergeWithHighlightWithNoConnectedClip = ({
  highlightsBlock,
  highlightsBlockWithOutConnectedClipIdBlock,
  tr,
  clip
}) => {
  const mergedHighlight = highlightsBlock.copy(
    highlightsBlock.content.append(
      highlightsBlockWithOutConnectedClipIdBlock == null ? void 0 : highlightsBlockWithOutConnectedClipIdBlock.node.content
    )
  );
  if (clip == null ? void 0 : clip.pos) {
    const highlightsJSON = mergedHighlight.toJSON();
    tr.setNodeAttribute(clip.pos + 3, "highlights", highlightsJSON);
  }
  tr.replaceWith(
    highlightsBlockWithOutConnectedClipIdBlock.pos,
    highlightsBlockWithOutConnectedClipIdBlock.node.nodeSize,
    mergedHighlight
  );
  return tr;
};
const insertHighlightsBlockTransaction = ({
  tr,
  state,
  pos,
  selection,
  collapsed,
  emitSelectionUpdate = true
}) => {
  var _a2, _b2;
  const { schema } = state;
  const { $from } = selection;
  const clip = getNearestClip({ doc: tr.doc, from: pos != null ? pos : $from.pos });
  if (clip && isClipAlreadyConnected({ doc: tr.doc, clip: clip.node }))
    return tr;
  const highlightsBlock = createHighlightsBlock({ doc: tr.doc, schema, clip });
  if (!highlightsBlock)
    return tr;
  const highlightsBlockWithOutConnectedClipIdBlock = findHighlightsBlockWithOutConnectedClipId(
    {
      doc: tr.doc
    }
  );
  let insertPos = (_a2 = highlightsBlockWithOutConnectedClipIdBlock == null ? void 0 : highlightsBlockWithOutConnectedClipIdBlock.pos) != null ? _a2 : getInsertPos({
    clip,
    $from
  });
  if (highlightsBlockWithOutConnectedClipIdBlock == null ? void 0 : highlightsBlockWithOutConnectedClipIdBlock.node) {
    tr = mergeWithHighlightWithNoConnectedClip({
      highlightsBlock,
      tr,
      clip,
      highlightsBlockWithOutConnectedClipIdBlock
    });
  } else {
    tr.insert(insertPos, highlightsBlock);
    if (collapsed)
      tr.setNodeMarkup(insertPos, void 0, {
        ...highlightsBlock.attrs,
        collapsed: true
      });
    tr.removeMark(
      insertPos,
      insertPos + highlightsBlock.nodeSize,
      schema.marks[MarkTypes.HIGHLIGHT]
    );
  }
  if (emitSelectionUpdate) {
    let caretPos = getInsertPos({
      clip,
      $from
    });
    if (!!highlightsBlock.childCount) {
      caretPos = insertPos + highlightsBlock.content.size + ((_b2 = highlightsBlockWithOutConnectedClipIdBlock == null ? void 0 : highlightsBlockWithOutConnectedClipIdBlock.node.content.size) != null ? _b2 : 0) - SESHAT_CONTENT_DEPTH - 2;
    }
    tr = setCaretNearbyTransaction({ state, tr, pos: caretPos });
  }
  return tr.setMeta(highlightsBlocksObserverPluginKey, true);
};
const syncHighlightsBlocksAfterClipModification = () => ({
  state,
  tr,
  dispatch
}) => {
  const clips = getClipsFromDoc(tr.doc).map(
    (clip) => {
      var _a2;
      return (_a2 = clip.node.attrs) == null ? void 0 : _a2[BlockAttrsParams.BLOCK_UUID];
    }
  );
  dispatch == null ? void 0 : dispatch(
    syncHighlightsBlocksAfterClipModificationTransaction({
      state,
      modifiedClips: clips
    })
  );
  return true;
};
const syncHighlightsBlocksAfterClipModificationTransaction = ({
  state,
  modifiedClips
}) => {
  let { tr, schema } = state;
  modifiedClips.forEach((clipId) => {
    const clip = getSeshatBlockByBlockId(tr.doc, clipId);
    let block = getConnectedHighlightsBlockByClipId(tr.doc, clipId);
    if (!clip)
      return;
    let highlights;
    if (clip.node.attrs.type === BlockTypes.CLIP_CONTENT) {
      if (isClipWithAttributesSync(clip.node))
        return;
      tr = maybeAddMissingMarksInClipContent({ tr, clipId });
      highlights = createHighlightsFromClipContent({
        doc: tr.doc,
        schema,
        clipId
      });
      const isFirstHighlightAndNotHighlightsBlock = !block && (highlights == null ? void 0 : highlights.length) !== 0;
      if (isFirstHighlightAndNotHighlightsBlock) {
        tr = insertHighlightsBlockTransaction({
          tr,
          state,
          selection: tr.selection,
          pos: clip.pos,
          collapsed: true,
          emitSelectionUpdate: false
        });
        block = getConnectedHighlightsBlockByClipId(tr.doc, clipId);
      }
    } else if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOK && block) {
      const newHighlightsNodes = createNewHighlightsFromKindleHighlights({
        schema,
        block,
        clip
      });
      if (newHighlightsNodes) {
        highlights = [...block.node.content.content, ...newHighlightsNodes];
      }
    } else if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOKMARK) {
      highlights = createHighlightsBlockFromClipBookmark({
        schema,
        clip: clip.node
      }).content.content;
      const isFirstHighlightAndNotHighlightsBlock = !block && (highlights == null ? void 0 : highlights.length) !== 0;
      if (isFirstHighlightAndNotHighlightsBlock) {
        tr = insertHighlightsBlockTransaction({
          tr,
          state,
          selection: tr.selection,
          pos: clip.pos,
          collapsed: true,
          emitSelectionUpdate: false
        });
        block = getConnectedHighlightsBlockByClipId(tr.doc, clipId);
      }
    }
    if (!block)
      return;
    const wrappedContentStart = block.pos + 1;
    const wrappedContentEnd = block.pos + block.node.nodeSize - 1;
    const filteredHighlights = highlights == null ? void 0 : highlights.filter((h) => !isEmptyHighlight(h));
    const newContent = filteredHighlights ? new Slice(Fragment.from(filteredHighlights), 0, 0) : void 0;
    tr.replace(wrappedContentStart, wrappedContentEnd, newContent);
    if (newContent)
      tr.removeMark(
        wrappedContentStart,
        wrappedContentStart + newContent.size,
        schema.marks[MarkTypes.HIGHLIGHT]
      );
  });
  tr.setMeta(clipObserverPluginKey, true);
  tr.setMeta(IgnoreContentEditableFalse, true);
  return tr;
};
const isEmptyHighlight = (node) => {
  const EMPTY_SESHAT_BLOCK_SIZE = 6;
  const HIGHLIGHT_WRAPPER_SIZE = 4;
  return node.nodeSize <= EMPTY_SESHAT_BLOCK_SIZE + HIGHLIGHT_WRAPPER_SIZE;
};
const getNearestHighlightBlock = ($from) => {
  let depth = $from.depth;
  while (depth >= 0) {
    let node = $from.node(depth);
    if ((node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHT) {
      return { node, depth };
    } else {
      depth--;
    }
  }
  return void 0;
};
const insertHighlightNote = ({
  pos
} = {}) => ({ dispatch, state, tr }) => {
  var _a2;
  const $from = pos ? state.doc.resolve(pos) : state.selection.$from;
  const highlightBlock = getNearestHighlightBlock($from);
  if (!highlightBlock)
    return false;
  const hasHighlightNote = ((_a2 = highlightBlock.node.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE;
  if (hasHighlightNote) {
    tr = insertEmptyBlockAtEndOfNote({ state, $from, highlightBlock });
  } else {
    tr = insertNoteWithEmptyBlock({ state, $from, highlightBlock });
  }
  tr.setMeta(ANALYTICS_META, ANALYTICS_EVENTS.INSERT_HIGHLIGHT_NOTE);
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const insertEmptyBlockAtEndOfNote = ({
  state,
  $from,
  highlightBlock
}) => {
  var _a2, _b2;
  const { tr, schema } = state;
  const blockquoteEnd = $from.end(highlightBlock.depth + 1) + 1;
  const noteSize = (_b2 = (_a2 = highlightBlock.node.lastChild) == null ? void 0 : _a2.content.size) != null ? _b2 : 0;
  const insertPos = blockquoteEnd + noteSize + 1;
  const block = createSeshatBlock({ schema });
  tr.insert(insertPos, block);
  return setCaretNearbyTransaction({
    state,
    tr,
    pos: insertPos + block.content.size - SESHAT_CONTENT_DEPTH
  });
};
const insertNoteWithEmptyBlock = ({
  state,
  $from,
  highlightBlock
}) => {
  const { tr, schema } = state;
  const blockquoteEnd = $from.end(highlightBlock.depth + 1);
  const insertPos = blockquoteEnd + 1;
  const block = schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { type: BlockTypes.HIGHLIGHT_NOTE },
    [createSeshatBlock({ schema })]
  );
  tr.insert(insertPos, block);
  return setCaretNearbyTransaction({
    state,
    tr,
    pos: insertPos + block.content.size - SESHAT_CONTENT_DEPTH
  });
};
const liftBlockOutOfHighlights = () => ({ state, chain }) => {
  const { doc, selection } = state.tr;
  const blockSelection = BlockSelection.createFromPosition(doc, selection.from);
  const block = blockSelection.firstBlock();
  const highlightsBlock = findAncestor(selection.$from, isHighlightsBlock$2);
  if (!highlightsBlock)
    return false;
  const insertPos = selection.$from.after(highlightsBlock.depth);
  return chain().insertContentAt(insertPos, generateEmptyBlock(block.node.attrs)).focus(insertPos + SESHAT_CONTENT_DEPTH + 1).deleteRange({ from: block.from - 1, to: block.to + 1 }).run();
};
const isHighlightsBlock$2 = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS;
const removeOrphanHighlightsBlock = () => ({
  state,
  tr,
  dispatch
}) => {
  const highlightsBlocks = findChildren(
    state.doc,
    (node) => node.attrs.type === BlockTypes.HIGHLIGHTS
  );
  highlightsBlocks.forEach(({ node, pos }) => {
    const connectedClipId = node.attrs.connectedClip;
    if (!connectedClipId)
      return;
    const connectedClip = getSeshatBlockByBlockId(state.doc, connectedClipId);
    if (!connectedClip) {
      tr.deleteRange(pos, pos + node.nodeSize);
    }
  });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const turnHighlightsBlocksIntoBlockquotes$1 = () => ({
  state,
  dispatch
}) => {
  let tr = unwrapHighlightsBlock(state.tr);
  if (!tr)
    return false;
  tr = unwrapHighlightNote(tr);
  if (!tr)
    return false;
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const unwrapHighlightsBlock = (tr) => {
  const { selection } = tr;
  const highlightsBlock = findAncestor(selection.$from, isHighlightsBlock$1);
  if (!highlightsBlock)
    return false;
  const startPos = selection.$from.before(highlightsBlock.depth + 1) + 1;
  const endPos = selection.$from.end(highlightsBlock.depth + 1) - 1;
  const range = tr.doc.resolve(startPos).blockRange(tr.doc.resolve(endPos));
  if (!range)
    return false;
  return tr.lift(range, 1);
};
const unwrapHighlightNote = (tr) => {
  const [highlightNoteWithPos] = findChildren(tr.doc, isHighlightNote$1);
  if (!highlightNoteWithPos)
    return false;
  const { pos, node } = highlightNoteWithPos;
  const startPos = pos + SESHAT_CONTENT_DEPTH;
  const endPos = startPos + node.nodeSize - SESHAT_CONTENT_DEPTH - 1;
  const range = tr.doc.resolve(startPos).blockRange(tr.doc.resolve(endPos));
  if (!range)
    return false;
  return tr.lift(range, 1);
};
const isHighlightsBlock$1 = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS;
const isHighlightNote$1 = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHT_NOTE;
const getHighlightBlockByHighlightId = (doc, highlightId) => {
  const highlightBlock = findChildren(
    doc,
    (node) => node.attrs.type === BlockTypes.HIGHLIGHT && node.attrs[BlockAttrsParams.HIGHLIGHT_UUID] === highlightId
  );
  return highlightBlock.length ? highlightBlock[0] : void 0;
};
const updateHighlightBlockAttributes$1 = (props) => ({ state, dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(
    updateHighlightBlockAttributesTransaction({ state, tr, ...props })
  );
  return true;
};
const updateHighlightBlockAttributesTransaction = ({
  tr,
  attrs,
  state,
  highlightId,
  scrollIntoView
}) => {
  var _a2;
  if (!highlightId)
    return false;
  const pos = (_a2 = getHighlightBlockByHighlightId(state.doc, highlightId)) == null ? void 0 : _a2.pos;
  if (!pos)
    return false;
  const node = tr.doc.nodeAt(pos);
  if ((node == null ? void 0 : node.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  tr.setNodeMarkup(pos, void 0, {
    ...node.attrs,
    ...attrs
  });
  if (scrollIntoView)
    tr.scrollIntoView();
  return tr;
};
const turnHighlightsBlockHighlightsIntoBlockquotes = ({
  state,
  removedClips
}) => {
  let { tr, doc } = state;
  removedClips.forEach((clipId) => {
    const block = getConnectedHighlightsBlockByClipId(doc, clipId);
    if (!block)
      return;
    const $block = NodeSelection.create(doc, block.pos);
    const { content: highlightBlockNodes } = $block.node;
    tr = removeWrappingBlock({
      tr,
      blockStart: $block.$from.pos,
      blockEnd: $block.$to.pos,
      content: highlightBlockNodes
    });
    let removedWrappersCount = 0;
    highlightBlockNodes.forEach((node, parentOffset) => {
      var _a2;
      const deletedPosCount = removedWrappersCount * 2;
      const highlightStart = $block.$from.pos + parentOffset - deletedPosCount;
      const highlightEnd = highlightStart + node.nodeSize - 1;
      tr = removeWrappingBlock({
        tr,
        blockStart: highlightStart,
        blockEnd: highlightEnd,
        content: node.content
      });
      const blockquote = node.firstChild;
      const note = ((_a2 = node.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE ? node.lastChild : void 0;
      if (blockquote && note) {
        removedWrappersCount++;
        tr = removeWrappingBlock({
          tr,
          blockStart: highlightStart + blockquote.nodeSize,
          blockEnd: highlightEnd,
          content: note.content
        });
      }
      removedWrappersCount++;
    });
  });
  return tr.setMeta(clipObserverPluginKey, true);
};
const removeWrappingBlock = ({
  tr,
  blockStart,
  blockEnd,
  content
}) => tr.replace(blockStart, blockEnd, new Slice(content, 0, 0));
const getTouchedClipIds = (trs) => {
  const clipIds = {
    removed: [],
    modified: []
  };
  trs.forEach((tr) => {
    if (wasTransactionDispatchedBySyncPlugin(tr))
      return;
    if (wasTransactionDispatchedByBlockIdPlugin(tr))
      return;
    if (wasTransactionDispatchedByMentionPlugin(tr))
      return;
    tr.steps.forEach((step, i) => {
      const doc = tr.docs.length && tr.docs[i];
      if (!doc || !isModificationStep(step))
        return;
      const clips = getClipsFromDoc(doc);
      clips.forEach((clip) => {
        const clipId = clip.node.attrs[BlockAttrsParams.BLOCK_UUID];
        if (!clipId)
          return;
        if (isModificationWithinNode(clip, step) && !clipIds.modified.includes(clipId))
          clipIds.modified.push(clipId);
        if (isReplacementAcrossNode(clip, step) && !clipIds.removed.includes(clipId))
          clipIds.removed.push(clipId);
      });
    });
  });
  return clipIds;
};
const isUndoAction = (trs) => {
  return trs.some((tr) => {
    var _a2;
    return ((_a2 = tr.getMeta("history$")) == null ? void 0 : _a2.redo) === false;
  });
};
const clipObserverPlugin = new Plugin({
  key: clipObserverPluginKey,
  appendTransaction(trs, _2, state) {
    const hasDocChanged = trs.some((tr) => tr.docChanged);
    if (!hasDocChanged || isUndoAction(trs))
      return;
    const clipIds = getTouchedClipIds(trs);
    if (clipIds.removed.length) {
      return turnHighlightsBlockHighlightsIntoBlockquotes({
        state,
        removedClips: clipIds.removed
      });
    }
    if (clipIds.modified.length) {
      return syncHighlightsBlocksAfterClipModificationTransaction({
        state,
        modifiedClips: clipIds.modified
      });
    }
    return;
  }
});
const getBlockquoteContentFromHighlight = (highlight2) => {
  var _a2;
  if (((_a2 = highlight2.firstChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.BLOCKQUOTE && highlight2.firstChild.firstChild) {
    const startOfBlockquoteContent = SESHAT_CONTENT_DEPTH * 2;
    const endOfBlockquoteContent = highlight2.firstChild.nodeSize - SESHAT_CONTENT_DEPTH * 2;
    return highlight2.slice(startOfBlockquoteContent, endOfBlockquoteContent);
  } else {
    return new Slice(Fragment.from(), 0, 0);
  }
};
const removeEmptyHighlightsFromHighlightsBlock = ({
  tr,
  highlightsBlock
}) => {
  if (!(highlightsBlock == null ? void 0 : highlightsBlock.node.content))
    return tr;
  let newTr = tr;
  highlightsBlock.node.content.forEach((highlight2, offset) => {
    if (hasVideoHighlighBlockquote(highlight2))
      return;
    const content = getBlockquoteContentFromHighlight(highlight2);
    if (content.size !== 0)
      return;
    const blockStart = highlightsBlock.pos + offset + 1;
    const blockEnd = blockStart + highlight2.nodeSize;
    newTr = newTr.delete(blockStart, blockEnd);
  });
  return newTr;
};
const hasVideoHighlighBlockquote = (highlight2) => {
  var _a2;
  return !!highlight2.attrs.timestamp && ((_a2 = highlight2.firstChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.BLOCKQUOTE;
};
const removeEmptyNotesFromHighlightsBlock = ({
  tr,
  highlightsBlock
}) => {
  if (!(highlightsBlock == null ? void 0 : highlightsBlock.node.content))
    return tr;
  let newTr = tr;
  let $rangesToDelete = [];
  highlightsBlock.node.content.forEach((highlight2, offset) => {
    var _a2, _b2;
    const hasNote = ((_a2 = highlight2.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE;
    if (!hasNote)
      return;
    const hasNoteContent = (_b2 = highlight2.lastChild) == null ? void 0 : _b2.childCount;
    if (hasNoteContent)
      return;
    const blockquoteSize = highlight2.firstChild.nodeSize;
    const noteStart = highlightsBlock.pos + offset + blockquoteSize + 1;
    const noteEnd = noteStart + highlight2.lastChild.nodeSize;
    $rangesToDelete.push({
      $from: newTr.doc.resolve(noteStart),
      $to: newTr.doc.resolve(noteEnd)
    });
  });
  $rangesToDelete.forEach(($range) => {
    newTr.delete($range.$from.pos, $range.$to.pos);
  });
  return newTr;
};
const syncClipAfterHighlightsBlockModification = ({
  state,
  modifiedHighlightsBlocks
}) => {
  let { tr, schema } = state;
  modifiedHighlightsBlocks.forEach((blockId) => {
    let highlightsBlock = getSeshatBlockByBlockId(tr.doc, blockId);
    if (!highlightsBlock)
      return;
    tr = removeEmptyHighlightsFromHighlightsBlock({ tr, highlightsBlock });
    tr = removeEmptyNotesFromHighlightsBlock({ tr, highlightsBlock });
    const connectedClipId = highlightsBlock == null ? void 0 : highlightsBlock.node.attrs.connectedClip;
    if (!connectedClipId)
      return;
    const clip = getSeshatBlockByBlockId(tr.doc, connectedClipId);
    if (!clip)
      return;
    if (clip.node.attrs.type === BlockTypes.CLIP_CONTENT) {
      tr = isClipWithAttributesSync(clip.node) ? syncPaywallClipContent({ tr, highlightsBlock, clip }) : syncClipContent({ tr, schema, highlightsBlock, clip });
    }
    if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOKMARK) {
      tr = syncClipBookmark({ tr, highlightsBlock, clip });
    }
    if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOK) {
      tr = syncClipBookmark({ tr, highlightsBlock, clip });
    }
  });
  tr.setMeta(highlightsBlocksObserverPluginKey, true);
  tr.setMeta(IgnoreContentEditableFalse, true);
  return tr;
};
const getTouchedHighlightsBlockIds = (trs) => {
  const highlightsBlockIds = [];
  trs.forEach((tr) => {
    if (wasTransactionDispatchedBySyncPlugin(tr))
      return;
    if (wasTransactionDispatchedByBlockIdPlugin(tr))
      return;
    if (wasTransactionDispatchedByMentionPlugin(tr))
      return;
    tr.steps.forEach((step, i) => {
      const doc = tr.docs.length && tr.docs[i];
      if (!doc || !isModificationStep(step))
        return;
      const blocks = getHighlightsBlocksFromDoc(doc);
      blocks.forEach((block) => {
        if (isReplacementAcrossNode(block, step))
          return;
        const blockId = block.node.attrs[BlockAttrsParams.BLOCK_UUID];
        if (isModificationWithinNode(block, step) && !highlightsBlockIds.includes(blockId))
          highlightsBlockIds.push(blockId);
      });
    });
  });
  return highlightsBlockIds;
};
const highlightsBlocksObserverPlugin = new Plugin({
  key: highlightsBlocksObserverPluginKey,
  appendTransaction(trs, _2, state) {
    const hasDocChanged = trs.some((tr) => tr.docChanged);
    if (!hasDocChanged || isUndoAction(trs))
      return;
    const highlightsBlockIds = getTouchedHighlightsBlockIds(trs);
    if (highlightsBlockIds.length) {
      return syncClipAfterHighlightsBlockModification({
        state,
        modifiedHighlightsBlocks: highlightsBlockIds
      });
    }
    return;
  }
});
const HighlightsBlock = Extension.create({
  name: BlockTypes.HIGHLIGHTS,
  addCommands() {
    return {
      insertHighlightsBlock,
      insertHighlightNote,
      removeOrphanHighlightsBlock,
      liftBlockOutOfHighlights,
      turnHighlightsBlocksIntoBlockquotes: turnHighlightsBlocksIntoBlockquotes$1,
      syncHighlightsBlocksAfterClipModification,
      updateHighlightBlockAttributes: updateHighlightBlockAttributes$1
    };
  },
  addProseMirrorPlugins() {
    return [clipObserverPlugin, highlightsBlocksObserverPlugin];
  }
});
const getClipByHrefAndEmpty = ({
  doc,
  from,
  href
}) => {
  for (let i = 0; i <= doc.nodeSize - SESHAT_CONTENT_DEPTH; i++) {
    const node = doc.nodeAt(i);
    if (isSeshatBlockClip({ node, href })) {
      return { node, pos: i };
    }
  }
  for (let i = from; i >= 0; i--) {
    const node = doc.nodeAt(i);
    if (isSeshatBlockClip({ node, href })) {
      return { node, pos: i };
    }
  }
  return void 0;
};
const isSeshatBlockClip = ({
  node,
  href
}) => {
  var _a2;
  if ((node == null ? void 0 : node.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  if (!!node.textContent)
    return false;
  const nodeType = (_a2 = node == null ? void 0 : node.attrs.nodeViewType) != null ? _a2 : node == null ? void 0 : node.attrs.type;
  return nodeType && (node == null ? void 0 : node.attrs.href) === href && clipBlocks.includes(nodeType);
};
const isCaretWithinHighlightBlockquote = ($from) => {
  var _a2, _b2, _c2;
  const highlightBlock = getNearestHighlightBlock($from);
  if (!highlightBlock)
    return false;
  if (((_a2 = highlightBlock.node.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.BLOCKQUOTE)
    return true;
  const highlightBlockStart = $from.start(highlightBlock.depth) + 1;
  const blockquoteSize = (_c2 = (_b2 = highlightBlock.node.firstChild) == null ? void 0 : _b2.content.size) != null ? _c2 : 0;
  const blockquoteEnd = highlightBlockStart + blockquoteSize;
  return highlightBlockStart <= $from.pos && $from.pos < blockquoteEnd;
};
const isCaretWithinHighlightNote = ($from) => {
  var _a2, _b2, _c2;
  const highlightBlock = getNearestHighlightBlock($from);
  if (!highlightBlock)
    return false;
  if (((_a2 = highlightBlock.node.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.BLOCKQUOTE)
    return false;
  const highlightBlockStart = $from.start(highlightBlock.depth) + 1;
  const highlightBlockEnd = $from.end(highlightBlock.depth) - 1;
  const blockquoteSize = (_c2 = (_b2 = highlightBlock.node.firstChild) == null ? void 0 : _b2.content.size) != null ? _c2 : 0;
  const noteStart = highlightBlockStart + blockquoteSize + 1;
  return noteStart <= $from.pos && $from.pos < highlightBlockEnd;
};
const isEmptyHighlightsBlock = (node) => {
  return (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS && node.childCount === 0;
};
const isAtom = (node) => {
  if (!node)
    return false;
  return isEmptyHighlightsBlock(node) || isContentEditableFalse(node) || node.isAtom;
};
const hasSelectableText$1 = (node) => {
  var _a2;
  return !isAtom(node) && ((_a2 = node.firstChild) == null ? void 0 : _a2.type.name) === SeshatNodes.BLOCK_CONTENT;
};
const hasSelectableChildren = (node) => {
  return node.type.spec.group === SeshatNodeGroups.BLOCK && !isAtom(node) && !node.attrs.collapsed;
};
const getForwardSeshatBlockContent = ({
  doc,
  selection
}) => {
  const previousSibling = getShallowPreviousTarget({ doc, selection });
  if (!previousSibling)
    return;
  let lastDeepPreviousTarget;
  selection.$from.doc.nodesBetween(
    previousSibling.pos,
    previousSibling.pos + previousSibling.node.nodeSize,
    (node, pos, parent) => {
      if (node.type.name === SeshatNodes.BLOCK_CONTENT)
        return false;
      if (hasSelectableText$1(node)) {
        lastDeepPreviousTarget = {
          node: node.firstChild,
          pos: pos + 1,
          parentNode: node,
          textSelectable: true
        };
      } else {
        lastDeepPreviousTarget = {
          node,
          pos,
          parentNode: parent,
          textSelectable: false
        };
      }
      return hasSelectableChildren(node);
    }
  );
  return lastDeepPreviousTarget;
};
const getShallowPreviousTarget = ({
  doc,
  selection
}) => {
  var _a2;
  const block = getCurrentBlock(doc, selection.$from.pos);
  if (!(block == null ? void 0 : block.node))
    return void 0;
  let { depth } = block;
  let currentParentNode;
  let currentTarget;
  let parentTargetPosition;
  let parentDepth = depth - 1;
  while (depth >= SESHAT_ROOT_DEPTH) {
    parentDepth = depth - 1;
    const seshatBlockNodeStart = selection.$from.start(depth);
    currentParentNode = selection.$from.node(parentDepth);
    const parentNodeStart = selection.$from.start(parentDepth);
    let gap = 1;
    while (!currentTarget && !currentParentNode.attrs.collapsed) {
      const currentPreviousSibling = currentParentNode == null ? void 0 : currentParentNode.childBefore(
        seshatBlockNodeStart - parentNodeStart - gap
      );
      if (!currentPreviousSibling.node)
        break;
      currentTarget = currentPreviousSibling;
      parentTargetPosition = parentNodeStart;
      gap += (_a2 = currentPreviousSibling == null ? void 0 : currentPreviousSibling.node) == null ? void 0 : _a2.nodeSize;
    }
    depth--;
  }
  if ((currentTarget == null ? void 0 : currentTarget.node) && parentTargetPosition !== void 0) {
    return {
      node: currentTarget.node,
      pos: parentTargetPosition + currentTarget.offset
    };
  }
  return void 0;
};
const getDirectPreviousSibling = ({
  doc,
  selection
}) => {
  const block = getCurrentBlock(doc, selection.$from.pos);
  if (!(block == null ? void 0 : block.node))
    return void 0;
  let { depth } = block;
  const seshatBlockNodeStart = selection.$from.start(depth);
  let parentDepth = depth - 1;
  const parentNode = selection.$from.node(parentDepth);
  const parentNodeStart = selection.$from.start(parentDepth);
  const previousSibling = parentNode.childBefore(
    seshatBlockNodeStart - parentNodeStart - 1 || 0
  );
  return {
    node: previousSibling.node,
    pos: parentNodeStart + previousSibling.offset,
    parentNode
  };
};
const getPreviousSibling = ({
  $from
}) => {
  let previousSibling;
  let parentNodeStart;
  const block = getCurrentBlock($from.doc, $from.pos);
  if (!(block == null ? void 0 : block.node))
    return void 0;
  const seshatBlockNodeStart = $from.start(block.depth);
  let parentDepth = block.depth - 1;
  while ((!(previousSibling == null ? void 0 : previousSibling.node) || parentNodeStart === void 0) && parentDepth >= 0) {
    const parentNode = $from.node(parentDepth != null ? parentDepth : 0);
    parentNodeStart = $from.start(parentDepth != null ? parentDepth : 0);
    previousSibling = parentNode.childBefore(
      seshatBlockNodeStart - (parentNodeStart != null ? parentNodeStart : 0) - 1 || 0
    );
    parentDepth -= 1;
  }
  return {
    node: previousSibling == null ? void 0 : previousSibling.node,
    offset: previousSibling == null ? void 0 : previousSibling.offset,
    index: previousSibling == null ? void 0 : previousSibling.index,
    parentNodeStart
  };
};
const hasNodeSchemaAttribute = ({
  schema,
  node,
  attributeType
}) => {
  var _a2, _b2, _c2, _d2;
  if (!(schema == null ? void 0 : schema.nodes))
    return false;
  const nodeType = (_a2 = node == null ? void 0 : node.type) == null ? void 0 : _a2.name;
  if (!nodeType)
    return false;
  const attributesNodes = (_d2 = (_c2 = (_b2 = schema == null ? void 0 : schema.nodes) == null ? void 0 : _b2[nodeType]) == null ? void 0 : _c2.spec) == null ? void 0 : _d2.attrs;
  if (!attributesNodes)
    return true;
  return Object.keys(attributesNodes).some((val) => val === attributeType);
};
const isCardTitleNode = (state) => {
  var _a2, _b2;
  const block = getCurrentBlock(state.doc, state.selection.$from.pos);
  return (block == null ? void 0 : block.depth) === 1 && ((_b2 = (_a2 = block.node) == null ? void 0 : _a2.attrs) == null ? void 0 : _b2.type) === BlockTypes.CARD_CONTENT;
};
const getNodeDepth = (node) => {
  return Math.floor((node.nodeSize - node.textContent.length) / 2);
};
const escapeBlockSelection = () => ({
  state,
  chain,
  commands
}) => {
  if (isBlockSelection(state.selection) || isCardTitleNode(state)) {
    return chain().unsetBlockSelection({ updateCaret: false }).blur().run();
  } else {
    return commands.selectBlock();
  }
};
const selectBlock = (props = {}) => ({
  tr,
  dispatch
}) => {
  dispatch == null ? void 0 : dispatch(selectBlockTransaction({ tr, ...props }));
  return true;
};
const selectBlockTransaction = ({
  tr,
  ...props
}) => {
  var _a2;
  if (props.pos) {
    return tr.setSelection(
      BlockSelection.createFromPosition(tr.doc, props.pos)
    );
  }
  const block = getCurrentBlock(
    tr.doc,
    tr.selection.from,
    (_a2 = props.isSelectableBlock) != null ? _a2 : isSelectableBlock
  );
  return block ? tr.setSelection(
    BlockSelection.createFromRange(tr.doc, block.from, block.to)
  ) : tr;
};
const selectBlocks = (props = {}) => ({
  tr,
  dispatch
}) => {
  dispatch == null ? void 0 : dispatch(selectBlocksTransaction({ tr, ...props }));
  return true;
};
const selectBlocksTransaction = ({
  tr,
  ...props
}) => {
  var _a2, _b2, _c2;
  const from = (_a2 = props.from) != null ? _a2 : tr.selection.from;
  const to = (_b2 = props.to) != null ? _b2 : tr.selection.to;
  const isBlockLevel = !!((_c2 = tr.doc.nodeAt(from)) == null ? void 0 : _c2.isBlock);
  const selection = isBlockLevel ? BlockSelection.createFromRange(tr.doc, from, to) : BlockSelection.createFromTextSelection(
    tr.doc,
    new TextSelection(tr.doc.resolve(from), tr.doc.resolve(to))
  );
  return tr.setSelection(selection);
};
const selectBlockContent = () => ({ state, tr, dispatch }) => {
  const { selection } = state;
  if (isBlockSelection(selection))
    return false;
  const start = selection.$anchor.start(selection.$anchor.depth);
  const end = selection.$anchor.end(selection.$anchor.depth);
  const isEmptyBlock = start === end;
  if (!isEmptyBlock && isBlockContentAlreadySelected(selection, start, end))
    return false;
  const selectedContent = isEmptyBlock ? BlockSelection.createFromPosition(state.doc, start) : TextSelection.create(state.doc, start, end);
  dispatch == null ? void 0 : dispatch(tr.setSelection(selectedContent));
  return true;
};
const isBlockContentAlreadySelected = (selection, start, end) => selection.$anchor.pos === start && selection.$head.pos === end;
const selectEditorContent = () => ({ state, dispatch }) => {
  let firstBlock = 0;
  const { tr } = state;
  for (let i = 1; i < tr.doc.nodeSize; i++) {
    const node = state.doc.nodeAt(i);
    if (node && node.type.spec.group === SeshatNodeGroups.BLOCK) {
      firstBlock = i;
      break;
    }
  }
  const isCardTitleSelected = tr.selection.head < firstBlock;
  if (isCardTitleSelected)
    return true;
  tr.setSelection(
    BlockSelection.createFromRange(tr.doc, firstBlock, tr.doc.nodeSize - 3)
  );
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const selectNextBlock = (options) => ({
  state,
  dispatch
}) => {
  var _a2;
  if (!isBlockSelection(state.selection))
    return false;
  const { tr, doc, selection } = state;
  const nextBlock = getNextBlock(
    doc,
    selection.to,
    (_a2 = options == null ? void 0 : options.isSelectableBlock) != null ? _a2 : isSelectableBlock,
    {
      ignoreChildren: (options == null ? void 0 : options.expand) ? true : false
    }
  );
  if (!nextBlock)
    return true;
  const newSelectionFrom = nextBlock.depth < selection.$from.depth ? selection.$from.before(selection.$from.depth) : selection.from;
  const newSelection = (options == null ? void 0 : options.expand) ? BlockSelection.createFromRange(doc, newSelectionFrom, nextBlock.to) : BlockSelection.createFromPosition(doc, nextBlock.from);
  dispatch == null ? void 0 : dispatch(tr.setSelection(newSelection).scrollIntoView());
  return true;
};
const selectNextNonEditableBlock = () => ({ chain, state }) => {
  const block = getCurrentBlock(state.doc, state.selection.from);
  const nextBlock = block && getNextBlock(state.doc, block.to);
  if (!nextBlock || !isAtom(nextBlock.node))
    return false;
  return chain().selectBlock({ pos: nextBlock.from }).scrollIntoView().run();
};
const selectPrevBlock = (options) => ({
  state,
  dispatch
}) => {
  var _a2;
  if (!isBlockSelection(state.selection))
    return false;
  const { tr, doc, selection } = state;
  const prevBlock = getPreviousBlock(
    doc,
    selection.from,
    (_a2 = options == null ? void 0 : options.isSelectableBlock) != null ? _a2 : isSelectableBlock,
    {
      ignoreChildren: (options == null ? void 0 : options.expand) ? true : false
    }
  );
  if (!prevBlock)
    return !!(options == null ? void 0 : options.expand);
  let newSelection;
  if (options == null ? void 0 : options.expand) {
    const isPrevBlockParent = prevBlock.depth < selection.$to.depth;
    const toPos = isPrevBlockParent ? prevBlock.to : selection.to;
    newSelection = BlockSelection.createFromRange(doc, prevBlock.from, toPos);
  } else {
    newSelection = BlockSelection.createFromPosition(doc, prevBlock.from);
  }
  dispatch == null ? void 0 : dispatch(tr.setSelection(newSelection).scrollIntoView());
  return true;
};
const selectPrevNonEditableBlock = () => ({ tr, chain }) => {
  const prevBlock = getPreviousBlock(tr.doc, tr.selection.from);
  if (!prevBlock || !isAtom(prevBlock.node))
    return false;
  return chain().selectBlock({ pos: prevBlock.from }).scrollIntoView().run();
};
const unsetBlockSelection = ({ updateCaret } = { updateCaret: true }) => ({ state, tr, dispatch }) => {
  if (!isBlockSelection(state.selection))
    return false;
  const lastBlock = state.selection.lastBlock();
  if (!lastBlock)
    return false;
  let returnValue = false;
  if (updateCaret) {
    const caretPos = lastBlock.node.type.name === SeshatNodes.BLOCK ? getEndOfBlockContent(lastBlock) - 1 : lastBlock.to - 1;
    dispatch == null ? void 0 : dispatch(setCaretNearbyTransaction({ state, tr, pos: caretPos }));
    returnValue = true;
  }
  return returnValue;
};
const getEndOfBlockContent = (block) => {
  var _a2, _b2;
  return block.from + ((_b2 = (_a2 = block.node.firstChild) == null ? void 0 : _a2.nodeSize) != null ? _b2 : 0);
};
const BlockSelectionDecorationPluginKey = new PluginKey(
  "BlockSelectionDecorationPlugin"
);
const BlockSelectionDecorationPlugin = (options) => {
  const isReadView = (options == null ? void 0 : options.extensionVersion) === "read_later_view";
  return new Plugin({
    key: BlockSelectionDecorationPluginKey,
    props: {
      decorations(state) {
        if (!isBlockSelection(state.selection))
          return null;
        const decorations = state.selection.list().map(
          ({ from, to }) => Decoration.node(from, to, {
            class: `${SeshatCssClass.SELECTED_BLOCK}`
          })
        );
        return DecorationSet.create(state.doc, [
          hideSelectionDecoration(state.doc),
          ...decorations
        ]);
      },
      scrollMargin: isReadView ? {
        top: 300,
        bottom: 0,
        left: 0,
        right: 0
      } : void 0
    }
  });
};
const ANNOTATION_MODE_ATTRIBUTE = "data-annotation-mode";
const ANNOTATION_META = "annotation";
const isAnnotation = (transaction) => {
  return transaction.getMeta(ANNOTATION_META) === true;
};
const AnnotationModeExtension = (options) => Extension.create({
  name: "annotationMode",
  addOptions() {
    return { annotationOnly: options == null ? void 0 : options.annotationOnly };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("annotationMode"),
        filterTransaction: (transaction) => {
          if (!this.options.annotationOnly) {
            return true;
          }
          if (transaction.docChanged) {
            return isAnnotation(transaction) || transaction.getMeta("history$");
          }
          return true;
        },
        props: {
          attributes: this.options.annotationOnly ? { [ANNOTATION_MODE_ATTRIBUTE]: "true" } : void 0
        }
      })
    ];
  },
  addCommands() {
    return {
      markAsAnnotation: () => ({ commands }) => commands.setMeta(ANNOTATION_META, true)
    };
  }
});
const SelectionBoxSelector = "data-selection-box";
class SelectionBox {
  constructor(view) {
    var _a2;
    this.box = null;
    this.box = document.createElement("div");
    this.box.setAttribute(SelectionBoxSelector, "true");
    this.box.setAttribute("id", "block_selection");
    (_a2 = view.dom.parentElement) == null ? void 0 : _a2.appendChild(this.box);
    this.dom = view.dom;
    this.offsetElement = this.box.offsetParent;
    this.setInitDecorations();
  }
  setInitDecorations() {
    var _a2, _b2, _c2, _d2;
    (_a2 = this.box) == null ? void 0 : _a2.style.setProperty("border", "1px solid rgb(114, 114, 115)");
    (_b2 = this.box) == null ? void 0 : _b2.style.setProperty("position", "absolute");
    (_c2 = this.box) == null ? void 0 : _c2.style.setProperty("z-index", "999999999999");
    (_d2 = this.box) == null ? void 0 : _d2.style.setProperty("background", "rgba(50, 51, 56, .6)");
  }
  remove() {
    var _a2;
    (_a2 = this.box) == null ? void 0 : _a2.remove();
  }
  calculatePosition({
    startCoords,
    endCoords
  }) {
    var _a2, _b2, _c2, _d2, _e2, _f2;
    const domRect = this.dom.getBoundingClientRect();
    const offsetRect = (_b2 = (_a2 = this.offsetElement).getBoundingClientRect) == null ? void 0 : _b2.call(_a2);
    const x3 = Math.min(startCoords.x, endCoords.x) + domRect.x - offsetRect.x;
    const x4 = Math.max(startCoords.x, endCoords.x) + domRect.x - offsetRect.x;
    const y3 = Math.min(startCoords.y, endCoords.y) + domRect.y - offsetRect.y;
    const y4 = Math.max(startCoords.y, endCoords.y) + domRect.y - offsetRect.y;
    (_c2 = this.box) == null ? void 0 : _c2.style.setProperty("left", x3 + "px");
    (_d2 = this.box) == null ? void 0 : _d2.style.setProperty("top", y3 + "px");
    (_e2 = this.box) == null ? void 0 : _e2.style.setProperty("width", x4 - x3 + "px");
    (_f2 = this.box) == null ? void 0 : _f2.style.setProperty("height", y4 - y3 + "px");
  }
}
const PLUGIN_NAME = "MouseBlockSelectionPlugin";
const MouseBlockSelectionPluginKey = new PluginKey(PLUGIN_NAME);
const MouseBlockSelectionPlugin = () => {
  let startCoords;
  let endCoords;
  let selectionBox;
  let prevBlocksPositions;
  let targetEditorId;
  const stopSelection = () => {
    startCoords = void 0;
    endCoords = void 0;
    selectionBox == null ? void 0 : selectionBox.remove();
    selectionBox = void 0;
    prevBlocksPositions = void 0;
    targetEditorId = null;
    document.body.style.pointerEvents = "";
  };
  return new Plugin({
    key: MouseBlockSelectionPluginKey,
    filterTransaction(tr) {
      const isTrTriggerDuringBlockSelectionButNotBlockSelection = selectionBox && !tr.getMeta(PLUGIN_NAME);
      if (isTrTriggerDuringBlockSelectionButNotBlockSelection)
        return false;
      return true;
    },
    view(view) {
      const onMouseMove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!startCoords)
          return false;
        if (view.dom.getAttribute("id") !== targetEditorId)
          return false;
        const docHeight = document.body.scrollTop + document.body.clientHeight;
        if (docHeight <= e.y)
          return false;
        selectionBox = selectionBox != null ? selectionBox : new SelectionBox(view);
        endCoords = getMouseEventRectInView(e, view);
        if (startCoords.x === endCoords.x && startCoords.y === endCoords.y)
          return false;
        selectionBox.calculatePosition({ startCoords, endCoords });
        const blocksPositions = getBlocksPositionsUnderSelection(
          view,
          startCoords,
          endCoords
        );
        if (JSON.stringify(prevBlocksPositions) === JSON.stringify(blocksPositions))
          return false;
        prevBlocksPositions = blocksPositions;
        const { state, dispatch } = view;
        const { doc, tr } = state;
        const blockSelection = BlockSelection.createFromPositions(
          doc,
          blocksPositions
        );
        tr.setSelection(blockSelection);
        tr.setMeta(PLUGIN_NAME, true);
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      };
      const addEvent = (e) => {
        const target = e.target;
        if (!(target == null ? void 0 : target.classList.contains("ProseMirror")))
          return;
        if ((target == null ? void 0 : target.getAttribute(ANNOTATION_MODE_ATTRIBUTE)) === "true")
          return;
        if (isBlockSelection(view.state.selection))
          removeEvent();
        targetEditorId = target == null ? void 0 : target.getAttribute("id");
        document.body.style.pointerEvents = "none";
        startCoords = getMouseEventRectInView(e, view);
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("contextmenu", stopSelection);
        window.addEventListener("mouseup", stopSelection);
      };
      const removeEvent = () => {
        setTimeout(() => {
          document.body.style.pointerEvents = "";
          window.removeEventListener("mousemove", onMouseMove);
          window.removeEventListener("contextmenu", stopSelection);
          window.removeEventListener("mouseup", stopSelection);
        }, 100);
      };
      window.addEventListener("mousedown", addEvent);
      window.addEventListener("mouseup", removeEvent);
      return {
        destroy: () => {
          document.body.style.pointerEvents = "";
          window.removeEventListener("mousedown", addEvent);
          window.removeEventListener("mouseup", removeEvent);
          window.removeEventListener("mousemove", onMouseMove);
          window.removeEventListener("contextmenu", stopSelection);
          window.removeEventListener("mouseup", stopSelection);
        }
      };
    },
    props: {
      handleDOMEvents: {
        click() {
          stopSelection();
          return false;
        }
      }
    }
  });
};
const SESHAT_SELECTABLE_SELECTOR = '.seshat_block:not([type="seshatCardContent"])';
const getMouseEventRectInView = (e, view) => {
  const viewDomRect = view.dom.getBoundingClientRect();
  return { x: e.clientX - viewDomRect.left, y: e.clientY - viewDomRect.top };
};
const getBlocksPositionsUnderSelection = (view, { x: x1, y: y1 }, { x: x2, y: y2 }) => {
  const rootRect = {
    top: Math.min(y1, y2),
    left: Math.min(x1, x2),
    bottom: Math.max(y1, y2),
    right: Math.max(x1, x2)
  };
  const viewDomRect = view.dom.getBoundingClientRect();
  const blocks = document.querySelectorAll(SESHAT_SELECTABLE_SELECTOR);
  const domBlocks = Array.from(blocks).filter((block) => {
    const blockRect = block.getBoundingClientRect();
    const blockRectInView = {
      top: blockRect.top - viewDomRect.top,
      left: blockRect.left - viewDomRect.left,
      right: blockRect.right - viewDomRect.left,
      bottom: blockRect.bottom - viewDomRect.top
    };
    return isOverLapping(rootRect, blockRectInView);
  });
  return domBlocks.map((dom) => view.posAtDOM(dom, 0) - 1).filter(
    (pos) => pos >= SESHAT_ROOT_DEPTH && pos < view.state.doc.nodeSize - SESHAT_ROOT_DEPTH
  );
};
const isOverLapping = (rect1, rect2) => {
  return !(rect1.right < rect2.left || rect1.left > rect2.right || rect1.bottom < rect2.top || rect1.top > rect2.bottom);
};
const PreventKeyInputPlugin = () => new Plugin({
  key: new PluginKey("prevent-key-input-block-selection-plugin"),
  props: {
    handleDOMEvents: {
      keypress(view, event) {
        if (!isBlockSelection(view.state.selection))
          return false;
        event.preventDefault();
        event.stopPropagation();
        return true;
      }
    }
  }
});
const BoldMark = Bold.extend({
  addInputRules() {
    var _a2;
    return (((_a2 = this.parent) == null ? void 0 : _a2.call(this)) || []).map((rule) => seshatBlockMarkRule(rule));
  }
});
const CodeMark = Code.extend({
  addInputRules() {
    var _a2;
    return (((_a2 = this.parent) == null ? void 0 : _a2.call(this)) || []).map((rule) => seshatBlockMarkRule(rule));
  }
});
const ItalicMark = Italic.extend({
  addInputRules() {
    var _a2;
    return (((_a2 = this.parent) == null ? void 0 : _a2.call(this)) || []).map((rule) => seshatBlockMarkRule(rule));
  }
});
const checkNodeHasMark = (node, markType) => {
  var _a2;
  return (_a2 = node == null ? void 0 : node.marks) == null ? void 0 : _a2.some((r2) => {
    var _a3;
    return ((_a3 = r2 == null ? void 0 : r2.type) == null ? void 0 : _a3.name) === markType;
  });
};
const getNodeMarkAttributes = (node, markType) => {
  var _a2, _b2;
  return (_b2 = (_a2 = node == null ? void 0 : node.marks) == null ? void 0 : _a2.find((r2) => {
    var _a3;
    return ((_a3 = r2 == null ? void 0 : r2.type) == null ? void 0 : _a3.name) === markType;
  })) == null ? void 0 : _b2.attrs;
};
const markInputRuleWithSetContent = ({
  regexp,
  markType,
  getAttributes,
  getText: getText2
}) => {
  return new InputRule({
    find: regexp,
    handler: ({ state, match, range, commands }) => {
      const { tr } = state;
      const attributes = getAttributes == null ? void 0 : getAttributes(match);
      const text = (getText2 == null ? void 0 : getText2(match)) || match[match.length - 1];
      const fullMatch = match[0];
      let markEnd = range.to;
      if (!text)
        return;
      const startSpaces = fullMatch.search(/\S/);
      const textStart = range.from + fullMatch.indexOf(text);
      const textEnd = textStart + text.length;
      const excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter((item) => {
        return item.mark.type.excluded.find(
          (type) => type.name === markType.name
        );
      }).filter((item) => item.to > textStart);
      if (excludedMarks.length)
        return;
      if (textEnd < range.to) {
        tr.delete(textEnd, range.to);
      }
      if (textStart > range.from) {
        tr.delete(range.from + startSpaces, textStart);
      }
      markEnd = range.from + startSpaces + text.length;
      tr.addMark(
        range.from + startSpaces,
        markEnd,
        markType.create(attributes)
      );
      tr.removeStoredMark(markType);
      commands.command(({ dispatch }) => {
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      });
      return;
    }
  });
};
const updateLink = (url) => ({ chain }) => {
  return chain().focus().extendMarkRange("link").setLink({ href: url }).run();
};
const inputRegexExact = /(https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*))[?:^|\s\n]$/gi;
const markdownRegexExact = /(?:^|\s)\[([\w\s\d]+)\]\((https?:\/\/[\w\d./?=#]+)\)$/gi;
const LinkMark = Link.extend({
  priority: 1e4,
  inclusive: false,
  addCommands() {
    var _a2;
    return {
      ...(_a2 = this.parent) == null ? void 0 : _a2.call(this),
      updateLink
    };
  },
  addOptions() {
    var _a2, _b2;
    return {
      ...(_a2 = this.parent) == null ? void 0 : _a2.call(this),
      linkOnPaste: false,
      HTMLAttributes: {
        ...(_b2 = this.parent) == null ? void 0 : _b2.call(this).HTMLAttributes,
        class: void 0
      }
    };
  },
  addInputRules() {
    return [
      seshatBlockMarkRule(
        markInputRule({
          find: inputRegexExact,
          type: this.type,
          getAttributes: (match) => {
            const href = match == null ? void 0 : match[1];
            return { href };
          }
        })
      ),
      seshatBlockMarkRule(
        markInputRuleWithSetContent({
          regexp: markdownRegexExact,
          markType: this.type,
          getAttributes: (match) => {
            const href = match == null ? void 0 : match[2];
            return {
              href
            };
          },
          getText: (match) => match == null ? void 0 : match[1]
        })
      )
    ];
  },
  parseHTML() {
    return [
      {
        tag: 'a[href]:not([href *= "javascript:" i]):not([href *= "#"]):not([href *= "/#"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const attrs = mergeAttributes(HTMLAttributes, {
      ...HTMLAttributes,
      target: "_blank",
      rel: "noopener noreferrer"
    });
    return ["a", attrs, 0];
  }
});
const getLinkAttributes = (state, pos) => {
  const isRange = isRangeTextSelected(state);
  const { $from } = state.selection;
  const position = pos != null ? pos : isRange ? $from.pos + 1 : $from.pos;
  const { node } = getNodeFromPosition(state, position);
  if (!node)
    return void 0;
  const isLinkNode = checkNodeHasMark(node, MarkTypes.LINK);
  if (!isLinkNode)
    return void 0;
  return getNodeMarkAttributes(node, MarkTypes.LINK);
};
const ShineMark = Mark.create({
  name: MarkTypes.SHINE,
  addOptions() {
    return {
      class: "shine"
    };
  },
  parseHTML() {
    return [
      {
        tag: "span.shine"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(this.options, HTMLAttributes), 0];
  }
});
const StrikeMark = Strike.extend({
  addKeyboardShortcuts() {
    return {
      [shortcutConfig.strikethrough]: () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    var _a2;
    return (((_a2 = this.parent) == null ? void 0 : _a2.call(this)) || []).map((rule) => seshatBlockMarkRule(rule));
  }
});
const TextStyleMark = TextStyle.extend({
  addInputRules() {
    var _a2;
    return (((_a2 = this.parent) == null ? void 0 : _a2.call(this)) || []).map((rule) => seshatBlockMarkRule(rule));
  }
});
const UnderlineMark = Underline.extend({
  addInputRules() {
    var _a2;
    return (((_a2 = this.parent) == null ? void 0 : _a2.call(this)) || []).map((rule) => seshatBlockMarkRule(rule));
  }
});
const ReapplyBlockSelectionPluginKey = new PluginKey(
  "reapply-block-selection-plugin"
);
const IS_MOUSE_DOWN_STATE_KEY = "isMouseDown";
const ReapplyBlockSelectionPlugin = () => {
  return new Plugin({
    key: ReapplyBlockSelectionPluginKey,
    state: {
      init() {
        return { [IS_MOUSE_DOWN_STATE_KEY]: false };
      },
      apply(tr, pluginState) {
        const value = tr.getMeta(IS_MOUSE_DOWN_STATE_KEY);
        if (value === void 0)
          return pluginState;
        return { [IS_MOUSE_DOWN_STATE_KEY]: value };
      }
    },
    props: {
      handleDOMEvents: {
        mousedown: (view) => {
          view.dispatch(view.state.tr.setMeta(IS_MOUSE_DOWN_STATE_KEY, true));
        },
        mouseup: (view) => {
          view.dispatch(view.state.tr.setMeta(IS_MOUSE_DOWN_STATE_KEY, false));
        }
      }
    },
    appendTransaction(_2, oldState, state) {
      var _a2;
      if ((_a2 = ReapplyBlockSelectionPluginKey.getState(state)) == null ? void 0 : _a2.isMouseDown)
        return;
      const { selection: sel, tr, doc } = state;
      if (!isEmptyTextSelection(sel) || isSelectionInHighlight(sel))
        return;
      const block = getCurrentBlock(doc, sel.from);
      if ((block == null ? void 0 : block.node) && isSelectableBlockInReadView(block.node))
        return selectBlockTransaction({ tr, pos: block.from });
      const blockFromPreviousSelection = getCurrentBlock(
        doc,
        oldState.selection.from
      );
      if ((blockFromPreviousSelection == null ? void 0 : blockFromPreviousSelection.node) && isSelectableBlockInReadView(blockFromPreviousSelection.node))
        return selectBlockTransaction({
          tr,
          pos: blockFromPreviousSelection.from
        }).scrollIntoView();
      const next = getNextBlock(doc, sel.from, isSelectableBlockInReadView);
      if (next)
        return selectBlockTransaction({ tr, pos: next.from });
      return;
    }
  });
};
const isSelectionInHighlight = (selection) => {
  var _a2;
  return !!((_a2 = selection.$from.doc.nodeAt(selection.from)) == null ? void 0 : _a2.marks.find(isHighlightMark));
};
const isEmptyTextSelection = (selection) => selection instanceof TextSelection && selection.empty;
const BlockSelectionExtension = (options) => Extension.create({
  name: "BlockSelectionExtension",
  addCommands() {
    const isReadView = (options == null ? void 0 : options.extensionVersion) === "read_later_view";
    const readViewOptions = {
      isSelectableBlock: isSelectableBlockInReadView
    };
    return {
      selectBlock: isReadView ? (options2) => selectBlock({ ...readViewOptions, ...options2 }) : selectBlock,
      selectBlocks: isReadView ? (options2) => selectBlocks({ ...readViewOptions, ...options2 }) : selectBlocks,
      selectNextBlock: isReadView ? (options2) => selectNextBlock({ ...readViewOptions, ...options2 }) : selectNextBlock,
      selectPrevBlock: isReadView ? (options2) => selectPrevBlock({ ...readViewOptions, ...options2 }) : selectPrevBlock,
      selectNextNonEditableBlock,
      selectPrevNonEditableBlock,
      deleteBlockSelection,
      selectBlockContent,
      selectEditorContent,
      escapeBlockSelection,
      unsetBlockSelection
    };
  },
  addKeyboardShortcuts() {
    const isLauncher = (options == null ? void 0 : options.extensionVersion) === "launcher";
    const isReadView = (options == null ? void 0 : options.extensionVersion) === "read_later_view";
    return {
      Escape: () => {
        return this.editor.commands.first(
          ({ commands: commands2 }) => !isLauncher ? [() => commands2.escapeBlockSelection()] : []
        );
      },
      [shortcutConfig.selectNextBlock]: () => {
        return this.editor.commands.first(({ commands: commands2 }) => [
          () => commands2.selectNextBlock(),
          isReadView ? () => false : () => commands2.selectNextNonEditableBlock(),
          () => commands2.insertTrailingLineOnArrowDown()
        ]);
      },
      [shortcutConfig.selectPrevBlock]: () => {
        return this.editor.commands.first(({ commands: commands2 }) => [
          () => commands2.selectPrevBlock(),
          isReadView ? () => false : () => commands2.selectPrevNonEditableBlock()
        ]);
      },
      [shortcutConfig.expandNextBlock]: () => {
        return this.editor.commands.first(({ commands: commands2, state }) => [
          () => !isBlockSelection(state.selection) ? commands2.selectBlock() : false,
          () => commands2.selectNextBlock({ expand: true })
        ]);
      },
      [shortcutConfig.expandPrevBlock]: () => {
        return this.editor.commands.first(({ commands: commands2, state }) => [
          () => !isBlockSelection(state.selection) ? commands2.selectBlock() : false,
          () => commands2.selectPrevBlock({ expand: true })
        ]);
      },
      [shortcutConfig.selectAll]: () => {
        return this.editor.commands.first(({ commands: commands2 }) => [
          () => commands2.selectBlockContent(),
          () => commands2.selectEditorContent()
        ]);
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      ...(options == null ? void 0 : options.extensionVersion) === "read_later_view" ? [ReapplyBlockSelectionPlugin()] : [],
      BlockSelectionDecorationPlugin(options),
      MouseBlockSelectionPlugin(),
      ...(options == null ? void 0 : options.extensionVersion) !== "read_later_view" && (options == null ? void 0 : options.extensionVersion) !== "watch_later_view" ? [PreventKeyInputPlugin()] : []
    ];
  }
});
const BulletedListExtension = (_2) => Extension.create({
  name: BlockTypes.BULLETED_LIST,
  addCommands() {
    return {
      toggleBulletedList: () => ({ tr, dispatch }) => {
        const isBlockSelectionActive = isBlockSelection(tr.selection);
        if (!isBlockSelectionActive && !tr.selection.empty)
          return false;
        const block = getCurrentBlock(tr.doc, tr.selection.from);
        if (!block || block.node.attrs.type !== BlockTypes.BULLETED_LIST)
          return false;
        const hasNoChildren = block.node.childCount <= 1;
        if (hasNoChildren)
          return false;
        tr.setNodeAttribute(
          block.from,
          "collapsed",
          !block.node.attrs.collapsed
        );
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin$1({
        key: new PluginKey$1("handleCollapsibleBlocks"),
        appendTransaction: (_22, __, state) => {
          var _a2;
          const { doc, selection } = state;
          const collapsedBlock = getHighestCollapsedParent(doc, selection);
          if (!collapsedBlock)
            return null;
          const inlineContent = collapsedBlock.block.firstChild;
          const endOfInlineContent = collapsedBlock.pos + ((_a2 = inlineContent == null ? void 0 : inlineContent.content.size) != null ? _a2 : 0) + 1;
          return state.tr.setSelection(
            new TextSelection$1(state.tr.doc.resolve(endOfInlineContent))
          );
        }
      })
    ];
  }
});
const getHighestCollapsedParent = (doc, selection) => {
  const $from = doc.resolve(selection.from);
  let depth = $from.depth;
  let pos;
  let collapsedBlock;
  while (depth >= 1) {
    let node = $from.node(depth);
    if (isBlockCollapsed(node)) {
      collapsedBlock = node;
      pos = $from.before(depth);
    }
    depth--;
  }
  if (!collapsedBlock || pos === void 0)
    return void 0;
  const isCaretInInlineContentOfCollapsedBlock = isBlockSelection(selection) ? selection.from === pos : $from.start($from.depth - SESHAT_CONTENT_DEPTH) - 1 === pos || $from.pos - 1 === pos;
  return !isCaretInInlineContentOfCollapsedBlock ? { block: collapsedBlock, pos } : void 0;
};
const resetCapture = (content) => ({
  tr,
  dispatch,
  editor,
  view
}) => {
  var _a2;
  const { schema } = editor;
  const captureBlock = (_a2 = editor.schema.nodes[SeshatNodes.WRAPPING_BLOCK]) == null ? void 0 : _a2.create(
    { type: BlockTypes.CAPTURE },
    content ? Node$1.fromJSON(schema, content) : createSeshatBlock({ schema })
  );
  tr.replaceWith(0, tr.doc.content.size, [captureBlock]);
  tr.setSelection(Selection.atEnd(tr.doc));
  dispatch == null ? void 0 : dispatch(tr);
  setTimeout(function scrollAfterLauncherResize() {
    view.dispatch(view.state.tr.scrollIntoView());
  }, 200);
  return true;
};
const ValidAncestorNodeTypes = [
  SeshatNodes.BLOCK,
  SeshatNodes.WRAPPING_BLOCK,
  SeshatNodes.BLOCK_CONTENT,
  SeshatNodes.CONTENT
];
const isAtStartOfCapture = (state) => {
  const { selection, doc } = state;
  let pos = selection.$from.pos - 1;
  let node = doc.nodeAt(pos);
  while (node && ValidAncestorNodeTypes.includes(node.type.name)) {
    if ((node == null ? void 0 : node.attrs.type) === BlockTypes.CAPTURE)
      return true;
    pos--;
    node = doc.nodeAt(pos);
  }
  return false;
};
const CaptureBlock = (options) => Extension.create({
  name: "CaptureBlock",
  addCommands: () => ({
    resetCapture
  }),
  addKeyboardShortcuts() {
    return {
      ArrowUp: () => {
        var _a2;
        if (!isAtStartOfCapture(this.editor.state))
          return false;
        return !!((_a2 = options == null ? void 0 : options.capture) == null ? void 0 : _a2.arrowUpOnTopOfEditorCallback());
      }
    };
  }
});
const cardInputRule = ({
  regexp,
  callback
}) => new InputRule({
  find: regexp,
  handler: ({ state, chain, commands, range }) => {
    const { $from } = state.selection;
    if ($from.pos !== 5)
      return;
    const root = state.doc.resolve(1).parent;
    if (BlockTypes.CAPTURE !== root.attrs.type)
      return;
    commands.deleteRange({ from: $from.start(), to: $from.end() });
    callback({ state, chain, commands, range });
  }
});
const turnEditorIntoCard = (attrs, options) => ({ tr, state, dispatch }) => {
  tr = turnEditorIntoCardTransaction({ tr, state, attrs, options });
  return dispatch == null ? void 0 : dispatch(
    tr.setMeta("skipDebounce", true).setMeta(RECALCULATE_PLACEHOLDER, true)
  );
};
const buildTitleContent = (schema, title) => {
  const serializer = new TextSerializer(schema);
  if (typeof title === "string" && title.length > 0)
    return {
      text: title,
      content: Fragment.fromArray([schema.text(title)])
    };
  if (typeof title === "object")
    return {
      text: serializer.serializeContent(title),
      content: Fragment.fromJSON(schema, title)
    };
  return void 0;
};
const formatCard = ({
  tr,
  state,
  title: initialTitle,
  seshatBlock,
  cardType,
  options
}) => {
  var _a2;
  const { schema } = state;
  const title = buildTitleContent(schema, initialTitle);
  const seshatContent = schema.nodes.seshatContent.create({}, title == null ? void 0 : title.content);
  const seshatBlockContent = state.schema.nodes[SeshatNodes.BLOCK_CONTENT].create({}, seshatContent);
  const cardContentBlock = state.schema.nodes[SeshatNodes.BLOCK].create(
    {
      ...seshatBlock.attrs,
      cardType,
      type: BlockTypes.CARD_CONTENT
    },
    [seshatBlockContent, ...seshatBlock.content.content]
  );
  tr.replaceWith(0, tr.doc.content.size, cardContentBlock);
  if ((options == null ? void 0 : options.focus) !== false)
    tr.setSelection(
      TextSelection.create(tr.doc, 3 + ((_a2 = title == null ? void 0 : title.content.size) != null ? _a2 : 0))
    );
  return tr;
};
const changeTitle = ({
  tr,
  state,
  title: initialTitle,
  firstChildBlock,
  options
}) => {
  var _a2;
  const { schema } = state;
  const title = buildTitleContent(schema, initialTitle);
  const seshatContent = schema.nodes.seshatContent.create({}, title == null ? void 0 : title.content);
  const seshatBlockContent = state.schema.nodes[SeshatNodes.BLOCK_CONTENT].create({}, seshatContent);
  tr.replaceWith(1, 1 + firstChildBlock.nodeSize, seshatBlockContent);
  if ((options == null ? void 0 : options.focus) !== false)
    tr.setSelection(
      TextSelection.create(tr.doc, 3 + ((_a2 = title == null ? void 0 : title.content.size) != null ? _a2 : 0))
    );
  return tr;
};
const formatCapture = ({
  tr,
  state,
  seshatBlock,
  options
}) => {
  const captureBlock = state.schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    {
      ...seshatBlock.attrs,
      cardType: "capture",
      type: BlockTypes.CAPTURE
    },
    [...seshatBlock.content.content.slice(1)]
  );
  tr.replaceWith(0, tr.doc.content.size, captureBlock);
  if ((options == null ? void 0 : options.focus) !== false)
    tr.setSelection(TextSelection.near(tr.doc.resolve(3)));
  return tr;
};
const turnEditorIntoCardTransaction = ({
  tr,
  state,
  attrs,
  options
}) => {
  const { cardType, title } = attrs;
  const seshatBlock = tr.doc.content.content[0];
  const firstSeshatBlockAttrs = seshatBlock.attrs;
  const isCapture = firstSeshatBlockAttrs.type === BlockTypes.CAPTURE;
  const firstChildBlock = seshatBlock.content.content[0];
  if (title !== void 0 && ["task", "note"].includes(cardType)) {
    if (isCapture && (firstChildBlock == null ? void 0 : firstChildBlock.type.name) !== SeshatNodes.BLOCK_CONTENT) {
      tr = formatCard({ tr, state, title, seshatBlock, cardType, options });
    } else {
      tr = changeTitle({ tr, state, title, firstChildBlock, options });
      tr.setNodeMarkup(0, state.schema.nodes[SeshatNodes.BLOCK], {
        ...firstSeshatBlockAttrs,
        cardType,
        type: BlockTypes.CARD_CONTENT
      });
    }
  }
  if (!isCapture && cardType === "capture") {
    tr = formatCapture({ tr, state, seshatBlock, options });
  }
  return tr;
};
const insertBlockIfCardContentIsEmpty = (state) => {
  const { tr } = state;
  const seshatBlockCard = tr.doc.content.content[0];
  const isSeshatBlockInsideCardContent = seshatBlockCard.content.content.find(
    (b) => b.type.spec.group === SeshatNodeGroups.BLOCK
  );
  if (!isSeshatBlockInsideCardContent) {
    const seshatBlockNew = createSeshatBlock({
      schema: state.schema,
      attrs: { type: BlockTypes.PARAGRAPH }
    });
    tr.insert(seshatBlockCard.nodeSize - SESHAT_ROOT_DEPTH, seshatBlockNew);
  }
  return tr;
};
const CardBlock = (options) => Extension.create({
  name: BlockTypes.CARD_CONTENT,
  priority: 1e3,
  addCommands: () => ({
    turnEditorIntoCard
  }),
  addInputRules() {
    return (options == null ? void 0 : options.extensionVersion) === "launcher" ? [
      cardInputRule({
        regexp: /^#\s/,
        callback: ({ chain, range, state }) => {
          const $start = state.doc.resolve(range.to);
          const existingTitle = state.doc.slice($start.pos, $start.end());
          chain().turnEditorIntoCard({
            cardType: "note",
            title: existingTitle.content.toJSON()
          }).setMeta(
            ANALYTICS_META,
            ANALYTICS_EVENTS.MARKDOWN_TURN_INTO_NOTE
          ).run();
        }
      }),
      cardInputRule({
        regexp: /^\[\]/,
        callback: ({ chain, range, state }) => {
          const $start = state.doc.resolve(range.to);
          const existingTitle = state.doc.slice($start.pos, $start.end());
          chain().turnEditorIntoCard({
            cardType: "task",
            title: existingTitle.content.toJSON()
          }).setMeta(
            ANALYTICS_META,
            ANALYTICS_EVENTS.MARKDOWN_TURN_INTO_TASK
          ).run();
        }
      })
    ] : [];
  },
  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        var _a2, _b2;
        if ((options == null ? void 0 : options.extensionVersion) !== "launcher")
          return false;
        const { doc, selection } = editor.state.tr;
        const { node } = (_a2 = getCurrentBlock(doc, selection.from)) != null ? _a2 : {};
        const isCaretInCardTitle = (node == null ? void 0 : node.attrs.type) === BlockTypes.CARD_CONTENT;
        if (!isCaretInCardTitle)
          return false;
        const isCardTitleEmpty = ((_b2 = node == null ? void 0 : node.firstChild) == null ? void 0 : _b2.content.size) === 2;
        if (!isCardTitleEmpty)
          return false;
        return editor.commands.turnEditorIntoCard({
          cardType: "capture"
        });
      },
      Escape: ({ editor }) => {
        var _a2, _b2;
        if ((options == null ? void 0 : options.extensionVersion) !== "launcher")
          return false;
        const { doc, selection } = editor.state.tr;
        const { node } = (_a2 = getCurrentBlock(doc, selection.from)) != null ? _a2 : {};
        const isCaretInCardTitle = (node == null ? void 0 : node.attrs.type) === BlockTypes.CARD_CONTENT;
        if (!isCaretInCardTitle)
          return false;
        const isCardTitleEmpty = ((_b2 = node == null ? void 0 : node.firstChild) == null ? void 0 : _b2.content.size) === 2;
        if (isCardTitleEmpty) {
          editor.commands.turnEditorIntoCard({ cardType: "capture" });
          return true;
        }
        const start = selection.$anchor.start(selection.$anchor.depth);
        const end = selection.$anchor.end(selection.$anchor.depth);
        const isCardTitleSelected = selection.from === start && selection.to === end;
        if (isCardTitleSelected) {
          editor.commands.turnEditorIntoCard({ cardType: "capture" });
          return true;
        } else {
          return false;
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("CardContentValidation"),
        appendTransaction: (_trs, _oldState, newState) => {
          return insertBlockIfCardContentIsEmpty(newState);
        }
      })
    ];
  }
});
const isContentNotEmpty = (content) => {
  var _a2;
  return !!(content.content && content.content.length >= 1 && ((_a2 = content.content) == null ? void 0 : _a2.some((c2) => c2.text || isContentNotEmpty(c2))));
};
const maybeFormatNode = (node) => {
  if (node.type !== SeshatNodes.BLOCK && node.type === SeshatNodes.BLOCK_CONTENT) {
    return {
      type: SeshatNodes.BLOCK,
      attrs: {
        type: BlockTypes.HEADING_1
      },
      content: [node]
    };
  }
  return node;
};
const removeCardFromAppendContent = (content) => {
  return content.flatMap((node) => {
    if (isRootBlockJSON(node)) {
      return removeCardFromAppendContent(node.content || []);
    }
    return maybeFormatNode(node);
  });
};
const appendContentInACardContent = ({
  seshatNode,
  newSeshatBlockContent
}) => {
  const cardContent = seshatNode.content;
  if (!cardContent)
    return seshatNode;
  const _isCardContentEmpty = !isContentNotEmpty(seshatNode);
  const previousContent = _isCardContentEmpty ? [] : cardContent;
  return {
    ...seshatNode,
    content: [
      ...previousContent,
      ...removeCardFromAppendContent(newSeshatBlockContent)
    ]
  };
};
const createShellCardContent = ({
  attrs,
  schema
}) => {
  var _a2;
  return (_a2 = schema.nodes[SeshatNodes.BLOCK]) == null ? void 0 : _a2.create(
    {
      type: BlockTypes.CARD_CONTENT,
      ...attrs
    },
    []
  );
};
const getCardContentFromSeshatBlockCard = (seshatNode) => {
  var _a2, _b2;
  if (((_a2 = seshatNode.content) == null ? void 0 : _a2[0].type) === SeshatNodes.BLOCK)
    return seshatNode.content;
  return (_b2 = seshatNode.content) == null ? void 0 : _b2.slice(1);
};
const getCardTitleContentFromSeshatBlockCard = (seshatNode) => {
  var _a2, _b2, _c2, _d2;
  if (((_a2 = seshatNode.attrs) == null ? void 0 : _a2.type) !== BlockTypes.CARD_CONTENT) {
    return void 0;
  }
  return (_d2 = (_c2 = (_b2 = seshatNode.content) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.content) == null ? void 0 : _d2[0];
};
const getCardLinkText = (node) => {
  var _a2;
  const nodes = (_a2 = getSeshatContent(node).node) == null ? void 0 : _a2.content.toJSON();
  if (!nodes)
    return void 0;
  return trimLastTextNode(nodes);
};
const trimLastTextNode = (nodes) => {
  var _a2, _b2;
  const lastNode = nodes[nodes.length - 1];
  if (lastNode.type !== SeshatInlineNodes.TEXT)
    return nodes;
  lastNode.text = (_a2 = lastNode.text) == null ? void 0 : _a2.trimEnd();
  return ((_b2 = lastNode.text) == null ? void 0 : _b2.length) !== 0 ? [...nodes.slice(0, -1), lastNode] : nodes.slice(0, -1);
};
const insertCardLink = (props) => ({
  tr,
  chain,
  state
}) => {
  var _a2, _b2, _c2, _d2;
  const { selection } = tr;
  const { $from } = selection;
  const node = $from.node();
  const pos = $from.start();
  const block = getCurrentBlock(tr.doc, $from.pos);
  if (!block || !(node == null ? void 0 : node.textContent) || !node.childCount)
    return true;
  const attrs = {
    cardType: (_a2 = props.cardType) != null ? _a2 : "note",
    cardLinkText: (_b2 = props.cardLinkText) != null ? _b2 : getCardLinkText(block.node),
    isDone: (_c2 = props.isDone) != null ? _c2 : void 0
  };
  const CardLink = state.schema.nodes[NodeViewTypes.CARD_LINK].create(attrs);
  const runningChain = chain().insertNodeViewContent({
    node: CardLink,
    blockAttrs: {
      type: BlockTypes.CARD_LINK,
      [BlockAttrsParams.BLOCK_UUID]: (_d2 = props.cardUuid) != null ? _d2 : block.node.attrs[BlockAttrsParams.BLOCK_UUID]
    }
  }).deleteRange({ from: block.from, to: block.to });
  runningChain.setCaretNearby({ pos });
  return runningChain.run();
};
const getInjectedCardLinkViewElement = (selection, predicate) => {
  var _a2, _b2, _c2;
  if (!isBlockSelection(selection) || selection.list().length > 1)
    return;
  const { node } = selection.firstBlock();
  const blockId = node.attrs[BlockAttrsParams.BLOCK_UUID];
  if (node.attrs.type !== BlockTypes.CARD_LINK || !blockId)
    return;
  const cardLinkAttrs = (_c2 = (_b2 = (_a2 = node.firstChild) == null ? void 0 : _a2.firstChild) == null ? void 0 : _b2.firstChild) == null ? void 0 : _c2.attrs;
  if (cardLinkAttrs && predicate && !predicate(cardLinkAttrs))
    return;
  const cardLinkView = document.querySelector(`[data-card-link="${blockId}"`);
  return cardLinkView;
};
const isTask$1 = ({ cardType }) => cardType === "task";
const markTaskAsDone = () => ({ state }) => {
  const cardLinkView = getInjectedCardLinkViewElement(state.selection, isTask$1);
  if (!cardLinkView)
    return false;
  cardLinkView.dispatchEvent(
    new KeyboardEvent("keydown", {
      key: shortcutConfig.markAsDone,
      view: window,
      bubbles: true,
      cancelable: true
    })
  );
  return true;
};
const isTask = ({ cardType }) => cardType === "task";
const markTaskAsUndone = () => ({ state }) => {
  const cardLinkView = getInjectedCardLinkViewElement(state.selection, isTask);
  if (!cardLinkView)
    return false;
  cardLinkView.dispatchEvent(
    new KeyboardEvent("keydown", {
      key: shortcutConfig.markAsDone,
      shiftKey: true,
      view: window,
      bubbles: true,
      cancelable: true
    })
  );
  return true;
};
const onEnterOnCardLink = () => ({ chain, state }) => {
  var _a2, _b2, _c2, _d2;
  if (!isBlockSelection(state.selection) || state.selection.list().length !== 1) {
    return false;
  }
  const firstBlock = state.selection.firstBlock();
  const { node, to, from } = firstBlock;
  const cardLinkNode = (_b2 = (_a2 = node == null ? void 0 : node.firstChild) == null ? void 0 : _a2.firstChild) == null ? void 0 : _b2.firstChild;
  const cardLinkType = (_c2 = cardLinkNode == null ? void 0 : cardLinkNode.attrs) == null ? void 0 : _c2.cardType;
  const cardLinkText = (_d2 = cardLinkNode == null ? void 0 : cardLinkNode.attrs) == null ? void 0 : _d2.cardLinkText;
  if ((node == null ? void 0 : node.attrs.type) !== BlockTypes.CARD_LINK) {
    return false;
  }
  if (cardLinkType !== "task" && cardLinkType !== "note" || !cardLinkText)
    return false;
  const updateCardLinkToType = cardLinkType === "task" ? BlockTypes.TASK_EDITABLE : BlockTypes.NOTE_EDITABLE;
  const editableBlock = generateEditable({
    content: cardLinkText,
    attrs: {
      type: updateCardLinkToType,
      [BlockAttrsParams.BLOCK_UUID]: node.attrs[BlockAttrsParams.BLOCK_UUID]
    }
  });
  chain().deleteRange({ from, to }).insertContentAt(from, editableBlock).run();
  return true;
};
const openSelectedCard = () => ({ state, dispatch }) => {
  const cardLinkView = getInjectedCardLinkViewElement(state.selection);
  if (!cardLinkView)
    return false;
  dispatch == null ? void 0 : dispatch(
    setCaretNearbyTransaction({
      state,
      tr: state.tr,
      pos: state.selection.from
    })
  );
  setTimeout(() => {
    var _a2;
    return (_a2 = cardLinkView.click) == null ? void 0 : _a2.call(cardLinkView);
  });
  return true;
};
const duplicateBlock = () => ({ tr, dispatch, state }) => {
  var _a2;
  const { doc } = state;
  const blockSelection = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(doc, state.selection);
  const currentBlock = getCurrentBlock(doc, blockSelection.$from.pos);
  if (isHighlight(currentBlock == null ? void 0 : currentBlock.node) || findAncestor(blockSelection.$from, isHighlight))
    return true;
  const slice = resetAttrsInSlice(state.schema, blockSelection.content());
  const selectionTo = (_a2 = removeHighlights(blockSelection, slice)) != null ? _a2 : slice.size;
  tr.replace(blockSelection.to, void 0, slice);
  tr.setSelection(
    BlockSelection.createFromRange(
      tr.doc,
      blockSelection.to,
      blockSelection.to + selectionTo
    )
  ).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const removeHighlights = (blockSelection, slice) => {
  const selectionContainsHighlight = _.compact(
    blockSelection.list().map((block, index) => {
      if (isHighlight(block.node))
        return index;
      return void 0;
    })
  );
  const removedSizes = selectionContainsHighlight.map((blockPos) => {
    const removedHighlight = slice.content.content[0].content.content.splice(
      blockPos,
      1
    );
    return removedHighlight[0].nodeSize;
  });
  return removedSizes.length ? slice.content.content[0].content.size - _.sum(removedSizes) : void 0;
};
const isHighlight = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHT || (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS;
const focusAtSelectionEnd = () => ({ commands, state }) => commands.focus(state.selection.to);
const focusLastPosition = () => ({ chain, tr }) => {
  const selection = Selection.atEnd(tr.doc);
  return chain().insertContentAt(selection.to, " ").focus(selection.to).deleteRange({ from: selection.to, to: selection.to + 1 }).run();
};
const indentBlock = () => ({ state, tr, dispatch }) => {
  const blockSelection = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(state.doc, state.selection);
  if (!isIndentationAllowed(blockSelection))
    return true;
  tr.delete(blockSelection.from, blockSelection.to);
  tr.insert(blockSelection.from - 1, blockSelection.getFragment());
  const updatedRange = {
    from: state.selection.from - 1,
    to: state.selection.to - 1
  };
  const updatedSelection = isBlockSelection(state.selection) ? BlockSelection.createFromRange(tr.doc, updatedRange.from, updatedRange.to) : TextSelection.create(tr.doc, updatedRange.from, updatedRange.to);
  tr.setSelection(updatedSelection);
  tr = uncollapseNewParentBlock({ tr, blockSelection });
  if (!isBlockSelection(state.selection))
    tr = liftChildrenToInitialDepth({ tr, blockSelection });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isIndentationAllowed = (selection) => {
  const containsInAllowedBlocks = selection.list().some(({ node }) => disabledIndent.includes(node.attrs.type));
  if (containsInAllowedBlocks)
    return false;
  const { nodeBefore } = selection.firstBlock().$from;
  if ((nodeBefore == null ? void 0 : nodeBefore.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  if (nodeBefore.attrs.type === BlockTypes.HIGHLIGHTS)
    return false;
  if (nodeBefore.attrs.type === BlockTypes.CARD_LINK)
    return false;
  if (nodeBefore.attrs.type === BlockTypes.BLOCK_LINE)
    return false;
  if (isContentEditableFalse(nodeBefore))
    return false;
  return true;
};
const liftChildrenToInitialDepth = ({
  tr,
  blockSelection
}) => {
  const singleBlock = blockSelection.list().length === 1 && blockSelection.firstBlock();
  if (!singleBlock || singleBlock.node.childCount === 1)
    return tr;
  if (isBlockCollapsed(singleBlock.node))
    return tr;
  const childStart = singleBlock.from + singleBlock.node.firstChild.nodeSize;
  const childEnd = singleBlock.to - 2;
  const children = tr.doc.slice(childStart, childEnd);
  tr.insert(singleBlock.to - 1, children.content);
  tr.delete(childStart, childEnd);
  return tr;
};
const uncollapseNewParentBlock = ({
  tr,
  blockSelection
}) => {
  const { nodeBefore } = blockSelection.$from;
  if (!nodeBefore || !isBlockCollapsible(nodeBefore))
    return tr;
  const parentPos = blockSelection.from - nodeBefore.nodeSize;
  return tr.setNodeMarkup(parentPos, void 0, {
    ...nodeBefore.attrs,
    collapsed: false
  });
};
const indentText = () => ({ dispatch, tr, state }) => {
  if (isBlockSelection(state.selection))
    return false;
  const { from } = state.selection;
  const block = getCurrentBlock(state.doc, from);
  if ((block == null ? void 0 : block.node.attrs.type) !== BlockTypes.CODE)
    return false;
  tr.replaceWith(from, from, state.schema.text("	")).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const insertBlock = (attrs) => ({
  chain,
  tr
}) => {
  var _a2, _b2, _c2, _d2, _e2;
  const { selection, doc } = tr;
  const { $from } = selection;
  const { depth } = $from;
  const contentEnd = $from.end();
  const block = getCurrentBlock(doc, $from.pos);
  let type = (_a2 = block == null ? void 0 : block.node.attrs.type) != null ? _a2 : BlockTypes.PARAGRAPH;
  const isRegularBlock = ((_b2 = block == null ? void 0 : block.node) == null ? void 0 : _b2.type.name) === SeshatNodes.BLOCK;
  const isWrappingBlock2 = ((_c2 = block == null ? void 0 : block.node) == null ? void 0 : _c2.type.name) === SeshatNodes.WRAPPING_BLOCK;
  const insertPosition = isWrappingBlock2 || isRegularBlock ? block.to : contentEnd + depth;
  const focusPosition = insertPosition + SESHAT_CONTENT_DEPTH;
  const finalAttrs = {
    type,
    [BlockAttrsParams.CONTEXT_UUID]: (_e2 = (_d2 = block == null ? void 0 : block.node) == null ? void 0 : _d2.attrs) == null ? void 0 : _e2[BlockAttrsParams.CONTEXT_UUID],
    ...attrs || {}
  };
  return chain().insertContentAt(insertPosition, generateEmptyBlock(finalAttrs)).focus(focusPosition).scrollIntoView().run();
};
const insertSoftBreak = () => ({ dispatch, tr }) => {
  tr.insertText("\n").scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const insertSoftBreakOnEnter = () => ({ tr, commands }) => {
  const { selection } = tr;
  const { $from } = selection;
  const depth = $from.depth;
  const parentSeshatBlockDepth = depth - 2;
  const seshatBlockNode = $from.node(parentSeshatBlockDepth);
  if (!seshatBlockSoftBreakOnEnter.includes(seshatBlockNode == null ? void 0 : seshatBlockNode.attrs.type))
    return false;
  return commands.insertSoftBreak();
};
const onBackspace = () => ({ tr, commands, chain }) => {
  const { selection, doc } = tr;
  const { $from } = selection;
  const isAtStart = $from.parentOffset === 0;
  if (!isAtStart || !selection.empty)
    return false;
  const block = getCurrentBlock(doc, $from.pos);
  if (isAtStartOfHighlightBlockquote({ doc, $from }))
    return true;
  if (isAtStartOfNonEmptyHighlightNote({ doc, $from }))
    return true;
  if (shouldResetBlock({ block, commands }))
    return true;
  return deleteInPreviousSibling({ tr, block, commands, chain });
};
const isAtStartOfHighlightBlockquote = ({
  doc,
  $from
}) => {
  var _a2;
  const wrappingBlockStart = $from.pos - SESHAT_CONTENT_DEPTH - 2;
  const nodeBeforePos = minMax(wrappingBlockStart - 1, 0, doc.nodeSize);
  if (((_a2 = doc.nodeAt(nodeBeforePos)) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT)
    return true;
  return false;
};
const getHighlightNoteNodeBefore = ({
  doc,
  $from
}) => {
  const wrappingBlockStart = $from.pos - SESHAT_CONTENT_DEPTH - 2;
  const nodeBeforePos = minMax(wrappingBlockStart, 0, doc.nodeSize);
  const nodeBefore = doc.nodeAt(nodeBeforePos);
  return (nodeBefore == null ? void 0 : nodeBefore.attrs.type) === BlockTypes.HIGHLIGHT_NOTE ? nodeBefore : void 0;
};
const isEmptyHighlightNote = (node) => node.childCount === 1 && isSeshatBlockEmpty(node.firstChild);
const isAtStartOfNonEmptyHighlightNote = ({
  doc,
  $from
}) => {
  const highlightNote = getHighlightNoteNodeBefore({ doc, $from });
  return highlightNote && !isEmptyHighlightNote(highlightNote);
};
const shouldResetBlock = ({
  block,
  commands
}) => {
  if ((block == null ? void 0 : block.depth) === SESHAT_ROOT_DEPTH || !seshatBlockResetOnStartBackspace.includes(block == null ? void 0 : block.node.attrs.type))
    return false;
  return commands.resetBlock();
};
const selectPreviousAtomBlock = ({
  $from,
  chain,
  seshatBlockDepth
}) => {
  const isNodeEmpty = $from.node().textContent.length < 1;
  if (!isNodeEmpty)
    return chain().selectPrevNonEditableBlock().run();
  const from = $from.before(seshatBlockDepth);
  const to = $from.after(seshatBlockDepth);
  return chain().selectPrevNonEditableBlock().deleteRange({ from, to }).run();
};
const selectPreviousHighlights = ({
  $from,
  chain,
  seshatBlockDepth,
  blockBefore
}) => {
  const highlightsPos = blockBefore.from;
  const isNodeEmpty = $from.node().textContent.length < 1;
  if (!isNodeEmpty)
    return chain().selectBlock({ pos: highlightsPos }).run();
  const from = $from.before(seshatBlockDepth);
  const to = $from.after(seshatBlockDepth);
  return chain().selectBlock({ pos: highlightsPos }).deleteRange({ from, to }).run();
};
const deleteInPreviousSibling = ({
  tr,
  block,
  commands,
  chain
}) => {
  if (!(block == null ? void 0 : block.node))
    return false;
  const { selection, doc } = tr;
  const { $from } = selection;
  if (selection.empty && block.node.type.spec.group !== SeshatNodeGroups.BLOCK)
    return false;
  const previousTarget = getForwardSeshatBlockContent({ doc, selection });
  if (!(previousTarget == null ? void 0 : previousTarget.node) || !(previousTarget == null ? void 0 : previousTarget.pos))
    return false;
  if (isAtom(previousTarget.node)) {
    return selectPreviousAtomBlock({
      chain,
      $from,
      seshatBlockDepth: block.depth
    });
  }
  const blockBefore = getPreviousBlock(doc, $from.pos, void 0, {
    ignoreChildren: true
  });
  if ((blockBefore == null ? void 0 : blockBefore.node.attrs.type) === BlockTypes.HIGHLIGHTS) {
    return selectPreviousHighlights({
      chain,
      $from,
      seshatBlockDepth: block.depth,
      blockBefore
    });
  }
  return commands.unwrapChildrenAndMoveContentToTarget({
    block,
    previousTarget
  });
};
const onDelete = () => ({ tr, dispatch }) => {
  const { selection } = tr;
  const { $from } = selection;
  const node = $from.node();
  const isAtTheEnd = $from.parentOffset === node.content.size;
  if (!(isAtTheEnd && dispatch))
    return false;
  const block = getCurrentBlock(tr.doc, $from.pos);
  const nextPos = $from.after(block == null ? void 0 : block.depth);
  const nextNode = tr.doc.nodeAt(nextPos);
  if (!nextNode)
    return false;
  if (hasSelectableText(nextNode)) {
    const pos = $from.pos;
    onDeleteAtTheEndWhenNextSiblingIsSeshatBlockWithSeshatContent({
      nextNode,
      tr,
      pos,
      dispatch
    });
  } else if (!isAtom(nextNode)) {
    unwrapNextNode({ nextNode, nextPos, tr, $from, dispatch });
  } else {
    blockSelectNextNode({ nextPos, tr, dispatch });
  }
  return true;
};
const unwrapNextNode = ({
  nextNode,
  nextPos,
  tr,
  $from,
  dispatch
}) => {
  var _a2, _b2, _c2;
  if (((_a2 = nextNode.firstChild) == null ? void 0 : _a2.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return;
  const depth = (_c2 = (_b2 = getCurrentBlock(tr.doc, $from.pos)) == null ? void 0 : _b2.depth) != null ? _c2 : $from.depth;
  const nextNodeStartPos = nextPos + 1;
  const nextNodeEndPos = nextNodeStartPos + nextNode.nodeSize - 2;
  const range = tr.doc.resolve(nextNodeStartPos).blockRange(tr.doc.resolve(nextNodeEndPos));
  if (!range)
    return;
  tr.lift(range, depth - 1);
  dispatch == null ? void 0 : dispatch(tr);
};
const blockSelectNextNode = ({
  nextPos,
  tr,
  dispatch
}) => {
  tr.setSelection(BlockSelection.createFromPosition(tr.doc, nextPos));
  dispatch == null ? void 0 : dispatch(tr);
};
const hasSelectableText = (node) => {
  var _a2;
  return !isAtom(node) && ((_a2 = node.firstChild) == null ? void 0 : _a2.type.name) === SeshatNodes.BLOCK_CONTENT;
};
const onDeleteAtTheEndWhenNextSiblingIsSeshatBlockWithSeshatContent = ({
  nextNode,
  tr,
  pos,
  dispatch
}) => {
  var _a2, _b2;
  const textNode = getSeshatContent(nextNode);
  const nextSiblingStart = pos + SESHAT_CONTENT_DEPTH + 1;
  const nextSiblingEnd = pos + (((_a2 = textNode.node) == null ? void 0 : _a2.nodeSize) || 0) + 2 * (SESHAT_CONTENT_DEPTH + 1);
  tr.delete(nextSiblingStart, nextSiblingEnd).insert(pos, ((_b2 = textNode.node) == null ? void 0 : _b2.content.content) || []).setSelection(TextSelection.create(tr.doc, pos)).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
};
const onEnter = () => ({ tr, commands, chain }) => {
  var _a2;
  const { selection, doc } = tr;
  const { $from } = selection;
  const isAtStart = $from.parentOffset === 0;
  const nodeIsEmpty = $from.node().textContent.length < 1;
  const block = getCurrentBlock(doc, $from.pos);
  const type = block == null ? void 0 : block.node.attrs.type;
  const depth = (_a2 = block == null ? void 0 : block.depth) != null ? _a2 : 0;
  const isRoot = depth === SESHAT_ROOT_DEPTH;
  const isIndented = depth > SESHAT_CONTENT_DEPTH;
  if (isRoot && isAtStart) {
    return true;
  }
  if (!(block == null ? void 0 : block.node)) {
    return commands.insertBlock();
  }
  if (isCaretWithinHighlightBlockquote($from)) {
    return commands.insertHighlightNote();
  }
  if (!isRoot && nodeIsEmpty && seshatBlockResetOnEmptyEnter.includes(type)) {
    return commands.resetBlock();
  }
  if (isIndented && isAtStart && nodeIsEmpty) {
    return commands.outdentBlock();
  }
  if (isAtStart && !nodeIsEmpty) {
    return chain().insertContentAt(block.from, [generateEmptyBlock()]).focus(block.from + SESHAT_CONTENT_DEPTH * 3 + 1).run();
  }
  return commands.splitBlock();
};
const maybeDoHardBreakDueToBlockType = ({
  block,
  commands
}) => {
  if (!HARD_BREAK_DUE_TO_BLOCK_TYPE.includes(block.attrs.type))
    return false;
  return commands.insertBlock({ type: BlockTypes.PARAGRAPH });
};
const maybeDoHardBreakDueToParentType = ({
  tr,
  schema,
  depth,
  $from,
  dispatch
}) => {
  let parentDeep = depth - 1;
  const parent = $from.node(parentDeep);
  if (!HARD_BREAK_DUE_TO_PARENT_TYPE.includes(parent.attrs.type))
    return false;
  const parentParent = $from.node(parentDeep - 1);
  if (parentParent.attrs.type === BlockTypes.HIGHLIGHT) {
    parentDeep = parentDeep - 2;
  }
  const newBlock = createSeshatBlock({ schema });
  const nodeAfterPos = $from.end(parentDeep) + 1;
  const caretPos = nodeAfterPos + SESHAT_CONTENT_DEPTH + 1;
  tr.insert(nodeAfterPos, newBlock).setSelection(TextSelection.create(tr.doc, caretPos)).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const onHardBreak = () => ({
  tr,
  dispatch,
  state,
  commands,
  view
}) => {
  if (view.dom.id === LAUNCHER_EDITOR_ID)
    return false;
  const { schema } = state;
  const { selection } = tr;
  const { $from } = selection;
  const block = getCurrentBlock(tr.doc, $from.pos);
  if (!block)
    return false;
  if (maybeDoHardBreakDueToBlockType({ block: block.node, commands }))
    return true;
  if (maybeDoHardBreakDueToParentType({
    tr,
    schema,
    depth: block.depth,
    $from,
    dispatch
  }))
    return true;
  return false;
};
const outdentBlock = ({
  stopPropagation
} = {}) => ({ state, tr, dispatch }) => {
  var _a2;
  const blockSel = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(state.doc, state.selection);
  if (!shouldOutdent(blockSel))
    return stopPropagation != null ? stopPropagation : true;
  const blockSelectionStart = blockSel.firstBlock().$from;
  const lastNode = (_a2 = blockSel.lastBlock()) == null ? void 0 : _a2.node;
  const parentNode = blockSelectionStart.parent;
  const parentNodeEnd = blockSel.from - blockSelectionStart.parentOffset + (parentNode == null ? void 0 : parentNode.nodeSize) - SESHAT_CONTENT_DEPTH;
  let selectionStart = blockSelectionStart.pos;
  let insertPos = parentNodeEnd + 1;
  let offset = 1;
  let fragmentToInsert = blockSel.list().slice(0, -1).reduce((fragment, block) => {
    return fragment.append(Fragment.from(block.node));
  }, Fragment.from());
  const { index } = findChildByBlockId({
    parentNode,
    blockId: lastNode == null ? void 0 : lastNode.attrs[BlockAttrsParams.BLOCK_UUID]
  });
  const nextBlockSiblings = parentNode.content.content.slice(index + 1);
  const outdentBlockNode = lastNode == null ? void 0 : lastNode.type.create(lastNode.attrs, [
    ...lastNode.content.content,
    ...nextBlockSiblings
  ]);
  fragmentToInsert = fragmentToInsert.append(Fragment.from(outdentBlockNode));
  let deleteFrom = selectionStart;
  const previousBlocks = parentNode.content.content.slice(0, index);
  if (previousBlocks.length === 0) {
    deleteFrom -= 1;
  }
  if ((parentNode == null ? void 0 : parentNode.attrs.type) === BlockTypes.BLOCK_COLUMN) {
    insertPos += 1;
    offset += 1;
    deleteFrom -= 1;
  }
  if ((parentNode == null ? void 0 : parentNode.attrs.type) === BlockTypes.HIGHLIGHT_NOTE) {
    insertPos += 2;
    offset += 2;
  }
  if (isOnlyChildInWrappingBlock(parentNode)) {
    offset -= 2;
  }
  tr.insert(insertPos, fragmentToInsert);
  tr.delete(deleteFrom, parentNodeEnd);
  if (isBlockSelection(state.selection)) {
    tr.setSelection(
      BlockSelection.createFromRange(
        tr.doc,
        state.selection.from + offset,
        state.selection.to + offset
      )
    );
  } else {
    tr.setSelection(
      TextSelection.create(
        tr.doc,
        state.selection.from + offset,
        state.selection.to + offset
      )
    );
  }
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isOnlyChildInWrappingBlock = (parentNode) => parentNode.type.name === SeshatNodes.WRAPPING_BLOCK && parentNode.childCount === 1;
const isWithinHighlightQuote = (parentNode, $from) => {
  if (parentNode.attrs.type !== BlockTypes.BLOCKQUOTE)
    return false;
  return $from.node($from.depth - 1).attrs.type === BlockTypes.HIGHLIGHT;
};
const isHighlightNote = (parentNode) => parentNode.attrs.type === BlockTypes.HIGHLIGHT_NOTE;
const isVeryLastHighlightNote = ($to) => {
  if (!$to)
    return false;
  const highlightNoteContentEnd = $to.pos;
  const expectedHighlightEnd = highlightNoteContentEnd + 2;
  return $to.doc.resolve(expectedHighlightEnd).nodeAfter === null;
};
const shouldOutdent = (blockSelection) => {
  var _a2, _b2;
  if (blockSelection.empty)
    return false;
  const $from = blockSelection.firstBlock().$from;
  const $to = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.$to;
  const parentNode = $from.parent;
  const lastNode = (_b2 = blockSelection.lastBlock()) == null ? void 0 : _b2.node;
  if ((parentNode == null ? void 0 : parentNode.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  if (isHighlightNote(parentNode) && !isVeryLastHighlightNote($to))
    return false;
  if (isWithinHighlightQuote(parentNode, $from))
    return false;
  if ((lastNode == null ? void 0 : lastNode.attrs.type) === BlockTypes.CODE)
    return false;
  if (isParentRootBlock({ $from, blockDepth: $from.depth })) {
    return false;
  }
  return true;
};
const outdentText = () => ({ dispatch, tr, state }) => {
  if (isBlockSelection(state.selection))
    return false;
  const { from } = state.selection;
  const block = getCurrentBlock(state.doc, from);
  if ((block == null ? void 0 : block.node.attrs.type) !== BlockTypes.CODE)
    return false;
  const charBefore = tr.doc.textBetween(from - 1, from);
  if (charBefore !== "	")
    return false;
  tr.replaceWith(from - 1, from, Fragment.empty).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const removeFirstLine$1 = () => ({ tr, dispatch }) => {
  const from = tr.doc.resolve(3);
  const start = from.start();
  const end = from.end();
  tr.deleteRange(start, end);
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const replaceContent = ({
  content,
  skipUpdate = false,
  parseOptions
}) => ({ tr, chain }) => {
  const formattedContent = Array.isArray(content) ? verifyRootBlock(content) : content;
  const initialSelection = tr.selection.toJSON();
  return chain().setContent(formattedContent, !skipUpdate, parseOptions).setMeta("skipUpdate", skipUpdate).command(({ tr: tr2, dispatch }) => {
    try {
      const restoredSelection = Selection.fromJSON(tr2.doc, initialSelection);
      dispatch == null ? void 0 : dispatch(tr2.setSelection(restoredSelection));
      return true;
    } catch {
      return false;
    }
  }).run();
};
const PAIRED_TOKEN = {
  "(": ")",
  "[": "]",
  "{": "}"
};
const wrapSelectionWithBrackets = (token) => ({
  tr,
  dispatch
}) => {
  const { selection } = tr;
  if (selection.empty)
    return false;
  if (!(selection instanceof TextSelection))
    return false;
  if (!isInlineContent(selection))
    return false;
  const { from, to } = selection;
  tr.insertText(token, from);
  tr.insertText(PAIRED_TOKEN[token], to + 1);
  tr.setSelection(TextSelection.create(tr.doc, from + 1, to + 1));
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isInlineContent = (selection) => selection.$from.parent.inlineContent;
const BRACKETS_EXTENSION_NAME = "BracketsExtension";
const BracketsExtension = Extension.create({
  name: BRACKETS_EXTENSION_NAME,
  addProseMirrorPlugins() {
    const shortcuts = addKeypressShortcuts(this.editor);
    const handler = keypressHandler(shortcuts);
    return [makePlugin(BRACKETS_EXTENSION_NAME, handler)];
  },
  addCommands() {
    return { wrapSelectionWithBrackets };
  }
});
const addKeypressShortcuts = (editor) => ({
  "(": makeWrapSelectionWithBrackets(editor, "("),
  "[": makeWrapSelectionWithBrackets(editor, "["),
  "{": makeWrapSelectionWithBrackets(editor, "{")
});
const keypressHandler = (shortcuts) => (view, event) => {
  var _a2, _b2;
  const { key } = event;
  return (_b2 = (_a2 = shortcuts == null ? void 0 : shortcuts[key]) == null ? void 0 : _a2.call(shortcuts, view.state)) != null ? _b2 : false;
};
const makeWrapSelectionWithBrackets = (editor, token) => () => editor.commands.wrapSelectionWithBrackets(token);
const makePlugin = (key, handleKeyPress2) => new Plugin({ key: new PluginKey(key), props: { handleKeyPress: handleKeyPress2 } });
const domSerializerConfig = {
  [BlockTypes.CARD_CONTENT]: ({ content, node }) => {
    var _a2;
    const title = (_a2 = node.firstChild) == null ? void 0 : _a2.textContent;
    if (!title)
      return content;
    return `<h1>${title}</h1>${content}`;
  },
  [BlockTypes.PARAGRAPH]: ({ content }) => {
    return `<p>${content}</p>`;
  },
  [BlockTypes.HEADING_1]: ({ content }) => {
    return `<h1>${content}</h1>`;
  },
  [BlockTypes.HEADING_2]: ({ content }) => {
    return `<h2>${content}</h2>`;
  },
  [BlockTypes.HEADING_3]: ({ content }) => {
    return `<h3>${content}</h3>`;
  },
  [BlockTypes.HEADING_4]: ({ content }) => {
    return `<h4>${content}</h4>`;
  },
  [BlockTypes.NUMBERED_LIST]: ({ content, prevNode, nextNode }) => {
    return `${(prevNode == null ? void 0 : prevNode.attrs.type) !== BlockTypes.NUMBERED_LIST ? "<ol>" : ""}<li>${content}</li>${(nextNode == null ? void 0 : nextNode.attrs.type) !== BlockTypes.NUMBERED_LIST ? "</ol>" : ""}`;
  },
  [BlockTypes.BULLETED_LIST]: ({ content, prevNode, nextNode }) => {
    return `${(prevNode == null ? void 0 : prevNode.attrs.type) !== BlockTypes.BULLETED_LIST ? "<ul>" : ""}<li>${content}</li>${(nextNode == null ? void 0 : nextNode.attrs.type) !== BlockTypes.BULLETED_LIST ? "</ul>" : ""}`;
  },
  [BlockTypes.BLOCKQUOTE]: ({ content }) => {
    return content ? `<blockquote>${content}</blockquote>` : "";
  },
  [BlockTypes.HIGHLIGHTS]: ({ content }) => {
    return `<div><strong>Highlights:</strong></div>${content}`;
  },
  [BlockTypes.HIGHLIGHT]: ({ node, content }) => {
    return node.attrs.timestamp ? `<blockquote>${node.attrs.timestamp}</blockquote>${content}` : content;
  },
  [SeshatNodes.CONTENT_NODE_VIEW]: ({ content }) => {
    return content;
  },
  [SeshatNodes.CONTENT]: ({ content }) => {
    return content;
  },
  [SeshatNodes.BLOCK_CONTENT]: ({ content, parentNode }) => {
    return (parentNode == null ? void 0 : parentNode.attrs.type) !== BlockTypes.CARD_CONTENT ? content : "";
  },
  [NodeViewTypes.CLIP_BOOKMARK]: ({ node, content, inline }) => {
    if (node.attrs.title && node.attrs.href && inline)
      return `
[${node.attrs.title}](${node.attrs.href})`;
    if (node.attrs.title && node.attrs.href && !inline)
      return `<a href='${node.attrs.href}' target='_blank'>${node.attrs.title}</a>`;
    if (node.attrs.title)
      return `
${node.attrs.title}`;
    return content;
  },
  [SeshatInlineNodes.EXTERNAL_IMAGE]: ({ node, content, inline }) => {
    var _a2;
    if (node.attrs.src && inline)
      return `![${(_a2 = node.attrs.alt) != null ? _a2 : ""}](${node.attrs.src})`;
    if (node.attrs.src && !inline)
      return `<img src="${node.attrs.src}" />`;
    return content;
  },
  [SeshatInlineNodes.REFERENCE]: ({ node, content }) => {
    var _a2;
    return (_a2 = `[[${node.attrs.value}]]`) != null ? _a2 : content;
  },
  default: ({ content }) => {
    return `<div>${content}</div>`;
  }
};
class ClipboardDOMSerializer {
  constructor(schema) {
    this.serialize = ({
      node,
      prevNode,
      parentNode,
      nextNode
    }) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
      if (!node)
        return "";
      const isInlineAndNotAFileOrExternalImage = node.isInline && node.textContent;
      if (isInlineAndNotAFileOrExternalImage) {
        const wrapper = document.createElement("div");
        const serializedContent = (_b2 = (_a2 = domSerializerConfig[node.type.name]) == null ? void 0 : _a2.call(domSerializerConfig, { node, content: "" })) != null ? _b2 : this.nativeSerializer.serializeNode(node);
        wrapper.append(serializedContent);
        return wrapper.innerHTML;
      }
      const content = (_e2 = (_d2 = (_c2 = node == null ? void 0 : node.content) == null ? void 0 : _c2.content) == null ? void 0 : _d2.reduce(
        (acc, childNode, i) => acc + this.serialize({
          node: childNode,
          parentNode: node,
          prevNode: node.content.content[i - 1],
          nextNode: node.content.content[i + 1]
        }),
        ""
      )) != null ? _e2 : "";
      const serializeNode = (_g2 = (_f2 = domSerializerConfig[node.attrs.type]) != null ? _f2 : domSerializerConfig[node.type.name]) != null ? _g2 : domSerializerConfig.default;
      return serializeNode({ node, content, parentNode, prevNode, nextNode });
    };
    this.nativeSerializer = DOMSerializer.fromSchema(schema);
    this.marks = this.nativeSerializer.marks;
    this.nodes = this.nativeSerializer.nodes;
  }
  getNodeToSerialize(fragment) {
    if (fragment.childCount === 1 && fragment.firstChild) {
      return fragment.firstChild;
    } else {
      const schema = getSeshatEditorSchema();
      return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
        { type: BlockTypes.CAPTURE },
        fragment.content
      );
    }
  }
  serializeFragment(fragment) {
    const html = this.serialize({ node: this.getNodeToSerialize(fragment) });
    return createFragmentFromHtml(html);
  }
  serializeNode(node) {
    const html = this.serialize({ node });
    return createNodeFromHtml(html);
  }
}
const createNodeFromHtml = (html) => {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  return wrapper.firstChild;
};
const createFragmentFromHtml = (html) => {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  const formattedDomFragment = document.createDocumentFragment();
  formattedDomFragment.append(...wrapper.children);
  return formattedDomFragment;
};
const serializeForClipboard = ({
  schema = getSeshatEditorSchema(),
  content
}) => {
  const serializableContent = getSerializableContent(content);
  const capture = schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { type: BlockTypes.CAPTURE },
    serializableContent
  );
  const domSerializer = new ClipboardDOMSerializer(schema);
  const domFragment = domSerializer.serializeNode(capture);
  const dom = document.createElement("div");
  dom.append(domFragment);
  const markdown2 = createMarkdownFromJSON(capture.toJSON());
  return {
    html: dom.innerHTML,
    text: markdown2,
    json: content instanceof Slice ? content.toJSON() : Slice.maxOpen(serializableContent).toJSON()
  };
};
const getSerializableContent = (content) => {
  if (content instanceof Node$1)
    return Fragment.from(content);
  if (content instanceof Slice)
    return content.content;
  return content;
};
const setClipboardEventData = ({
  state,
  data
}) => {
  var _a2;
  const { from, to } = state.selection;
  const slice = state.doc.slice(from, to, false);
  if (!slice.size)
    return;
  const { html, text, json: json2 } = serializeForClipboard({
    content: slice,
    schema: state.schema
  });
  (_a2 = data.clearData) == null ? void 0 : _a2.call(data);
  data.setData("text/html", html);
  data.setData("text/plain", text);
  data.setData(
    SESHAT_JSON_MIME,
    JSON.stringify({
      slice: json2,
      blockSelection: isBlockSelection(state.selection)
    })
  );
};
const clipboardCopyHandler = (view, event) => {
  if (!(event instanceof ClipboardEvent))
    return true;
  const data = event.clipboardData;
  event.preventDefault();
  if (!data)
    return true;
  setClipboardEventData({ state: view.state, data });
  return true;
};
const clipboardCutHandler = (view, event) => {
  var _a2;
  if (!(event instanceof ClipboardEvent))
    return true;
  const data = event.clipboardData;
  event.preventDefault();
  if (!data)
    return true;
  setClipboardEventData({ state: view.state, data });
  const { tr } = view.state;
  tr.deleteSelection();
  (_a2 = view.dispatch) == null ? void 0 : _a2.call(view, tr);
  return true;
};
const WRAPPING_BLOCKS_TO_REMOVE = [
  BlockTypes.HIGHLIGHTS,
  BlockTypes.HIGHLIGHT,
  BlockTypes.HIGHLIGHT_NOTE
];
const cleanupPastedContent = ({
  state,
  pastedContentRange
}) => {
  const { tr } = state;
  const isPasteWithinClipContent = !!findAncestor(
    tr.selection.$from,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.CLIP_CONTENT
  );
  const currentBlock = getCurrentBlock(state.doc, state.selection.from);
  const isPastedAtNestedLevel = currentBlock && currentBlock.depth > 2;
  tr.doc.nodesBetween(
    pastedContentRange.from,
    pastedContentRange.to,
    (node, pos) => {
      var _a2;
      if (pos < pastedContentRange.from || pos > pastedContentRange.to)
        return;
      const blockType = (_a2 = node.attrs.nodeViewType) != null ? _a2 : node.attrs.type;
      if (WRAPPING_BLOCKS_TO_REMOVE.includes(blockType)) {
        const $from = tr.doc.resolve(tr.mapping.map(pos + 1));
        const $to = tr.doc.resolve(tr.mapping.map(pos + node.nodeSize - 1));
        tr.lift(new NodeRange($from, $to, $from.depth), $from.depth - 1);
      }
      if (isPasteWithinClipContent && clipBlocks.includes(blockType)) {
        tr.delete(tr.mapping.map(pos), tr.mapping.map(pos + node.content.size));
      }
      const isNodeNested = tr.doc.resolve(tr.mapping.map(pos)).depth > 1;
      if ((isPastedAtNestedLevel || isNodeNested) && blockType === BlockTypes.CARD_LINK) {
        const newBlock = createParagraphWithBidirectionalLink(state, node);
        tr.replaceWith(
          tr.mapping.map(pos),
          tr.mapping.map(pos + node.content.size),
          newBlock
        );
      }
    }
  );
  return tr;
};
const createParagraphWithBidirectionalLink = (state, node) => {
  const bidirectionalLink = state.schema.nodes[SeshatInlineNodes.REFERENCE].create({
    id: node.attrs[BlockAttrsParams.BLOCK_UUID],
    cardUuid: node.attrs[BlockAttrsParams.BLOCK_UUID],
    value: createBidirectionalLinkValueFromCardLinkText(node)
  });
  return createSeshatBlock({
    attrs: { type: BlockTypes.PARAGRAPH },
    content: [bidirectionalLink],
    schema: state.schema
  });
};
const createBidirectionalLinkValueFromCardLinkText = (node) => {
  var _a2, _b2, _c2;
  const cardLinkNodeView = (_b2 = (_a2 = node.firstChild) == null ? void 0 : _a2.firstChild) == null ? void 0 : _b2.firstChild;
  return cardLinkNodeView ? (_c2 = cardLinkNodeView.attrs.cardLinkText) == null ? void 0 : _c2.reduce(
    (prev, curr) => {
      var _a3;
      return prev + ((_a3 = curr.text) != null ? _a3 : "");
    },
    ""
  ) : node.textContent;
};
const pastedInEmptyPaywallClip = (state) => {
  var _a2, _b2, _c2;
  const { $anchor } = state.selection;
  const { depth } = $anchor;
  const clipNode = depth >= 5 && $anchor.node(depth - 3);
  return clipNode && clipNode.attrs.type === BlockTypes.CLIP_CONTENT && clipNode.attrs.isPaywallContent && ((_c2 = (_b2 = (_a2 = clipNode.firstChild) == null ? void 0 : _a2.firstChild) == null ? void 0 : _b2.firstChild) == null ? void 0 : _c2.childCount) === 0;
};
const clipboardPasteHandler = (view, e, pastedSlice) => {
  var _a2, _b2;
  if ((_a2 = e.clipboardData) == null ? void 0 : _a2.files.length)
    return false;
  const { content, json: json2 } = getClipboardDataFromEvent({
    view,
    slice: pastedSlice,
    event: e
  });
  const slice = resetAttrsInSlice(view.state.schema, content);
  const hasSeveralBlocks = slice.content.content.filter(
    (node) => node.type.spec.group === SeshatNodeGroups.BLOCK
  ).length > 1;
  let { tr } = view.state;
  if (hasSeveralBlocks && (!json2 || json2.blockSelection)) {
    tr = pasteAsBlocks({ view, slice });
  } else {
    tr = pasteAsInline({ view, slice });
  }
  if (pastedInEmptyPaywallClip(view.state)) {
    tr = setIsPaywallContent({ tr, state: view.state, value: false });
    tr = matchHighlightsWithClipContentTransaction({ tr, state: view.state });
  }
  (_b2 = view.dispatch) == null ? void 0 : _b2.call(view, tr);
  return true;
};
const getClipboardDataFromEvent = ({
  view,
  slice,
  event
}) => {
  var _a2, _b2;
  try {
    const clipboardData = getLazyClipboardData(event);
    if (clipboardData) {
      const content = Slice.fromJSON(view.state.schema, clipboardData.slice);
      return { content, json: clipboardData };
    }
    const text = (_a2 = event.clipboardData) == null ? void 0 : _a2.getData("text/plain");
    const isPlainText = text && !((_b2 = event.clipboardData) == null ? void 0 : _b2.getData("text/html"));
    if (isPlainText) {
      const content = new MarkdownParser(view.state.schema).parseSlice(text);
      return { content };
    }
    return { content: slice };
  } catch {
    return { content: slice };
  }
};
const getLazyClipboardData = (event) => {
  var _a2, _b2;
  try {
    const clipboardSerializedData = (_b2 = (_a2 = event.clipboardData) == null ? void 0 : _a2.getData(SESHAT_JSON_MIME)) != null ? _b2 : void 0;
    const clipboardData = clipboardSerializedData && JSON.parse(clipboardSerializedData);
    if (!clipboardData)
      return void 0;
    return clipboardData;
  } catch {
    return void 0;
  }
};
const pasteAsBlocks = ({ view, slice }) => {
  var _a2, _b2, _c2;
  const selection = view.state.selection;
  const lastBlock = isBlockSelection(selection) ? selection.lastBlock() : getCurrentBlock(view.state.doc, selection.to);
  if (!lastBlock)
    return view.state.tr;
  let tr = view.state.tr;
  const startPos = lastBlock.node.textContent ? lastBlock.to : lastBlock.from;
  const endPos = lastBlock.to;
  const finalContent = isWrappedInRootBlock(slice) ? slice.content.firstChild.content : slice.content;
  tr.replaceWith(startPos, endPos, finalContent);
  (_a2 = view.dispatch) == null ? void 0 : _a2.call(view, tr);
  const pastedContentRange = {
    from: startPos,
    to: startPos + finalContent.size
  };
  const newTr = cleanupPastedContent({ state: view.state, pastedContentRange });
  if (isUrl((_c2 = (_b2 = finalContent == null ? void 0 : finalContent.content) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.textContent))
    return newTr;
  newTr.setSelection(
    BlockSelection.createFromRange(
      newTr.doc,
      newTr.mapping.map(startPos),
      newTr.mapping.map(startPos + finalContent.size)
    )
  );
  return newTr.scrollIntoView();
};
const pasteAsInline = ({ view, slice }) => {
  var _a2;
  const isSingleTextBlock = slice.content.childCount === 1 && ((_a2 = slice.content.firstChild) == null ? void 0 : _a2.type.spec.group) === SeshatNodeGroups.BLOCK && slice.content.firstChild.textContent;
  if (isSingleTextBlock) {
    const inlineDepth = SESHAT_CONTENT_DEPTH + 1;
    slice = new Slice(slice.content, inlineDepth, inlineDepth);
  }
  const { tr } = view.state;
  return tr.replaceSelection(slice).scrollIntoView();
};
const setIsPaywallContent = ({
  tr,
  state,
  value
}) => {
  const { $anchor } = state.selection;
  const { depth } = $anchor;
  const clipNode = depth >= 5 && $anchor.node(depth - 3);
  if (!clipNode || clipNode.attrs.type !== BlockTypes.CLIP_CONTENT)
    return tr;
  const clipPos = $anchor.pos - 1 - SESHAT_CONTENT_DEPTH - 1;
  return tr.setNodeMarkup(clipPos, void 0, {
    ...clipNode.attrs,
    isPaywallContent: value === true ? true : void 0
  });
};
const isWrappedInRootBlock = (slice) => {
  var _a2, _b2, _c2;
  return ((_b2 = (_a2 = slice.content) == null ? void 0 : _a2.firstChild) == null ? void 0 : _b2.attrs.type) === BlockTypes.CAPTURE || ((_c2 = slice.content.firstChild) == null ? void 0 : _c2.attrs.type) === BlockTypes.CARD_CONTENT;
};
const ClipboardExtension = Extension.create({
  name: "ClipboardExtension",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          transformPastedHTML: (html) => {
            var _a2;
            const minifiedHTML = removeWhitespaceBetweenHTMLTags(html);
            const doc = new DOMParser().parseFromString(
              minifiedHTML,
              "text/html"
            );
            return (_a2 = doc.body.innerHTML.trim()) != null ? _a2 : html.trim();
          },
          handlePaste: clipboardPasteHandler,
          handleDOMEvents: {
            copy: clipboardCopyHandler,
            cut: clipboardCutHandler
          }
        }
      })
    ];
  }
});
const ContextIDExtension = (options) => Extension.create({
  name: "ContextUuidExtension",
  addOptions() {
    var _a2;
    return {
      generateId: (_a2 = options == null ? void 0 : options.generateRandomId) != null ? _a2 : generateRandomId
    };
  }
});
const applyContextIdToExtension = (extension) => extension.extend({
  addAttributes() {
    var _a2;
    return {
      ...(_a2 = this.parent) == null ? void 0 : _a2.call(this),
      [BlockAttrsParams.CONTEXT_UUID]: {
        default: void 0,
        keepOnSplit: false,
        parseHTML: (element) => {
          const contextUuid = element.getAttribute(
            BlockAttrsParams.CONTEXT_UUID
          );
          return contextUuid;
        },
        renderHTML: (attributes) => {
          return {
            ...attributes,
            [BlockAttrsParams.CONTEXT_UUID]: attributes == null ? void 0 : attributes[BlockAttrsParams.CONTEXT_UUID]
          };
        }
      }
    };
  }
});
const INDENTATION_PADDING = 25;
const moveTo = ($block) => {
  return { type: "moveTo", pos: $block.from };
};
const appendTo = ($block) => {
  return { type: "appendTo", pos: $block.from };
};
const insertAsBlockBefore = ($block) => {
  return { type: "row", pos: $block.from };
};
const insertAsBlockAfter = ($block) => {
  return { type: "row", pos: $block.to };
};
const insertAsNestedBlock = ($block) => {
  return { type: "row", pos: $block.from + 1 };
};
const insertAsIndentedBlock = ($block) => {
  var _a2;
  const blockContentLength = ((_a2 = $block.node.firstChild) == null ? void 0 : _a2.nodeSize) || 0;
  return {
    type: "indented",
    pos: $block.from + blockContentLength + 1
  };
};
const insertAsColumn$1 = ($block, side) => {
  return {
    type: "column",
    pos: findColumnInsertPos($block),
    side
  };
};
const findColumnInsertPos = ($block) => {
  let pos = $block.from;
  if (!isBlockColumn($block.node)) {
    const existingBlockColumn = findAncestor($block.$from, isBlockColumn);
    pos = existingBlockColumn ? $block.$from.before(existingBlockColumn.depth) : $block.from;
  }
  return pos;
};
const isBlockColumn = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_COLUMN;
const isDropTargetValid = (target, $initialBlocks) => {
  const { $block, isOutsideEditor } = target;
  if ($block.from === 0)
    return false;
  if (isSameBlock($initialBlocks, $block))
    return false;
  if (isHighlightsBlockDragged($initialBlocks) && isClipContentTarget($block))
    return false;
  if (isClipDragged($initialBlocks) && isClipContentTarget($block))
    return false;
  if (isContentEditableFalseTarget($block))
    return false;
  if (isHighlightsBlock($block))
    return false;
  if (isCardLinkDragged($initialBlocks) && !isAtRootDepth($block))
    return false;
  if ((isCardLinkDragged($initialBlocks) || isCardLinkTarget($block)) && isOutsideEditor)
    return false;
  return !isBlockLineWithMaxColumnCount($block);
};
const getInitialBlocks = (view, content) => {
  var _a2, _b2;
  if (!content)
    return (_a2 = view.dragging) == null ? void 0 : _a2.blocks;
  const blockId = (_b2 = content.firstChild) == null ? void 0 : _b2.attrs[BlockAttrsParams.BLOCK_UUID];
  const block = getSeshatBlockByBlockId(view.state.doc, blockId);
  if (!block)
    return void 0;
  return BlockSelection.createFromRange(
    view.state.doc,
    block.pos,
    block.pos + content.size
  ).list();
};
const isBlockLineWithMaxColumnCount = ($block) => {
  const blockLine = findAncestor(
    $block.$from,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_LINE
  );
  return blockLine && blockLine.node.childCount >= MAX_COLUMNS;
};
const isHighlightsBlock = ($block) => {
  return !!findAncestor(
    $block.$from,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS
  );
};
const isHighlightsBlockDragged = ($blocks) => {
  return $blocks == null ? void 0 : $blocks.some(
    (block) => block.node.attrs.type === BlockTypes.HIGHLIGHTS
  );
};
const isClipDragged = ($blocks) => {
  return $blocks == null ? void 0 : $blocks.some((block) => {
    var _a2;
    const nodeType = (_a2 = block == null ? void 0 : block.node.attrs.nodeViewType) != null ? _a2 : block == null ? void 0 : block.node.attrs.type;
    return !!nodeType && clipBlocks.includes(nodeType);
  });
};
const isClipContent = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.CLIP_CONTENT;
const isClipContentTarget = ($block) => {
  return !!findAncestor($block.$from, isClipContent);
};
const isCardLinkDragged = ($blocks) => {
  return $blocks == null ? void 0 : $blocks.some(
    (block) => block.node.attrs.type === BlockTypes.CARD_LINK
  );
};
const isCardLinkTarget = ($block) => $block.node.attrs.type === BlockTypes.CARD_LINK;
const isCollapsedBulletedListTarget = ($block) => $block.node.attrs.type === BlockTypes.BULLETED_LIST && $block.node.attrs.collapsed;
const isAtRootDepth = ($block) => $block.$from.depth === 1;
const isSameBlock = (b1, b2) => b1 && b2 && b1[0].from <= b2.from && b2.to <= b1[b1.length - 1].to;
const isContentEditableFalseTarget = ($block) => !!findAncestor($block.$from, (node) => isContentEditableFalse(node)) && !isCardLinkTarget($block);
const findDropPosition = (view, event, content) => {
  const target = findBlockAtMousePosition(view, event);
  const $initialBlocks = getInitialBlocks(view, content);
  if (!target || !isDropTargetValid(target, $initialBlocks))
    return null;
  const { $block } = target;
  if (isCardLinkTarget($block)) {
    if (isInFirstQuarterOfBlock(view, target))
      return insertAsBlockBefore($block);
    if (isInLastQuarterOfBlock(view, target))
      return insertAsBlockAfter($block);
    return moveTo($block);
  }
  if (isCollapsedBulletedListTarget($block)) {
    if (isInFirstQuarterOfBlock(view, target))
      return insertAsBlockBefore($block);
    if (isInLastQuarterOfBlock(view, target))
      return insertAsBlockAfter($block);
    return appendTo($block);
  }
  if (isCardLinkDragged($initialBlocks))
    return insertAsBlockBefore($block);
  if (isLeftColumnInsert(target))
    return insertAsColumn$1($block, "left");
  if (isRightColumnInsert(target))
    return insertAsColumn$1($block, "right");
  if (isWrappingBlock($block)) {
    if (isContentEditableFalse($block.node) || $block.node.attrs.type === BlockTypes.HIGHLIGHTS || $block.node.attrs.type === BlockTypes.BLOCK_LINE)
      return insertAsBlockBefore($block);
    else
      return insertAsNestedBlock($block);
  }
  if (isInFirstHalfOfBlock(view, target))
    return insertAsBlockBefore($block);
  return isIndentedInsert(view, target) && !isContentEditableFalse($block.node) ? insertAsIndentedBlock($block) : insertAsBlockAfter($block);
};
const isLeftColumnInsert = (target) => {
  const isBlockColumn2 = target.$block.node.attrs.type === BlockTypes.BLOCK_COLUMN;
  return isBlockColumn2 || target.isOutsideEditor === "left";
};
const isRightColumnInsert = (target) => {
  return target.isOutsideEditor === "right";
};
const isInFirstHalfOfBlock = (view, target) => {
  var _a2;
  const blockDOM = view.nodeDOM(target.$block.from);
  const blockRect = (_a2 = blockDOM == null ? void 0 : blockDOM.getBoundingClientRect) == null ? void 0 : _a2.call(blockDOM);
  const blockHeight = blockRect.bottom - blockRect.top;
  return blockRect && target.clientY < blockRect.top + blockHeight / 2;
};
const isInFirstQuarterOfBlock = (view, target) => {
  const blockDOM = view.nodeDOM(target.$block.from);
  if (blockDOM instanceof HTMLElement) {
    const blockRect = blockDOM.getBoundingClientRect();
    return target.clientY < blockRect.top + blockRect.height / 4 * 1;
  }
  return false;
};
const isInLastQuarterOfBlock = (view, target) => {
  const blockDOM = view.nodeDOM(target.$block.from);
  if (blockDOM instanceof HTMLElement) {
    const blockRect = blockDOM.getBoundingClientRect();
    return target.clientY > blockRect.top + blockRect.height / 4 * 3;
  }
  return false;
};
const isIndentedInsert = (view, target) => {
  var _a2;
  const blockDOM = view.nodeDOM(target.$block.from);
  const blockRect = (_a2 = blockDOM == null ? void 0 : blockDOM.getBoundingClientRect) == null ? void 0 : _a2.call(blockDOM);
  return blockRect ? blockRect.left + INDENTATION_PADDING < target.clientX : false;
};
const isWrappingBlock = ($block) => getNodeTypeByBlockType($block.node.attrs.type) === SeshatNodes.WRAPPING_BLOCK;
class DropCursor {
  constructor(view) {
    this.timeout = null;
    this.view = view;
    this.dropPos = null;
    this.element = null;
    this.handlers = [
      "dragover",
      "dragend",
      "drop",
      "dragleave"
    ].map((name) => {
      const handler = (e) => this[name](e);
      view.dom.addEventListener(name, handler);
      return { name, handler };
    });
  }
  destroy() {
    this.handlers.forEach(
      ({ name, handler }) => this.view.dom.removeEventListener(name, handler)
    );
  }
  scheduleRemoval(timeout) {
    if (this.timeout)
      clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.updateDropPos(null), timeout);
  }
  hasDropPosChanged(newPos) {
    if (!this.dropPos) {
      return true;
    }
    if (newPos.type !== this.dropPos.type || newPos.pos !== this.dropPos.pos) {
      return true;
    }
    switch (newPos.type) {
      case "column":
        return newPos.side !== this.dropPos.side;
      default:
        return false;
    }
  }
  getVerticalOverlay(dropPos) {
    var _a2;
    const pos = dropPos.pos;
    const blockDOM = this.view.nodeDOM(pos);
    if (!(blockDOM instanceof HTMLElement))
      return;
    const blockRect = (_a2 = blockDOM.getBoundingClientRect) == null ? void 0 : _a2.call(blockDOM);
    const x = dropPos.side === "left" ? blockRect.left : blockRect.right;
    return {
      left: x - 1,
      right: x - 1,
      top: blockRect.top - 1,
      bottom: blockRect.bottom - 3
    };
  }
  getHorizontalOverlay(dropPos) {
    const { doc } = this.view.state;
    let pos = dropPos.pos;
    const isInsertAtEnd = !doc.nodeAt(pos);
    if (isInsertAtEnd) {
      const $block = getCurrentBlock(doc, pos);
      if (!$block)
        return;
      pos = $block.from;
    }
    const blockDOM = this.view.nodeDOM(pos);
    if (!(blockDOM instanceof HTMLElement))
      return;
    const blockRect = blockDOM.getBoundingClientRect();
    if (dropPos.type === "moveTo" || dropPos.type === "appendTo") {
      const padding = 4;
      return {
        top: blockRect.top - 1 - padding,
        right: blockRect.right - 2 + padding,
        left: blockRect.left - 1 - padding,
        bottom: blockRect.bottom - 2 + padding
      };
    }
    const y = isInsertAtEnd ? blockRect.bottom : blockRect.top;
    const paddingLeft = blockDOM.getAttribute("type") === BlockTypes.CLIP_CONTENT || blockDOM.getAttribute("type") === BlockTypes.NUMBERED_LIST || blockDOM.getAttribute("type") === BlockTypes.BULLETED_LIST ? 0 : parseInt(window.getComputedStyle(blockDOM).paddingLeft, 10);
    const left = dropPos.type === "indented" ? blockRect.left + paddingLeft + INDENTATION_PADDING : blockRect.left + paddingLeft;
    return {
      top: y - 1,
      right: blockRect.right - 2,
      left: left - 1,
      bottom: y - 1
    };
  }
  getOverlayCoords(dropPos) {
    return dropPos.type === "column" ? this.getVerticalOverlay(dropPos) : this.getHorizontalOverlay(dropPos);
  }
  getElement() {
    if (this.element) {
      return this.element;
    }
    const domParent = this.view.dom.offsetParent;
    if (!domParent) {
      return null;
    }
    const element = document.createElement("div");
    element.classList.add(SeshatCssClass.DROPCURSOR);
    domParent.appendChild(element);
    this.element = element;
    return element;
  }
  removeElement() {
    var _a2;
    if (!((_a2 = this.element) == null ? void 0 : _a2.parentNode)) {
      return;
    }
    this.element.parentNode.removeChild(this.element);
    this.element = null;
  }
  updateDropPos(dropPos) {
    this.dropPos = dropPos;
    if (!dropPos) {
      this.removeElement();
      return;
    }
    const element = this.getElement();
    if (!element) {
      return;
    }
    const overlayRect = this.getOverlayCoords(dropPos);
    if (!overlayRect) {
      return;
    }
    const domParent = this.view.dom.offsetParent;
    const domParentIsStaticBody = domParent === document.body && window.getComputedStyle(domParent).position === "static";
    let parentLeft, parentTop;
    if (!domParent || domParentIsStaticBody) {
      parentLeft = -window.pageXOffset;
      parentTop = -window.pageYOffset;
    } else {
      const rect = domParent.getBoundingClientRect();
      parentLeft = rect.left - domParent.scrollLeft;
      parentTop = rect.top - domParent.scrollTop;
    }
    element.style.top = `${overlayRect.top - parentTop}px`;
    element.style.height = `${overlayRect.bottom - overlayRect.top}px`;
    element.style.left = `${overlayRect.left - parentLeft}px`;
    element.style.width = `${overlayRect.right - overlayRect.left}px`;
  }
  dragover(event) {
    if (!this.view.editable) {
      return;
    }
    const dropPosition = findDropPosition(this.view, event);
    if (!dropPosition) {
      this.updateDropPos(null);
      return;
    }
    if (this.hasDropPosChanged(dropPosition)) {
      this.updateDropPos(dropPosition);
      this.scheduleRemoval(5e3);
    }
  }
  dragend(_2) {
    this.scheduleRemoval(20);
  }
  drop(_2) {
    this.scheduleRemoval(20);
  }
  dragleave(event) {
    if (event.target === this.view.dom)
      this.updateDropPos(null);
  }
}
const wrapNodeViewContentIntoBlock = ({
  node,
  schema,
  indentedNodes,
  blockAttrs
}) => {
  var _a2, _b2;
  const seshatNodeViewContent = (_a2 = schema.nodes[SeshatNodes.CONTENT_NODE_VIEW]) == null ? void 0 : _a2.create({}, [node]);
  const seshatBlockContent = schema.nodes[SeshatNodes.BLOCK_CONTENT].create(
    {},
    [seshatNodeViewContent]
  );
  return (_b2 = schema.nodes[SeshatNodes.BLOCK]) == null ? void 0 : _b2.create(
    {
      ...{ type: BlockTypes.NODE_VIEW, nodeViewType: node.type.name },
      ...blockAttrs || {}
    },
    [seshatBlockContent, ...indentedNodes || []]
  );
};
const insertNodeViewContent = ({
  node,
  indentedNodes,
  blockAttrs,
  at
}) => ({ tr, dispatch, state }) => {
  dispatch == null ? void 0 : dispatch(
    insertNodeViewContentTransaction({
      state,
      tr,
      node,
      indentedNodes,
      blockAttrs,
      at
    })
  );
  return true;
};
const insertNodeViewContentTransaction = ({
  state,
  tr,
  node,
  indentedNodes,
  blockAttrs,
  at
}) => {
  const newTr = tr != null ? tr : state.tr;
  const { selection } = newTr;
  const { schema } = state;
  const { $from } = selection;
  const block = getCurrentBlock(newTr.doc, $from.pos);
  if (!block)
    return newTr;
  let insertAt = at != null ? at : block.to;
  if (isSeshatBlockEmpty(block.node) && !at) {
    newTr.delete(block.from, block.to);
    insertAt = block.from;
  }
  const seshatBlock = wrapNodeViewContentIntoBlock({
    node,
    schema,
    indentedNodes,
    blockAttrs
  });
  newTr.insert(insertAt, [seshatBlock, createSeshatBlock({ schema })]);
  return setCaretNearbyTransaction({
    state,
    tr: newTr,
    pos: insertAt + seshatBlock.nodeSize + SESHAT_CONTENT_DEPTH + 1
  });
};
const uploadAndInsertFile = ({
  view,
  editor,
  files,
  insertPos,
  updateFileAttributes,
  ...props
}) => {
  if (!files || !editor && !view)
    return;
  [...files].forEach((file) => {
    const href = file == null ? void 0 : file.path;
    if (file.type === "application/pdf" && href) {
      const _editor = editor != null ? editor : view == null ? void 0 : view.dom.editor;
      _editor == null ? void 0 : _editor.chain().insertClipBookmark({
        pos: insertPos,
        nodeViewAttrs: {
          href,
          clipBookmarkType: "pdf",
          hasError: true,
          highlights: {}
        },
        attrs: {
          type: BlockTypes.NODE_VIEW,
          fetched: void 0,
          isPaywallContent: void 0
        }
      }).setMeta(RECALCULATE_PLACEHOLDER, true).run();
    } else {
      uploadAndInsertRegularFile({
        view,
        editor,
        files,
        insertPos,
        updateFileAttributes,
        ...props
      });
    }
  });
};
const uploadAndInsertRegularFile = ({
  view,
  editor,
  files,
  onUpload,
  previewType,
  insertPos,
  updateFileAttributes
}) => {
  var _a2, _b2;
  if (!files || !editor && !view)
    return;
  const doc = (_a2 = editor != null ? editor : view) == null ? void 0 : _a2.state.tr.doc;
  const isAtFileNode = insertPos && ((_b2 = doc == null ? void 0 : doc.nodeAt(insertPos)) == null ? void 0 : _b2.type.name) === NodeViewTypes.FILE;
  const setFile = editor ? (attrs) => {
    if (isAtFileNode && updateFileAttributes) {
      return updateFileAttributes(attrs);
    } else {
      return editor.commands.setFile({ ...attrs });
    }
  } : view ? (attrs) => {
    var _a3, _b3;
    if (isAtFileNode) {
      for (const [key, value] of Object.entries(attrs)) {
        view.state.tr.setNodeAttribute(insertPos, key, value);
      }
      (_a3 = view.dispatch) == null ? void 0 : _a3.call(view, view.state.tr);
    } else {
      const node = view.state.schema.nodes[NodeViewTypes.FILE].create(
        attrs
      );
      (_b3 = view.dispatch) == null ? void 0 : _b3.call(
        view,
        insertNodeViewContentTransaction({
          tr: view.state.tr,
          state: view.state,
          at: insertPos,
          node
        })
      );
    }
  } : void 0;
  if (!setFile)
    return;
  Array.from(files).forEach((file) => {
    onUpload == null ? void 0 : onUpload({ file, previewType }).then((attrs) => {
      if (attrs)
        setFile(attrs);
    });
  });
};
const createColumnNode = (schema, content, attrs) => {
  var _a2;
  return (_a2 = schema.nodes[SeshatNodes.WRAPPING_BLOCK]) == null ? void 0 : _a2.create(
    {
      type: BlockTypes.BLOCK_COLUMN,
      ...attrs
    },
    content
  );
};
const insertColumnWithBlockLineWrapper = ({
  schema,
  tr,
  content,
  dropPos
}) => {
  var _a2;
  const $block = BlockSelection.createFromPosition(
    tr.doc,
    dropPos.pos
  ).firstBlock();
  const columnNode = createColumnNode(schema, $block.node);
  const columnNodeDragged = createColumnNode(schema, content);
  const blockLineContent = dropPos.side === "left" ? [columnNodeDragged, columnNode] : [columnNode, columnNodeDragged];
  const blockLineNode = (_a2 = schema.nodes[SeshatNodes.WRAPPING_BLOCK]) == null ? void 0 : _a2.create(
    {
      type: BlockTypes.BLOCK_LINE
    },
    blockLineContent
  );
  return tr.delete($block.from, $block.to).insert(dropPos.pos, blockLineNode);
};
const insertAsColumn = ({
  tr,
  schema,
  dropPos,
  content
}) => {
  var _a2, _b2;
  const { parent: parentNode } = tr.doc.resolve(dropPos.pos);
  const hasBlockLineWrapper = (parentNode == null ? void 0 : parentNode.attrs.type) === BlockTypes.BLOCK_LINE;
  if (!hasBlockLineWrapper)
    return insertColumnWithBlockLineWrapper({ schema, tr, content, dropPos });
  const columnNodeDragged = createColumnNode(schema, content);
  const columnBeforeSize = (_b2 = (_a2 = tr.doc.nodeAt(dropPos.pos)) == null ? void 0 : _a2.nodeSize) != null ? _b2 : 0;
  const insertPos = dropPos.side === "left" ? dropPos.pos : dropPos.pos + columnBeforeSize;
  return tr.insert(insertPos, columnNodeDragged);
};
const dropHandleHandler = (view, event, slice, moved, options) => {
  var _a2, _b2, _c2, _d2;
  event.preventDefault();
  const contentToInsert = slice.content;
  const dragEvent = event;
  const hasFiles = (_a2 = dragEvent == null ? void 0 : dragEvent.dataTransfer) == null ? void 0 : _a2.files.length;
  const isExternalContent = !moved;
  const dropPosition = findDropPosition(view, dragEvent, contentToInsert);
  if (!dropPosition)
    return true;
  if (isExternalContent && hasFiles && (options == null ? void 0 : options.file))
    return handleExternalFileDrop({
      view,
      dropPosition,
      files: (_b2 = dragEvent == null ? void 0 : dragEvent.dataTransfer) == null ? void 0 : _b2.files,
      options: options.file
    });
  if (dropPosition.type === "moveTo") {
    const targetNode = (_c2 = getCurrentBlock(view.state.doc, dropPosition.pos)) == null ? void 0 : _c2.node;
    if (targetNode) {
      (_d2 = options == null ? void 0 : options.dropHandle) == null ? void 0 : _d2.onMoveCardsTo(targetNode, contentToInsert.content);
    }
    return true;
  }
  return handleDroppedSeshatBlocks({ view, contentToInsert, dropPosition });
};
const handleExternalFileDrop = ({
  view,
  files,
  dropPosition,
  options
}) => {
  if (!files)
    return true;
  const insertPos = dropPosition.type === "indented" ? dropPosition.pos - 1 : dropPosition.pos;
  uploadAndInsertFile({
    view,
    files,
    insertPos,
    onUpload: options.onUpload
  });
  return true;
};
const handleDroppedSeshatBlocks = ({
  view,
  contentToInsert,
  dropPosition
}) => {
  if (!contentToInsert)
    return true;
  const content = contentToInsert;
  const { state, dispatch } = view;
  let { tr, schema } = state;
  tr = deleteInitialBlock(tr, content);
  dropPosition.pos = tr.mapping.map(dropPosition.pos);
  if (dropPosition.type === "column") {
    tr = insertAsColumn({ tr, schema, content, dropPos: dropPosition });
  } else if (dropPosition.type === "appendTo") {
    tr.insert(tr.doc.resolve(dropPosition.pos + 1).after() - 1, content);
  } else {
    tr.insert(dropPosition.pos, content);
  }
  tr = selectBlockAfterDrop(tr, content);
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const getDraggedBlock = (tr, content) => {
  var _a2;
  const draggedBlockId = (_a2 = content.firstChild) == null ? void 0 : _a2.attrs[BlockAttrsParams.BLOCK_UUID];
  return getSeshatBlockByBlockId(tr.doc, draggedBlockId);
};
const deleteInitialBlock = (tr, content) => {
  const block = getDraggedBlock(tr, content);
  return block ? tr.delete(block.pos, block.pos + content.size) : tr;
};
const selectBlockAfterDrop = (tr, content) => {
  const block = getDraggedBlock(tr, content);
  return block ? tr.setSelection(
    BlockSelection.createFromRange(
      tr.doc,
      block.pos,
      block.pos + content.size
    )
  ) : tr;
};
const DROP_HANDLE_EXTENSION = new PluginKey("drop-handle-extension");
const DropHandleExtension = (options) => Extension.create({
  name: "DropHandleExtension",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: DROP_HANDLE_EXTENSION,
        view(view) {
          return new DropCursor(view);
        },
        props: {
          handleDrop: (...args) => dropHandleHandler(...args, options)
        }
      })
    ];
  }
});
const FontColorExtension = Extension.create({
  name: "FontColorExtension",
  addOptions() {
    return {
      types: [MarkTypes.TEXT_STYLE]
    };
  },
  parseHTML() {
    return [
      {
        tag: "span.color",
        priority: 56
      }
    ];
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontColor: {
            default: null,
            renderHTML: (attributes) => attributes.fontColor ? {
              style: `color: ${attributes.fontColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontColor: (fontColor) => ({ chain }) => {
        return chain().setMark(MarkTypes.TEXT_STYLE, { fontColor }).run();
      },
      unsetFontColor: () => ({ chain }) => {
        return chain().setMark(MarkTypes.TEXT_STYLE, { fontColor: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
const resetHistory = () => ({ view, editor }) => {
  const plugins = view.state.plugins;
  const historyPlugin = plugins == null ? void 0 : plugins.find(
    (plugin) => {
      var _a2;
      return (_a2 = plugin == null ? void 0 : plugin.key) == null ? void 0 : _a2.includes("history");
    }
  );
  const newState = view.state.reconfigure({
    plugins: [...plugins.filter((plugin) => {
      var _a2;
      return !((_a2 = plugin.key) == null ? void 0 : _a2.includes("history"));
    })]
  });
  view.updateState(newState);
  setTimeout(function registerNewInstanceOfHistoryPlugin() {
    editor.registerPlugin(history({ ...historyPlugin == null ? void 0 : historyPlugin.spec.config }));
  }, 500);
  return true;
};
const HistoryExtension = History.extend({
  addCommands() {
    var _a2;
    return {
      ...(_a2 = this.parent) == null ? void 0 : _a2.call(this),
      resetHistory
    };
  }
});
const RestoreLayoutPlugin = new Plugin({
  key: new PluginKey("restore-document-layout-plugin"),
  appendTransaction: (trs, __, state) => {
    if (hasValidLayout(state.doc))
      return;
    const attrs = getAttrsFromOldRootBlock(trs);
    if (!attrs)
      return;
    const { tr, schema } = state;
    const children = [createSeshatBlock({ schema })];
    const newRootBlock = createSeshatBlock({ attrs, schema, children });
    tr.replaceWith(0, tr.doc.content.size, newRootBlock);
    tr.setSelection(TextSelection.create(tr.doc, SESHAT_ROOT_DEPTH));
    return tr;
  }
});
const isRootBlockType = (type) => type === BlockTypes.CARD_CONTENT || type === BlockTypes.CAPTURE;
const hasValidLayout = (doc) => {
  var _a2;
  return isRootBlockType((_a2 = doc.firstChild) == null ? void 0 : _a2.attrs.type);
};
const getAttrsFromOldRootBlock = (trs) => {
  const docs = trs.reduce(
    (prevDocs, tr) => [...prevDocs, ...tr.docs],
    []
  );
  const attrs = docs.reduce((prevAttrs, doc) => {
    var _a2, _b2;
    if (isRootBlockType((_a2 = doc.firstChild) == null ? void 0 : _a2.attrs.type))
      return { ...prevAttrs, ...(_b2 = doc.firstChild) == null ? void 0 : _b2.attrs };
    else
      return prevAttrs;
  }, {});
  return attrs.type ? attrs : void 0;
};
const LayoutNode = Document.extend({
  content: `${SeshatNodeGroups.BLOCK}`,
  addProseMirrorPlugins() {
    return [RestoreLayoutPlugin];
  }
});
const findCardLinksInSelection = (blockSelection) => {
  return blockSelection.list().some((b) => b.node.attrs.type === BlockTypes.CARD_LINK);
};
const isHighlightElementBeingMoved = (block) => {
  if (block.node.attrs.type === BlockTypes.HIGHLIGHT_NOTE)
    return true;
  if (block.node.attrs.type === BlockTypes.HIGHLIGHT)
    return true;
  if (isHighlightBlockquote$1(block))
    return true;
  return false;
};
const isHighlightBlockquote$1 = (block) => block.node.attrs.type === BlockTypes.BLOCKQUOTE && block.$from.node(block.depth - 1).attrs.type === BlockTypes.HIGHLIGHT;
const insertAsChild = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2, _c2, _d2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  const insertPos = block.node.type.name === SeshatNodes.WRAPPING_BLOCK ? block.from + 1 : block.from + ((_d2 = (_c2 = block.node.firstChild) == null ? void 0 : _c2.nodeSize) != null ? _d2 : 0) + 1;
  tr.insert(insertPos, blockSelection.getFragment());
  tr.delete(selectionStart, selectionEnd);
  const offset = insertPos - block.from;
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + offset,
    initialSelection.to + offset
  ) : TextSelection.create(tr.doc, initialSelection.from + offset);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertBelow = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  tr.insert(block.to, blockSelection.getFragment());
  tr.delete(selectionStart, selectionEnd);
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + block.node.nodeSize,
    initialSelection.to + block.node.nodeSize
  ) : TextSelection.create(tr.doc, initialSelection.from + block.node.nodeSize);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertInColumnAfter = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  tr.insert(block.from + 1, blockSelection.getFragment());
  tr.delete(selectionStart, selectionEnd);
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + 2,
    initialSelection.to + 2
  ) : TextSelection.create(tr.doc, initialSelection.from + 2);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertOutdent = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2, _c2, _d2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionDepth = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.depth) != null ? _b2 : blockSelection.firstBlock().depth;
  const selectionEnd = (_d2 = (_c2 = blockSelection.lastBlock()) == null ? void 0 : _c2.to) != null ? _d2 : blockSelection.firstBlock().to;
  tr.insert(block.from, blockSelection.getFragment());
  tr.delete(selectionStart, selectionEnd);
  const offset = selectionDepth - block.depth - 1;
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + offset,
    initialSelection.to + offset
  ) : TextSelection.create(tr.doc, initialSelection.from + offset);
  tr.setSelection(updatedSelection);
  return tr;
};
const findBlockLineAncestor = (block) => {
  if (!block)
    return void 0;
  return findAncestor(block.$from, (node) => {
    return (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_LINE;
  });
};
const maybeSkipBlockLine = ({
  doc,
  block,
  blockSelection
}) => {
  const containsCardLink = findCardLinksInSelection(blockSelection);
  const blockLine = findBlockLineAncestor(block);
  if (!block || !containsCardLink || !blockLine)
    return block;
  const blockLineStart = block.$from.before(blockLine.depth);
  let nextBlock = getCurrentBlock(doc, blockLineStart);
  while ((nextBlock == null ? void 0 : nextBlock.node.attrs.type) === BlockTypes.BLOCK_LINE) {
    nextBlock = getCurrentBlock(doc, nextBlock.to + 1);
  }
  return nextBlock ? getPreviousBlock(doc, nextBlock.from, void 0, {
    ignoreChildren: true
  }) : void 0;
};
const moveDown = ({ editor }) => {
  var _a2;
  const { dispatch } = editor.view;
  let { doc, tr } = editor.state;
  const isBlockSelectionActive = isBlockSelection(editor.state.selection);
  if (!isBlockSelectionActive && !editor.state.selection.empty)
    return true;
  const blockSelection = isBlockSelectionActive ? editor.state.selection : BlockSelection.createFromTextSelection(doc, editor.state.selection);
  const firstBlock = blockSelection.firstBlock();
  const lastBlock = (_a2 = blockSelection.lastBlock()) != null ? _a2 : firstBlock;
  if (lastBlock.to === doc.nodeSize - SESHAT_ROOT_DEPTH)
    return true;
  if (isCaretWithinHighlightBlockquote(lastBlock.$from))
    return true;
  if (isAtEndOfHighlightNote(lastBlock))
    return true;
  if (isHighlightElementBeingMoved(lastBlock))
    return true;
  let nextBlock = getNextBlock(doc, lastBlock.to, (node) => {
    return node.attrs.type !== BlockTypes.BLOCK_LINE;
  });
  nextBlock = maybeSkipBlockLine({ doc, block: nextBlock, blockSelection });
  if (!nextBlock)
    return true;
  if (nextBlock.node.attrs.type === BlockTypes.BLOCK_COLUMN) {
    dispatch == null ? void 0 : dispatch(insertInColumnAfter({ tr, blockSelection, block: nextBlock }));
    return true;
  }
  if (nextBlock.depth + 1 < lastBlock.depth) {
    dispatch == null ? void 0 : dispatch(insertOutdent({ tr, blockSelection, block: nextBlock }));
    return true;
  }
  if (hasChildren(nextBlock.node) && isChildInsertAllowed(blockSelection, nextBlock.node)) {
    dispatch == null ? void 0 : dispatch(insertAsChild({ tr, blockSelection, block: nextBlock }));
    return true;
  }
  dispatch == null ? void 0 : dispatch(insertBelow({ tr, blockSelection, block: nextBlock }));
  return true;
};
const isChildInsertAllowed = (blockSelection, node) => {
  return !findCardLinksInSelection(blockSelection) && !isContentEditableFalse(node) && !isBlockCollapsed(node) && node.attrs.type !== BlockTypes.HIGHLIGHTS && node.attrs.type !== BlockTypes.BLOCK_LINE;
};
const isAtEndOfHighlightNote = (block) => {
  var _a2;
  const parent = block.$from.node(block.depth - 1);
  if (parent.attrs.type !== BlockTypes.HIGHLIGHT_NOTE)
    return false;
  return ((_a2 = parent.lastChild) == null ? void 0 : _a2.attrs[BlockAttrsParams.BLOCK_UUID]) === block.node.attrs[BlockAttrsParams.BLOCK_UUID];
};
const insertAbove = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  tr.delete(selectionStart, selectionEnd);
  tr.insert(block.from, blockSelection.getFragment());
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from - block.node.nodeSize,
    initialSelection.to - block.node.nodeSize
  ) : TextSelection.create(tr.doc, initialSelection.from - block.node.nodeSize);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertInColumnBefore = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  tr.delete(selectionStart, selectionEnd);
  tr.insert(block.to - 1, blockSelection.getFragment());
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from - 2,
    initialSelection.to - 2
  ) : TextSelection.create(tr.doc, initialSelection.from - 2);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertIndent = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2, _c2, _d2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionDepth = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.depth) != null ? _b2 : blockSelection.firstBlock().depth;
  const selectionEnd = (_d2 = (_c2 = blockSelection.lastBlock()) == null ? void 0 : _c2.to) != null ? _d2 : blockSelection.firstBlock().to;
  tr.delete(selectionStart, selectionEnd);
  tr.insert(block.to, blockSelection.getFragment());
  const offset = selectionDepth - block.depth - 1;
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + offset,
    initialSelection.to + offset
  ) : TextSelection.create(tr.doc, initialSelection.from + offset);
  tr.setSelection(updatedSelection);
  return tr;
};
const findHighlightsBlockAncestor = (block) => {
  if (!block)
    return void 0;
  return findAncestor(block.$from, (node) => {
    return (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS;
  });
};
const maybeSkipHighlightsBlocks = ({
  doc,
  block
}) => {
  while (block) {
    let highlightsBlock = findHighlightsBlockAncestor(block);
    if (!highlightsBlock)
      break;
    const { depth } = highlightsBlock;
    const highlightsBlockStart = block.$from.start(depth);
    block = getPreviousBlock(doc, highlightsBlockStart);
  }
  return block;
};
const maybeSkipIndentedBlock = ({
  doc,
  block,
  blockSelection
}) => {
  return findCardLinksInSelection(blockSelection) ? getPreviousBlock(doc, blockSelection.from + 1, void 0, {
    ignoreChildren: true
  }) : block;
};
const moveUp = ({ editor }) => {
  var _a2;
  const { dispatch } = editor.view;
  let { tr, doc } = editor.state;
  const isBlockSelectionActive = isBlockSelection(editor.state.selection);
  if (!isBlockSelectionActive && !editor.state.selection.empty)
    return true;
  const blockSelection = isBlockSelectionActive ? editor.state.selection : BlockSelection.createFromTextSelection(doc, editor.state.selection);
  const firstBlock = blockSelection.firstBlock();
  if (isCaretWithinHighlightBlockquote(firstBlock.$from))
    return true;
  if (isAtStartOfHighlightNote(doc, firstBlock))
    return true;
  if (isHighlightElementBeingMoved(firstBlock))
    return true;
  let prevBlock = getPreviousBlock(doc, firstBlock.from, (node) => {
    return node.attrs.type !== BlockTypes.BLOCK_LINE;
  });
  prevBlock = maybeSkipIndentedBlock({ doc, block: prevBlock, blockSelection });
  prevBlock = maybeSkipHighlightsBlocks({ doc, block: prevBlock });
  if (!prevBlock || prevBlock.from === 0)
    return true;
  if (prevBlock.depth + 1 < firstBlock.depth) {
    const blockType = (_a2 = doc.nodeAt(firstBlock.from - 1)) == null ? void 0 : _a2.attrs.type;
    return getNodeTypeByBlockType(blockType) === SeshatNodes.WRAPPING_BLOCK ? editor.commands.unwrapBlock({ ignoreAtStart: true }) : editor.commands.outdentBlock();
  }
  if (prevBlock.node.attrs.type === BlockTypes.BLOCK_COLUMN) {
    dispatch == null ? void 0 : dispatch(insertInColumnBefore({ tr, blockSelection, block: prevBlock }));
    return true;
  }
  if (firstBlock.depth < prevBlock.depth + 1) {
    dispatch == null ? void 0 : dispatch(insertIndent({ tr, blockSelection, block: prevBlock }));
    return true;
  }
  dispatch == null ? void 0 : dispatch(insertAbove({ tr, blockSelection, block: prevBlock }));
  return true;
};
const isAtStartOfHighlightNote = (doc, block) => {
  var _a2;
  return ((_a2 = doc.nodeAt(block.from - 1)) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE;
};
const MoveBlockExtension = Extension.create({
  name: "MoveBlockExtension",
  addKeyboardShortcuts() {
    return {
      [shortcutConfig.moveUp]: moveUp,
      [shortcutConfig.moveDown]: moveDown
    };
  }
});
const TabIndexExtension = Extension.create({
  name: "TabIndexExtension",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("TabIndex"),
        props: {
          attributes: () => {
            return {
              tabindex: "-1"
            };
          }
        }
      })
    ];
  }
});
const isEditableBlockNode = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.TASK_EDITABLE || (node == null ? void 0 : node.attrs.type) === BlockTypes.NOTE_EDITABLE;
const turnEditableBlockIntoCardLink = (props) => ({ state, dispatch, tr }) => {
  const newTr = turnEditableBlockIntoCardLinkTransaction({
    state,
    tr,
    ...props
  });
  if (!newTr)
    return false;
  dispatch == null ? void 0 : dispatch(newTr);
  return true;
};
const turnEditableBlockIntoCardLinkTransaction = ({
  tr,
  state,
  block: initialBlock,
  focus
}) => {
  const block = getCurrentBlock(
    tr.doc,
    initialBlock ? initialBlock.pos : tr.selection.$from.pos
  );
  if (!isEditableBlockNode(block == null ? void 0 : block.node) || !block)
    return void 0;
  return !isSeshatBlockEmpty(block.node) ? turnIntoCardLink({ block, tr, schema: state.schema, focus }) : tr.setNodeMarkup(block.$from.pos, void 0, {
    ...block.node.attrs,
    type: BlockTypes.PARAGRAPH,
    collapsed: false
  });
};
const turnIntoCardLink = ({
  block,
  tr,
  schema,
  focus
}) => {
  if (!block)
    return tr;
  const blockId = block.node.attrs[BlockAttrsParams.BLOCK_UUID];
  const cardType = block.node.attrs.type === BlockTypes.TASK_EDITABLE ? "task" : "note";
  const cardLinkNode = createCardLink$1({
    schema,
    attrs: {
      cardUuid: blockId,
      cardType,
      cardLinkText: getCardLinkText(block.node),
      isDone: block.node.attrs.isDone
    }
  });
  tr.delete(block.$from.pos, block.$to.pos);
  tr.insert(block.$from.pos, cardLinkNode);
  const updatedBlock = getCurrentBlock(tr.doc, block.$from.pos);
  if (focus === "block") {
    tr.setSelection(BlockSelection.createFromPosition(tr.doc, block.$from.pos));
  }
  if (updatedBlock && focus === "before") {
    tr.setSelection(TextSelection.near(tr.doc.resolve(updatedBlock.from), -1));
  }
  if (updatedBlock && focus === "after") {
    tr.setSelection(TextSelection.near(tr.doc.resolve(updatedBlock.to)));
  }
  return tr;
};
const getEditableBlocksFromDoc = (doc) => {
  return findChildren(doc, isEditableBlockNode);
};
const updateBlockAttributes = (attrs, options) => ({ tr, state, dispatch }) => {
  const finalTr = updateBlockAttributesTransaction({
    state,
    tr,
    attrs
  });
  if (!finalTr)
    return false;
  if (options == null ? void 0 : options.turnIntoCardLink) {
    const editableBlocks = getEditableBlocksFromDoc(tr.doc).reverse();
    const initialStart = tr.selection.from;
    if (editableBlocks.length) {
      for (const block of editableBlocks) {
        turnEditableBlockIntoCardLinkTransaction({ tr: finalTr, state, block });
      }
      tr.setSelection(
        BlockSelection.createFromRange(tr.doc, initialStart, tr.selection.to)
      );
    }
  }
  dispatch == null ? void 0 : dispatch(finalTr);
  return true;
};
const updateBlockAttributesTransaction = ({
  tr,
  state,
  attrs
}) => {
  const blockSelection = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(state.doc, state.selection);
  const type = attrs.type;
  blockSelection.list().reverse().forEach((block) => {
    if (block.node.attrs.type === BlockTypes.CARD_LINK) {
      const cardLinkNodePos = block.from + SESHAT_CONTENT_DEPTH + 1;
      const cardLinkNode = tr.doc.nodeAt(cardLinkNodePos);
      if (cardLinkNode && type === BlockTypes.NOTE_EDITABLE) {
        tr.setNodeAttribute(cardLinkNodePos, "cardType", CARD_NOTE_TYPE);
        tr.setMeta("skipDebounce", true);
      }
      if (cardLinkNode && type === BlockTypes.TASK_EDITABLE) {
        tr.setNodeAttribute(cardLinkNodePos, "cardType", CARD_TASK_TYPE);
        tr.setMeta("skipDebounce", true);
      }
      return;
    }
    if (type && getNodeTypeByBlockType(type) === SeshatNodes.WRAPPING_BLOCK && getNodeTypeByBlockType(block.node.attrs.type) !== SeshatNodes.WRAPPING_BLOCK) {
      wrapIntoBlock$1({
        tr,
        schema: state.schema,
        attrs: { ...attrs, type },
        $from: block.$from,
        $to: block.$to
      });
      return;
    }
    tr.setNodeMarkup(block.from, void 0, {
      ...block.node.attrs,
      ...attrs
    });
  });
  return tr;
};
const wrapIntoBlock$1 = ({
  schema,
  tr,
  attrs,
  $from,
  $to
}) => {
  if (getNodeTypeByBlockType(attrs.type) !== SeshatNodes.WRAPPING_BLOCK)
    return tr;
  const seshatBlockNode = $from.node();
  if (seshatBlockNode.type.spec.group !== SeshatNodeGroups.BLOCK)
    return tr;
  const range = $from.blockRange($to);
  if (!range)
    return tr;
  tr.wrap(range, [{ type: schema.nodes[SeshatNodes.WRAPPING_BLOCK], attrs }]);
  tr.scrollIntoView();
  return tr;
};
const TextAlignExtension = Extension.create({
  name: "TextAlignExtension",
  addCommands() {
    return {
      setAlign: (align) => ({ tr, state, dispatch }) => {
        const block = getCurrentBlock(tr.doc, tr.selection.from);
        if (!block)
          return false;
        tr = updateBlockAttributesTransaction({
          tr,
          state,
          attrs: {
            ...block.node.attrs,
            textAlign: align
          }
        });
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      }
    };
  }
});
function checkIfNextContent({ state }) {
  let hasNextContent = false;
  const $to = state.selection.$to;
  const endOfBlock = isBlockSelection(state.selection) ? state.selection.to : state.selection.$from.after();
  state.doc.cut(endOfBlock, $to.end(0)).descendants((node) => {
    if (node.type.name === SeshatNodes.CONTENT) {
      hasNextContent = true;
    }
    return !hasNextContent;
  });
  return hasNextContent;
}
const insertTrailingLineOnArrowDown = () => ({
  state,
  chain
}) => {
  const { from } = state.selection;
  const block = getCurrentBlock(state.doc, from);
  if (isCurrentBlockEmptyText(block == null ? void 0 : block.node))
    return false;
  if (checkIfNextContent({ state }))
    return false;
  chain().unsetBlockSelection().insertTrailingLine({}).run();
  return true;
};
const isCurrentBlockEmptyText = (node) => {
  return !node || node.textContent === "" || isSeshatBlockEmpty(node);
};
function isMouseUnderLastBlock({
  view,
  e
}) {
  var _a2;
  const lastBlockDom = (_a2 = view.dom) == null ? void 0 : _a2.lastElementChild;
  return lastBlockDom && e.pageY > lastBlockDom.getBoundingClientRect().bottom;
}
const onMouseDown = (view, e) => {
  if (!(e instanceof MouseEvent))
    return false;
  const { state, dispatch } = view;
  const {
    selection: { $from }
  } = state;
  if (isLastBlockEmptyText({ $from }))
    return false;
  if (!isMouseUnderLastBlock({ view, e }))
    return false;
  dispatch == null ? void 0 : dispatch(insertTrailingLineTransaction({ state, tr: state.tr }));
  return true;
};
const isLastBlockEmptyText = ({ $from }) => {
  const mainBlock = $from.node(SESHAT_ROOT_DEPTH);
  if (!mainBlock)
    return false;
  const lastBlock = mainBlock.child(mainBlock.childCount - 1);
  return !isAtom(lastBlock) && !lastBlock.textContent;
};
const TrailingLineExtension = Extension.create({
  name: "TrailingLineExtension",
  addCommands() {
    return {
      insertTrailingLineOnArrowDown,
      insertTrailingLine
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: { handleDOMEvents: { mousedown: onMouseDown } },
        appendTransaction: (_2, __, state) => {
          const parentBlock = state.doc.firstChild;
          if (parentBlock && !hasEditableChildBlocks(parentBlock))
            return insertTrailingLineTransaction({
              state,
              tr: state.tr,
              withoutSetSelection: true
            });
          return;
        }
      })
    ];
  }
});
const hasEditableChildBlocks = (blockNode) => {
  return findChildren(
    blockNode,
    (node) => node.type.spec.group === SeshatNodeGroups.BLOCK && !isAtom(node)
  ).length;
};
const InlineEditingExtension = Extension.create({
  priority: 1e3,
  addKeyboardShortcuts() {
    return {
      Enter: () => true,
      "Shift-Enter": () => true
    };
  }
});
const replaceSelection$1 = ({
  content
}) => ({ tr, dispatch, state }) => {
  if (isBlockSelection(state.selection)) {
    const slice = content ? Slice.fromJSON(state.schema, content) : Slice.empty;
    tr.replace(tr.selection.from, tr.selection.to, slice);
    tr.setSelection(
      BlockSelection.createFromRange(
        tr.doc,
        tr.selection.from,
        tr.selection.from + slice.size
      )
    );
  } else {
    const slice = content ? getInlineContentSlice({ state, content }) : Slice.empty;
    tr.replace(tr.selection.from, tr.selection.to, slice);
    tr.setSelection(
      TextSelection.create(
        tr.doc,
        tr.selection.from,
        tr.selection.from + slice.size
      )
    );
  }
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const getInlineContentSlice = ({
  state,
  content
}) => {
  var _a2;
  const contentToInsert = Array.isArray(content) ? createSeshatBlock({
    schema: state.schema,
    children: Fragment.fromJSON(state.schema, content).content
  }) : Node$1.fromJSON(state.schema, content);
  let inlineContentDistance = 0;
  for (let pos = 0; pos < contentToInsert.nodeSize; pos++) {
    if ((_a2 = contentToInsert.nodeAt(pos)) == null ? void 0 : _a2.isInline) {
      inlineContentDistance = pos;
      break;
    }
  }
  return contentToInsert.slice(
    inlineContentDistance,
    contentToInsert.nodeSize - inlineContentDistance - SESHAT_CONTENT_DEPTH
  );
};
const createNodeFromContent = (content, schema) => {
  if (typeof content === "string") {
    try {
      const json2 = new HTMLParser(schema).parseContent(content);
      return Fragment.fromArray(json2.map((item) => schema.nodeFromJSON(item)));
    } catch {
      return createNodeFromContent("", schema);
    }
  }
  if (typeof content === "object" && content !== null) {
    try {
      if (Array.isArray(content)) {
        return Fragment.fromArray(
          content.map((item) => schema.nodeFromJSON(item))
        );
      }
      return schema.nodeFromJSON(content);
    } catch {
      return createNodeFromContent("", schema);
    }
  }
  return createNodeFromContent("", schema);
};
const replaceWith = ({
  content: value,
  from,
  to
}) => ({ tr, dispatch, editor }) => {
  const content = createNodeFromContent(value, editor.schema);
  if (content.toString() === "<>") {
    return true;
  }
  tr.replaceWith(from, to, content);
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const resetBlock = () => ({ tr, commands }) => {
  const { selection } = tr;
  const { $from } = selection;
  const isAtStart = $from.parentOffset === 0;
  if (!isAtStart)
    return false;
  return commands.updateBlockAttributes({
    type: BlockTypes.PARAGRAPH,
    collapsed: void 0
  });
};
const scrollToBlock$1 = (props) => ({
  view,
  dispatch
}) => {
  dispatch == null ? void 0 : dispatch(scrollToBlockTransaction({ view, ...props }));
  return true;
};
const scrollToBlockTransaction = ({
  view,
  uuid,
  options
}) => {
  var _a2;
  if (!uuid)
    return false;
  const block = getSeshatBlockByBlockId(view.state.doc, uuid);
  if (!block)
    return false;
  const $from = view.state.doc.resolve(block.pos);
  const uneditableParent = findAncestor($from, isContentEditableFalse);
  const collapsedParent = findAncestor($from, (node) => node == null ? void 0 : node.attrs.collapsed);
  let parentBlockId;
  if (uneditableParent && !collapsedParent) {
    parentBlockId = uneditableParent.node.attrs[BlockAttrsParams.BLOCK_UUID];
  }
  if (!uneditableParent && collapsedParent) {
    parentBlockId = collapsedParent.node.attrs[BlockAttrsParams.BLOCK_UUID];
  }
  if (uneditableParent && collapsedParent) {
    const parentCloserToRoot = uneditableParent.depth < collapsedParent.depth ? uneditableParent : collapsedParent;
    parentBlockId = parentCloserToRoot.node.attrs[BlockAttrsParams.BLOCK_UUID];
  }
  const targetBlockId = parentBlockId != null ? parentBlockId : uuid;
  const query = `div[${BlockAttrsParams.BLOCK_UUID}="${targetBlockId}"]`;
  const domBlock = view.dom.querySelector(query);
  if (!domBlock)
    return false;
  const scrollOptions = {
    ...options,
    behavior: (_a2 = options == null ? void 0 : options.behavior) != null ? _a2 : "smooth"
  };
  domBlock.scrollIntoView(scrollOptions);
  return true;
};
const splitBlock = () => ({ tr, dispatch, state }) => {
  const { selection } = tr;
  const { $from } = selection;
  const block = getCurrentBlock(tr.doc, $from.pos);
  if (!block)
    return false;
  const isRoot = block.depth === SESHAT_ROOT_DEPTH;
  if (isRoot || block.node.attrs.type === BlockTypes.CARD_CONTENT) {
    dispatch == null ? void 0 : dispatch(splitBlockWithChildrenTransaction({ schema: state.schema, tr }));
    return true;
  }
  if (block.node.attrs.type === BlockTypes.BULLETED_LIST && block.node.attrs.collapsed === true && block.node.childCount > 1) {
    dispatch == null ? void 0 : dispatch(splitBlockWithAfterTransaction({ schema: state.schema, tr }));
    return true;
  }
  dispatch == null ? void 0 : dispatch(splitBlockTransaction({ tr, schema: state.schema }));
  return true;
};
const splitBlockTransaction = ({
  tr,
  schema
}) => {
  var _a2;
  const { selection } = tr;
  const { $from, $to } = selection;
  const contentDepth = $from.depth;
  const seshatBlockDepth = contentDepth - SESHAT_CONTENT_DEPTH;
  const selectionStart = $from.pos;
  const selectionEnd = $to.pos;
  const contentNodeStart = $from.start();
  const seshatBlockEnd = $from.end(seshatBlockDepth);
  const block = getCurrentBlock(tr.doc, $from.pos);
  const blockType = seshatBlockOnEnter[block == null ? void 0 : block.node.attrs.type] || (block == null ? void 0 : block.node.attrs.type);
  const seshatBlock = (_a2 = schema.nodes[getNodeTypeByBlockType(blockType)]) == null ? void 0 : _a2.create(
    {
      ...block == null ? void 0 : block.node.attrs,
      [BlockAttrsParams.BLOCK_UUID]: void 0,
      [BlockAttrsParams.HIGHLIGHT_UUID]: void 0,
      [BlockAttrsParams.CONTEXT_UUID]: block == null ? void 0 : block.node.attrs[BlockAttrsParams.CONTEXT_UUID],
      type: blockType != null ? blockType : BlockTypes.PARAGRAPH
    },
    block ? block.node.content : void 0
  );
  const insertPosition = seshatBlockEnd + 1;
  tr.insert(insertPosition, seshatBlock);
  const contentNodePositionStartOfNewNode = insertPosition + SESHAT_CONTENT_DEPTH + 1;
  const numberOfPositionDeletedInNewNode = selectionEnd - contentNodeStart;
  tr.delete(
    contentNodePositionStartOfNewNode,
    contentNodePositionStartOfNewNode + numberOfPositionDeletedInNewNode
  );
  const endOfOldBlock = insertPosition - 1;
  tr.delete(selectionStart, endOfOldBlock);
  const numberOfPositionDeletedInOldNode = endOfOldBlock - selectionStart;
  tr.setSelection(
    TextSelection.create(
      tr.doc,
      contentNodePositionStartOfNewNode - numberOfPositionDeletedInOldNode + SESHAT_CONTENT_DEPTH
    )
  ).scrollIntoView();
  return tr;
};
const splitBlockWithChildrenTransaction = ({
  tr,
  schema
}) => {
  const { selection } = tr;
  const { $from, $to } = selection;
  const selectionStart = $from.pos;
  const selectionEnd = $to.pos;
  const contentNodeStart = $from.start();
  const contentNodeEnd = $from.end();
  const block = getCurrentBlock(tr.doc, $from.pos);
  const seshatContent = schema.nodes.seshatContent.create(
    {},
    $from.node().content
  );
  const seshatBlockContent = schema.nodes[SeshatNodes.BLOCK_CONTENT].create(
    {},
    seshatContent
  );
  const seshatBlock = schema.nodes[SeshatNodes.BLOCK].create(
    {
      type: BlockTypes.PARAGRAPH,
      [BlockAttrsParams.CONTEXT_UUID]: block == null ? void 0 : block.node.attrs[BlockAttrsParams.CONTEXT_UUID]
    },
    seshatBlockContent
  );
  tr.insert(contentNodeEnd + SESHAT_CONTENT_DEPTH, seshatBlock);
  const newChildDepth = SESHAT_CONTENT_DEPTH + 1;
  const newSeshatBlockContentTemporaryStart = contentNodeEnd + SESHAT_CONTENT_DEPTH + newChildDepth;
  const numberOfPositionDeletedInNewNode = selectionEnd - contentNodeStart;
  tr.delete(
    newSeshatBlockContentTemporaryStart,
    newSeshatBlockContentTemporaryStart + numberOfPositionDeletedInNewNode
  );
  tr.delete(selectionStart, contentNodeEnd);
  const numberOfPositionDeletedInOldNode = contentNodeEnd - selectionStart;
  tr.setSelection(
    TextSelection.create(
      tr.doc,
      newSeshatBlockContentTemporaryStart - numberOfPositionDeletedInOldNode
    )
  ).scrollIntoView();
  return tr;
};
const splitBlockWithAfterTransaction = ({
  tr,
  schema
}) => {
  var _a2, _b2;
  const { selection } = tr;
  const { $from, $to } = selection;
  const selectionStart = $from.pos;
  const selectionEnd = $to.pos;
  const contentNodeStart = $from.start();
  const contentNodeEnd = $from.end();
  const blockDepth = $from.depth - SESHAT_CONTENT_DEPTH;
  const blockEnd = $from.after(blockDepth);
  const blockStart = $from.before(blockDepth);
  const seshatContent = schema.nodes.seshatContent.create(
    {},
    $from.node().content
  );
  const seshatBlockContent = schema.nodes[SeshatNodes.BLOCK_CONTENT].create(
    {},
    seshatContent
  );
  const seshatBlock = schema.nodes[SeshatNodes.BLOCK].create(
    {
      type: (_b2 = (_a2 = tr.doc.nodeAt(blockStart)) == null ? void 0 : _a2.attrs.type) != null ? _b2 : BlockTypes.PARAGRAPH
    },
    seshatBlockContent
  );
  tr.insert(blockEnd, seshatBlock);
  const newSeshatContentStart = blockEnd + SESHAT_CONTENT_DEPTH + 1;
  const numberOfPositionDeletedInNewNode = selectionEnd - contentNodeStart;
  tr.delete(
    newSeshatContentStart,
    newSeshatContentStart + numberOfPositionDeletedInNewNode
  );
  tr.delete(selectionStart, contentNodeEnd);
  const numberOfPositionDeletedInOldNode = contentNodeEnd - selectionStart;
  tr.setSelection(
    TextSelection.create(
      tr.doc,
      newSeshatContentStart - numberOfPositionDeletedInOldNode
    )
  ).scrollIntoView();
  return tr;
};
const unwrapBlock = ({
  ignoreAtStart
} = {}) => ({ state, tr, dispatch }) => {
  var _a2;
  const { $from, from } = state.selection;
  const isAtStart = $from.parentOffset === 0;
  if (!isAtStart && !ignoreAtStart)
    return false;
  const previousBlock = getPreviousBlock(state.doc, from);
  const previousBlockType = (_a2 = previousBlock == null ? void 0 : previousBlock.node) == null ? void 0 : _a2.attrs.type;
  if (getNodeTypeByBlockType(previousBlockType) !== SeshatNodes.WRAPPING_BLOCK)
    return false;
  dispatch == null ? void 0 : dispatch(unwrapBlockTransaction({ tr, state }));
  return true;
};
const unwrapBlockTransaction = ({
  state,
  tr
}) => {
  var _a2, _b2, _c2, _d2, _e2;
  const { $from } = tr.selection;
  const previousSibling = getPreviousSibling({ $from });
  const blockSel = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(state.doc, state.selection);
  const fragment = blockSel.getFragment();
  const isColumn = ((_b2 = (_a2 = previousSibling == null ? void 0 : previousSibling.node) == null ? void 0 : _a2.attrs) == null ? void 0 : _b2.type) === BlockTypes.BLOCK_COLUMN;
  const isLine = ((_d2 = (_c2 = previousSibling == null ? void 0 : previousSibling.node) == null ? void 0 : _c2.attrs) == null ? void 0 : _d2.type) === BlockTypes.BLOCK_LINE;
  const offset = isLine || isColumn ? -2 : -1;
  tr.delete(blockSel.from, blockSel.to);
  tr.insert(blockSel.from + offset, fragment);
  if (((_e2 = previousSibling == null ? void 0 : previousSibling.node) == null ? void 0 : _e2.childCount) === 1) {
    tr.delete(blockSel.to, blockSel.to + 1);
  }
  if (isBlockSelection(state.selection)) {
    tr.setSelection(
      BlockSelection.createFromRange(
        tr.doc,
        blockSel.from + offset,
        blockSel.to + offset
      )
    );
  } else {
    tr.setSelection(
      TextSelection.create(tr.doc, state.selection.from + offset)
    );
  }
  return tr;
};
const unwrapChildrenAndMoveContentToTarget = ({
  previousTarget,
  block
}) => ({
  tr,
  dispatch
}) => {
  var _a2, _b2, _c2, _d2;
  if (!block)
    return false;
  const { selection } = tr;
  const { $from } = selection;
  const isEmpty2 = isSeshatBlockEmpty(block.node);
  const previousNodeDepth = ((_a2 = previousTarget.parentNode) == null ? void 0 : _a2.attrs.type) === BlockTypes.CARD_CONTENT ? tr.doc.resolve(previousTarget.pos).depth + 1 : getNodeDepth(previousTarget.node);
  const offsetToReachEndOfPreviousTarget = isEmpty2 ? 0 : previousNodeDepth;
  if ((block == null ? void 0 : block.node.firstChild) && block.node.childCount > 1) {
    const firstChildSize = block.node.firstChild.nodeSize;
    const secondChildPos = $from.start(block.depth) + firstChildSize;
    const range = tr.doc.resolve(secondChildPos).blockRange(tr.doc.resolve($from.end(block.depth)));
    if (range)
      tr.lift(range, block.depth - 1);
  }
  const hasPreviousBlockCollapsedChildren = ((_b2 = previousTarget.parentNode) == null ? void 0 : _b2.attrs.collapsed) && previousTarget.parentNode.childCount > 1;
  const endOfPreviousTarget = previousTarget.pos + previousTarget.node.nodeSize;
  const caretPos = endOfPreviousTarget - previousNodeDepth;
  if (hasPreviousBlockCollapsedChildren) {
    const remainingContent = (_d2 = (_c2 = block.node.firstChild) == null ? void 0 : _c2.firstChild) == null ? void 0 : _d2.content;
    const slice = new Slice(remainingContent != null ? remainingContent : Fragment.empty, 0, 0);
    tr.delete(block.from, block.from + slice.size + SESHAT_CONTENT_DEPTH + 1);
    tr.insert(
      endOfPreviousTarget - offsetToReachEndOfPreviousTarget,
      slice.content
    );
  } else {
    tr.delete(
      endOfPreviousTarget - offsetToReachEndOfPreviousTarget,
      $from.pos
    );
  }
  tr.setSelection(TextSelection.create(tr.doc, caretPos)).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const unwrapInParentBlock = ({
  ignoreAtStart
} = {}) => ({ state, commands }) => {
  const { selection } = state;
  const { $from } = selection;
  const isAtStart = $from.parentOffset === 0;
  if (!(isAtStart && selection.empty) && !ignoreAtStart)
    return false;
  const block = getCurrentBlock(state.doc, state.selection.from);
  const isEmpty2 = block && isSeshatBlockEmpty(block.node);
  const wrappingBlock = getWrappingBlock(state);
  if (!(wrappingBlock && isEmpty2))
    return false;
  const isRootBlock2 = wrappingBlock.depth === SESHAT_ROOT_DEPTH;
  if (isRootBlock2)
    return false;
  if (!isFirstOrLastItem(wrappingBlock))
    return false;
  if (isHighlightBlockquote(state.doc, wrappingBlock))
    return false;
  return commands.outdentBlock({ stopPropagation: false });
};
const isFirstOrLastItem = (wrappingBlock) => {
  const isLastItem = wrappingBlock.childIndex === wrappingBlock.node.childCount - 1;
  const isFirstItem = wrappingBlock.childIndex === 0;
  return isLastItem || isFirstItem;
};
const isHighlightBlockquote = (doc, wrappingBlock) => {
  if (!wrappingBlock.node || wrappingBlock.node.attrs.type !== BlockTypes.BLOCKQUOTE)
    return false;
  const nodeBefore = doc.nodeAt(minMax(wrappingBlock.pos - 2, 0, doc.nodeSize));
  return (nodeBefore == null ? void 0 : nodeBefore.attrs) && (nodeBefore == null ? void 0 : nodeBefore.attrs.type) === BlockTypes.HIGHLIGHT;
};
const getWrappingBlock = (state) => {
  const block = getCurrentBlock(state.doc, state.selection.from);
  if (!block)
    return void 0;
  const parentNode = state.selection.$from.node(block.depth - 1);
  return parentNode.type.name === SeshatNodes.WRAPPING_BLOCK ? {
    node: parentNode,
    pos: state.selection.$from.start(block.depth - 1),
    childIndex: state.selection.$from.index(block.depth - 1),
    depth: block.depth - 1
  } : void 0;
};
const updateBlockAttributesAt = (props) => ({ state, dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(updateBlockAttributesAtTransaction({ state, tr, ...props }));
  return true;
};
const updateBlockAttributesAtTransaction = ({
  tr,
  pos,
  attrs,
  scrollIntoView
}) => {
  const node = tr.doc.nodeAt(pos);
  if ((node == null ? void 0 : node.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  tr.setNodeMarkup(pos, void 0, {
    ...node.attrs,
    ...attrs
  });
  if (scrollIntoView)
    tr.scrollIntoView();
  return tr;
};
const wrapIntoBlock = (attrs) => ({
  dispatch,
  tr,
  state
}) => {
  if (getNodeTypeByBlockType(attrs.type) !== SeshatNodes.WRAPPING_BLOCK)
    return false;
  dispatch == null ? void 0 : dispatch(wrapIntoBlockTransaction({ tr, attrs, schema: state.schema }));
  return true;
};
const wrapIntoBlockTransaction = ({
  tr,
  attrs,
  schema
}) => {
  if (getNodeTypeByBlockType(attrs.type) !== SeshatNodes.WRAPPING_BLOCK)
    return tr;
  const block = getCurrentBlock(tr.doc, tr.selection.from);
  if (!block)
    return tr;
  const range = tr.doc.resolve(block.from).blockRange(tr.doc.resolve(block.to));
  if (!range)
    return tr;
  tr.wrap(range, [{ type: schema.nodes[SeshatNodes.WRAPPING_BLOCK], attrs }]);
  tr.scrollIntoView();
  return tr;
};
const seshatBlockCommands = {
  deleteBlock,
  duplicateBlock,
  focusAtSelectionEnd,
  focusLastPosition,
  indentBlock,
  insertBlock,
  insertSoftBreak,
  insertSoftBreakOnEnter,
  indentText,
  onBackspace,
  onDelete,
  onEnter,
  onHardBreak,
  outdentBlock,
  outdentText,
  removeFirstLine: removeFirstLine$1,
  resetBlock,
  replaceSelection: replaceSelection$1,
  replaceContent,
  replaceWith,
  scrollToBlock: scrollToBlock$1,
  setCaretNearby,
  splitBlock,
  unwrapBlock,
  unwrapChildrenAndMoveContentToTarget,
  unwrapInParentBlock,
  updateBlockAttributes,
  updateBlockAttributesAt,
  wrapIntoBlock
};
const SeshatBlockContentNode = Node.create({
  name: SeshatNodes.BLOCK_CONTENT,
  group: `${SeshatNodes.BLOCK_CONTENT}`,
  defining: true,
  content: `${SeshatNodes.CONTENT}`,
  addOptions() {
    return {
      class: SeshatCssClass.BLOCK_CONTENT
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options, HTMLAttributes), 0];
  }
});
const SeshatContentGroup = Node.create({
  priority: 1e3,
  group: `${SeshatNodeGroups.CONTENT}`,
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options, HTMLAttributes), 0];
  }
});
const SeshatContentNode = SeshatContentGroup.extend({
  name: SeshatNodes.CONTENT,
  content: "inline*",
  addOptions() {
    return {
      class: SeshatCssClass.CONTENT
    };
  }
});
const SeshatNodeViewContentNode = SeshatContentGroup.extend({
  name: SeshatNodes.CONTENT_NODE_VIEW,
  content: SeshatNodeGroups.NODE_VIEW,
  addOptions() {
    return {
      class: SeshatCssClass.CONTENT_NODE_VIEW
    };
  },
  addCommands() {
    return {
      insertNodeViewContent
    };
  }
});
const seshatBlockInputRule = ({
  regexp,
  getAttrs: getAttrs2,
  matchCondition
}) => {
  return new InputRule({
    find: regexp,
    handler: ({ match, state, commands }) => {
      var _a2, _b2;
      if (matchCondition && !matchCondition(state))
        return;
      const parent = getCurrentBlock(state.doc, state.selection.from);
      if ((parent == null ? void 0 : parent.node.attrs.type) === BlockTypes.CARD_CONTENT)
        return;
      if ((parent == null ? void 0 : parent.node.attrs.type) === BlockTypes.CODE)
        return;
      if ((parent == null ? void 0 : parent.node.attrs.type) === BlockTypes.CLIP_CONTENT_TITLE)
        return;
      const content = (parent == null ? void 0 : parent.node) && ((_a2 = getSeshatContent(parent.node).node) == null ? void 0 : _a2.content);
      if (((_b2 = content == null ? void 0 : content.firstChild) == null ? void 0 : _b2.type.name) === SeshatInlineNodes.REFERENCE)
        return;
      const attrs = (getAttrs2 instanceof Function ? getAttrs2(match) : getAttrs2) || { type: BlockTypes.PARAGRAPH };
      const { tr, selection } = state;
      const { $from } = selection;
      tr.deleteRange($from.pos - match[0].length + 1, $from.pos);
      if (getNodeTypeByBlockType(attrs.type) === SeshatNodes.WRAPPING_BLOCK) {
        commands.wrapIntoBlock(attrs);
      } else {
        commands.updateBlockAttributes(attrs);
      }
    }
  });
};
const SeshatBlockGroup = (options) => applyContextIdToExtension(
  applyBlockIdToExtension(options)(
    Node.create({
      group: SeshatNodeGroups.BLOCK,
      defining: true,
      addOptions() {
        return {
          class: SeshatCssClass.BLOCK
        };
      },
      addAttributes() {
        return seshatBlockAttributes;
      },
      addCommands() {
        return seshatBlockCommands;
      },
      addKeyboardShortcuts() {
        return {
          Enter: () => {
            var _a2, _b2;
            if ((_b2 = (_a2 = this.editor.commands).unsetBlockSelection) == null ? void 0 : _b2.call(_a2))
              return true;
            return this.editor.commands.first(({ commands }) => [
              () => commands.insertSoftBreakOnEnter(),
              () => commands.onEnter()
            ]);
          },
          Delete: () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.onDelete()
            ]);
          },
          "Mod-Enter": () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.toggleBulletedList(),
              () => commands.onHardBreak()
            ]);
          },
          "Mod-d": () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.duplicateBlock()
            ]);
          },
          "Shift-Enter": () => {
            return this.editor.commands.insertSoftBreak();
          },
          Backspace: () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.deleteBlockSelection && commands.deleteBlockSelection(),
              () => commands.unwrapInParentBlock(),
              () => commands.onBackspace()
            ]);
          },
          Tab: () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.indentText(),
              () => commands.indentBlock()
            ]);
          },
          "Shift-Tab": () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.outdentText(),
              () => commands.outdentBlock()
            ]);
          },
          ...seshatBlockShortcut.reduce(
            (result, value) => {
              result[value.keys] = () => {
                var _a2;
                const editor = this.editor;
                const cfg = ALL_BLOCK_COMMANDS.find(
                  (b) => b.type === value.type
                );
                return (_a2 = cfg == null ? void 0 : cfg.runCommand(editor, "shortcut")) != null ? _a2 : editor.commands.updateBlockAttributes({
                  type: value.type
                });
              };
              return result;
            },
            {}
          )
        };
      },
      addProseMirrorPlugins() {
        return [SeshatDOMParserPlugin(this.editor.state.schema)];
      },
      addInputRules() {
        return seshatBlockMarkdown.reduce((result, value) => {
          return [
            ...result,
            ...value.regexExps.map(
              (regex) => seshatBlockInputRule({
                matchCondition: value.matchCondition,
                regexp: regex,
                getAttrs: (match) => ({
                  ...value.attrs,
                  ...match.groups
                })
              })
            )
          ];
        }, []);
      },
      renderHTML({ HTMLAttributes }) {
        return ["div", mergeAttributes(this.options, HTMLAttributes), 0];
      },
      extendNodeSchema(extension) {
        return {
          toText: getExtensionField(extension, "toText")
        };
      }
    })
  )
);
const SeshatWrappingBlockNodeConfig = {
  name: SeshatNodes.WRAPPING_BLOCK,
  content: `${SeshatNodeGroups.BLOCK}*`,
  parseHTML() {
    return parseHTML.wrappingBlock;
  }
};
const SeshatWrappingBlockNode = (options) => SeshatBlockGroup(options).extend(SeshatWrappingBlockNodeConfig);
const removeCardLinksAtNestedLevels = () => ({
  tr,
  dispatch,
  state
}) => {
  const { schema } = state;
  const cardLinks = findChildren(tr.doc, isCardLinkBlock).filter(({ pos }) => tr.doc.resolve(pos).depth !== SESHAT_ROOT_DEPTH).reverse();
  cardLinks.forEach(({ node: block, pos }) => {
    var _a2;
    const node = (_a2 = findChildren(block, isCardLinkNode)) == null ? void 0 : _a2[0].node;
    if (!node)
      return;
    let content = node.attrs.cardLinkText;
    const isTaskDone = node.attrs.cardType === "task" && node.attrs.isDone;
    if (content && isTaskDone) {
      content = [{ type: "text", text: "[X] " }, ...content];
    }
    const isTaskUndone = node.attrs.cardType === "task" && !node.attrs.isDone;
    if (content && isTaskUndone) {
      content = [{ type: "text", text: "[ ] " }, ...content];
    }
    const bulletedList = createSeshatBlock({
      schema,
      attrs: { type: BlockTypes.BULLETED_LIST },
      content: Fragment.fromJSON(schema, content)
    });
    tr.insert(pos + block.nodeSize, bulletedList);
    tr.delete(pos, pos + block.nodeSize);
  });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isCardLinkBlock = (node) => node.attrs.type === BlockTypes.CARD_LINK;
const isCardLinkNode = (node) => node.type.name === NodeViewTypes.CARD_LINK;
const CardLinkBlock = Node.create({
  name: NodeViewTypes.CARD_LINK,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  draggable: true,
  addAttributes() {
    return {
      cardType: {
        default: "note"
      },
      cardLinkText: {
        default: void 0
      },
      isDone: {
        default: void 0
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "card_link_component"
      }
    ];
  },
  addCommands() {
    return {
      markTaskAsDone,
      markTaskAsUndone,
      insertCardLink,
      openSelectedCard,
      onEnterOnCardLink,
      removeCardLinksAtNestedLevels
    };
  },
  addKeyboardShortcuts() {
    return {
      [shortcutConfig.markAsDone]: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.markTaskAsDone()
        ]);
      },
      [shortcutConfig.markAsUndone]: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.markTaskAsUndone()
        ]);
      },
      Enter: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.onEnterOnCardLink()
        ]);
      },
      "Mod-Enter": () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.openSelectedCard()
        ]);
      },
      Space: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.openSelectedCard()
        ]);
      }
    };
  },
  toText({ node }) {
    var _a2;
    const fallback = `${node.textContent}

` || "";
    if (!((_a2 = node.attrs.cardLinkText) == null ? void 0 : _a2.length))
      return fallback;
    try {
      const serializer = new TextSerializer(node.type.schema);
      return `${serializer.serializeContent(node.attrs.cardLinkText)}

`;
    } catch {
      return fallback;
    }
  },
  renderHTML({ HTMLAttributes }) {
    return ["card_link_component", mergeAttributes(HTMLAttributes)];
  }
});
const createCardLink$1 = ({
  attrs: { cardUuid, ...attrs },
  schema
}) => {
  var _a2, _b2, _c2, _d2;
  const cardLink = (_a2 = schema.nodes[NodeViewTypes.CARD_LINK]) == null ? void 0 : _a2.create(attrs);
  const seshatNodeViewContent = (_b2 = schema.nodes[SeshatNodes.CONTENT_NODE_VIEW]) == null ? void 0 : _b2.create({}, cardLink);
  const seshatBlockContent = (_c2 = schema.nodes[SeshatNodes.BLOCK_CONTENT]) == null ? void 0 : _c2.create(
    {},
    seshatNodeViewContent
  );
  return (_d2 = schema.nodes[SeshatNodes.BLOCK]) == null ? void 0 : _d2.create(
    { type: BlockTypes.CARD_LINK, [BlockAttrsParams.BLOCK_UUID]: cardUuid },
    seshatBlockContent
  );
};
const insertClipBook = ({
  attrs,
  at
}) => ({ state: { schema }, dispatch, tr }) => dispatch == null ? void 0 : dispatch(insertClipBookTransaction({ schema, tr, at, attrs }));
const insertClipBookTransaction = ({
  schema,
  tr,
  at,
  attrs
}) => {
  const insertPos = at ? minMax(at, 0, tr.doc.content.size) : BlockSelection.createFromPosition(tr.doc, tr.selection.$from.pos).to;
  const node = schema.nodes[NodeViewTypes.CLIP_BOOK].create(attrs);
  const seshatBlock = wrapNodeViewContentIntoBlock({
    node,
    schema,
    blockAttrs: { nodeViewType: NodeViewTypes.CLIP_BOOK }
  });
  tr = tr.insert(insertPos, seshatBlock);
  tr.setSelection(BlockSelection.createFromPosition(tr.doc, insertPos));
  return tr;
};
const handleEnterOnSelectedClipBook = ({
  editor
}) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const node = (_b2 = (_a2 = editor.state) == null ? void 0 : _a2.selection) == null ? void 0 : _b2.$from.nodeAfter;
  if (!node || node.attrs.nodeViewType !== NodeViewTypes.CLIP_BOOK)
    return false;
  const { asin } = ((_f2 = (_e2 = (_d2 = (_c2 = node.content.content) == null ? void 0 : _c2[0].content.content) == null ? void 0 : _d2[0].content.content) == null ? void 0 : _e2[0]) == null ? void 0 : _f2.attrs) || {};
  if (!asin)
    return false;
  const url = getAsinUrl(asin);
  if (typeof window !== "undefined")
    window.open(url, "_blank");
  return true;
};
const ClipBookBlock = (options) => Node.create({
  name: NodeViewTypes.CLIP_BOOK,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: false,
  addOptions() {
    return options == null ? void 0 : options.clip;
  },
  addAttributes() {
    return {
      asin: {
        default: void 0,
        keepOnSplit: true
      },
      title: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      coverUrl: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      author: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      highlights: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      kindleHighlights: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      status: {
        default: void 0,
        keepOnSplit: true
      }
    };
  },
  addCommands() {
    return {
      insertClipBook
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), ["div"]];
  },
  toText({ node }) {
    var _a2;
    if (!node.attrs.title)
      return "";
    const author = (_a2 = node.attrs.author) == null ? void 0 : _a2.name;
    return `${node.attrs.title}${author ? ` by ${author}` : ""}

`;
  },
  addKeyboardShortcuts() {
    return {
      Enter: handleEnterOnSelectedClipBook
    };
  }
});
const insertClipBookmark$1 = ({
  attrs,
  nodeViewAttrs,
  pos
}) => ({
  state: { schema },
  dispatch,
  tr
}) => dispatch == null ? void 0 : dispatch(
  insertClipBookmarkTransaction({ schema, tr, pos, attrs, nodeViewAttrs })
);
const findPosition = ({
  tr,
  nodeViewAttrs,
  pos
}) => {
  let block = getCurrentBlock(tr.doc, pos != null ? pos : tr.selection.$from.pos);
  let insertAfterBlock = true;
  if ((nodeViewAttrs == null ? void 0 : nodeViewAttrs.clipBookmarkType) === "pdf") {
    while (block && block.depth > SESHAT_CONTENT_DEPTH) {
      block = getNextBlock(tr.doc, block.to);
      insertAfterBlock = false;
    }
  }
  if (block && insertAfterBlock)
    return block.to;
  if (block && !insertAfterBlock)
    return block.from;
  return tr.doc.nodeSize - SESHAT_CONTENT_DEPTH - SESHAT_ROOT_DEPTH;
};
const insertClipBookmarkTransaction = ({
  schema,
  tr,
  nodeViewAttrs,
  attrs,
  pos
}) => {
  const insertPos = findPosition({ tr, pos, nodeViewAttrs });
  const node = schema.nodes[NodeViewTypes.CLIP_BOOKMARK].create(nodeViewAttrs);
  const seshatBlock = wrapNodeViewContentIntoBlock({
    node,
    schema,
    blockAttrs: { ...attrs, nodeViewType: NodeViewTypes.CLIP_BOOKMARK }
  });
  tr = tr.insert(insertPos, seshatBlock);
  if (!(attrs == null ? void 0 : attrs.clipBookmarkType))
    return tr;
  return tr;
};
const replaceClipBookmarkByClipContent = () => ({
  editor,
  tr,
  chain
}) => {
  const { doc } = tr;
  const result = retrieveClipBookmarkAndHref(doc);
  if (!result)
    return false;
  const {
    node: clipBookmarkNode,
    pos: clipBookmarkPos,
    href,
    hrefBackup,
    title,
    highlights
  } = result;
  const emptyBlock = generateEmptyBlock();
  tr.setMeta(ANALYTICS_META, ANALYTICS_EVENTS.CLIP_CONTENT_FROM_BOOKMARK);
  return chain().insertContentAt(
    {
      from: clipBookmarkPos,
      to: clipBookmarkPos + clipBookmarkNode.nodeSize
    },
    {
      type: SeshatNodes.WRAPPING_BLOCK,
      content: [emptyBlock],
      attrs: {
        [BlockAttrsParams.BLOCK_UUID]: generateBlockId(editor),
        ...clipBookmarkNode.attrs,
        type: BlockTypes.CLIP_CONTENT,
        nodeViewType: void 0,
        pending: true,
        href,
        hrefBackup,
        title,
        highlights
      }
    }
  ).run();
};
const retrieveClipBookmarkAndHref = (doc) => {
  var _a2, _b2;
  const clipBookmarkNode = (_a2 = findChildren(
    doc,
    (node2) => (node2 == null ? void 0 : node2.attrs.nodeViewType) === NodeViewTypes.CLIP_BOOKMARK
  )) == null ? void 0 : _a2[0];
  if (!clipBookmarkNode)
    return;
  const { node, pos } = clipBookmarkNode;
  const { href, hrefBackup, title, highlights } = (_b2 = findChildren(
    node,
    (node2) => node2.type.name === NodeViewTypes.CLIP_BOOKMARK
  )) == null ? void 0 : _b2[0].node.attrs;
  return {
    node,
    pos,
    href,
    hrefBackup,
    title,
    highlights
  };
};
const ClipBookmarkBlock = Node.create({
  name: NodeViewTypes.CLIP_BOOKMARK,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: false,
  addAttributes() {
    return {
      title: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      favicon: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      attachmentUuid: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      href: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      hrefBackup: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      highlights: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      hasError: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      video: {
        default: void 0,
        keepOnSplit: true
      },
      status: {
        default: void 0,
        keepOnSplit: true
      },
      clipBookmarkType: {
        default: void 0,
        keepOnSplit: true
      }
    };
  },
  addCommands() {
    return {
      insertClipBookmark: insertClipBookmark$1,
      replaceClipBookmarkByClipContent
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), ["div"]];
  },
  toText({ node }) {
    if (node.attrs.clipBookmarkType === ClipBookmarksTypes.PDF) {
      return node.attrs.title ? `${node.attrs.title}

` : "";
    } else {
      return node.attrs.href ? `${node.attrs.href}

` : "";
    }
  }
});
const fault = Object.assign(create(Error), {
  eval: create(EvalError),
  range: create(RangeError),
  reference: create(ReferenceError),
  syntax: create(SyntaxError),
  type: create(TypeError),
  uri: create(URIError)
});
function create(Constructor) {
  FormattedError.displayName = Constructor.displayName || Constructor.name;
  return FormattedError;
  function FormattedError(format, ...values) {
    const reason = format ? formatter(format, ...values) : format;
    return new Constructor(reason);
  }
}
const own = {}.hasOwnProperty;
const defaultPrefix = "hljs-";
function highlight(language, value, options = {}) {
  let prefix = options.prefix;
  if (typeof language !== "string") {
    throw fault("Expected `string` for name, got `%s`", language);
  }
  if (!high.getLanguage(language)) {
    throw fault("Unknown language: `%s` is not registered", language);
  }
  if (typeof value !== "string") {
    throw fault("Expected `string` for value, got `%s`", value);
  }
  if (prefix === null || prefix === void 0) {
    prefix = defaultPrefix;
  }
  high.configure({ __emitter: HastEmitter, classPrefix: prefix });
  const result = high.highlight(value, { language, ignoreIllegals: true });
  high.configure({});
  if (result.errorRaised) {
    throw result.errorRaised;
  }
  result._emitter.root.data.language = result.language;
  result._emitter.root.data.relevance = result.relevance;
  return result._emitter.root;
}
function highlightAuto(value, options = {}) {
  const subset = options.subset || high.listLanguages();
  options.prefix;
  let index = -1;
  let result = {
    type: "root",
    data: { language: null, relevance: 0 },
    children: []
  };
  if (typeof value !== "string") {
    throw fault("Expected `string` for value, got `%s`", value);
  }
  while (++index < subset.length) {
    const name = subset[index];
    if (!high.getLanguage(name))
      continue;
    const current = highlight(name, value, options);
    if (current.data.relevance > result.data.relevance)
      result = current;
  }
  return result;
}
function registerLanguage(language, syntax) {
  high.registerLanguage(language, syntax);
}
const registerAlias = function(language, alias) {
  if (typeof language === "string") {
    high.registerAliases(alias, { languageName: language });
  } else {
    let key;
    for (key in language) {
      if (own.call(language, key)) {
        high.registerAliases(language[key], { languageName: key });
      }
    }
  }
};
function registered(aliasOrLanguage) {
  return Boolean(high.getLanguage(aliasOrLanguage));
}
function listLanguages() {
  return high.listLanguages();
}
class HastEmitter {
  constructor(options) {
    this.options = options;
    this.root = {
      type: "root",
      data: { language: null, relevance: 0 },
      children: []
    };
    this.stack = [this.root];
  }
  addText(value) {
    if (value === "")
      return;
    const current = this.stack[this.stack.length - 1];
    const tail = current.children[current.children.length - 1];
    if (tail && tail.type === "text") {
      tail.value += value;
    } else {
      current.children.push({ type: "text", value });
    }
  }
  addKeyword(value, name) {
    this.openNode(name);
    this.addText(value);
    this.closeNode();
  }
  addSublanguage(other, name) {
    const current = this.stack[this.stack.length - 1];
    const results = other.root.children;
    if (name) {
      current.children.push({
        type: "element",
        tagName: "span",
        properties: { className: [name] },
        children: results
      });
    } else {
      current.children.push(...results);
    }
  }
  openNode(name) {
    const className = name.split(".").map((d, i) => i ? d + "_".repeat(i) : this.options.classPrefix + d);
    const current = this.stack[this.stack.length - 1];
    const child = {
      type: "element",
      tagName: "span",
      properties: { className },
      children: []
    };
    current.children.push(child);
    this.stack.push(child);
  }
  closeNode() {
    this.stack.pop();
  }
  closeAllNodes() {
  }
  finalize() {
  }
  toHTML() {
    return "";
  }
}
const lowlight = {
  highlight,
  highlightAuto,
  registerLanguage,
  registered,
  listLanguages,
  registerAlias
};
const parseNodes = (nodes, className = []) => {
  return nodes.map((node) => {
    const classes = [
      ...className,
      ...node.properties ? node.properties.className : []
    ];
    if (node.children) {
      return parseNodes(node.children, classes);
    }
    return {
      text: node.value,
      classes
    };
  }).flat();
};
const generateDecorationsForABlock = (block, language) => {
  const blockDecorations = [];
  let from = block.pos + SESHAT_CONTENT_DEPTH + 1;
  const nodes = lowlight.highlight(language, block.node.textContent).children;
  parseNodes(nodes).forEach((node) => {
    const to = from + node.text.length;
    if (node.classes.length) {
      const decoration = Decoration.inline(from, to, {
        class: node.classes.join(" ")
      });
      blockDecorations.push(decoration);
    }
    from = to;
  });
  return blockDecorations;
};
lowlight.registerLanguage("arduino", arduino);
lowlight.registerLanguage("bash", bash);
lowlight.registerLanguage("c", c);
lowlight.registerLanguage("cpp", cpp);
lowlight.registerLanguage("csharp", csharp);
lowlight.registerLanguage("css", css);
lowlight.registerLanguage("diff", diff);
lowlight.registerLanguage("go", go);
lowlight.registerLanguage("ini", ini);
lowlight.registerLanguage("java", java);
lowlight.registerLanguage("javascript", javascript);
lowlight.registerLanguage("json", json);
lowlight.registerLanguage("kotlin", kotlin);
lowlight.registerLanguage("less", less);
lowlight.registerLanguage("lua", lua);
lowlight.registerLanguage("makefile", makefile);
lowlight.registerLanguage("markdown", markdown);
lowlight.registerLanguage("objectivec", objectivec);
lowlight.registerLanguage("perl", perl);
lowlight.registerLanguage("php", php);
lowlight.registerLanguage("php-template", phpTemplate);
lowlight.registerLanguage("plaintext", plaintext);
lowlight.registerLanguage("python", python);
lowlight.registerLanguage("python-repl", pythonRepl);
lowlight.registerLanguage("r", r);
lowlight.registerLanguage("ruby", ruby);
lowlight.registerLanguage("rust", rust);
lowlight.registerLanguage("scss", scss);
lowlight.registerLanguage("shell", shell);
lowlight.registerLanguage("sql", sql);
lowlight.registerLanguage("swift", swift);
lowlight.registerLanguage("typescript", typescript);
lowlight.registerLanguage("vbnet", vbnet);
lowlight.registerLanguage("xml", xml);
lowlight.registerLanguage("yaml", yaml);
const plainTextLanguage = "plain-text";
const codeBlockLanguages = [
  plainTextLanguage,
  ...lowlight.listLanguages()
];
const isSupportedCodeBlockLanguage = (language) => codeBlockLanguages.includes(language);
const getDecorations = ({ doc }) => {
  let decorations = [];
  findChildren(doc, (node) => node.attrs.type === BlockTypes.CODE).forEach(
    (block) => {
      const language = block.node.attrs.language;
      if (!isSupportedCodeBlockLanguage(language))
        return;
      const blockDecorations = generateDecorationsForABlock(block, language);
      decorations = decorations.concat(blockDecorations);
    }
  );
  return DecorationSet.create(doc, decorations);
};
const CodeBlockHighlightPluginKey = new PluginKey("code-block-highlight");
const CodeBlockHighlightPlugin = new Plugin({
  key: CodeBlockHighlightPluginKey,
  state: {
    init: (_2, { doc }) => getDecorations({ doc }),
    apply: ({ doc, docChanged }, decorationSet) => docChanged ? getDecorations({ doc }) : decorationSet
  },
  props: {
    decorations(state) {
      return CodeBlockHighlightPluginKey.getState(state);
    }
  }
});
const CodeBlockPastePlugin = new Plugin({
  key: new PluginKey("code-block-paste-plugin"),
  props: {
    handlePaste: (view, event, slice) => {
      if (!event.clipboardData)
        return false;
      const text = event.clipboardData.getData("text/plain");
      if (!text)
        return false;
      const { state, dispatch } = view;
      const block = getCurrentBlock(state.doc, state.selection.from);
      if (!block)
        return false;
      const vscode = event.clipboardData.getData("vscode-editor-data");
      const vscodeData = vscode ? JSON.parse(vscode) : void 0;
      const vscodeLang = vscodeData == null ? void 0 : vscodeData.mode;
      let { tr, schema } = state;
      const content = text.replace(/\r\n?/g, "\n");
      const isPasteWithinCodeBlock = block.node.attrs.type === BlockTypes.CODE;
      const isPastedCodeBlock = vscodeData || isSliceWithSingleCodeBlock(slice);
      if (!isPasteWithinCodeBlock && !isPastedCodeBlock)
        return false;
      if (isPasteWithinCodeBlock && isBlockSelection(tr.selection)) {
        const contentStart = block.from + SESHAT_CONTENT_DEPTH + 1;
        const contentEnd = block.to - SESHAT_CONTENT_DEPTH - 1;
        tr.setSelection(TextSelection.create(tr.doc, contentStart, contentEnd));
      }
      if (isPasteWithinCodeBlock) {
        tr.insertText(content, tr.selection.from, tr.selection.to);
      }
      if (!isPasteWithinCodeBlock) {
        const lang = isSupportedCodeBlockLanguage(vscodeLang) ? vscodeLang : void 0;
        const attrs = { type: BlockTypes.CODE, language: lang };
        const code = createSeshatBlock({ schema, attrs, content });
        const contentEnd = block.to - SESHAT_CONTENT_DEPTH - 1 + code.nodeSize;
        tr.insert(block.to, code);
        tr.setSelection(TextSelection.near(tr.doc.resolve(contentEnd)));
      }
      tr.scrollIntoView();
      dispatch(tr);
      return true;
    }
  }
});
const isSliceWithSingleCodeBlock = (slice) => {
  var _a2;
  return slice.content.childCount === 1 && ((_a2 = slice.content.firstChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.CODE;
};
const CodeBlock = Extension.create({
  name: BlockTypes.CODE,
  priority: 500,
  addProseMirrorPlugins() {
    return [CodeBlockHighlightPlugin, CodeBlockPastePlugin];
  }
});
const onEnterOnEditable = () => ({
  tr,
  chain,
  state,
  commands
}) => {
  const { selection } = tr;
  const { $from } = selection;
  const block = getCurrentBlock(tr.doc, $from.pos);
  if (!block)
    return false;
  if (isBlockSelection(state.selection))
    return false;
  if (!isEditableBlockNode(block.node))
    return false;
  const nodeIsEmpty = $from.node().textContent.length < 1;
  if (nodeIsEmpty)
    return commands.resetBlock();
  const cardType = block.node.attrs.type === BlockTypes.TASK_EDITABLE ? "task" : "note";
  const _chain = chain();
  _chain.insertCardLink({
    cardType,
    cardUuid: block.node.attrs[BlockAttrsParams.BLOCK_UUID],
    cardLinkText: getCardLinkText(block.node),
    isDone: block.node.attrs.isDone
  });
  if (cardType === "task")
    _chain.updateBlockAttributes({ type: BlockTypes.TASK_EDITABLE });
  return _chain.run();
};
const EditableBlock = Extension.create({
  name: "EditableBlock",
  addCommands() {
    return {
      onEnterOnEditable,
      turnEditableBlockIntoCardLink
    };
  },
  onBlur({ event }) {
    if (isEditorRelatedElementFocused(event))
      return;
    const chain = this.editor.chain();
    const blocks = getEditableBlocksFromDoc(this.editor.state.doc).reverse();
    for (const block of blocks) {
      chain.turnEditableBlockIntoCardLink({ block });
    }
    return chain.run();
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.onEnterOnEditable()
        ]);
      },
      Escape: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.turnEditableBlockIntoCardLink({ focus: "block" })
        ]);
      },
      [shortcutConfig.selectNextBlock]: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.turnEditableBlockIntoCardLink({ focus: "after" })
        ]);
      },
      [shortcutConfig.selectPrevBlock]: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.turnEditableBlockIntoCardLink({ focus: "before" })
        ]);
      }
    };
  }
});
const getSeshatNodesOfType = ({
  content,
  includeInType
}) => {
  return (content == null ? void 0 : content.reduce((result, node) => {
    var _a2, _b2;
    if (node.attrs && node.attrs["type"] && (includeInType.includes((_a2 = node.attrs) == null ? void 0 : _a2.type) || includeInType.includes((_b2 = node.attrs) == null ? void 0 : _b2.nodeViewType))) {
      return [...result, node];
    }
    if (!node.content)
      return result;
    return [
      ...result,
      ...getSeshatNodesOfType({
        content: node.content["content"],
        includeInType
      })
    ];
  }, [])) || [];
};
const FileBlock = (options) => Node.create({
  name: NodeViewTypes.FILE,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  draggable: true,
  addAttributes() {
    return {
      fileUuid: {
        default: void 0,
        keepOnSplit: false
      },
      fileName: {
        default: void 0,
        keepOnSplit: false
      },
      fileSize: {
        default: void 0,
        keepOnSplit: false
      },
      fileType: {
        default: void 0,
        keepOnSplit: false
      },
      previewType: {
        default: PreviewFile.FILE,
        keepOnSplit: false
      }
    };
  },
  addOptions() {
    var _a2;
    return (_a2 = options == null ? void 0 : options.file) != null ? _a2 : {};
  },
  parseHTML() {
    return [
      {
        tag: 'input[type="file"]'
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "input",
      {
        ...HTMLAttributes,
        fileUuid: void 0,
        fileName: void 0,
        fileType: void 0,
        fileSize: void 0,
        previewUrl: void 0,
        previewType: PreviewFile.FILE
      }
    ];
  },
  toText({ node }) {
    return node.attrs.fileName || "";
  },
  addCommands() {
    return {
      setFile: (options2) => ({ commands }) => {
        const node = this.type.create(options2);
        return commands.insertNodeViewContent({ node });
      },
      cleanEmptyFilePlaceholder: () => ({ tr, dispatch }) => {
        const fileNodes = getSeshatNodesOfType({
          content: tr.doc.content["content"],
          includeInType: [BlockTypes.NODE_VIEW]
        });
        fileNodes.forEach((node) => {
          if (isPreviewBlockEmpty(node)) {
            const block = getSeshatBlockByBlockId(
              tr.doc,
              node.attrs["block-id"]
            );
            if (!(block == null ? void 0 : block.pos))
              return;
            tr.deleteRange(block.pos, block.pos + node.nodeSize);
            dispatch == null ? void 0 : dispatch(tr);
          }
        });
        return true;
      },
      uploadAndInsertFile: ({ files }) => ({ editor }) => {
        var _a2;
        uploadAndInsertFile({
          editor,
          files,
          onUpload: (_a2 = this.options) == null ? void 0 : _a2.onUpload
        });
        return true;
      }
    };
  },
  addProseMirrorPlugins() {
    const { editor, options: options2 } = this;
    return [
      new Plugin({
        props: {
          handlePaste: function(_2, e) {
            var _a2;
            e == null ? void 0 : e.preventDefault();
            const files = (_a2 = e == null ? void 0 : e.clipboardData) == null ? void 0 : _a2.files;
            if (!(files == null ? void 0 : files.length))
              return false;
            uploadAndInsertFile({
              editor,
              files,
              onUpload: options2 == null ? void 0 : options2.onUpload
            });
            return true;
          }
        }
      })
    ];
  }
});
const isPreviewBlockEmpty = (node) => {
  var _a2, _b2;
  if (node.attrs.type !== BlockTypes.NODE_VIEW)
    return false;
  const comp = (_b2 = (_a2 = node.firstChild) == null ? void 0 : _a2.firstChild) == null ? void 0 : _b2.firstChild;
  if ((comp == null ? void 0 : comp.type.name) !== NodeViewTypes.FILE)
    return false;
  return noPlaceholderPreviewFile.includes(comp == null ? void 0 : comp.attrs.previewType) && !(comp == null ? void 0 : comp.attrs.fileUuid);
};
const HorizontalRuleBlock = Node.create({
  name: NodeViewTypes.HORIZONTAL_RULE,
  addOptions() {
    return {
      class: "horizontal_rule"
    };
  },
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options, HTMLAttributes), ["div"]];
  },
  toText() {
    return "";
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ commands }) => {
        const node = this.type.create();
        return commands.insertNodeViewContent({ node });
      }
    };
  },
  addInputRules() {
    return [
      new InputRule({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        handler: ({ chain, range }) => {
          const node = this.type.create();
          chain().deleteRange(range).insertNodeViewContent({ node }).run();
        }
      })
    ];
  }
});
const IFrameBlock = Node.create({
  name: NodeViewTypes.IFRAME,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  addAttributes() {
    return {
      src: {
        default: null
      },
      srcDoc: {
        default: null
      },
      alt: {
        default: void 0
      },
      frameBorder: {
        default: 0
      },
      id: {
        default: null
      },
      allowFullScreen: {
        default: true
      },
      url: {
        parseHTML: (element) => element.getAttribute("url")
      }
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", ["iframe", HTMLAttributes]];
  },
  toText({ node }) {
    return node.attrs.url || node.attrs.src || "";
  },
  addCommands() {
    return {
      setIframe: (options) => ({ commands }) => {
        const node = this.type.create(options);
        return commands.insertNodeViewContent({ node });
      }
    };
  }
});
const TableOfContentsBlock = Node.create({
  name: NodeViewTypes.TABLE_OF_CONTENTS,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  addOptions() {
    return {
      class: "table_of_contents"
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options, HTMLAttributes), ["div"]];
  },
  toText() {
    return "";
  },
  addCommands() {
    return {
      setTableOfContents: () => ({ commands }) => {
        const node = this.type.create();
        return commands.insertNodeViewContent({ node });
      }
    };
  }
});
const HEADING_QUERY = "heading";
const getHeadingForTableOfContents = ({
  editor
}) => {
  const editorNodeContent = editor.view.state.doc.content;
  const firstNodeContent = editorNodeContent.content;
  const headingNodes = getBlocksOfType({
    content: firstNodeContent,
    includeInType: HEADING_QUERY
  });
  return headingNodes.map((node) => {
    const jsonNode = node.toJSON();
    return {
      ...jsonNode,
      text: node.textContent
    };
  });
};
const ExternalVideoBlock = (options) => Node.create({
  name: NodeViewTypes.EXTERNAL_VIDEO,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: false,
  addOptions() {
    var _a2;
    return {
      ...(_a2 = options == null ? void 0 : options.file) != null ? _a2 : {}
    };
  },
  addAttributes() {
    return {
      src: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      }
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), ["div"]];
  },
  toText({ node }) {
    return node.attrs.src ? `${node.attrs.src}

` : "";
  }
});
const initHeadlessEditor = ({
  id,
  content,
  extensionOptions
} = {}) => {
  const attributes = id ? { id } : void 0;
  return new Editor({
    editorProps: { attributes },
    extensions: getEditorExtensions({ extensionOptions }),
    content: content ? {
      type: "doc",
      content
    } : void 0
  });
};
const getBlockCardAttrs = (block) => {
  return (block == null ? void 0 : block.attrs) || {};
};
const LazyBlockTypes = { ...BlockTypes, ...NodeViewTypes };
const mentionEditorOptions = ({
  workspaceUuid,
  getList,
  MentionView,
  ContextSummary,
  ReferenceListItemView,
  currentCard
}) => ({
  mentions: {
    MentionView,
    items: [
      {
        MentionItemListComponent: ReferenceListItemView,
        ContextSummary,
        char: "#",
        name: REFERENCE_HASH_PLACEHOLDER,
        placeholder: MENTION_PLACEHOLDER,
        icon: "HASHTAG",
        searchField: "title",
        fieldMentionId: "uuid",
        generateNewMentionId: () => uuidV5(workspaceUuid),
        getList,
        currentCard
      },
      {
        MentionItemListComponent: ReferenceListItemView,
        ContextSummary,
        ...DEFAULT_REFERENCE,
        generateNewMentionId: () => uuidV5(workspaceUuid),
        getList,
        isDefault: true,
        handleWrappingKeyDown: true,
        currentCard
      }
    ]
  }
});
const getSchemasInterface = (workspaceUuid = "fakeWorkspace") => {
  return getSeshatEditorSchema({
    ...mentionEditorOptions({ workspaceUuid, getList: () => [] }),
    generateRandomId: () => uuidForBlockMigration(workspaceUuid)
  });
};
const nodeToJsonInterface = (node) => {
  return node.toJSON();
};
const createCardContentShell = ({ cardUuid }) => {
  const schema = getSchemasInterface();
  const node = createShellCardContent({
    attrs: { [BlockAttrsParams.BLOCK_UUID]: cardUuid },
    schema
  });
  return nodeToJsonInterface(node);
};
const createNodeCardLinkInterface = ({ cardUuid }) => {
  const schema = getSchemasInterface();
  return createCardLink$1({
    schema,
    attrs: { cardUuid, cardType: "note" }
  });
};
const createCardLink = ({ cardUuid }) => {
  const node = createNodeCardLinkInterface({ cardUuid });
  return nodeToJsonInterface(node);
};
const createSeshatBlockNodeInterface = ({
  attrs,
  content
}) => {
  const schema = getSchemasInterface();
  return createSeshatBlock({ attrs, content, schema });
};
const createParagraph = (props) => {
  const attrs = { ...props == null ? void 0 : props.attrs, type: BlockTypes.PARAGRAPH };
  const node = createSeshatBlockNodeInterface({ ...props, attrs });
  return nodeToJsonInterface(node);
};
const blurTextEditor = ({ editorId }) => {
  const api = getEditorApi(editorId);
  return api == null ? void 0 : api.commands.blur();
};
const isCardContent = (cardContent) => {
  return Array.isArray(cardContent) && typeof cardContent[0] === "object";
};
const appendContentInACardContentInterface = ({
  cardContent,
  newContent
}) => {
  if (!isCardContent(cardContent))
    return newContent;
  return [
    appendContentInACardContent({
      seshatNode: cardContent[0],
      newSeshatBlockContent: newContent
    })
  ];
};
const appendCardContentToContent = ({
  cardContent,
  newSeshatBlockContent
}) => {
  return appendContentInACardContentInterface({
    cardContent,
    newContent: newSeshatBlockContent
  });
};
const createCardWithTitleContent = ({
  title,
  cardUuid,
  cardType,
  content,
  attrs
}) => {
  let titleContent = [];
  if (!!title && typeof title === "string") {
    titleContent = [
      {
        type: "text",
        text: title
      }
    ];
  } else if (title && typeof title !== "string") {
    titleContent = title;
  }
  if (!titleContent)
    return content || [createParagraph()];
  return [
    {
      type: SeshatNodes.BLOCK,
      attrs: {
        type: BlockTypes.CARD_CONTENT,
        [BlockAttrsParams.BLOCK_UUID]: cardUuid,
        ...attrs || {},
        isDone: false,
        cardType
      },
      content: [
        {
          type: SeshatNodes.BLOCK_CONTENT,
          content: [
            {
              type: SeshatNodes.CONTENT,
              content: titleContent
            }
          ]
        },
        ...content || [createParagraph()]
      ]
    }
  ];
};
const createEmptyCaptureContent = ({
  cardUuid,
  content
}) => {
  return [
    {
      type: SeshatNodes.WRAPPING_BLOCK,
      attrs: {
        type: BlockTypes.CAPTURE,
        [BlockAttrsParams.BLOCK_UUID]: cardUuid
      },
      content: content != null ? content : [
        {
          type: SeshatNodes.BLOCK,
          attrs: {
            type: BlockTypes.PARAGRAPH
          },
          content: [
            {
              type: SeshatNodes.BLOCK_CONTENT,
              content: [
                {
                  type: SeshatNodes.CONTENT,
                  content: []
                }
              ]
            }
          ]
        }
      ]
    }
  ];
};
const extractTitleFromContent = (card) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  let title = card.title;
  let content = (_a2 = card.content) == null ? void 0 : _a2[0];
  if (!title && typeof content === "string") {
    const div = document.createElement("div");
    div.innerHTML = content || "";
    if (((_b2 = div.firstChild) == null ? void 0 : _b2.nodeName) === "H2") {
      title = div.firstChild.textContent || void 0;
      div.firstChild.remove();
    } else {
      const block = div.querySelector(".capture-block");
      if (block && ((_c2 = block.firstChild) == null ? void 0 : _c2.nodeName) === "H2") {
        title = block.firstChild.textContent || void 0;
        block.firstChild.remove();
      } else if (block && card.type === "task") {
        const extractedTitle = ((_d2 = block == null ? void 0 : block.firstChild) == null ? void 0 : _d2.textContent) || "";
        if (block == null ? void 0 : block.firstChild)
          block == null ? void 0 : block.removeChild(block == null ? void 0 : block.firstChild);
        title = convertContentToTitle(extractedTitle);
      } else if (!block && card.type === "task") {
        title = ((_e2 = div.firstChild) == null ? void 0 : _e2.textContent) || void 0;
        (_f2 = div.firstChild) == null ? void 0 : _f2.remove();
      }
    }
  }
  return { title };
};
const getCardContentFromCardContent = (cardContent) => {
  if (!isCardContent(cardContent))
    return [];
  return getCardContentFromSeshatBlockCard(cardContent[0]) || cardContent;
};
const getCardTitleContentFromCardContent = (seshatNode) => {
  return getCardTitleContentFromSeshatBlockCard(seshatNode);
};
const isBlockInCardContent = ({
  cardContent,
  blockMatch
}) => {
  return !!cardContent.find((node) => searchNodeInJson({ node, blockMatch }));
};
const searchNodeInJson = ({
  node,
  blockMatch
}) => {
  var _a2;
  return !!((_a2 = node.content) == null ? void 0 : _a2.find((node2) => {
    var _a3;
    if (blockMatch(node2))
      return true;
    if (node2.content && ((_a3 = node2.content) == null ? void 0 : _a3.length) > 0) {
      return searchNodeInJson({ node: node2, blockMatch });
    }
    return false;
  }));
};
const isBlockWithChildren = (node) => {
  var _a2, _b2, _c2, _d2;
  return ((_a2 = node == null ? void 0 : node.content) == null ? void 0 : _a2.length) && (((_b2 = node == null ? void 0 : node.content) == null ? void 0 : _b2.length) > 1 || ((_d2 = (_c2 = node.content) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.type) === SeshatNodes.BLOCK);
};
const isCardWithTitleContent = (cardContent) => {
  var _a2, _b2;
  return isCardContent(cardContent) && cardContent.length === 1 && ((_b2 = (_a2 = cardContent[0]) == null ? void 0 : _a2.attrs) == null ? void 0 : _b2.type) === BlockTypes.CARD_CONTENT;
};
const replaceBlockFromCardContent = ({
  cardContent,
  blockMatch,
  replaceBy
}) => {
  return cardContent.map(
    (node) => replaceNodeInJson({ node, blockMatch, replaceBy })
  );
};
const replaceNodeInJson = ({
  node,
  blockMatch,
  replaceBy
}) => {
  var _a2;
  const content = (_a2 = node.content) == null ? void 0 : _a2.reduce((result, node2) => {
    if (blockMatch(node2)) {
      if (replaceBy)
        return [...result, ...replaceBy(node2)];
      return result;
    }
    return [...result, replaceNodeInJson({ node: node2, blockMatch, replaceBy })];
  }, []);
  if (!content)
    return node;
  return { ...node, content };
};
const cardFromCkEditorToSeshatEditor = (card) => {
  let tmpContent;
  if (Array.isArray(card.content) && typeof card.content[0] === "string") {
    const result = extractTitleFromContent(card);
    tmpContent = card.content[0];
    card.title = result.title;
  } else {
    tmpContent = card.content;
  }
  if (!tmpContent) {
    if (!card.title && card.type && includesCardType(CARD_WITHOUT_TITLE_IN_TEXT_EDITOR_CONTENT, card.type))
      return {
        ...card,
        content: createEmptyCaptureContent({ cardUuid: card.uuid })
      };
    return {
      ...card,
      content: createCardWithTitleContent({
        title: card.title,
        cardUuid: card.uuid,
        cardType: card.type
      })
    };
  }
  if (isCardContent(tmpContent))
    return card;
  const jsonContent = new HTMLParser().parseContent(tmpContent, {
    config: { referenceName: REFERENCE_TE_ITEM.name },
    legacyMode: true
  });
  if (!jsonContent)
    return {
      ...card,
      content: createEmptyCaptureContent({ cardUuid: card.uuid })
    };
  if (!card.title && card.type && includesCardType(CARD_WITHOUT_TITLE_IN_TEXT_EDITOR_CONTENT, card.type)) {
    return {
      ...card,
      content: createEmptyCaptureContent({
        cardUuid: card.uuid,
        content: jsonContent
      })
    };
  }
  return {
    ...card,
    title: card.title || CARD_UNTITLED,
    content: createCardWithTitleContent({
      title: card.title || CARD_UNTITLED,
      cardUuid: card.uuid,
      cardType: card.type,
      content: jsonContent
    })
  };
};
const turnLegacyCardContentToJSONCardContent = (card) => {
  let { content: HTMLContent, ...restOfTheCard } = card;
  if (!HTMLContent) {
    if (card.type && includesCardType(CARD_WITHOUT_TITLE_IN_TEXT_EDITOR_CONTENT, card.type))
      return {
        ...restOfTheCard,
        content: createEmptyCaptureContent({ cardUuid: card.uuid })
      };
    return {
      ...restOfTheCard,
      content: createCardWithTitleContent({
        title: card.title || CARD_UNTITLED,
        cardUuid: card.uuid,
        cardType: card.type
      })
    };
  } else if (isCardContent(HTMLContent)) {
    return {
      ...restOfTheCard,
      content: HTMLContent
    };
  }
  return cardFromCkEditorToSeshatEditor({
    ...restOfTheCard,
    content: HTMLContent
  });
};
const deleteRange = ({
  editorId,
  range
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return false;
  return editor.commands.deleteRange(range);
};
const focusAtTheEndOfSelection = ({ editorId }) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.commands.focusAtSelectionEnd();
};
const focusTextEditor = ({
  editorId,
  position
}) => {
  var _a2, _b2;
  const api = getEditorApi(editorId);
  if (position === "title-end") {
    const root = api == null ? void 0 : api.state.doc.firstChild;
    const titleEndPos = (root == null ? void 0 : root.attrs.type) === BlockTypes.CAPTURE ? SESHAT_ROOT_DEPTH + SESHAT_CONTENT_DEPTH : SESHAT_ROOT_DEPTH + ((_b2 = (_a2 = root == null ? void 0 : root.firstChild) == null ? void 0 : _a2.content.size) != null ? _b2 : 0);
    return api == null ? void 0 : api.commands.focus(titleEndPos);
  } else {
    return api == null ? void 0 : api.commands.focus(position);
  }
};
const getBlockCardsInRange = ({
  editorId,
  range
}) => {
  const editor = getEditorApi(editorId);
  return editor ? getBlocksInRange(editor.state, range) : void 0;
};
const getEditorState = ({ editorId }) => {
  const api = getEditorApi(editorId);
  return api ? api.state.toJSON() : void 0;
};
const getFirstBlock = ({
  editorId,
  blacklist
}) => {
  const editor = getEditorApi(editorId);
  const root = editor == null ? void 0 : editor.state.doc.firstChild;
  if (!root)
    return void 0;
  let firstBlock = null;
  const serializer = new TextSerializer(editor.schema);
  const isWrappingBlock2 = root.type.name === SeshatNodes.WRAPPING_BLOCK;
  if (isWrappingBlock2)
    firstBlock = root.content.firstChild;
  const isBlock2 = root.type.name === SeshatNodes.BLOCK;
  if (isBlock2)
    firstBlock = root.content.content[1];
  if (firstBlock && (blacklist == null ? void 0 : blacklist.includes(firstBlock.attrs.type)))
    return void 0;
  return firstBlock ? {
    json: firstBlock.toJSON(),
    text: serializer.serializeFragment(firstBlock.content)
  } : void 0;
};
const getFirstLineRichContent = ({ editorId }) => {
  var _a2;
  const editor = getEditorApi(editorId);
  let firstChild = editor == null ? void 0 : editor.state.doc.firstChild;
  do {
    firstChild = firstChild == null ? void 0 : firstChild.firstChild;
  } while (firstChild && firstChild.type.name !== SeshatNodes.BLOCK_CONTENT);
  const seshatContent = (_a2 = firstChild == null ? void 0 : firstChild.content) == null ? void 0 : _a2.firstChild;
  return {
    text: seshatContent == null ? void 0 : seshatContent.toJSON().content,
    title: seshatContent == null ? void 0 : seshatContent.textContent
  };
};
const getJSONContent = ({ editorId }) => {
  const api = getEditorApi(editorId);
  return JSON.parse(
    JSON.stringify((api == null ? void 0 : api.getJSON().content) || [])
  );
};
const getTextContent$1 = ({ editorId }) => {
  const api = getEditorApi(editorId);
  return api == null ? void 0 : api.getText();
};
const insertAtStart = ({
  editorId,
  content
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.chain().insertContentAt(1, content).focusLastPosition().run();
};
const insertClip = ({
  editorId,
  url,
  contextUuid,
  content = "",
  contentEditable,
  status,
  backupUrl,
  focus,
  attrs
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  const contentEditableValue = contentEditable === false ? false : true;
  const chain = editor.chain();
  chain.insertClip({
    href: url,
    hrefBackup: backupUrl,
    content,
    insertAtEnd: true,
    contentEditable: contentEditableValue,
    contextUuid,
    status,
    attrs,
    focus
  });
  if (content !== "")
    chain.matchHighlightsWithClipContent();
  chain.run();
  setTimeout(function scrollToNewClip() {
    const clip = document.querySelector(`[type="${BlockTypes.CLIP_CONTENT}"]`);
    clip == null ? void 0 : clip.scrollIntoView({ block: "center" });
  }, 50);
  return true;
};
const insertClipBookmark = ({
  editorId,
  status,
  attachmentUuid,
  href,
  clipBookmarkType
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  editor.commands.insertClipBookmark({
    nodeViewAttrs: {
      href,
      status,
      clipBookmarkType,
      attachmentUuid,
      highlights: {}
    },
    attrs: {
      status,
      href,
      type: BlockTypes.NODE_VIEW
    }
  });
  setTimeout(function scrollToNewClip() {
    const clip = document.querySelector(
      `[nodeviewtype="${NodeViewTypes.CLIP_BOOKMARK}"]`
    );
    clip == null ? void 0 : clip.scrollIntoView({ block: "center" });
  }, 50);
  return true;
};
const insertClipVideo = ({
  editorId,
  url,
  contextUuid,
  content = "",
  contentEditable,
  status,
  backupUrl,
  focus,
  attrs
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  const contentEditableValue = contentEditable === false ? false : true;
  editor.chain().insertClipVideo({
    href: url,
    hrefBackup: backupUrl,
    content,
    insertAtEnd: true,
    contentEditable: contentEditableValue,
    contextUuid,
    status,
    attrs,
    focus
  }).run();
  setTimeout(function scrollToNewClip() {
    const clip = document.querySelector(`[type="${BlockTypes.CLIP_CONTENT}"]`);
    clip == null ? void 0 : clip.scrollIntoView({ block: "center" });
  }, 50);
  return true;
};
const insertContent = ({
  editorId,
  content
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.commands.insertContent(content);
};
const insertEmbed = ({
  editorId,
  src,
  id
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.commands.setIframe({ src, id });
};
const insertFiles = ({
  editorId,
  files
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.commands.uploadAndInsertFile({ files });
};
const insertMention = ({
  editorId,
  char
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  const mentionOptions = char === HASH_REFERENCE.char ? HASH_REFERENCE : DEFAULT_REFERENCE;
  return editor.commands.insertMentionPlaceholder({
    type: editor.schema.node(mentionOptions.name + "placeholder").type,
    attrs: { char: mentionOptions.char }
  });
};
const insertYoutubeTranscript = ({
  editorId,
  transcript
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  const content = `<p>${transcript}</p>`;
  return editor.commands.insertBlockquoteInHighlight({ content });
};
const isATextEditorEditing = () => getAllEditors().some(
  (element) => {
    var _a2;
    return ((_a2 = element.editor) == null ? void 0 : _a2.isFocused) && !element.hasAttribute(ANNOTATION_MODE_ATTRIBUTE);
  }
);
const isEditorFocused = (element) => {
  var _a2;
  return (_a2 = element == null ? void 0 : element.editor) == null ? void 0 : _a2.isFocused;
};
const isATextEditorFocused = () => getAllEditors().some(isEditorFocused);
const isEmpty = ({ editorId }) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return false;
  if (editor.state.doc.textContent)
    return false;
  const rootBlock = editor.state.doc.firstChild;
  if (!rootBlock)
    return true;
  let isEmpty2 = true;
  rootBlock.content.forEach((node) => {
    if (!isSeshatBlockEmpty(node))
      isEmpty2 = false;
    if (node.attrs.type === BlockTypes.HIGHLIGHTS && node.childCount > 0)
      isEmpty2 = false;
  });
  return isEmpty2;
};
const isSelectionAtRootLevel = ({ editorId }) => {
  var _a2;
  const editor = getEditorApi(editorId);
  if (!editor)
    return false;
  return ((_a2 = getCurrentBlock(editor.state.doc, editor.state.selection.from)) == null ? void 0 : _a2.$from.depth) === 1;
};
const isTextEditorFocused = ({ editorId }) => {
  const api = getEditorApi(editorId);
  return !!(api == null ? void 0 : api.isFocused);
};
const createReferenceLinkMark = ({
  attrs,
  content
}) => {
  var _a2;
  const schema = getSchemasInterface();
  const text = schema.text(content);
  return (_a2 = schema.nodes[REFERENCE_TE_ITEM.name]) == null ? void 0 : _a2.create(attrs, [text]).toJSON();
};
const createTextMark = (content) => {
  const schema = getSchemasInterface();
  const node = schema.text(content);
  return nodeToJsonInterface(node);
};
const insertReferenceInATextNode = (node, wordToReplace, cardUuid) => (result, text) => {
  if (!text)
    return result;
  if (text.toLowerCase() !== wordToReplace)
    return [...result, { ...node, text }];
  return [
    ...result,
    {
      type: REFERENCE_TE_ITEM.name,
      text: wordToReplace,
      attrs: {
        cardUuid,
        id: cardUuid,
        value: wordToReplace,
        char: "[["
      }
    }
  ];
};
const replaceWordByReferenceInsideTextNode = ({
  wordToReplace,
  cardUuid
}) => (node) => {
  var _a2;
  const regExp = RegExp(
    `(${_.escapeRegExp(wordToReplace.toLowerCase())})`,
    "g"
  );
  const textSplit = (_a2 = node.text) == null ? void 0 : _a2.split(regExp);
  const nodeFromTextSplit = textSplit == null ? void 0 : textSplit.reduce(
    insertReferenceInATextNode(node, wordToReplace.toLowerCase(), cardUuid),
    []
  );
  return nodeFromTextSplit != null ? nodeFromTextSplit : [node];
};
const removeFirstLine = ({ editorId }) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.commands.removeFirstLine();
};
const replaceCardTitle = ({
  editorId,
  content
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return false;
  const root = editor.state.doc.firstChild;
  if ((root == null ? void 0 : root.attrs.type) !== BlockTypes.CARD_CONTENT)
    return false;
  const titleContent = root.firstChild;
  if (!titleContent)
    return false;
  const titleStart = SESHAT_ROOT_DEPTH + SESHAT_CONTENT_DEPTH;
  const titleEnd = titleStart + titleContent.nodeSize - SESHAT_CONTENT_DEPTH;
  const fragment = Fragment.fromJSON(editor.schema, content);
  return editor.chain().replaceWith({
    from: titleStart,
    to: titleEnd,
    content: fragment.toJSON()
  }).focus(titleStart + fragment.size).run();
};
const replaceSelection = ({
  editorId,
  content
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return false;
  return editor.commands.replaceSelection({ content });
};
const resetToCapture = ({
  editorId,
  content,
  withHistoryReset
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  const chain = editor == null ? void 0 : editor.chain().resetCapture(content);
  if (withHistoryReset)
    chain.resetHistory();
  return chain.run();
};
const scrollToBlock = ({
  editorId,
  uuid,
  options
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.commands.scrollToBlock({ uuid, options });
};
const setHighlight = ({
  editorId,
  highlightId,
  highlightNote
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.chain().setHighlight({ highlightId, highlightNote }).focus(editor.state.tr.selection.to).run();
};
const setHorizontalRule = ({ editorId }) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.commands.setHorizontalRule();
};
const turnContentIntoCardContent = ({
  editorId,
  attrs,
  options = {}
}) => {
  const editor = getEditorApi(editorId);
  return editor == null ? void 0 : editor.commands.turnEditorIntoCard(attrs, options);
};
const turnHighlightsBlocksIntoBlockquotes = ({
  editorId
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return;
  return editor.commands.turnHighlightsBlocksIntoBlockquotes();
};
const updateHighlightBlockAttributes = ({
  editorId,
  highlightId,
  attrs
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return false;
  if (getNodeTypeByBlockType(attrs.type) === "wrappingBlock") {
    return editor.commands.wrapIntoBlock(attrs);
  }
  return editor.commands.updateHighlightBlockAttributes({ attrs, highlightId });
};
const updateTextEditorBlockAttributes = ({
  editorId,
  attrs
}) => {
  const editor = getEditorApi(editorId);
  if (!editor)
    return false;
  if (getNodeTypeByBlockType(attrs.type) === "wrappingBlock") {
    return editor.commands.wrapIntoBlock(attrs);
  }
  return editor.commands.updateBlockAttributes(attrs);
};
var TextEditor = {
  appendCardContentToContent,
  insertClipBookmark,
  appendContentInACardContent: appendContentInACardContentInterface,
  blurTextEditor,
  createCardContentShell,
  createCardLink,
  createCardWithTitleContent,
  createEmptyCaptureContent,
  createParagraph,
  createReferenceLinkMark,
  createTextMark,
  deleteRange,
  extractTitleFromContent,
  focusTextEditor,
  getCardContentFromCardContent,
  getCardTitleContentFromCardContent,
  getFirstBlock,
  getFirstLineRichContent,
  getSeshatNodesOfType,
  getJSONContent,
  getEditorState,
  getBlockCardAttrs,
  getBlockCardsInRange,
  getTextContent: getTextContent$1,
  insertAtStart,
  insertContent,
  insertClip,
  insertClipVideo,
  insertEmbed,
  insertFiles,
  insertMention,
  insertYoutubeTranscript,
  isATextEditorFocused,
  isATextEditorEditing,
  isTextEditorFocused,
  isSelectionAtRootLevel,
  isBlockInCardContent,
  isBlockWithChildren,
  isCardContent,
  isCardWithTitleContent,
  isEmpty,
  removeFirstLine,
  resetToCapture,
  replaceCardTitle,
  replaceSelection,
  replaceBlockFromCardContent,
  replaceWordByReferenceInsideTextNode,
  setHorizontalRule,
  scrollToBlock,
  setHighlight,
  updateHighlightBlockAttributes,
  turnContentIntoCardContent,
  turnLegacyCardContentToJSONCardContent,
  updateTextEditorBlockAttributes,
  focusAtTheEndOfSelection,
  turnHighlightsBlocksIntoBlockquotes
};
const debug = debug$2("textEditor:interface");
const TextEditorApi = {
  getEditorInterface(editor) {
    const attributes = editor.options.editorProps.attributes;
    return {
      id: typeof attributes !== "function" ? attributes == null ? void 0 : attributes.id : void 0,
      isFocused: () => {
        const isRelatedElementFocused = EDITOR_RELATED_ELEMENT_IDS.some(
          (id) => {
            var _a2;
            return ((_a2 = document.activeElement) == null ? void 0 : _a2.closest(`#${id}`)) !== null;
          }
        );
        return isRelatedElementFocused || editor.isFocused;
      },
      rawChain: () => editor.chain(),
      rawCommands: editor.commands,
      destroy: () => editor.destroy(),
      blur: () => editor.commands.blur(),
      focus: () => editor.commands.focus(),
      refresh({ content }) {
        try {
          debug("refresh", this.id);
          return editor.commands.replaceContent({ content, skipUpdate: true });
        } catch (e) {
          debug("error", e);
          return false;
        }
      },
      syncHighlights() {
        try {
          debug("syncHighlights", this.id);
          return editor.chain().syncHighlightsBlocksAfterClipModification().setMeta("skipDebounce", true).run();
        } catch (e) {
          debug("error", e);
          return false;
        }
      },
      insertAIContent({ content, pos }) {
        var _a2;
        try {
          debug("insertAIContent", this.id);
          const { doc, selection, schema } = editor.state;
          const currentBlock = getCurrentBlock(doc, pos != null ? pos : selection.to);
          if (!currentBlock)
            return false;
          const json2 = new MarkdownParser(schema, {
            plugins: [MarkdownParserToLazyRefPlugins.Reference]
          }).parseContent(content);
          const size = Fragment.fromJSON(schema, json2).size;
          let insertPos = currentBlock.to;
          if (isRootBlock(currentBlock.node)) {
            if (currentBlock.node.attrs.type === BlockTypes.CAPTURE) {
              insertPos = SESHAT_ROOT_DEPTH;
            } else {
              const blockContentLength = (_a2 = currentBlock.node.firstChild) == null ? void 0 : _a2.nodeSize;
              insertPos = SESHAT_ROOT_DEPTH + (blockContentLength != null ? blockContentLength : 0);
            }
          }
          if (isSeshatBlockEmpty(currentBlock.node)) {
            insertPos = { from: currentBlock.from, to: currentBlock.to };
          }
          return editor.chain().insertContentAt(insertPos, json2).command(({ tr, dispatch }) => {
            const start = typeof insertPos === "number" ? insertPos : insertPos.from;
            tr.setSelection(
              BlockSelection.createFromRange(tr.doc, start, start + size)
            );
            dispatch == null ? void 0 : dispatch(tr);
            return true;
          }).focus().scrollIntoView().run();
        } catch (e) {
          debug("error", e);
          return false;
        }
      },
      replaceWithAIContent(props) {
        var _a2, _b2, _c2, _d2;
        try {
          debug("replaceWithAIContent", this.id);
          const { selection, schema } = editor.state;
          const range = {
            from: props.selection && props.selection.anchor < props.selection.head ? props.selection.anchor : (_b2 = (_a2 = props.selection) == null ? void 0 : _a2.head) != null ? _b2 : selection.from,
            to: props.selection && props.selection.anchor < props.selection.head ? props.selection.head : (_d2 = (_c2 = props.selection) == null ? void 0 : _c2.anchor) != null ? _d2 : selection.to
          };
          const isBlockContent = !!(props.content.match(/\n/g) || []).length;
          const parser = new MarkdownParser(schema);
          const json2 = isBlockContent ? parser.parseContent(props.content) : parser.parseInline(props.content);
          return editor.chain().insertContentAt(range, json2).setTextSelection({
            from: range.from,
            to: range.from + props.content.length
          }).scrollIntoView().run();
        } catch (e) {
          debug("error", e);
          return false;
        }
      },
      getJSON() {
        return editor.state.doc.toJSON();
      },
      getHTML() {
        return editor.getHTML();
      },
      getSelection() {
        return editor.state.selection.toJSON();
      },
      getSelectionText() {
        return getSelectionText(editor.state);
      },
      getRootUuid() {
        var _a2;
        return (_a2 = editor.state.doc.firstChild) == null ? void 0 : _a2.attrs[BlockAttrsParams.BLOCK_UUID];
      }
    };
  },
  getAllInstances() {
    return getAllEditors().filter(
      (element) => !!element.editor
    ).map(({ editor }) => this.getEditorInterface(editor));
  },
  getInstance(editorId) {
    try {
      const editor = getEditorApi(editorId);
      if (editor)
        return this.getEditorInterface(editor);
    } catch (e) {
      debug("error", e);
    }
    return void 0;
  },
  getFocusedInstance() {
    return this.getAllInstances().find(({ isFocused }) => !!isFocused);
  },
  createHeadlessEditor(config) {
    const editor = initHeadlessEditor(config);
    return this.getEditorInterface(editor);
  }
};
const formatCardsToSeshatContent = (rootUuid, cards, isChildren) => {
  const card = cards[rootUuid];
  if (!card)
    return void 0;
  if (card.type === NodeViewTypes.CLIP_BOOK)
    return buildSeshatClipBookNode(card);
  if (card.type === NodeViewTypes.CLIP_BOOKMARK)
    return buildSeshatClipBookmarkNode(card);
  if (card.type === NodeViewTypes.FILE)
    return buildSeshatFileNode(card);
  if (card.type === NodeViewTypes.IFRAME)
    return buildSeshatIframeNode(card);
  if (card.type === NodeViewTypes.EXTERNAL_VIDEO)
    return buildSeshatExternalVideoNode(card);
  if (card.type === NodeViewTypes.TABLE_OF_CONTENTS)
    return buildSeshatTableOfContentsNode(card);
  if (card.type === NodeViewTypes.HORIZONTAL_RULE)
    return buildSeshatHorizontalRuleNode(card);
  if (["capture", "day"].includes(card.type))
    return createCaptureContent(card, cards);
  if (isChildren && includesCardType(CARD_WITH_TITLE_IN_TEXT_EDITOR_CONTENT, card.type))
    return buildSeshatCardLink(card);
  if (isChildren && card.type === BlockTypes.CAPTURE)
    return void 0;
  return {
    type: SeshatWrappingBlocks.includes(card.type) ? SeshatNodes.WRAPPING_BLOCK : SeshatNodes.BLOCK,
    attrs: getAttrs$1(card),
    content: getContent(card, cards)
  };
};
const createCaptureContent = (card, cards) => {
  var _a2;
  return {
    type: SeshatNodes.WRAPPING_BLOCK,
    attrs: getAttrs$1(card),
    content: !((_a2 = card.childrenIds) == null ? void 0 : _a2.length) ? [createSeshatParagraphShell()] : getChildren$1(card.childrenIds, cards)
  };
};
const getText = (card, cards) => {
  var _a2;
  if (!((_a2 = card.text) == null ? void 0 : _a2.length)) {
    return;
  }
  return card.text.map((item) => {
    var _a3, _b2, _c2, _d2;
    if (item.type === SeshatInlineNodes.REFERENCE && (!((_a3 = item.attrs) == null ? void 0 : _a3.cardUuid) || !cards[(_b2 = item.attrs) == null ? void 0 : _b2.cardUuid])) {
      return ((_c2 = item.attrs) == null ? void 0 : _c2.value) ? generateMarkText((_d2 = item.attrs) == null ? void 0 : _d2.value) : void 0;
    }
    return { ...item, text: !!item.text ? item.text : void 0 };
  }).filter((c2) => !!c2);
};
const getContent = (card, cards) => {
  var _a2;
  const childrenIds = (_a2 = card.childrenIds) != null ? _a2 : [];
  const hasText = includesCardType(CARD_WITH_TITLE_IN_TEXT_EDITOR_CONTENT, card.type) || !!card.text;
  const content = hasText ? [createSeshatContentShell(getText(card, cards))] : [];
  const fullContent = childrenIds.length > 0 ? content.concat(getChildren$1(childrenIds, cards)) : content;
  return fullContent.length > 0 ? fullContent : void 0;
};
const createSeshatContentShell = (content) => {
  if (!content)
    return {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT
        }
      ]
    };
  return {
    type: SeshatNodes.BLOCK_CONTENT,
    content: [
      {
        type: SeshatNodes.CONTENT,
        content
      }
    ]
  };
};
const createSeshatParagraphShell = (content) => ({
  type: SeshatNodes.BLOCK,
  attrs: { type: BlockTypes.PARAGRAPH },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT,
          content
        }
      ]
    }
  ]
});
const getChildren$1 = (childrenIds, cards) => {
  var _a2;
  return (_a2 = childrenIds.map((childUuid) => {
    return formatCardsToSeshatContent(
      childUuid,
      cards,
      true
    );
  }).filter((item) => item)) != null ? _a2 : [];
};
const getType$1 = (card) => {
  const isCardType = includesCardType(
    CARD_WITH_TITLE_IN_TEXT_EDITOR_CONTENT,
    card.type
  );
  if (card.type === CARD_DAY_TYPE)
    return BlockTypes.CAPTURE;
  if (isCardType)
    return BlockTypes.CARD_CONTENT;
  return card.type;
};
const getAttrs$1 = (card) => {
  const isCardType = includesCardType(
    CARD_WITH_TITLE_IN_TEXT_EDITOR_CONTENT,
    card.type
  );
  return {
    ...card.attrs,
    [BlockAttrsParams.BLOCK_UUID]: card.uuid,
    cardType: isCardType ? card.type : void 0,
    type: getType$1(card)
  };
};
const buildSeshatClipBookNode = (card) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
  return {
    type: SeshatNodes.BLOCK,
    attrs: {
      type: BlockTypes.NODE_VIEW,
      nodeViewType: NodeViewTypes.CLIP_BOOK,
      [BlockAttrsParams.BLOCK_UUID]: card.uuid
    },
    content: [
      {
        type: SeshatNodes.BLOCK_CONTENT,
        content: [
          {
            type: SeshatNodes.CONTENT_NODE_VIEW,
            content: [
              {
                type: NodeViewTypes.CLIP_BOOK,
                attrs: {
                  status: (_a2 = card.attrs) == null ? void 0 : _a2.status,
                  asin: (_b2 = card == null ? void 0 : card.attrs) == null ? void 0 : _b2.asin,
                  author: (_c2 = card == null ? void 0 : card.attrs) == null ? void 0 : _c2.author,
                  coverUrl: (_d2 = card == null ? void 0 : card.attrs) == null ? void 0 : _d2.coverUrl,
                  kindleHighlights: (_e2 = card == null ? void 0 : card.attrs) == null ? void 0 : _e2.kindleHighlights,
                  title: (_g2 = (_f2 = card.text) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.text
                }
              }
            ]
          }
        ]
      }
    ]
  };
};
const buildSeshatClipBookmarkNode = (card) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  return {
    type: SeshatNodes.BLOCK,
    attrs: {
      type: BlockTypes.NODE_VIEW,
      nodeViewType: NodeViewTypes.CLIP_BOOKMARK,
      [BlockAttrsParams.BLOCK_UUID]: card.uuid
    },
    content: [
      {
        type: SeshatNodes.BLOCK_CONTENT,
        content: [
          {
            type: SeshatNodes.CONTENT_NODE_VIEW,
            content: [
              {
                type: NodeViewTypes.CLIP_BOOKMARK,
                attrs: {
                  href: (_a2 = card == null ? void 0 : card.attrs) == null ? void 0 : _a2.href,
                  title: (_b2 = card.attrs) == null ? void 0 : _b2.title,
                  attachmentUuid: (_c2 = card.attrs) == null ? void 0 : _c2.attachmentUuid,
                  clipBookmarkType: (_d2 = card.attrs) == null ? void 0 : _d2.clipBookmarkType,
                  status: (_e2 = card.attrs) == null ? void 0 : _e2.status,
                  highlights: (_f2 = card.attrs) == null ? void 0 : _f2.highlights
                }
              }
            ]
          }
        ]
      }
    ]
  };
};
const buildSeshatFileNode = (card) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    type: BlockTypes.NODE_VIEW,
    [BlockAttrsParams.BLOCK_UUID]: card.uuid
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT_NODE_VIEW,
          content: [
            {
              type: NodeViewTypes.FILE,
              attrs: card.attrs
            }
          ]
        }
      ]
    }
  ]
});
const buildSeshatTableOfContentsNode = (card) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    type: BlockTypes.NODE_VIEW,
    [BlockAttrsParams.BLOCK_UUID]: card.uuid
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT_NODE_VIEW,
          content: [
            {
              type: NodeViewTypes.TABLE_OF_CONTENTS,
              attrs: card.attrs
            }
          ]
        }
      ]
    }
  ]
});
const buildSeshatIframeNode = (card) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    type: BlockTypes.NODE_VIEW,
    [BlockAttrsParams.BLOCK_UUID]: card.uuid
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT_NODE_VIEW,
          content: [
            {
              type: NodeViewTypes.IFRAME,
              attrs: card.attrs
            }
          ]
        }
      ]
    }
  ]
});
const buildSeshatExternalVideoNode = (card) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    type: BlockTypes.NODE_VIEW,
    [BlockAttrsParams.BLOCK_UUID]: card.uuid,
    nodeViewType: NodeViewTypes.EXTERNAL_VIDEO
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT_NODE_VIEW,
          content: [
            {
              type: NodeViewTypes.EXTERNAL_VIDEO,
              attrs: card.attrs
            }
          ]
        }
      ]
    }
  ]
});
const buildSeshatHorizontalRuleNode = (card) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    type: BlockTypes.NODE_VIEW,
    [BlockAttrsParams.BLOCK_UUID]: card.uuid
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT_NODE_VIEW,
          content: [
            {
              type: NodeViewTypes.HORIZONTAL_RULE,
              attrs: card.attrs
            }
          ]
        }
      ]
    }
  ]
});
const buildSeshatCardLink = (card) => {
  if (card.status === STATUS_TRASH)
    return void 0;
  return {
    type: SeshatNodes.BLOCK,
    attrs: {
      type: BlockTypes.CARD_LINK,
      [BlockAttrsParams.BLOCK_UUID]: card.uuid
    },
    content: [
      {
        type: SeshatNodes.BLOCK_CONTENT,
        content: [
          {
            type: SeshatNodes.CONTENT_NODE_VIEW,
            content: [
              {
                type: NodeViewTypes.CARD_LINK,
                attrs: {
                  cardType: card.type,
                  cardLinkText: card.text,
                  isDone: card.type === CARD_TASK_TYPE ? card.status === STATUS_DONE : void 0
                }
              }
            ]
          }
        ]
      }
    ]
  };
};
const DEFAULT_LAZY_BLOCK = BlockTypes.PARAGRAPH;
const extractLazyBlockFromSeshatContent = (content) => {
  const partialLazyBlock = formatProseMirrorContentToCard(content);
  return listAllChildren(partialLazyBlock);
};
const listAllChildren = (partialLazyBlock) => {
  var _a2, _b2;
  return [
    partialLazyBlock,
    ...(_b2 = (_a2 = partialLazyBlock.children) == null ? void 0 : _a2.flatMap(
      (child) => listAllChildren(child)
    )) != null ? _b2 : []
  ];
};
const formatProseMirrorContentToCard = (card) => {
  var _a2, _b2;
  if (((_a2 = card.attrs) == null ? void 0 : _a2.type) === BlockTypes.NODE_VIEW)
    return formatSeshatNodeViewContent(card);
  if (((_b2 = card.attrs) == null ? void 0 : _b2.type) === BlockTypes.CARD_LINK)
    return formatSeshatCardLink(card);
  return {
    uuid: getBlockId(card),
    type: getType(card),
    text: getCardText(card),
    attrs: getAttrs(card),
    children: getChildren(card)
  };
};
const formatSeshatNodeViewContent = (card) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h, _i, _j, _k, _l;
  if (((_a2 = card.attrs) == null ? void 0 : _a2.nodeViewType) === NodeViewTypes.CLIP_BOOK)
    return formatSeshatClipBook(card);
  if (((_b2 = card.attrs) == null ? void 0 : _b2.nodeViewType) === NodeViewTypes.CLIP_BOOKMARK)
    return formatSeshatClipBookmark(card);
  return {
    uuid: getBlockId(card),
    type: ((_g2 = (_f2 = (_e2 = (_d2 = (_c2 = card.content) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.content) == null ? void 0 : _e2[0].content) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.type) || getType(card),
    attrs: (_l = (_k = (_j = (_i = (_h = card.content) == null ? void 0 : _h[0]) == null ? void 0 : _i.content) == null ? void 0 : _j[0].content) == null ? void 0 : _k[0]) == null ? void 0 : _l.attrs
  };
};
const getClipBookElement = (content) => {
  var _a2;
  if (!content)
    return;
  if ((content == null ? void 0 : content.type) === NodeViewTypes.CLIP_BOOK)
    return content;
  return getClipBookElement((_a2 = content.content) == null ? void 0 : _a2[0]);
};
const formatSeshatClipBook = (card) => {
  var _a2;
  const clipBook = getClipBookElement((_a2 = card.content) == null ? void 0 : _a2[0]);
  const clipBookAttrs = clipBook == null ? void 0 : clipBook.attrs;
  return {
    uuid: getBlockId(card),
    type: NodeViewTypes.CLIP_BOOK,
    text: [{ text: (clipBookAttrs == null ? void 0 : clipBookAttrs.title) || "", type: "text" }],
    attrs: {
      status: clipBookAttrs == null ? void 0 : clipBookAttrs.status,
      asin: clipBookAttrs == null ? void 0 : clipBookAttrs.asin,
      author: clipBookAttrs == null ? void 0 : clipBookAttrs.author,
      kindleHighlights: clipBookAttrs == null ? void 0 : clipBookAttrs.kindleHighlights,
      coverUrl: clipBookAttrs == null ? void 0 : clipBookAttrs.coverUrl
    }
  };
};
const getClipBookmarkElement = (content) => {
  var _a2;
  if (!content)
    return;
  if ((content == null ? void 0 : content.type) === NodeViewTypes.CLIP_BOOKMARK)
    return content;
  return getClipBookmarkElement((_a2 = content.content) == null ? void 0 : _a2[0]);
};
const formatSeshatClipBookmark = (card) => {
  var _a2;
  const clipBookmark = getClipBookmarkElement((_a2 = card.content) == null ? void 0 : _a2[0]);
  const clipBookAttrs = clipBookmark == null ? void 0 : clipBookmark.attrs;
  return {
    uuid: getBlockId(card),
    type: NodeViewTypes.CLIP_BOOKMARK,
    text: [],
    attrs: {
      href: clipBookAttrs == null ? void 0 : clipBookAttrs.href,
      title: clipBookAttrs == null ? void 0 : clipBookAttrs.title,
      highlights: clipBookAttrs == null ? void 0 : clipBookAttrs.highlights,
      attachmentUuid: clipBookAttrs == null ? void 0 : clipBookAttrs.attachmentUuid,
      clipBookmarkType: clipBookAttrs == null ? void 0 : clipBookAttrs.clipBookmarkType,
      status: clipBookAttrs == null ? void 0 : clipBookAttrs.status
    }
  };
};
const getCardLinkElement = (content) => {
  var _a2;
  if (!content)
    return;
  if ((content == null ? void 0 : content.type) === NodeViewTypes.CARD_LINK)
    return content;
  return getCardLinkElement((_a2 = content.content) == null ? void 0 : _a2[0]);
};
const formatSeshatCardLink = (card) => {
  var _a2, _b2, _c2;
  const cardLink = getCardLinkElement((_a2 = card.content) == null ? void 0 : _a2[0]);
  return {
    uuid: getBlockId(card),
    type: ((_b2 = cardLink == null ? void 0 : cardLink.attrs) == null ? void 0 : _b2.cardType) || getType(card),
    attrs: cardLink ? getAttrs(cardLink) : getAttrs(card),
    text: ((_c2 = cardLink == null ? void 0 : cardLink.attrs) == null ? void 0 : _c2.cardLinkText) && formatContentToMarkedText(cardLink.attrs.cardLinkText)
  };
};
const NON_PERSISTENT_ATTRS = [
  BlockAttrsParams.BLOCK_UUID,
  "type",
  "cardType",
  "cardLinkText"
];
const getType = (card) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const isACardWithoutCardTypeBlock = ((_a2 = card.attrs) == null ? void 0 : _a2.type) === BlockTypes.CARD_CONTENT && !((_b2 = card.attrs) == null ? void 0 : _b2.cardType);
  if (isACardWithoutCardTypeBlock)
    return DEFAULT_CARD_TYPE;
  return (_f2 = (_e2 = (_c2 = card.attrs) == null ? void 0 : _c2.cardType) != null ? _e2 : (_d2 = card.attrs) == null ? void 0 : _d2.type) != null ? _f2 : DEFAULT_LAZY_BLOCK;
};
const getBlockId = (card) => {
  var _a2, _b2;
  return (_b2 = (_a2 = card.attrs) == null ? void 0 : _a2[BlockAttrsParams.BLOCK_UUID]) != null ? _b2 : uuidV1();
};
const getAttrs = (card) => {
  var _a2;
  return Object.entries((_a2 = card.attrs) != null ? _a2 : {}).reduce(
    (acc, entry) => NON_PERSISTENT_ATTRS.indexOf(entry[0]) === -1 ? { ...acc, [entry[0]]: entry[1] } : acc,
    {}
  );
};
const getCardText = (card) => {
  const textContent = getTextContent(card);
  if (!textContent)
    return void 0;
  return formatContentToMarkedText(textContent);
};
const getChildren = (card) => {
  var _a2, _b2, _c2, _d2;
  const hasText = ((_a2 = card.content) == null ? void 0 : _a2[0]) && isBlockText((_b2 = card.content) == null ? void 0 : _b2[0]);
  const children = hasText ? (_c2 = card.content) == null ? void 0 : _c2.slice(1) : card.content;
  return (_d2 = children == null ? void 0 : children.map((child) => formatProseMirrorContentToCard(child))) != null ? _d2 : [];
};
const isBlockText = (child) => {
  return child.type === SeshatNodes.BLOCK_CONTENT;
};
const getTextContent = (card) => {
  var _a2, _b2, _c2, _d2, _e2;
  if (!((_a2 = card.content) == null ? void 0 : _a2[0]) || !isBlockText((_b2 = card.content) == null ? void 0 : _b2[0]))
    return void 0;
  return (_e2 = (_d2 = (_c2 = card.content) == null ? void 0 : _c2[0].content) == null ? void 0 : _d2[0].content) != null ? _e2 : [];
};
const isPlaceholder = (type) => type.includes("placeholder");
const turnPlaceholderInText = (item) => {
  var _a2, _b2;
  return {
    type: "text",
    text: (_b2 = (_a2 = item.attrs) == null ? void 0 : _a2.char) != null ? _b2 : ""
  };
};
const formatContentToMarkedText = (content) => {
  return content.map((item) => {
    var _a2, _b2;
    if (isPlaceholder(item.type))
      return turnPlaceholderInText(item);
    return {
      text: (_a2 = item.text) != null ? _a2 : "",
      marks: item.marks,
      type: (_b2 = item.type) != null ? _b2 : "text",
      attrs: item.attrs
    };
  });
};
const getHighlightNoteFromHighlight = (highlightCard) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const lastChild = (_a2 = highlightCard.content) == null ? void 0 : _a2.slice(-1)[0];
  if (((_b2 = lastChild == null ? void 0 : lastChild.attrs) == null ? void 0 : _b2.type) !== BlockTypes.HIGHLIGHT_NOTE)
    return void 0;
  const hasContent = !!((_f2 = (_e2 = (_d2 = (_c2 = lastChild == null ? void 0 : lastChild.content) == null ? void 0 : _c2[0].content) == null ? void 0 : _d2[0].content) == null ? void 0 : _e2[0].content) == null ? void 0 : _f2.length);
  return hasContent ? lastChild : void 0;
};
const getHighlightBlockquoteFromHighlight = (highlightCard) => {
  var _a2;
  return ((_a2 = highlightCard.content) == null ? void 0 : _a2.length) ? highlightCard.content[0] : void 0;
};
const ExternalImageNode = (options) => Node.create({
  name: SeshatInlineNodes.EXTERNAL_IMAGE,
  group: "inline",
  inline: true,
  atom: true,
  selectable: false,
  marks: `${MarkTypes.HIGHLIGHT}`,
  addOptions() {
    var _a2;
    return {
      ...(_a2 = options == null ? void 0 : options.file) != null ? _a2 : {}
    };
  },
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      height: {
        default: null
      },
      width: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "img[src]",
        priority: 55,
        getAttrs: (node) => {
          var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
          if (typeof node === "string")
            return false;
          const htmlNode = node;
          const src = (_a2 = htmlNode.attributes.getNamedItem("src")) == null ? void 0 : _a2.value;
          const alt = (_c2 = (_b2 = htmlNode.attributes) == null ? void 0 : _b2.getNamedItem("alt")) == null ? void 0 : _c2.value;
          const width = (_e2 = (_d2 = htmlNode.attributes) == null ? void 0 : _d2.getNamedItem("width")) == null ? void 0 : _e2.value;
          const height = (_g2 = (_f2 = htmlNode.attributes) == null ? void 0 : _f2.getNamedItem("height")) == null ? void 0 : _g2.value;
          const ABSOLUTE_URL_REGEX = /^https:\/\//i;
          if (src && !ABSOLUTE_URL_REGEX.test(src))
            return false;
          return { src, alt, width, height };
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["img", mergeAttributes(HTMLAttributes)];
  },
  toText({ node }) {
    return node.attrs.src ? `${node.attrs.src}

` : "";
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("preventExternalImageParseRulesOnPaste"),
        props: {
          transformPastedHTML: (html) => {
            let sanitizedHtml = sanitizeSlackEmoji(html);
            sanitizedHtml = sanitizeFacebookEmoji(html);
            if (sanitizedHtml)
              return sanitizedHtml;
            const isImagePasteRegex = /^(<meta charset='utf-8'>)*<img [^>]*src=".*?[^]"[^>]*\/>$/g;
            return html.match(isImagePasteRegex) ? "" : html;
          }
        }
      })
    ];
  },
  addCommands() {
    return {
      insertExternalImage: (attrs) => ({
        commands
      }) => {
        var _a2, _b2, _c2, _d2;
        const content = [
          {
            attrs,
            type: SeshatInlineNodes.EXTERNAL_IMAGE
          }
        ];
        const paragraph = createParagraph();
        if ((_d2 = (_c2 = (_b2 = (_a2 = paragraph.content) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.content) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.content)
          paragraph.content[0].content[0].content = content;
        commands.insertContent(paragraph);
        return true;
      }
    };
  }
});
const ZERO_WIDTH_SPACE = "\u200B";
const MentionNode = (options) => Node.create({
  name: SeshatInlineNodes.REFERENCE,
  inline: true,
  selectable: false,
  atom: true,
  group: "inline",
  addAttributes() {
    return {
      id: {
        parseHTML: (element) => {
          var _a2;
          return element.dataset.uuid || element.id || ((_a2 = options == null ? void 0 : options.generateRandomId) == null ? void 0 : _a2.call(options));
        },
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }
          return {
            "data-uuid": attributes.id
          };
        }
      },
      cardUuid: {
        parseHTML: (element) => {
          var _a2;
          return element.dataset.uuid || element.id || ((_a2 = options == null ? void 0 : options.generateRandomId) == null ? void 0 : _a2.call(options));
        },
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }
          return {
            "data-uuid": attributes.id
          };
        }
      },
      char: {
        parseHTML: (element) => {
          return element.dataset.char;
        },
        renderHTML: (attributes) => {
          if (!attributes.char) {
            return {};
          }
          return {
            "data-char": attributes.char
          };
        },
        default: void 0
      },
      value: {
        default: void 0,
        parseHTML: (element) => {
          return element.textContent;
        }
      },
      initialCardProps: {
        default: void 0
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span[data-mention]"
      },
      {
        tag: "a.reference"
      }
    ];
  },
  addOptions() {
    return options == null ? void 0 : options.mentions;
  },
  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        return editor.commands.command(({ tr, commands }) => {
          const start = tr.selection.from;
          if (shouldDeleteLastCharBetweenBlockStartAndMention(tr)) {
            return commands.deleteRange({ from: start - 1, to: start });
          }
          if (shouldDeleteZeroWidthSpace(tr, "backwards")) {
            return commands.deleteRange({ from: start - 2, to: start });
          }
          return false;
        });
      },
      Delete: ({ editor }) => {
        return editor.commands.command(({ tr, commands }) => {
          const end = tr.selection.to;
          if (shouldDeleteZeroWidthSpace(tr, "forwards")) {
            return commands.deleteRange({ from: end, to: end + 2 });
          }
          return false;
        });
      },
      ArrowRight: ({ editor }) => {
        return editor.commands.command(({ tr, dispatch }) => {
          return dispatch ? maybeSkipZeroWidthSpace(dispatch, tr, "forwards") : false;
        });
      },
      "Shift-ArrowRight": ({ editor }) => {
        return editor.commands.command(({ tr, dispatch }) => {
          return dispatch ? maybeSkipZeroWidthSpace(dispatch, tr, "expand-forwards") : false;
        });
      },
      ArrowLeft: ({ editor }) => {
        return editor.commands.command(({ tr, dispatch }) => {
          return dispatch ? maybeSkipZeroWidthSpace(dispatch, tr, "backwards") : false;
        });
      },
      "Shift-ArrowLeft": ({ editor }) => {
        return editor.commands.command(({ tr, dispatch }) => {
          return dispatch ? maybeSkipZeroWidthSpace(dispatch, tr, "expand-backwards") : false;
        });
      }
    };
  },
  toText({ node }) {
    var _a2;
    return `${(_a2 = node.attrs.value) != null ? _a2 : node.attrs.cardUuid}`;
  },
  renderHTML({ HTMLAttributes }) {
    return [SeshatInlineNodes.REFERENCE, mergeAttributes(HTMLAttributes)];
  },
  addCommands() {
    return {
      insertMention: (attrs) => ({
        state,
        dispatch
      }) => {
        const { tr, selection } = state;
        const { $from } = selection;
        const node = this.type.create({ ...attrs });
        tr.insert($from.pos, node);
        tr.insert($from.pos + 1, this.type.schema.text(ZERO_WIDTH_SPACE));
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      }
    };
  }
});
const shouldDeleteLastCharBetweenBlockStartAndMention = (tr) => {
  var _a2;
  return tr.selection.empty && tr.selection.$from.parentOffset === 1 && ((_a2 = tr.selection.$to.nodeAfter) == null ? void 0 : _a2.type.name) === SeshatInlineNodes.REFERENCE;
};
const shouldDeleteZeroWidthSpace = (tr, dir) => {
  if (isBlockSelection(tr.selection) || !tr.selection.empty)
    return false;
  return tr.doc.cut(
    dir === "backwards" ? tr.selection.from - 1 : tr.selection.to,
    dir === "forwards" ? tr.selection.to + 1 : tr.selection.from
  ).textContent === ZERO_WIDTH_SPACE;
};
const shiftFocusByNumberOfChars = (tr, count, dir) => {
  const { $head, $anchor } = tr.selection;
  const shift = dir.includes("backwards") ? -count : count;
  return tr.setSelection(
    TextSelection.create(
      tr.doc,
      !dir.startsWith("expand") ? $head.pos + shift : $anchor.pos,
      !dir.startsWith("expand") ? void 0 : $head.pos + shift
    )
  );
};
const maybeSkipZeroWidthSpace = (dispatch, tr, dir) => {
  if (isBlockSelection(tr.selection))
    return false;
  if (!tr.selection.$head.parent.isTextblock)
    return false;
  const { $head } = tr.selection;
  const prevChar = tr.doc.textBetween(
    dir.includes("backwards") ? $head.pos - 1 : $head.pos,
    dir.includes("forwards") ? $head.pos + 1 : $head.pos
  );
  if (prevChar === ZERO_WIDTH_SPACE) {
    dispatch == null ? void 0 : dispatch(shiftFocusByNumberOfChars(tr, 2, dir));
    return true;
  }
  const secondPrevChar = tr.doc.textBetween(
    dir.includes("backwards") ? $head.pos - 2 : $head.pos + 1,
    dir.includes("forwards") ? $head.pos + 2 : $head.pos - 1
  );
  if (secondPrevChar === ZERO_WIDTH_SPACE) {
    dispatch == null ? void 0 : dispatch(shiftFocusByNumberOfChars(tr, 2, dir));
    return true;
  }
  return false;
};
const TextNode = Text.extend({
  marks: "_"
});
const defaultCodeBlockAttrs = { type: BlockTypes.CODE };
const getTextContentFromHTMLElement = (element) => {
  var _a2;
  const codeElement = element.querySelector("code") || element.querySelector("pre") || element;
  const lines = Array.from(codeElement.children);
  const isLineBased = lines.length > 0 && lines.every((c2) => c2.tagName === "DIV");
  codeElement.querySelectorAll("span").forEach((span) => {
    span.replaceWith(...span.childNodes);
  });
  const code = isLineBased ? lines.map((child) => {
    var _a3;
    return (_a3 = child.textContent) == null ? void 0 : _a3.trimEnd();
  }).join("\n") : ((_a2 = codeElement.textContent) == null ? void 0 : _a2.trim()) !== "" ? codeElement.textContent : codeElement.innerHTML.trim();
  return code == null ? void 0 : code.replace(/\r\n?/g, "\n").replaceAll("  \n", "\n");
};
const parseCodeBlockHtml = ({
  priority
}) => [
  {
    tag: "pre",
    priority,
    preserveWhitespace: "full",
    getContent: (node, schema) => {
      const element = node;
      const text = getTextContentFromHTMLElement(element) || "";
      return createSeshatBlock({ schema, content: text }).content;
    },
    getAttrs: (node) => {
      const htmlNode = node;
      const codeNode = htmlNode.querySelector("code");
      if (!codeNode)
        return defaultCodeBlockAttrs;
      const classes = Array.from(codeNode.classList.values());
      const languageClass = classes.find((c2) => c2.startsWith("language-"));
      if (!languageClass)
        return defaultCodeBlockAttrs;
      const language = languageClass.replace("language-", "");
      if (!language || !isSupportedCodeBlockLanguage(language))
        return defaultCodeBlockAttrs;
      return {
        ...defaultCodeBlockAttrs,
        language
      };
    }
  },
  {
    tag: "table.highlight[data-tagsearch-lang]",
    priority,
    preserveWhitespace: "full",
    getContent: (node, schema) => {
      var _a2;
      const element = node;
      const text = (_a2 = getTextContentFromHTMLElement(element)) != null ? _a2 : "";
      return createSeshatBlock({ schema, content: text }).content;
    },
    getAttrs: (node) => {
      var _a2;
      const htmlNode = node;
      const language = (_a2 = htmlNode.getAttribute("data-tagsearch-lang")) == null ? void 0 : _a2.toLowerCase();
      if (!language || !isSupportedCodeBlockLanguage(language))
        return defaultCodeBlockAttrs;
      return {
        ...defaultCodeBlockAttrs,
        language
      };
    }
  },
  {
    tag: 'div[data-codeblock="true"]',
    attrs: defaultCodeBlockAttrs,
    priority
  }
];
const pushNodeToSeshatBlockContent = ({
  nodeToPush,
  schema,
  seshatBlockType,
  indentedNode
}) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const seshatContent = seshatBlockType === BlockTypes.NODE_VIEW ? (_b2 = (_a2 = schema.nodes) == null ? void 0 : _a2[SeshatNodes.CONTENT_NODE_VIEW]) == null ? void 0 : _b2.create({}, [nodeToPush]) : (_d2 = (_c2 = schema.nodes) == null ? void 0 : _c2[SeshatNodes.CONTENT]) == null ? void 0 : _d2.create({}, [nodeToPush]);
  const seshatBlockContent = (_f2 = (_e2 = schema.nodes) == null ? void 0 : _e2[SeshatNodes.BLOCK_CONTENT]) == null ? void 0 : _f2.create({}, [seshatContent, ...indentedNode || []]);
  return seshatBlockContent;
};
const pushNodeToSeshatBlock = ({
  nodeToPush,
  schema,
  seshatBlockType,
  indentedNode
}) => {
  var _a2, _b2;
  const seshatBlockContent = pushNodeToSeshatBlockContent({
    nodeToPush,
    schema,
    seshatBlockType,
    indentedNode
  });
  const seshatBlock = (_b2 = (_a2 = schema.nodes) == null ? void 0 : _a2[SeshatNodes.BLOCK]) == null ? void 0 : _b2.create(
    {
      type: seshatBlockType
    },
    [seshatBlockContent]
  );
  return seshatBlock;
};
const parseDividerHtml = ({
  priority
}) => [
  {
    tag: "hr",
    priority,
    attrs: {
      type: BlockTypes.NODE_VIEW,
      nodeViewType: NodeViewTypes.HORIZONTAL_RULE
    },
    getContent: (_2, schema) => {
      var _a2, _b2;
      const dividerNode = (_b2 = (_a2 = schema.nodes) == null ? void 0 : _a2[NodeViewTypes.HORIZONTAL_RULE]) == null ? void 0 : _b2.create(
        {},
        []
      );
      const seshatBlock = pushNodeToSeshatBlock({
        schema,
        nodeToPush: dividerNode,
        seshatBlockType: BlockTypes.NODE_VIEW
      });
      return seshatBlock;
    }
  }
];
const parseFileHtml = ({ priority }) => [
  {
    tag: "section.file",
    attrs: { type: BlockTypes.NODE_VIEW },
    priority,
    getContent: (node, schema) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h;
      const htmlNode = node;
      const fileUUID = (_b2 = (_a2 = htmlNode.attributes) == null ? void 0 : _a2.getNamedItem("data-id")) == null ? void 0 : _b2.value;
      const fileExt = (_d2 = (_c2 = htmlNode.attributes) == null ? void 0 : _c2.getNamedItem("data-ext")) == null ? void 0 : _d2.value;
      const fileName = (_f2 = (_e2 = htmlNode.attributes) == null ? void 0 : _e2.getNamedItem("data-name")) == null ? void 0 : _f2.value;
      const file = (_h = (_g2 = schema.nodes) == null ? void 0 : _g2[NodeViewTypes.FILE]) == null ? void 0 : _h.create({
        fileUuid: fileUUID,
        fileName: fileName && fileExt ? `${fileName}.${fileExt}` : void 0
      });
      const seshatBlock = pushNodeToSeshatBlock({
        nodeToPush: file,
        schema,
        seshatBlockType: BlockTypes.NODE_VIEW
      });
      return seshatBlock;
    }
  }
];
const parseIframeHtml = ({ priority }) => [
  {
    tag: "iframe",
    attrs: { type: BlockTypes.NODE_VIEW, nodeViewType: NodeViewTypes.IFRAME },
    priority,
    getContent: (node, schema) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h, _i, _j, _k, _l;
      const htmlNode = node;
      const iframe = (_l = (_a2 = schema.nodes) == null ? void 0 : _a2[NodeViewTypes.IFRAME]) == null ? void 0 : _l.create({
        src: (_c2 = (_b2 = htmlNode.attributes) == null ? void 0 : _b2.getNamedItem("src")) == null ? void 0 : _c2.value,
        alt: (_e2 = (_d2 = htmlNode.attributes) == null ? void 0 : _d2.getNamedItem("alt")) == null ? void 0 : _e2.value,
        srcDoc: (_g2 = (_f2 = htmlNode.attributes) == null ? void 0 : _f2.getNamedItem("srcdoc")) == null ? void 0 : _g2.value,
        id: (_i = (_h = htmlNode.attributes) == null ? void 0 : _h.getNamedItem("id")) == null ? void 0 : _i.value,
        frameBorder: (_k = (_j = htmlNode.attributes) == null ? void 0 : _j.getNamedItem("frameborder")) == null ? void 0 : _k.value
      });
      const seshatBlock = pushNodeToSeshatBlock({
        nodeToPush: iframe,
        schema,
        seshatBlockType: BlockTypes.NODE_VIEW
      });
      return seshatBlock;
    }
  },
  {
    tag: "oembed",
    attrs: { type: BlockTypes.NODE_VIEW, nodeViewType: NodeViewTypes.IFRAME },
    priority,
    getContent: (node, schema) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h, _i, _j, _k, _l;
      const htmlNode = node;
      const iframe = (_l = (_a2 = schema.nodes) == null ? void 0 : _a2[NodeViewTypes.IFRAME]) == null ? void 0 : _l.create({
        src: (_c2 = (_b2 = htmlNode.attributes) == null ? void 0 : _b2.getNamedItem("url")) == null ? void 0 : _c2.value,
        alt: (_e2 = (_d2 = htmlNode.attributes) == null ? void 0 : _d2.getNamedItem("alt")) == null ? void 0 : _e2.value,
        srcDoc: (_g2 = (_f2 = htmlNode.attributes) == null ? void 0 : _f2.getNamedItem("srcdoc")) == null ? void 0 : _g2.value,
        id: (_i = (_h = htmlNode.attributes) == null ? void 0 : _h.getNamedItem("id")) == null ? void 0 : _i.value,
        frameBorder: (_k = (_j = htmlNode.attributes) == null ? void 0 : _j.getNamedItem("frameborder")) == null ? void 0 : _k.value
      });
      const seshatBlock = pushNodeToSeshatBlock({
        nodeToPush: iframe,
        schema,
        seshatBlockType: BlockTypes.NODE_VIEW
      });
      return seshatBlock;
    }
  }
];
const parseListHtml = ({
  priority,
  type,
  tag
}) => ({
  tag,
  attrs: { type },
  priority,
  getContent: (node, schema) => {
    var _a2, _b2;
    const html = node.innerHTML.trim();
    const parsedBlocks = new HTMLParser(schema).parseContent(html, {
      disableSanitizing: true
    });
    const content = (_b2 = (_a2 = parsedBlocks[0].content) == null ? void 0 : _a2[0].content) == null ? void 0 : _b2[0].content;
    const children = parsedBlocks.slice(1);
    traverseProsemirrorDoc({ content: children }, ({ node: node2 }) => {
      var _a3;
      return ((_a3 = node2.attrs) == null ? void 0 : _a3.type) !== BlockTypes.CARD_LINK;
    });
    const seshatBlock = createSeshatBlock({
      schema,
      content: Fragment.fromJSON(schema, content != null ? content : []),
      children: children.length >= 1 ? Fragment.fromJSON(schema, children).content : void 0
    });
    return seshatBlock.content;
  }
});
const removeNewlineCharacters = (content) => {
  if (!content)
    return "";
  let result = "";
  let insideCode = false;
  for (let i = 0; i < content.length; i++) {
    const char = content.charAt(i);
    if (!insideCode && char === "\n") {
      result += " ";
    } else if (content.startsWith("<code", i)) {
      insideCode = true;
      result += "<code";
      i += 4;
    } else if (content.startsWith("</code>", i)) {
      insideCode = false;
      result += "</code>";
      i += 6;
    } else {
      result += char;
    }
  }
  return result;
};
const CK5_TODO = "ul.todo-list>li";
const EVERNOTE_TODO = "ul[data-todo]>li";
const EVERNOTE_TODO_V2 = 'div[data-task="true"]';
const GOOGLE_DOCS_TODO = 'ul>li[role="checkbox"]';
const GENERIC_TODO = "ul>li";
const GENERIC_TODO_REGEX = /^(<.+>|)(\[\] |\[ \] |\[\S\] )/;
const GOOGLE_KEEP_CHECKED = "\u2611";
const GOOGLE_KEEP_UNCHECKED = "\u2610";
const parseTodoHtml = ({ priority }) => [
  {
    tag: GENERIC_TODO,
    priority,
    getAttrs: (node) => {
      var _a2;
      if (typeof node === "string")
        return false;
      if (!((_a2 = node.textContent) == null ? void 0 : _a2.match(GENERIC_TODO_REGEX)))
        return false;
      return { type: BlockTypes.CARD_LINK };
    },
    getContent: (node, schema) => {
      var _a2, _b2;
      const htmlNode = node;
      const title = (_a2 = htmlNode.innerHTML) == null ? void 0 : _a2.split(/(<ul|<ol)/).shift();
      const titleWithoutBrackets = title == null ? void 0 : title.replace(GENERIC_TODO_REGEX, "");
      const stripped = removeNewlineCharacters(titleWithoutBrackets).trim();
      const parsedText = new HTMLParser(schema).parseInline(stripped);
      return createCardLinkFragment(schema, {
        isDone: !!((_b2 = htmlNode.textContent) == null ? void 0 : _b2.match(/^(<.+>|)\[\S\] /)),
        cardType: "task",
        cardLinkText: parsedText
      });
    }
  },
  {
    tag: GENERIC_TODO,
    priority,
    getAttrs: (node) => {
      var _a2, _b2;
      if (typeof node === "string")
        return false;
      if (!((_a2 = node.textContent) == null ? void 0 : _a2.startsWith(GOOGLE_KEEP_CHECKED)) && !((_b2 = node.textContent) == null ? void 0 : _b2.startsWith(GOOGLE_KEEP_UNCHECKED)))
        return false;
      return { type: BlockTypes.CARD_LINK };
    },
    getContent: (node, schema) => {
      var _a2, _b2, _c2, _d2, _e2;
      const htmlNode = node;
      const isDone = (_a2 = htmlNode == null ? void 0 : htmlNode.textContent) == null ? void 0 : _a2.startsWith(GOOGLE_KEEP_CHECKED);
      const title = (_e2 = (_d2 = (_b2 = htmlNode.querySelector(".text")) == null ? void 0 : _b2.innerHTML) != null ? _d2 : (_c2 = htmlNode.textContent) == null ? void 0 : _c2.substring(2)) != null ? _e2 : "Untitled Task";
      const stripped = removeNewlineCharacters(title).trim();
      const parsedText = new HTMLParser(schema).parseInline(stripped);
      return createCardLinkFragment(schema, {
        isDone,
        cardType: "task",
        cardLinkText: parsedText
      });
    }
  },
  {
    tag: EVERNOTE_TODO_V2,
    priority,
    getAttrs: () => ({
      type: BlockTypes.CARD_LINK
    }),
    getContent: (node, schema) => {
      var _a2;
      const htmlNode = node;
      const title = htmlNode.querySelector("[data-tasktitle]");
      const parsedText = new HTMLParser(schema).parseInline(
        (_a2 = title == null ? void 0 : title.innerHTML) != null ? _a2 : "Untitled Task"
      );
      return createCardLinkFragment(schema, {
        isDone: htmlNode.getAttribute("data-completed") === "true",
        cardType: "task",
        cardLinkText: parsedText
      });
    }
  },
  {
    tag: GOOGLE_DOCS_TODO,
    priority,
    getAttrs: () => ({
      type: BlockTypes.CARD_LINK
    }),
    getContent: (node, schema) => {
      var _a2;
      const htmlNode = node;
      const title = htmlNode.querySelector("p>span");
      const parsedText = new HTMLParser(schema).parseInline(
        (_a2 = title == null ? void 0 : title.innerHTML) != null ? _a2 : "Untitled Task"
      );
      return createCardLinkFragment(schema, {
        isDone: htmlNode.getAttribute("aria-checked") === "true",
        cardType: "task",
        cardLinkText: parsedText
      });
    }
  },
  {
    tag: CK5_TODO,
    getAttrs: (node) => {
      var _a2;
      const input = (_a2 = node == null ? void 0 : node.querySelector) == null ? void 0 : _a2.call(node, "input");
      const isDone = input == null ? void 0 : input.checked;
      return {
        type: BlockTypes.CARD_CONTENT,
        collapsed: true,
        cardType: "task",
        isDone
      };
    },
    priority,
    getContent: (node, schema) => getCardContent(node, schema)
  },
  {
    tag: EVERNOTE_TODO,
    priority,
    getAttrs: () => {
      return { type: BlockTypes.CARD_LINK };
    },
    getContent: (node, schema) => {
      const htmlNode = node;
      return createCardLinkFragment(schema, {
        isDone: htmlNode.getAttribute("data-checked") !== "false",
        cardType: "task",
        cardLinkText: [{ type: "text", text: htmlNode.innerText.trim() }]
      });
    }
  }
];
const createCardLinkFragment = (schema, attrs) => {
  var _a2, _b2, _c2;
  const cardLink = (_a2 = schema.nodes[NodeViewTypes.CARD_LINK]) == null ? void 0 : _a2.create(attrs);
  const seshatNodeViewContent = (_b2 = schema.nodes[SeshatNodes.CONTENT_NODE_VIEW]) == null ? void 0 : _b2.create({}, cardLink);
  return Fragment.from(
    (_c2 = schema.nodes[SeshatNodes.BLOCK_CONTENT]) == null ? void 0 : _c2.create({}, seshatNodeViewContent)
  );
};
function getCardContent(node, schema) {
  const textContent = (node == null ? void 0 : node.textContent) ? [schema.text(node == null ? void 0 : node.textContent)] : void 0;
  const seshatContent = schema.nodes.seshatContent.create({}, textContent);
  const seshatBlockContent = schema.nodes[SeshatNodes.BLOCK_CONTENT].create(
    {},
    [seshatContent]
  );
  return Fragment.from([
    seshatBlockContent,
    createSeshatBlock({
      schema,
      attrs: { type: BlockTypes.PARAGRAPH }
    })
  ]);
}
const parseVideoHtml = ({ priority }) => [
  {
    tag: "video",
    attrs: {
      type: BlockTypes.NODE_VIEW,
      nodeViewType: NodeViewTypes.EXTERNAL_VIDEO
    },
    priority,
    getContent: (node, schema) => {
      var _a2, _b2, _c2, _d2;
      const htmlNode = node;
      let src = (_a2 = htmlNode.attributes.getNamedItem("src")) == null ? void 0 : _a2.value;
      if (!src) {
        const mp4 = htmlNode.querySelector('source[type="video/mp4"]');
        const source = mp4 != null ? mp4 : htmlNode.querySelector("source");
        src = (_b2 = source == null ? void 0 : source.attributes.getNamedItem("src")) == null ? void 0 : _b2.value;
      }
      const nodeToPush = (_d2 = (_c2 = schema.nodes) == null ? void 0 : _c2[NodeViewTypes.EXTERNAL_VIDEO]) == null ? void 0 : _d2.create({
        src
      });
      return pushNodeToSeshatBlock({
        nodeToPush,
        schema,
        seshatBlockType: BlockTypes.NODE_VIEW
      });
    }
  }
];
const parseHTML = {
  [SeshatNodes.BLOCK]: [
    ...parseTodoHtml({ priority: 56 }),
    ...parseDividerHtml({ priority: 55 }),
    ...parseCodeBlockHtml({ priority: 55 }),
    ...parseFileHtml({ priority: 55 }),
    ...parseIframeHtml({ priority: 55 }),
    ...parseVideoHtml({ priority: 55 }),
    parseListHtml({
      tag: "ol>li",
      type: BlockTypes.NUMBERED_LIST,
      priority: 55
    }),
    parseListHtml({
      tag: "ul>li",
      type: BlockTypes.BULLETED_LIST,
      priority: 55
    }),
    {
      tag: "h1.clipContentTitle",
      attrs: { type: BlockTypes.CLIP_CONTENT_TITLE },
      priority: 56
    },
    { tag: "h1", attrs: { type: BlockTypes.HEADING_1 }, priority: 55 },
    { tag: "h2", attrs: { type: BlockTypes.HEADING_2 }, priority: 55 },
    { tag: "h3", attrs: { type: BlockTypes.HEADING_3 }, priority: 55 },
    { tag: "h4", attrs: { type: BlockTypes.HEADING_4 }, priority: 55 },
    { tag: "h5", attrs: { type: BlockTypes.HEADING_4 }, priority: 55 },
    { tag: "h6", attrs: { type: BlockTypes.HEADING_4 }, priority: 55 },
    { tag: "p", attrs: { type: BlockTypes.PARAGRAPH }, priority: 51 },
    { tag: "aside", attrs: { type: BlockTypes.PARAGRAPH }, priority: 51 },
    {
      tag: "div",
      priority: 51,
      getAttrs: (node) => {
        const element = node;
        const shouldCreateParagraph = shouldCreateParagraphForDiv(element);
        return shouldCreateParagraph ? { type: BlockTypes.PARAGRAPH } : false;
      }
    }
  ],
  [SeshatNodes.WRAPPING_BLOCK]: [
    {
      tag: "blockquote.tweet",
      attrs: { type: BlockTypes.TWEET },
      priority: 57
    },
    {
      tag: "blockquote",
      attrs: { type: BlockTypes.BLOCKQUOTE },
      priority: 56
    },
    {
      tag: "quote",
      attrs: { type: BlockTypes.BLOCKQUOTE },
      priority: 56
    },
    {
      tag: "tr",
      attrs: { type: BlockTypes.BLOCK_LINE },
      priority: 55,
      consuming: false
    },
    {
      tag: "div.row",
      attrs: { type: BlockTypes.BLOCK_LINE },
      priority: 55,
      consuming: false
    },
    {
      tag: "td",
      consuming: false,
      attrs: { type: BlockTypes.BLOCK_COLUMN },
      priority: 55
    },
    {
      tag: "div.column",
      consuming: false,
      attrs: { type: BlockTypes.BLOCK_COLUMN },
      priority: 55
    },
    {
      tag: "th",
      consuming: false,
      attrs: { type: BlockTypes.BLOCK_COLUMN },
      priority: 55
    }
  ]
};
const shouldCreateParagraphForDiv = (element) => {
  return !["pre", EVERNOTE_TODO_V2, "div.column", "div.row"].some(
    (selector) => element.querySelector(selector)
  );
};
const SeshatBlockNodeConfig = {
  name: SeshatNodes.BLOCK,
  content: `${SeshatNodes.BLOCK_CONTENT} ${SeshatNodeGroups.BLOCK}*`,
  parseHTML() {
    return parseHTML.block;
  }
};
const SeshatBlockNode = (options) => SeshatBlockGroup(options).extend(SeshatBlockNodeConfig);
const editorNodeConfig = {
  [getExtensionName(ClipBookBlock)]: {
    extension: ClipBookBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(ClipBookmarkBlock)]: {
    extension: ClipBookmarkBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(ExternalImageNode)]: {
    extension: ExternalImageNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(TextNode)]: {
    extension: TextNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(IFrameBlock)]: {
    extension: IFrameBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(FileBlock)]: {
    extension: FileBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(LayoutNode)]: {
    extension: LayoutNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(MentionNode)]: {
    extension: MentionNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(MentionPlaceholderNodes)]: {
    extension: MentionPlaceholderNodes,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(HorizontalRuleBlock)]: {
    extension: HorizontalRuleBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(TableOfContentsBlock)]: {
    extension: TableOfContentsBlock,
    targetedEditorVersions: ["main"]
  },
  [getExtensionName(SeshatBlockNode)]: {
    extension: SeshatBlockNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(SeshatBlockContentNode)]: {
    extension: SeshatBlockContentNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(SeshatContentNode)]: {
    extension: SeshatContentNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(SeshatNodeViewContentNode)]: {
    extension: SeshatNodeViewContentNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(SeshatWrappingBlockNode)]: {
    extension: SeshatWrappingBlockNode,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(CardLinkBlock)]: {
    extension: CardLinkBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(ExternalVideoBlock)]: {
    extension: ExternalVideoBlock,
    targetedEditorVersions: ["all_editors"]
  }
};
const editorMarkConfig = {
  [getExtensionName(BoldMark)]: {
    extension: BoldMark.extend({
      priority: ((_a = LinkMark.config.priority) != null ? _a : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(CodeMark)]: {
    extension: CodeMark.extend({
      priority: ((_b = LinkMark.config.priority) != null ? _b : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(ItalicMark)]: {
    extension: ItalicMark.extend({
      priority: ((_c = LinkMark.config.priority) != null ? _c : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(HighlightMark)]: {
    extension: HighlightMark,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(StrikeMark)]: {
    extension: StrikeMark.extend({
      priority: ((_d = LinkMark.config.priority) != null ? _d : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(LinkMark)]: {
    extension: LinkMark,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(UnderlineMark)]: {
    extension: UnderlineMark.extend({
      priority: ((_e = LinkMark.config.priority) != null ? _e : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(TextStyleMark)]: {
    extension: TextStyleMark.extend({
      priority: ((_f = LinkMark.config.priority) != null ? _f : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(ShineMark)]: {
    extension: ShineMark,
    targetedEditorVersions: ["all_editors"]
  }
};
const editorExtensionConfig = {
  [getExtensionName(AnalyticsExtension)]: {
    extension: AnalyticsExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(AnnotationModeExtension)]: {
    extension: AnnotationModeExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(BlockSelectionExtension)]: {
    extension: BlockSelectionExtension,
    targetedEditorVersions: ["main", "launcher", "read_later_view"]
  },
  [getExtensionName(BlockLineBlock)]: {
    extension: BlockLineBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(BlockIDExtension)]: {
    extension: BlockIDExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(BracketsExtension)]: {
    extension: BracketsExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(BulletedListExtension)]: {
    extension: BulletedListExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(CaptureBlock)]: {
    extension: CaptureBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(CodeBlock)]: {
    extension: CodeBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(CardBlock)]: {
    extension: CardBlock,
    targetedEditorVersions: ["main", "launcher"]
  },
  [getExtensionName(ClipboardExtension)]: {
    extension: ClipboardExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(ClipContentBlock)]: {
    extension: ClipContentBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(ContentEditableExtension)]: {
    extension: ContentEditableExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(ContextIDExtension)]: {
    extension: ContextIDExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(DropHandleExtension)]: {
    extension: DropHandleExtension,
    targetedEditorVersions: ["main", "launcher"]
  },
  [getExtensionName(TrailingLineExtension)]: {
    extension: TrailingLineExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(FontColorExtension)]: {
    extension: FontColorExtension.extend({
      priority: ((_g = LinkMark.config.priority) != null ? _g : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(HighlightsBlock)]: {
    extension: HighlightsBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(HistoryExtension)]: {
    extension: HistoryExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(InlineEditingExtension)]: {
    extension: InlineEditingExtension,
    targetedEditorVersions: ["inline_editor"]
  },
  [getExtensionName(MoveBlockExtension)]: {
    extension: MoveBlockExtension,
    targetedEditorVersions: ["main", "launcher"]
  },
  [getExtensionName(TabIndexExtension)]: {
    extension: TabIndexExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(EditableBlock)]: {
    extension: EditableBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(TextAlignExtension)]: {
    extension: TextAlignExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [getExtensionName(Typography)]: {
    extension: Typography,
    targetedEditorVersions: ["all_editors"]
  }
};
const allEditorExtensionConfigs = {
  ...editorNodeConfig,
  ...editorMarkConfig,
  ...editorExtensionConfig
};
const EDITOR_CONTENT_DOM_ID = "seshat_container";
const EDITOR_CONTENT_DOM_EDITOR_SPECIFIER = "data-editor-container";
const getEditorExtensions = ({
  extensionOptions,
  extensionConfigs
}) => Object.values(extensionConfigs != null ? extensionConfigs : allEditorExtensionConfigs).filter(({ targetedEditorVersions }) => {
  var _a2;
  if (targetedEditorVersions == null ? void 0 : targetedEditorVersions.includes("all_editors"))
    return true;
  const editorVersion = (_a2 = extensionOptions == null ? void 0 : extensionOptions.extensionVersion) != null ? _a2 : "main";
  return targetedEditorVersions.includes(editorVersion);
}).flatMap(
  ({ extension }) => typeof extension === "function" ? extension(extensionOptions) : extension
);
const SESHAT_SESSION_STORAGE_PREFIX = "@lazy/SESHAT-";
const DOC_TYPE = "doc";
export { ALL_BLOCK_COMMANDS, ANALYTICS_EVENTS, ANALYTICS_META, ANNOTATION_META, ANNOTATION_MODE_ATTRIBUTE, AddNoteBlockConfig, AddTaskBlockConfig, AnalyticsExtension, AnnotationModeExtension, MAX_COLUMNS as BLOCK_LINE_MAX_COLUMNS, BlockIDExtension, BlockLineBlock, BlockSelection, BlockSelectionExtension, BoldMark, BracketsExtension, BulletBlockConfig, BulletedListExtension, CAPTURED_TRANSACTION, CAPTURING_TRANSACTION, CaptureBlock, CardBlock, CardLinkBlock, ClipBlockConfig, ClipBookBlock, ClipBookmarkBlock, ClipContentBlock, ClipboardDOMSerializer, ClipboardExtension, CodeBlock, CodeBlockConfig, CodeMark, ConnectionConfig, ContentEditableExtension, ContextIDExtension, DOC_TYPE, DROP_HANDLE_EXTENSION, DividerBlockConfig, DropCursor, DropHandleExtension, EDITOR_CONTENT_DOM_EDITOR_SPECIFIER, EDITOR_CONTENT_DOM_ID, EditableBlock, EmbedBlockConfig, ExternalImageNode, ExternalVideoBlock, FileBlock, FileBlockConfig, FontColorExtension, GroupColors, GroupHighlightColors, HARD_BREAK_DUE_TO_BLOCK_TYPE, HARD_BREAK_DUE_TO_PARENT_TYPE, HTMLParser, HeadingBlockConfig, HighlightMark, HighlightsBlock, HighlightsConfig, HistoryExtension, HorizontalRuleBlock, IFrameBlock, IgnoreContentEditableFalse, InlineEditingExtension, ItalicMark, LayoutNode, LazyBlockTypes, LinkMark, MarkdownParser, MarkdownParserPlugins, MarkdownParserToLazyRefPlugins, MentionNode, MentionPlaceholderExtensionKey, MentionPlaceholderNodes, MoveBlockExtension, NoteBlockConfig, NumberedBlockConfig, PREVENT_EDITOR_INPUT_PLUGIN, PREVENT_EDITOR_INPUT_PLUGIN_KEY, ParagraphBlockConfig, PreviewFile, QuoteBlockConfig, ReferenceConfig, SESHAT_CONTENT_DEPTH, SESHAT_ROOT_DEPTH, SESHAT_SESSION_STORAGE_PREFIX, SelectionBoxSelector, SeshatBlockContentNode, SeshatBlockGroup, SeshatBlockNode, SeshatBlockNodeConfig, SeshatContentNode, SeshatDOMParser, SeshatDOMParserPlugin, SeshatNodeViewContentNode, SeshatWrappingBlockNode, SeshatWrappingBlockNodeConfig, ShineMark, StrikeMark, Suggestion, SuggestionPluginKey, TRANSACTION_MEASURE, TabIndexExtension, TableOfContentBlockConfig, TableOfContentsBlock, TaskBlockConfig, TextAlignExtension, TextEditor, TextEditorApi, TextNode, TextSerializer, TextStyleMark, TrailingLineExtension, UnderlineMark, YELLOW, allEditorExtensionConfigs, appendContentInACardContent, applyBlockIdToExtension, applyContextIdToExtension, blockIdPluginKey, clipBlocks, clipObserverPlugin, clipObserverPluginKey, codeBlockLanguages, countLeaves, createCardLink$1 as createCardLink, createFileNameForMarkdown, createHighlightsBlockFromClipBookmark, createHighlightsFromClipContent, createHighlightsFromKindleHighlights, createHighlightsFromPaywallClipContent, createMarkdownFromJSON, createNewHighlightsFromKindleHighlights, createParagraph, createPathForMarkdown, createSeshatBlock, createShellCardContent, disabledIndent, domSerializerConfig, editorExtensionConfig, editorMarkConfig, editorNodeConfig, excludedFromBlockSelection, extractLazyBlockFromSeshatContent, findAncestor, findBlockAtMousePosition, findChildByBlockId, findFirst, findFirstHighlight, findHighlight, findHighlightBlockQuote, findHighlightBlockQuoteParagraph, findHighlights, findHighlightsBlockWithOutConnectedClipId, findNextCaretPosition, formatCardsToSeshatContent, formatContentToMarkedText, formatPDFHighlightsToSeshatHighlights, formatSeshatHighlightsToPDFHighlights, generateBlockId, generateBulletedList, generateCapture, generateClipBookmark, generateClipContent, generateEditable, generateEmptyBlock, generateHighlightWithNote, generateHighlights, generateHorizontalRule, generateNote, generateParagraph, generateTask, getAllEditors, getAsinUrl, getBlockquoteContentFromHighlight, getBlocksInRange, getBlocksOfType, getCardContentFromSeshatBlockCard, getCardLinkText, getCardTitleContentFromSeshatBlockCard, getCardUuid, getClipByHrefAndEmpty, getClipContent, getClipContentBlock, getClipPositions, getConnectedHighlightsBlockByClipId, getCurrentBlock, getDefaultHighlightColor, getDirectPreviousSibling, getEditorApi, getEditorExtensions, getEditorId, getExtensionName, getExtensionOptions, getForwardSeshatBlockContent, getFromNToFromRange, getHeadingForTableOfContents, getHighlightBlockquoteFromHighlight, getHighlightIdFromNode, getHighlightMarkFromNode, getHighlightNoteFromHighlight, getHighlightsFromAttrs, getHighlightsFromClipBook, getHighlightsFromClipContent, getHighlightsFromClipContentById, getInjectedCardLinkViewElement, getLinkAttributes, getNearestClip, getNearestHighlightBlock, getNearestSeshatBlockOfType, getNextBlock, getNodeDepth, getNodeFromPosition, getNodeTypeByBlockType, getNoteFromHighlight, getPluginStateValue, getPreviousBlock, getPreviousSibling, getSelectionText, getSeshatBlockByBlockId, getSeshatContent, getSeshatEditorSchema, getTouchedClipIds, hasChildren, hasNodeSchemaAttribute, hideSelectionDecoration, highlightMatchingClipContent, highlighters, highlightsBlocksObserverPlugin, highlightsBlocksObserverPluginKey, initHeadlessEditor, inputRegex, insertClipBookmark$1 as insertClipBookmark, insertClipBookmarkTransaction, isAnnotation, isAtom, isBlock, isBlockCollapsed, isBlockCollapsible, isBlockSelection, isCardContent, isCardTitleNode, isCaretInEmptyClip, isCaretWithinHighlightBlockquote, isCaretWithinHighlightNote, isClipWithAttributesSync, isContentEditableFalse, isContentEditableFalseBlockType, isEditorRelatedElementFocused, isEmptyClip, isEmptyHighlightsBlock, isEmptyNode, isHighlightMark, isHighlightMarkAllowed, isLargeDocument, isLauncherEditor, isParentRootBlock, isRangeTextSelected, isRootBlock, isRootBlockJSON, isSelectableBlock, isSelectableBlockInReadView, isSeshatBlockClip$1 as isSeshatBlockClip, isSeshatBlockEmpty, isSupportedCodeBlockLanguage, markdownSerializerConfig, matchHighlightsWithClipContent, matchHighlightsWithClipContentTransaction, maybeAddMissingMarksInClipContent, mentionEditorOptions, minMax, noPlaceholderPreviewFile, pasteRegex, pasteRegexForRoam, plainTextLanguage, preventEditorInputPlugin, replaceClipBookmarkByClipContent, replaceHeadingWithClipTitle, resetAttrsInSlice, serializeForClipboard, seshatBlockAttributes, seshatBlockCommands, seshatBlockMarkdown, seshatBlockOnEnter, seshatBlockResetOnEmptyEnter, seshatBlockResetOnStartBackspace, seshatBlockShortcut, seshatBlockSoftBreakOnEnter, setPluginStateValue, shortcutConfig, syncClipBookmark, syncClipContent, syncHighlightsBlocksAfterClipModification, syncHighlightsBlocksAfterClipModificationTransaction, syncPaywallClipContent, turnBlockIntoNote, uploadAndInsertFile, uploadAndInsertRegularFile, verifyRootBlock, withPerformanceLogs };
